export const kicadPcbTestData_keyDrip7Mod = `
(kicad_pcb (version 20211014) (generator pcbnew)

  (general
    (thickness 1.6)
  )

  (paper "A4")
  (layers
    (0 "F.Cu" signal)
    (31 "B.Cu" signal)
    (32 "B.Adhes" user "B.Adhesive")
    (33 "F.Adhes" user "F.Adhesive")
    (34 "B.Paste" user)
    (35 "F.Paste" user)
    (36 "B.SilkS" user "B.Silkscreen")
    (37 "F.SilkS" user "F.Silkscreen")
    (38 "B.Mask" user)
    (39 "F.Mask" user)
    (40 "Dwgs.User" user "User.Drawings")
    (41 "Cmts.User" user "User.Comments")
    (42 "Eco1.User" user "User.Eco1")
    (43 "Eco2.User" user "User.Eco2")
    (44 "Edge.Cuts" user)
    (45 "Margin" user)
    (46 "B.CrtYd" user "B.Courtyard")
    (47 "F.CrtYd" user "F.Courtyard")
    (48 "B.Fab" user)
    (49 "F.Fab" user)
    (50 "User.1" user)
    (51 "User.2" user)
    (52 "User.3" user)
    (53 "User.4" user)
    (54 "User.5" user)
    (55 "User.6" user)
    (56 "User.7" user)
    (57 "User.8" user)
    (58 "User.9" user)
  )

  (setup
    (stackup
      (layer "F.SilkS" (type "Top Silk Screen"))
      (layer "F.Paste" (type "Top Solder Paste"))
      (layer "F.Mask" (type "Top Solder Mask") (thickness 0.01))
      (layer "F.Cu" (type "copper") (thickness 0.035))
      (layer "dielectric 1" (type "core") (thickness 1.51) (material "FR4") (epsilon_r 4.5) (loss_tangent 0.02))
      (layer "B.Cu" (type "copper") (thickness 0.035))
      (layer "B.Mask" (type "Bottom Solder Mask") (thickness 0.01))
      (layer "B.Paste" (type "Bottom Solder Paste"))
      (layer "B.SilkS" (type "Bottom Silk Screen"))
      (copper_finish "None")
      (dielectric_constraints no)
    )
    (pad_to_mask_clearance 0)
    (pcbplotparams
      (layerselection 0x00010fc_ffffffff)
      (disableapertmacros false)
      (usegerberextensions false)
      (usegerberattributes true)
      (usegerberadvancedattributes true)
      (creategerberjobfile true)
      (svguseinch false)
      (svgprecision 6)
      (excludeedgelayer true)
      (plotframeref false)
      (viasonmask false)
      (mode 1)
      (useauxorigin false)
      (hpglpennumber 1)
      (hpglpenspeed 20)
      (hpglpendiameter 15.000000)
      (dxfpolygonmode true)
      (dxfimperialunits true)
      (dxfusepcbnewfont true)
      (psnegative false)
      (psa4output false)
      (plotreference true)
      (plotvalue true)
      (plotinvisibletext false)
      (sketchpadsonfab false)
      (subtractmaskfromsilk false)
      (outputformat 1)
      (mirror false)
      (drillshape 0)
      (scaleselection 1)
      (outputdirectory "out/")
    )
  )

  (net 0 "")
  (net 1 "key1")
  (net 2 "GND")
  (net 3 "key2")
  (net 4 "key3")
  (net 5 "key4")
  (net 6 "key5")
  (net 7 "key6")
  (net 8 "key7")
  (net 9 "unconnected-(U1-Pad7)")
  (net 10 "unconnected-(U1-Pad8)")
  (net 11 "unconnected-(U1-Pad9)")
  (net 12 "unconnected-(U1-Pad10)")
  (net 13 "unconnected-(U1-Pad12)")
  (net 14 "unconnected-(U1-Pad14)")

  (footprint "local_footprints:choc_socket" (layer "F.Cu")
    (tedit 60F65256) (tstamp 013ff3f2-2ec2-4379-9508-5173469d3b3c)
    (at 90 109 180)
    (property "Sheetfile" "pcb.kicad_sch")
    (property "Sheetname" "")
    (path "/b4e3ce4b-8cd9-4bf7-8aa9-fef0353c4599")
    (attr through_hole)
    (fp_text reference "KEY6" (at 0 9.5) (layer "B.SilkS")
      (effects (font (size 1 1) (thickness 0.15)) (justify mirror))
      (tstamp 8d14297d-3ba9-419e-9158-ff839869e650)
    )
    (fp_text value "SW_KEY" (at 0 -9) (layer "F.Fab") hide
      (effects (font (size 1 1) (thickness 0.15)))
      (tstamp 2095a3da-b5d9-44d1-bd65-96fad6076577)
    )
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer "B.SilkS") (width 0.15) (tstamp 0514e467-af45-4257-b42e-c3a493f6b3e0))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer "B.SilkS") (width 0.15) (tstamp 1d64005e-e245-4989-bc30-885e639b7fa1))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer "B.SilkS") (width 0.15) (tstamp 2546564f-a613-4418-9213-1a531a5bf92c))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer "B.SilkS") (width 0.15) (tstamp 532db26f-f5be-456b-9a73-a42b4f404914))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer "B.SilkS") (width 0.15) (tstamp 855d1eea-e522-45b5-9ca4-75ab89a84e0d))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer "B.SilkS") (width 0.15) (tstamp 90db794f-ef5d-44b3-a2d2-4e732cce06ea))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer "B.SilkS") (width 0.15) (tstamp 9ed5f679-cd18-44b0-8bdd-9541393e7271))
    (fp_arc (start -3.5 6.03) (mid -2.595908 6.48733) (end -2.28 7.45) (layer "B.SilkS") (width 0.15) (tstamp a66a0000-3e7d-44d0-a45e-3f3a38aec80f))
    (fp_arc (start -0.2 3.57) (mid -1.834422 2.975843) (end -2.57 1.4) (layer "B.SilkS") (width 0.15) (tstamp c3e3548e-3165-4cc2-a7d9-735a0726e57c))
    (fp_line (start -7 -7) (end 7 -7) (layer "F.SilkS") (width 0.15) (tstamp 2ee74b59-481e-40a1-8771-eb97445173a9))
    (fp_line (start -7 7) (end -7 -7) (layer "F.SilkS") (width 0.15) (tstamp 4501f2fc-6c5f-472d-a4c9-9b9a9609e5c5))
    (fp_line (start 7 7) (end -7 7) (layer "F.SilkS") (width 0.15) (tstamp 50d34bb1-eb70-4c1f-8126-c84c37b64311))
    (fp_line (start 7 -7) (end 7 7) (layer "F.SilkS") (width 0.15) (tstamp 825937d4-5768-43a2-ae98-a45aa4699724))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer "F.Fab") (width 0.15) (tstamp 7dc32deb-8877-4e1a-8d90-d881d7e4d966))
    (fp_line (start -8.5 8) (end 8.5 8) (layer "F.Fab") (width 0.15) (tstamp af38ed1f-aa13-46d2-b0d5-cd430a4c53f8))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer "F.Fab") (width 0.15) (tstamp d977eec8-fbca-46ca-8bee-28e7072a8e98))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer "F.Fab") (width 0.15) (tstamp ed5369c8-15e2-4247-806d-16ecbfcb1684))
    (pad "" thru_hole circle (at 0 0 270) (size 3.8 3.8) (drill 3.4) (layers *.Cu *.Mask) (tstamp 1dcfba99-c46c-45cc-a28a-986043a25f7c))
    (pad "" thru_hole circle (at 0 5.9 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp 7cb17b66-13b7-4547-9761-6fcfc023e407))
    (pad "" thru_hole circle (at -5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp 84a0365a-f950-425b-b070-76c5b570f7c1))
    (pad "" thru_hole circle (at -5 3.7 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp c121e730-01e1-4119-b401-3b06536ba344))
    (pad "" thru_hole circle (at 5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp e60281ee-c753-4351-8e65-0af0ddc9cec0))
    (pad "1" smd rect (at -8.3 3.7) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 7 "key6") (pinfunction "1") (pintype "passive") (tstamp 3f7137ca-319c-4e28-af12-be4928ef47f5))
    (pad "2" smd rect (at 3.3 5.9) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 2 "GND") (pinfunction "2") (pintype "passive") (tstamp 225397da-bb36-4b55-9d05-5c6afed86f66))
  )

  (footprint "local_footprints:choc_socket" (layer "F.Cu")
    (tedit 60F65256) (tstamp 059d3afe-020e-4980-901c-cebdd9b2550d)
    (at 90 90 180)
    (property "Sheetfile" "pcb.kicad_sch")
    (property "Sheetname" "")
    (path "/36972bb8-85b4-49d6-8d8f-466fb344a240")
    (attr through_hole)
    (fp_text reference "KEY3" (at 0 9.5) (layer "B.SilkS")
      (effects (font (size 1 1) (thickness 0.15)) (justify mirror))
      (tstamp 7771e07a-28f4-440a-9790-d41a57d1436f)
    )
    (fp_text value "SW_KEY" (at 0 -9) (layer "F.Fab") hide
      (effects (font (size 1 1) (thickness 0.15)))
      (tstamp c13f55b2-93f6-4ae4-97cf-a3a01dd51408)
    )
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer "B.SilkS") (width 0.15) (tstamp 2094d78b-eccf-4b0d-b8e7-1ad639ca5d7f))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer "B.SilkS") (width 0.15) (tstamp 3aa8edda-840e-45fc-a8ac-bf7cb6b3efc0))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer "B.SilkS") (width 0.15) (tstamp 92305ae8-7871-463a-8dc3-f68a51b0b4c9))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer "B.SilkS") (width 0.15) (tstamp a944f9e1-0bc7-4339-8da7-b0048862f9e0))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer "B.SilkS") (width 0.15) (tstamp ca60cca2-8704-4eaf-a19b-e19d8ace5200))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer "B.SilkS") (width 0.15) (tstamp cb3570c9-a6c9-4b10-9c56-4067b9409527))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer "B.SilkS") (width 0.15) (tstamp cea74cad-5c74-4948-9874-ae78af63e95c))
    (fp_arc (start -0.2 3.57) (mid -1.834422 2.975843) (end -2.57 1.4) (layer "B.SilkS") (width 0.15) (tstamp 5df05bed-be85-49c1-88c5-2fcb6359dfc4))
    (fp_arc (start -3.5 6.03) (mid -2.595908 6.48733) (end -2.28 7.45) (layer "B.SilkS") (width 0.15) (tstamp d640df02-cc73-42f0-98f9-9af36e947e66))
    (fp_line (start -7 -7) (end 7 -7) (layer "F.SilkS") (width 0.15) (tstamp 1b51b911-2436-49c7-99c1-ee3a6940e0d9))
    (fp_line (start -7 7) (end -7 -7) (layer "F.SilkS") (width 0.15) (tstamp 3865eb7e-fa16-4513-a00a-db59c43d071c))
    (fp_line (start 7 7) (end -7 7) (layer "F.SilkS") (width 0.15) (tstamp eb578120-de7d-4ed8-959f-63650842c965))
    (fp_line (start 7 -7) (end 7 7) (layer "F.SilkS") (width 0.15) (tstamp fb3a1d55-a2d8-4ac6-a80e-b3e6533b4ea3))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer "F.Fab") (width 0.15) (tstamp 4976ce2a-80bf-4387-a498-66048605d888))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer "F.Fab") (width 0.15) (tstamp bd3124a9-d52e-4ced-9928-d562f94ce68d))
    (fp_line (start -8.5 8) (end 8.5 8) (layer "F.Fab") (width 0.15) (tstamp fa242cf2-3235-43c9-972e-a1af07f20dcb))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer "F.Fab") (width 0.15) (tstamp fa875ad7-f94d-425d-9cdc-d0b0cb99d5d8))
    (pad "" thru_hole circle (at -5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp 2dacf2bd-222e-4a07-b06c-a77ebe0ad6bd))
    (pad "" thru_hole circle (at 0 5.9 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp 4f35ab77-d208-4f7b-b093-b5d641841c41))
    (pad "" thru_hole circle (at 5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp 4f5329ae-9c9c-42cb-b3de-cfc344d12830))
    (pad "" thru_hole circle (at 0 0 270) (size 3.8 3.8) (drill 3.4) (layers *.Cu *.Mask) (tstamp 6fad3505-98bb-4bb7-a3a2-a9e776211c2a))
    (pad "" thru_hole circle (at -5 3.7 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp d67cc009-4cd1-4dd7-b684-510228f4a840))
    (pad "1" smd rect (at -8.3 3.7) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 4 "key3") (pinfunction "1") (pintype "passive") (tstamp e8eed226-cbf0-4ca5-b939-831703b89ddb))
    (pad "2" smd rect (at 3.3 5.9) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 2 "GND") (pinfunction "2") (pintype "passive") (tstamp fac634e3-9c1b-4b8c-8fb8-21d2657c4697))
  )

  (footprint "local_footprints:choc_socket" (layer "F.Cu")
    (tedit 60F65256) (tstamp 201eaf87-f359-4464-a3b7-be99542415a0)
    (at 109 109 180)
    (property "Sheetfile" "pcb.kicad_sch")
    (property "Sheetname" "")
    (path "/c948ebc8-1af2-46cd-8d28-9afefc6bb0b5")
    (attr through_hole)
    (fp_text reference "KEY7" (at 0 9.5) (layer "B.SilkS")
      (effects (font (size 1 1) (thickness 0.15)) (justify mirror))
      (tstamp 84d8732e-08e5-4908-8f0d-3fcb58b71c30)
    )
    (fp_text value "SW_KEY" (at 0 -9) (layer "F.Fab") hide
      (effects (font (size 1 1) (thickness 0.15)))
      (tstamp 17da2322-41fb-4e18-affc-ff85c8eeb78f)
    )
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer "B.SilkS") (width 0.15) (tstamp 2300e1d2-6b8f-4c92-a31c-a8e348a94e36))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer "B.SilkS") (width 0.15) (tstamp 44996e8a-6d12-4953-b7e9-03a622547c40))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer "B.SilkS") (width 0.15) (tstamp c8cc715e-8e41-45cf-8894-fb9dd635856c))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer "B.SilkS") (width 0.15) (tstamp d077b301-a41b-4489-9be1-941a86e70608))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer "B.SilkS") (width 0.15) (tstamp d60710c6-ce90-4e9e-a496-0889725acc09))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer "B.SilkS") (width 0.15) (tstamp dc52659f-0abc-40d5-8276-8d71dfc97efa))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer "B.SilkS") (width 0.15) (tstamp fdd14712-ce01-4364-9b1c-5c9cbb5f6131))
    (fp_arc (start -3.5 6.03) (mid -2.595908 6.48733) (end -2.28 7.45) (layer "B.SilkS") (width 0.15) (tstamp 733509b2-3949-42ea-9ebf-a1a7f242a5b3))
    (fp_arc (start -0.2 3.57) (mid -1.834422 2.975843) (end -2.57 1.4) (layer "B.SilkS") (width 0.15) (tstamp a1aec1a9-d17f-4709-b10d-37606bf76836))
    (fp_line (start -7 -7) (end 7 -7) (layer "F.SilkS") (width 0.15) (tstamp 2ce49aa7-006b-4b72-a8b7-57ae9a73f154))
    (fp_line (start 7 -7) (end 7 7) (layer "F.SilkS") (width 0.15) (tstamp 449f649d-21ab-4e3f-ae98-89c5445f6528))
    (fp_line (start -7 7) (end -7 -7) (layer "F.SilkS") (width 0.15) (tstamp e768c041-4d3e-446a-a41a-730ba34279f7))
    (fp_line (start 7 7) (end -7 7) (layer "F.SilkS") (width 0.15) (tstamp f8981e47-e449-4db1-bedf-0a998b29fdee))
    (fp_line (start -8.5 8) (end 8.5 8) (layer "F.Fab") (width 0.15) (tstamp 09dede67-73bd-462f-a0d7-969d083e5c22))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer "F.Fab") (width 0.15) (tstamp 4fc3e550-ae7e-4b31-bda0-ce3d51e32f8b))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer "F.Fab") (width 0.15) (tstamp 8ffa0090-cea0-419f-b61d-30b75b3bba5f))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer "F.Fab") (width 0.15) (tstamp 94ebd9e9-763e-44de-bd9e-e8476be041d2))
    (pad "" thru_hole circle (at 0 5.9 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp 225bbc02-eb4d-479b-ba2e-616632fdbaab))
    (pad "" thru_hole circle (at -5 3.7 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp 2384b379-9bc1-4445-a2a2-8ca617755d1c))
    (pad "" thru_hole circle (at 5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp 25da445a-c170-4d7f-9ecd-2463bfcb0029))
    (pad "" thru_hole circle (at 0 0 270) (size 3.8 3.8) (drill 3.4) (layers *.Cu *.Mask) (tstamp 6f046ccb-0ff6-47b9-9853-13046fcf93d2))
    (pad "" thru_hole circle (at -5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp a1c90a94-a197-47e2-88a7-5c3640077a72))
    (pad "1" smd rect (at -8.3 3.7) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 8 "key7") (pinfunction "1") (pintype "passive") (tstamp 0356d84f-cf40-42dd-8dc3-0a1484186478))
    (pad "2" smd rect (at 3.3 5.9) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 2 "GND") (pinfunction "2") (pintype "passive") (tstamp feb6ce9c-c806-44c2-89d0-6093aa7ca406))
  )

  (footprint "local_footprints:choc_socket" (layer "F.Cu")
    (tedit 60F65256) (tstamp 6ce0a05b-39b9-4fc9-a97b-c39df36c74be)
    (at 71 109 180)
    (property "Sheetfile" "pcb.kicad_sch")
    (property "Sheetname" "")
    (path "/2de198a3-54cb-42a6-a24d-9afd18dc514d")
    (attr through_hole)
    (fp_text reference "KEY5" (at 0 9.5) (layer "B.SilkS")
      (effects (font (size 1 1) (thickness 0.15)) (justify mirror))
      (tstamp 23695fbd-1c8f-4521-bdfd-fc7c543d7c6a)
    )
    (fp_text value "SW_KEY" (at 0 -9) (layer "F.Fab") hide
      (effects (font (size 1 1) (thickness 0.15)))
      (tstamp cafb86cd-51a1-4a97-8bce-f4de009de850)
    )
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer "B.SilkS") (width 0.15) (tstamp 0656d6ce-5cd7-446a-adc3-a660066ef4e6))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer "B.SilkS") (width 0.15) (tstamp 08b3ca12-984b-4f3e-8abf-dc5d39f27040))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer "B.SilkS") (width 0.15) (tstamp 54a32c1a-2fe9-448f-8e93-3a033828f915))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer "B.SilkS") (width 0.15) (tstamp 758ce5d6-9b97-4ca5-9c20-e354bd203e52))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer "B.SilkS") (width 0.15) (tstamp 8ef97096-049a-406d-9e39-f6e9104c0183))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer "B.SilkS") (width 0.15) (tstamp 9ae924b2-57a7-4a80-bc08-972d54bc79a9))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer "B.SilkS") (width 0.15) (tstamp cc472b1a-d206-4fbb-9a2f-e16776e2e4f9))
    (fp_arc (start -3.5 6.03) (mid -2.595908 6.48733) (end -2.28 7.45) (layer "B.SilkS") (width 0.15) (tstamp 20f21fbb-aaff-42e3-a7ae-5e5e208036c3))
    (fp_arc (start -0.2 3.57) (mid -1.834422 2.975843) (end -2.57 1.4) (layer "B.SilkS") (width 0.15) (tstamp 780d4eaf-1513-4fc6-bb61-471b5a2eb3a1))
    (fp_line (start 7 7) (end -7 7) (layer "F.SilkS") (width 0.15) (tstamp 1d303259-d446-444d-8b07-111516ff5bfa))
    (fp_line (start 7 -7) (end 7 7) (layer "F.SilkS") (width 0.15) (tstamp 3d5aafdb-34df-4e51-a364-99f4db705e97))
    (fp_line (start -7 -7) (end 7 -7) (layer "F.SilkS") (width 0.15) (tstamp 8a6518f8-315e-4103-a98e-0e2112c1eb78))
    (fp_line (start -7 7) (end -7 -7) (layer "F.SilkS") (width 0.15) (tstamp f5ac468c-8a68-4051-a77f-cea95244899f))
    (fp_line (start -8.5 8) (end 8.5 8) (layer "F.Fab") (width 0.15) (tstamp 56013268-6a71-44f3-b6f5-9319b7f69ee6))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer "F.Fab") (width 0.15) (tstamp ab3e8048-b3ec-4a05-9dd3-384c55a17235))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer "F.Fab") (width 0.15) (tstamp d721d786-ed8a-45ff-aac3-7f471e526cc6))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer "F.Fab") (width 0.15) (tstamp f0cafe65-1bd5-4a90-a9bc-f8f7bed1623e))
    (pad "" thru_hole circle (at -5 3.7 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp 44a3c7fd-d7db-4f18-b94b-d35a3c7b6a57))
    (pad "" thru_hole circle (at 0 0 270) (size 3.8 3.8) (drill 3.4) (layers *.Cu *.Mask) (tstamp 7a986bbb-2ef8-40d5-b635-34d956d48890))
    (pad "" thru_hole circle (at 0 5.9 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp 80605fc9-3063-408e-8838-e4005e59772d))
    (pad "" thru_hole circle (at 5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp cd1759cb-f799-4be4-9c0c-a726646aecfe))
    (pad "" thru_hole circle (at -5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp ec713e8a-11f1-451e-9a63-e714e01a5c35))
    (pad "1" smd rect (at -8.3 3.7) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 6 "key5") (pinfunction "1") (pintype "passive") (tstamp c9dd1809-ba17-4ce6-b21f-eae1906b4e21))
    (pad "2" smd rect (at 3.3 5.9) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 2 "GND") (pinfunction "2") (pintype "passive") (tstamp e5aceea6-d287-48d0-9798-e031f31c0b18))
  )

  (footprint "local_footprints:choc_socket" (layer "F.Cu")
    (tedit 60F65256) (tstamp 977cf37f-9352-411c-83cb-c757077f53ee)
    (at 101 70 -150)
    (property "Sheetfile" "pcb.kicad_sch")
    (property "Sheetname" "")
    (path "/98be618c-9854-4bbc-98a0-3c7391305022")
    (attr through_hole)
    (fp_text reference "KEY1" (at 0 9.5 -330) (layer "B.SilkS")
      (effects (font (size 1 1) (thickness 0.15)) (justify mirror))
      (tstamp 4e278b8d-45f0-4480-bc0c-b0ee4f16ad88)
    )
    (fp_text value "SW_KEY" (at 0 -9 -330) (layer "F.Fab") hide
      (effects (font (size 1 1) (thickness 0.15)))
      (tstamp 7111e4b6-2c5c-49df-b9b3-a92b32694915)
    )
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer "B.SilkS") (width 0.15) (tstamp 03afc503-49bf-479e-8a35-3b33aee896cb))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer "B.SilkS") (width 0.15) (tstamp 4673017d-e938-4f65-a22e-0fa1d1c54a8a))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer "B.SilkS") (width 0.15) (tstamp 473f5951-b7ff-430d-8bff-d60237e2304f))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer "B.SilkS") (width 0.15) (tstamp 70e5929b-28bb-4608-bccb-55f0bd15b873))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer "B.SilkS") (width 0.15) (tstamp bb7004c9-93f2-452c-a549-a5feef849f2d))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer "B.SilkS") (width 0.15) (tstamp f9041152-cfe1-4f9f-a162-fac7dbb1b620))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer "B.SilkS") (width 0.15) (tstamp fbe6fcac-0c60-4302-9b11-6353f5d30fb8))
    (fp_arc (start -3.5 6.03) (mid -2.595909 6.48733) (end -2.28 7.45) (layer "B.SilkS") (width 0.15) (tstamp 0b960a03-7aa5-4373-a3ad-7835a8fcc42d))
    (fp_arc (start -0.2 3.57) (mid -1.834422 2.975843) (end -2.57 1.4) (layer "B.SilkS") (width 0.15) (tstamp 0ef76a81-be6b-4deb-a9d8-fcd5f6cc9ab8))
    (fp_line (start -7 7) (end -7 -7) (layer "F.SilkS") (width 0.15) (tstamp 1c60b18a-796c-43fc-8be0-3f34a6f223fb))
    (fp_line (start 7 -7) (end 7 7) (layer "F.SilkS") (width 0.15) (tstamp 5ec79e67-7783-4dc3-95e4-7e91aa98442d))
    (fp_line (start 7 7) (end -7 7) (layer "F.SilkS") (width 0.15) (tstamp 68e7bbaf-2461-4836-a113-3f1815e9ad8d))
    (fp_line (start -7 -7) (end 7 -7) (layer "F.SilkS") (width 0.15) (tstamp 7c8b11c8-70c9-4e42-ad4c-2525247aa340))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer "F.Fab") (width 0.15) (tstamp 419a9bb8-de2a-4aa5-a189-beba1c6ba58b))
    (fp_line (start -8.5 8) (end 8.5 8) (layer "F.Fab") (width 0.15) (tstamp 9b312390-f155-43d1-9bf5-eb9731ef11e4))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer "F.Fab") (width 0.15) (tstamp a852daed-4709-4b8f-bf13-ad8aa5740960))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer "F.Fab") (width 0.15) (tstamp f725061f-5b64-4c37-a8e8-5eecc05a3720))
    (pad "" thru_hole circle (at -5 3.7 300) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp 14533bdb-49ad-486f-a0c2-ab80222ad5b8))
    (pad "" thru_hole circle (at 0 0 300) (size 3.8 3.8) (drill 3.4) (layers *.Cu *.Mask) (tstamp 77c0675b-de38-4e07-a9c5-5c1fd6b8f1a3))
    (pad "" thru_hole circle (at 0 5.9 300) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp b592cd45-d16f-4294-a62a-2a862f49b468))
    (pad "" thru_hole circle (at -5.5 0 300) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp c83f9871-f340-4d94-995f-0d457541ed70))
    (pad "" thru_hole circle (at 5.5 0 300) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp fd189bee-f381-41cc-970e-bf0e113cffb9))
    (pad "1" smd rect (at -8.3 3.7 30) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 1 "key1") (pinfunction "1") (pintype "passive") (tstamp f1064c95-1cd1-4ff1-9fd1-63c9a30e6ff1))
    (pad "2" smd rect (at 3.3 5.9 30) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 2 "GND") (pinfunction "2") (pintype "passive") (tstamp fea23e0c-d6b4-475e-af38-31e99181151c))
  )

  (footprint "local_footprints:choc_socket" (layer "F.Cu")
    (tedit 60F65256) (tstamp 9dc903ca-0aeb-4aa3-9e7b-ade5ee47768e)
    (at 109 90 180)
    (property "Sheetfile" "pcb.kicad_sch")
    (property "Sheetname" "")
    (path "/14367fb6-673e-4c31-b384-2d2448296a34")
    (attr through_hole)
    (fp_text reference "KEY4" (at 0 9.5) (layer "B.SilkS")
      (effects (font (size 1 1) (thickness 0.15)) (justify mirror))
      (tstamp dcc158f3-526f-41e1-985f-242525395b0d)
    )
    (fp_text value "SW_KEY" (at 0 -9) (layer "F.Fab") hide
      (effects (font (size 1 1) (thickness 0.15)))
      (tstamp 4168e935-5564-478c-9db2-1447b6b0818a)
    )
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer "B.SilkS") (width 0.15) (tstamp 0b5e76ef-6453-4c99-84eb-fdac342f9ad3))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer "B.SilkS") (width 0.15) (tstamp 3c9311a9-b6cf-4fe2-aa23-fc9af5251133))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer "B.SilkS") (width 0.15) (tstamp 443cfbb3-ee9d-4c92-ac39-717cd4cf9d77))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer "B.SilkS") (width 0.15) (tstamp 45aff564-78e1-4fb5-89b9-0ee1816c350d))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer "B.SilkS") (width 0.15) (tstamp c84d12ca-f0c5-472a-8d1c-14ea86781d35))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer "B.SilkS") (width 0.15) (tstamp cad633b5-744c-44e1-9e82-08f8a7711eed))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer "B.SilkS") (width 0.15) (tstamp f5cf1191-916d-4d4b-b3b6-148a0b22224c))
    (fp_arc (start -3.5 6.03) (mid -2.595908 6.48733) (end -2.28 7.45) (layer "B.SilkS") (width 0.15) (tstamp 36ee6c7b-fc42-40f6-90af-9b5af2b17f0e))
    (fp_arc (start -0.2 3.57) (mid -1.834422 2.975843) (end -2.57 1.4) (layer "B.SilkS") (width 0.15) (tstamp c1ac63ce-e26d-4240-9eed-9397a845662b))
    (fp_line (start -7 -7) (end 7 -7) (layer "F.SilkS") (width 0.15) (tstamp 15131639-99a4-45cf-b2f6-7a1fcb1bcf65))
    (fp_line (start -7 7) (end -7 -7) (layer "F.SilkS") (width 0.15) (tstamp 460cb737-322b-4688-ab09-0b3260e82955))
    (fp_line (start 7 -7) (end 7 7) (layer "F.SilkS") (width 0.15) (tstamp cf59ebf2-8d32-4cf8-b57d-c87496c63ec2))
    (fp_line (start 7 7) (end -7 7) (layer "F.SilkS") (width 0.15) (tstamp fa62b9c1-7164-470d-ad89-3fb85039f862))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer "F.Fab") (width 0.15) (tstamp 2cd29552-c3bd-4ded-ad25-9f6f66c9352c))
    (fp_line (start -8.5 8) (end 8.5 8) (layer "F.Fab") (width 0.15) (tstamp 7f4605d4-09a7-4c19-a158-9514e6c6e2a5))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer "F.Fab") (width 0.15) (tstamp 96ee686f-0239-4889-a13c-6503766dd4b7))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer "F.Fab") (width 0.15) (tstamp b453aef2-8e39-4c08-81b0-424194e5c8ac))
    (pad "" thru_hole circle (at 5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp 2f816b19-140f-43c6-a5ee-4a833e805192))
    (pad "" thru_hole circle (at 0 5.9 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp 3406728b-34dd-430b-8102-3f03e091227e))
    (pad "" thru_hole circle (at 0 0 270) (size 3.8 3.8) (drill 3.4) (layers *.Cu *.Mask) (tstamp b0d3f083-5f4e-42bc-a74b-bbf2136df793))
    (pad "" thru_hole circle (at -5 3.7 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp b7109f86-adc8-4466-b5ae-1a1d5c4bc651))
    (pad "" thru_hole circle (at -5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp d9a68776-5d2a-4fbe-93a1-c4fc5968a204))
    (pad "1" smd rect (at -8.3 3.7) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 5 "key4") (pinfunction "1") (pintype "passive") (tstamp 4e96d119-1598-4017-b4a9-19e4a2b734d8))
    (pad "2" smd rect (at 3.3 5.9) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 2 "GND") (pinfunction "2") (pintype "passive") (tstamp 34f8fb9d-438d-41a7-9ba0-b9d39bbfb562))
  )

  (footprint "local_footprints:choc_socket" (layer "F.Cu")
    (tedit 60F65256) (tstamp d6b9228d-6538-48a0-a114-d7a447499c26)
    (at 71 90 180)
    (property "Sheetfile" "pcb.kicad_sch")
    (property "Sheetname" "")
    (path "/45c564f8-81ba-4138-857e-d80890b45d21")
    (attr through_hole)
    (fp_text reference "KEY2" (at 0 9.5) (layer "B.SilkS")
      (effects (font (size 1 1) (thickness 0.15)) (justify mirror))
      (tstamp d3f6d618-dee5-4063-8db6-6fa2215d6eba)
    )
    (fp_text value "SW_KEY" (at 0 -9) (layer "F.Fab") hide
      (effects (font (size 1 1) (thickness 0.15)))
      (tstamp 2afe968b-7a79-44a1-abce-ab4ac54ca8fc)
    )
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer "B.SilkS") (width 0.15) (tstamp 0205e0be-166d-4797-a4b8-a918f45f1ef2))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer "B.SilkS") (width 0.15) (tstamp 1c5c57ad-53b8-4eb5-8698-c969bc918e37))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer "B.SilkS") (width 0.15) (tstamp 3b6b5eb3-622f-4235-8f92-b146485aed92))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer "B.SilkS") (width 0.15) (tstamp 660e4e98-f4d3-4cb3-88dd-4015cee6d330))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer "B.SilkS") (width 0.15) (tstamp c4b80b76-18ed-4dbc-919b-d6452c765551))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer "B.SilkS") (width 0.15) (tstamp e38bec52-731d-4192-9f10-a83cc33d67ff))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer "B.SilkS") (width 0.15) (tstamp eb2835cc-0b7d-4337-8360-0a13b1da0c1f))
    (fp_arc (start -3.5 6.03) (mid -2.595908 6.48733) (end -2.28 7.45) (layer "B.SilkS") (width 0.15) (tstamp 6e730fdc-b011-4eee-8980-3791beb606e7))
    (fp_arc (start -0.2 3.57) (mid -1.834422 2.975843) (end -2.57 1.4) (layer "B.SilkS") (width 0.15) (tstamp 831f5bbc-2044-4821-b3bb-a041be2f2b62))
    (fp_line (start -7 -7) (end 7 -7) (layer "F.SilkS") (width 0.15) (tstamp 094a5276-a6dd-483f-8d3c-97abcf4b17fa))
    (fp_line (start -7 7) (end -7 -7) (layer "F.SilkS") (width 0.15) (tstamp 65ba433e-0bc5-498e-a3a8-deb4b712afea))
    (fp_line (start 7 -7) (end 7 7) (layer "F.SilkS") (width 0.15) (tstamp b8347028-1236-4dcc-9c01-c59077df43b4))
    (fp_line (start 7 7) (end -7 7) (layer "F.SilkS") (width 0.15) (tstamp cf0eb966-f525-4a55-bd4f-54562748165b))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer "F.Fab") (width 0.15) (tstamp 80a9f6a9-9a84-409a-8da6-bb6d96eddb71))
    (fp_line (start -8.5 8) (end 8.5 8) (layer "F.Fab") (width 0.15) (tstamp bc93b6b2-fb28-4d0e-bf51-4589888d9081))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer "F.Fab") (width 0.15) (tstamp be74af8d-0ae2-4f68-9c9a-c7be38864431))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer "F.Fab") (width 0.15) (tstamp c44be4c1-7439-4bfc-b3ce-d0c5a629ccf7))
    (pad "" thru_hole circle (at 0 0 270) (size 3.8 3.8) (drill 3.4) (layers *.Cu *.Mask) (tstamp 0010aad2-ef5f-4e42-b215-9a7eac183909))
    (pad "" thru_hole circle (at -5 3.7 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp 364b9826-5089-4855-a9e7-b32f940150bf))
    (pad "" thru_hole circle (at 5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp 4a0c18c0-c186-4ddd-9023-797384df042c))
    (pad "" thru_hole circle (at -5.5 0 270) (size 2.2 2.2) (drill 1.8) (layers *.Cu *.Mask) (tstamp 8505a94e-8e99-4bd0-9aa4-b640b7d90eca))
    (pad "" thru_hole circle (at 0 5.9 270) (size 3.3 3.3) (drill 3) (layers *.Cu *.Mask) (tstamp f10b59c9-1717-429e-ae19-3dae6951fb9f))
    (pad "1" smd rect (at -8.3 3.7) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 3 "key2") (pinfunction "1") (pintype "passive") (tstamp 33a03f49-96d9-4ffb-a6b7-3cafb935b027))
    (pad "2" smd rect (at 3.3 5.9) (size 2.2 3) (layers "B.Cu" "B.Paste" "B.Mask")
      (net 2 "GND") (pinfunction "2") (pintype "passive") (tstamp 91c2557c-9b2d-4ee8-8d83-facb6ba9a09e))
  )

  (footprint "local_footprints:xiao_rp2040" (layer "F.Cu")
    (tedit 0) (tstamp f8320551-8e6c-4ff6-a6a3-f191b4d31b2e)
    (at 80 68)
    (property "Sheetfile" "pcb.kicad_sch")
    (property "Sheetname" "")
    (path "/f3ed2d1d-9fbc-4b1e-8ec8-934b406ec7b5")
    (attr through_hole)
    (fp_text reference "U1" (at 0 -0.5 unlocked) (layer "F.SilkS")
      (effects (font (size 1 1) (thickness 0.15)))
      (tstamp 6bcba724-cdb3-4de5-971d-7c67ab295bb2)
    )
    (fp_text value "XIAO RP2040" (at 0 2 unlocked) (layer "F.SilkS")
      (effects (font (size 1 1) (thickness 0.15)))
      (tstamp 527ba569-2dfe-4e34-9112-d288f6712335)
    )
    (fp_text user "\${REFERENCE}" (at 0 1.25 unlocked) (layer "F.Fab") hide
      (effects (font (size 1 1) (thickness 0.15)))
      (tstamp c98ebb8c-b081-42d7-997d-fd8c2b327281)
    )
    (fp_line (start 6.7 8.75) (end 6.7 8.89) (layer "F.SilkS") (width 0.13) (tstamp 0da7e3a0-3c37-4afc-b924-2a76d4a98a86))
    (fp_line (start -6.7 8.75) (end -6.7 8.89) (layer "F.SilkS") (width 0.13) (tstamp 104f80bb-c7ad-4fd0-acdb-364f882d589e))
    (fp_line (start -6.7 -8.89) (end -6.7 6.35) (layer "F.SilkS") (width 0.13) (tstamp 18ebc403-31fd-4082-8a2d-a96416b99bf2))
    (fp_line (start 8.7 8.89) (end 8.3 8.89) (layer "F.SilkS") (width 0.13) (tstamp 196f5f98-da2b-436b-8ef0-99091a66a700))
    (fp_line (start -8.9 -9) (end -8.9 9) (layer "F.SilkS") (width 0.13) (tstamp 1a7490c0-1615-48cd-ad86-c520c9988025))
    (fp_line (start -7 11) (end 7 11) (layer "F.SilkS") (width 0.13) (tstamp 3a3693c3-f882-47a3-8268-9ef3d9567324))
    (fp_line (start -7.5 8.89) (end -7.9 8.89) (layer "F.SilkS") (width 0.13) (tstamp 4b695777-9524-44ef-8bfc-db02c459aeec))
    (fp_line (start -8.8 -8.89) (end -6.7 -8.89) (layer "F.SilkS") (width 0.13) (tstamp 5ffe68c1-4d3f-4290-bac5-9b702ef37bfe))
    (fp_line (start -8.3 8.89) (end -8.7 8.89) (layer "F.SilkS") (width 0.13) (tstamp 68193e52-26e0-49fb-9ad8-a3c099aa8aa9))
    (fp_line (start 7.1 8.89) (end 6.7 8.89) (layer "F.SilkS") (width 0.13) (tstamp 6879c167-b2db-49de-8da5-17c1e60fb2b9))
    (fp_line (start 4.5 -12) (end -4.5 -12) (layer "F.SilkS") (width 0.13) (tstamp 6de63018-b180-4b00-b0f6-c479c2229423))
    (fp_line (start -6.7 6.35) (end -6.7 6.75) (layer "F.SilkS") (width 0.13) (tstamp 7585ace1-2bd3-4524-8ba6-6b80834bd5d0))
    (fp_line (start 6.7 7.95) (end 6.7 8.35) (layer "F.SilkS") (width 0.13) (tstamp 77dc0b49-5fbe-4621-b23b-f0a9bc5e07e2))
    (fp_line (start -6.7 7.15) (end -6.7 7.55) (layer "F.SilkS") (width 0.13) (tstamp 7e75a9a8-3cc8-4975-865a-0bbced2b46f3))
    (fp_line (start 6.7 6.35) (end 6.7 -8.89) (layer "F.SilkS") (width 0.13) (tstamp 873a5cf3-7557-44f9-ad2a-3a7e423dc6bd))
    (fp_line (start -4.5 -12) (end -4.5 -4.5) (layer "F.SilkS") (width 0.13) (tstamp 8c801b41-e30e-4e59-b607-69eb0cde779b))
    (fp_line (start 6.7 -8.89) (end 8.8 -8.89) (layer "F.SilkS") (width 0.13) (tstamp 972027b2-839f-48c8-9bca-d9a326177e2d))
    (fp_line (start 6.7 7.15) (end 6.7 7.55) (layer "F.SilkS") (width 0.13) (tstamp 97c178bf-f69c-4883-ab26-9667cb095ab3))
    (fp_line (start 7 -11) (end -7 -11) (layer "F.SilkS") (width 0.13) (tstamp 9a35db30-7ff9-4558-9d5a-68dfd03ac4e7))
    (fp_line (start 8.9 9) (end 8.9 -9) (layer "F.SilkS") (width 0.13) (tstamp c03ab665-edc1-448b-8ff2-9f6a17a77bd5))
    (fp_line (start -8.8 6.35) (end -6.7 6.35) (layer "F.SilkS") (width 0.13) (tstamp d16abdd2-f753-4007-8fa8-08c74dafd55a))
    (fp_line (start -6.7 8.89) (end -7.1 8.89) (layer "F.SilkS") (width 0.13) (tstamp d3acd9d8-da57-46b1-b4cc-009d9d80345a))
    (fp_line (start -6.7 7.95) (end -6.7 8.35) (layer "F.SilkS") (width 0.13) (tstamp d8e548d2-b21d-44eb-a600-65028625547f))
    (fp_line (start 6.7 6.35) (end 8.8 6.35) (layer "F.SilkS") (width 0.13) (tstamp d8f11a62-1ef6-4bcb-963b-3b7f6b570ca8))
    (fp_line (start 6.7 6.35) (end 6.7 6.75) (layer "F.SilkS") (width 0.13) (tstamp e3c934f3-779b-4126-b918-7bb4f3fde6f9))
    (fp_line (start 7.9 8.89) (end 7.5 8.89) (layer "F.SilkS") (width 0.13) (tstamp e6b65293-42be-4ea3-8bca-8bb4862bb252))
    (fp_line (start -4.5 -4.5) (end 4.5 -4.5) (layer "F.SilkS") (width 0.13) (tstamp ef9fe515-91f6-4e91-a6f0-b8ddef8a8c98))
    (fp_line (start 4.5 -4.5) (end 4.5 -12) (layer "F.SilkS") (width 0.13) (tstamp f25256c1-a7a9-4266-b9bb-aa90f18d0eca))
    (fp_arc (start -6.9 11) (mid -8.314214 10.414214) (end -8.9 9) (layer "F.SilkS") (width 0.13) (tstamp 04e3785d-5f56-43cf-90da-748680763684))
    (fp_arc (start 8.9 9) (mid 8.314214 10.414214) (end 6.9 11) (layer "F.SilkS") (width 0.13) (tstamp 29fd55e8-0706-4e56-9b65-f1d3cab4f6f9))
    (fp_arc (start 6.9 -11) (mid 8.314214 -10.414214) (end 8.9 -9) (layer "F.SilkS") (width 0.13) (tstamp 505bf34f-b214-4a01-8298-0bf71b1eb6aa))
    (fp_arc (start -8.9 -9) (mid -8.314214 -10.414214) (end -6.9 -11) (layer "F.SilkS") (width 0.13) (tstamp e7fd8727-1609-434a-ae71-021f5322328d))
    (pad "1" thru_hole rect (at -7.62 -7.62 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 5 "key4") (pinfunction "GP26") (pintype "bidirectional") (tstamp 9ebde427-2751-4351-b58b-ef08cea8a33a))
    (pad "2" thru_hole circle (at -7.62 -5.08 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 4 "key3") (pinfunction "GP27") (pintype "bidirectional") (tstamp 9d05c094-f221-4ff8-bd2c-2ed2b3a0d39f))
    (pad "3" thru_hole circle (at -7.62 -2.54 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 3 "key2") (pinfunction "GP28") (pintype "bidirectional") (tstamp 3d6f4a7e-7656-4404-8e77-32d84dd2e9bf))
    (pad "4" thru_hole circle (at -7.62 0 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 6 "key5") (pinfunction "GP29") (pintype "bidirectional") (tstamp 7b9a0213-4b9d-4e06-b43c-a18d10838671))
    (pad "5" thru_hole circle (at -7.62 2.54 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 7 "key6") (pinfunction "GP6") (pintype "bidirectional") (tstamp 37dbca8d-7022-41f8-b09b-0a3f012dda43))
    (pad "6" thru_hole circle (at -7.62 5.08 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 8 "key7") (pinfunction "GP7") (pintype "bidirectional") (tstamp 2c86c7db-b26b-47c4-8282-70fa723aad9b))
    (pad "7" thru_hole circle (at -7.62 7.62 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 9 "unconnected-(U1-Pad7)") (pinfunction "GP0") (pintype "bidirectional+no_connect") (tstamp 9ea50a1b-4766-4191-ad65-c0bf621cedc2))
    (pad "8" thru_hole circle (at 7.62 7.62 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 10 "unconnected-(U1-Pad8)") (pinfunction "GP1") (pintype "bidirectional+no_connect") (tstamp 8cc355f8-294e-42cf-b913-80c56a7b0b5d))
    (pad "9" thru_hole circle (at 7.62 5.08 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 11 "unconnected-(U1-Pad9)") (pinfunction "GP2") (pintype "bidirectional+no_connect") (tstamp f73a475e-cb0a-44c0-8375-4c1151c1fa1f))
    (pad "10" thru_hole circle (at 7.62 2.54 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 12 "unconnected-(U1-Pad10)") (pinfunction "GP4") (pintype "bidirectional+no_connect") (tstamp 6c5c696d-255b-4bf1-a8da-8493bca3581f))
    (pad "11" thru_hole circle (at 7.62 0 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 1 "key1") (pinfunction "GP3") (pintype "bidirectional") (tstamp 3c8b089e-06f9-41f0-84ee-af57b0379341))
    (pad "12" thru_hole circle (at 7.62 -2.54 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 13 "unconnected-(U1-Pad12)") (pinfunction "3V3") (pintype "passive+no_connect") (tstamp 95899b22-c242-4bdf-bb77-8cb322c3e122))
    (pad "13" thru_hole circle (at 7.62 -5.08 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 2 "GND") (pinfunction "GND") (pintype "power_in") (tstamp 2a5aa9ae-3e0e-4cad-a48e-aa4d1efac5a2))
    (pad "14" thru_hole circle (at 7.62 -7.62 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 14 "unconnected-(U1-Pad14)") (pinfunction "5V") (pintype "passive+no_connect") (tstamp e95f52b8-1d48-48fc-ad64-57f712e0ae57))
    (group "" (id 68f8378b-198d-4f40-b841-5d5c07ed9776)
      (members
        04e3785d-5f56-43cf-90da-748680763684
        0da7e3a0-3c37-4afc-b924-2a76d4a98a86
        104f80bb-c7ad-4fd0-acdb-364f882d589e
        18ebc403-31fd-4082-8a2d-a96416b99bf2
        196f5f98-da2b-436b-8ef0-99091a66a700
        1a7490c0-1615-48cd-ad86-c520c9988025
        29fd55e8-0706-4e56-9b65-f1d3cab4f6f9
        3a3693c3-f882-47a3-8268-9ef3d9567324
        4b695777-9524-44ef-8bfc-db02c459aeec
        505bf34f-b214-4a01-8298-0bf71b1eb6aa
        5ffe68c1-4d3f-4290-bac5-9b702ef37bfe
        68193e52-26e0-49fb-9ad8-a3c099aa8aa9
        6879c167-b2db-49de-8da5-17c1e60fb2b9
        6de63018-b180-4b00-b0f6-c479c2229423
        7585ace1-2bd3-4524-8ba6-6b80834bd5d0
        77dc0b49-5fbe-4621-b23b-f0a9bc5e07e2
        7e75a9a8-3cc8-4975-865a-0bbced2b46f3
        873a5cf3-7557-44f9-ad2a-3a7e423dc6bd
        8c801b41-e30e-4e59-b607-69eb0cde779b
        972027b2-839f-48c8-9bca-d9a326177e2d
        97c178bf-f69c-4883-ab26-9667cb095ab3
        9a35db30-7ff9-4558-9d5a-68dfd03ac4e7
        c03ab665-edc1-448b-8ff2-9f6a17a77bd5
        d16abdd2-f753-4007-8fa8-08c74dafd55a
        d3acd9d8-da57-46b1-b4cc-009d9d80345a
        d8e548d2-b21d-44eb-a600-65028625547f
        d8f11a62-1ef6-4bcb-963b-3b7f6b570ca8
        e3c934f3-779b-4126-b918-7bb4f3fde6f9
        e6b65293-42be-4ea3-8bca-8bb4862bb252
        e7fd8727-1609-434a-ae71-021f5322328d
        ef9fe515-91f6-4e91-a6f0-b8ddef8a8c98
        f25256c1-a7a9-4266-b9bb-aa90f18d0eca
      )
    )
  )

  (gr_circle (center 62 62) (end 66 62) (layer "B.SilkS") (width 0.1) (fill none) (tstamp 2519586c-8085-4fb6-aee4-20d8cd1d2d5e))
  (gr_circle (center 62 116) (end 66 116) (layer "B.SilkS") (width 0.1) (fill none) (tstamp 89669163-72d8-46f0-be3a-691de782e3c8))
  (gr_circle (center 118 116) (end 122 116) (layer "B.SilkS") (width 0.1) (fill none) (tstamp 9c5a2585-27f5-44e3-9870-a2d0ca2b316b))
  (gr_circle (center 118 62) (end 122 62) (layer "B.SilkS") (width 0.1) (fill none) (tstamp a2e6eaa7-6819-4725-b1ba-dd4cdce74ed2))
  (gr_line (start 108.5 62.5) (end 93.5 62.5) (layer "Eco1.User") (width 0.25) (tstamp 0336e61a-f2bb-41af-9905-bfc534a31e87))
  (gr_line (start 63.5 101.5) (end 63.5 116.5) (layer "Eco1.User") (width 0.25) (tstamp 066c7b9e-3d35-47e1-940d-0c6dda8755f8))
  (gr_line (start 81.25 98.25) (end 98.75 98.25) (layer "Eco1.User") (width 0.25) (tstamp 0ab2f29e-f633-4eda-b8e4-8f907ca60e88))
  (gr_line (start 63.5 82.5) (end 63.5 97.5) (layer "Eco1.User") (width 0.25) (tstamp 0f77db64-49ce-4ce7-8c07-5e31ea9cae4e))
  (gr_arc (start 87 57) (mid 88.414214 57.585786) (end 89 59) (layer "Eco1.User") (width 0.25) (tstamp 136705fb-c0a6-4a36-a672-5ebce80ebeb8))
  (gr_arc (start 73 79) (mid 71.585786 78.414214) (end 71 77) (layer "Eco1.User") (width 0.25) (tstamp 138b47fd-cb85-4545-8f59-ce24ca7d61e0))
  (gr_line (start 101.5 101.5) (end 101.5 116.5) (layer "Eco1.User") (width 0.25) (tstamp 16787596-b54e-40ab-9802-1c1a9cda9bbb))
  (gr_line (start 75.5 62.75) (end 84.5 62.75) (layer "Eco1.User") (width 0.25) (tstamp 1939b3c7-1f1f-482a-916e-0952f74cf170))
  (gr_line (start 81.25 100.75) (end 81.25 117.25) (layer "Eco1.User") (width 0.25) (tstamp 1b416fe2-08c7-4a32-a55a-86a217a7342d))
  (gr_line (start 117.75 100.75) (end 100.25 100.75) (layer "Eco1.User") (width 0.25) (tstamp 1f6fae7d-b202-4906-9fa0-47f5fe191cf6))
  (gr_line (start 98.75 81.75) (end 81.25 81.75) (layer "Eco1.User") (width 0.25) (tstamp 25fff06d-4a05-4112-a63e-7067993670f7))
  (gr_line (start 117.75 117.25) (end 117.75 100.75) (layer "Eco1.User") (width 0.25) (tstamp 264f964a-1324-4cfa-ac5c-5074230326d3))
  (gr_line (start 90 108) (end 90 110) (layer "Eco1.User") (width 0.25) (tstamp 26722522-aefc-46d8-9892-092c672cecc2))
  (gr_line (start 108.5 77.5) (end 108.5 62.5) (layer "Eco1.User") (width 0.25) (tstamp 28dc68c0-413e-4cf7-b709-0aeea3627cfb))
  (gr_line (start 62.25 117.25) (end 79.75 117.25) (layer "Eco1.User") (width 0.25) (tstamp 2b29d1ef-7dbb-4b72-a0be-53ba9db28754))
  (gr_line (start 101.5 82.5) (end 101.5 97.5) (layer "Eco1.User") (width 0.25) (tstamp 2b51e30c-6174-44a7-947b-2b142ddd5b74))
  (gr_line (start 87 57) (end 73 57) (layer "Eco1.User") (width 0.25) (tstamp 2cc2f750-8176-4bf9-aa04-31d8be356ce6))
  (gr_line (start 100.25 81.75) (end 100.25 98.25) (layer "Eco1.User") (width 0.25) (tstamp 30b24746-144d-42e3-8df8-df03714741aa))
  (gr_line (start 116.5 97.5) (end 116.5 82.5) (layer "Eco1.User") (width 0.25) (tstamp 334ea2f4-62fe-49cc-9f1e-767e3ed40505))
  (gr_line (start 70 109) (end 72 109) (layer "Eco1.User") (width 0.25) (tstamp 346d341f-2e69-444c-a9f3-390199bef53d))
  (gr_line (start 78.5 97.5) (end 78.5 82.5) (layer "Eco1.User") (width 0.25) (tstamp 3ac482c7-92eb-48df-a6af-aafa25d96212))
  (gr_line (start 79.75 81.75) (end 62.25 81.75) (layer "Eco1.User") (width 0.25) (tstamp 3be2c22b-d929-4c31-a603-0fc0292f5a13))
  (gr_line (start 71 59) (end 71 77) (layer "Eco1.User") (width 0.25) (tstamp 3d111cd6-721c-435b-8398-5c3737e2c016))
  (gr_line (start 82.5 82.5) (end 82.5 97.5) (layer "Eco1.User") (width 0.25) (tstamp 3ebb2471-e58e-48c8-bd97-05a0313e874d))
  (gr_line (start 117.75 98.25) (end 117.75 81.75) (layer "Eco1.User") (width 0.25) (tstamp 4786de45-e123-4647-8886-46a1766320bc))
  (gr_line (start 82.5 101.5) (end 82.5 116.5) (layer "Eco1.User") (width 0.25) (tstamp 499ee4cf-c539-42cf-ae33-b9ab273dd6f9))
  (gr_line (start 116.5 101.5) (end 101.5 101.5) (layer "Eco1.User") (width 0.25) (tstamp 4c46366f-55f2-46f0-87ca-d2cbc135b1bd))
  (gr_line (start 101.5 116.5) (end 116.5 116.5) (layer "Eco1.User") (width 0.25) (tstamp 4ce03e7c-ea90-4388-8e2c-5d383b6767ef))
  (gr_line (start 81.25 117.25) (end 98.75 117.25) (layer "Eco1.User") (width 0.25) (tstamp 5087eaa2-9e4b-48ee-958e-fa778ec4336f))
  (gr_line (start 71 108) (end 71 110) (layer "Eco1.User") (width 0.25) (tstamp 52943e25-a830-4057-bc2a-9c72a1109c07))
  (gr_arc (start 71 59) (mid 71.585786 57.585786) (end 73 57) (layer "Eco1.User") (width 0.25) (tstamp 5a81fbe3-b1ba-4bc0-87f5-0ec59656e1a7))
  (gr_line (start 73 79) (end 87 79) (layer "Eco1.User") (width 0.25) (tstamp 5bdd52e7-1ab8-4309-a04b-6f3d17b3a7ed))
  (gr_arc (start 89 77) (mid 88.414214 78.414214) (end 87 79) (layer "Eco1.User") (width 0.25) (tstamp 5cad8245-0d68-483d-88b5-453bbd41bcea))
  (gr_line (start 93.5 62.5) (end 93.5 77.5) (layer "Eco1.User") (width 0.25) (tstamp 62f25e20-9774-4016-8fdf-318973027397))
  (gr_line (start 109.75 78.25) (end 109.75 61.75) (layer "Eco1.User") (width 0.25) (tstamp 64f8683b-ab58-4158-bc5d-ec6576c0f333))
  (gr_line (start 100.25 117.25) (end 117.75 117.25) (layer "Eco1.User") (width 0.25) (tstamp 652cb69d-71ea-41d0-bd23-5f5c71fb3264))
  (gr_line (start 89 90) (end 91 90) (layer "Eco1.User") (width 0.25) (tstamp 668c2930-ce67-4eba-a204-cdd743ea7275))
  (gr_line (start 82.5 116.5) (end 97.5 116.5) (layer "Eco1.User") (width 0.25) (tstamp 690e6026-7ef4-4af7-a6bb-5755b1c0a94b))
  (gr_line (start 97.5 101.5) (end 82.5 101.5) (layer "Eco1.User") (width 0.25) (tstamp 693b7933-5f55-4374-848f-311aa5c064f9))
  (gr_line (start 101.5 97.5) (end 116.5 97.5) (layer "Eco1.User") (width 0.25) (tstamp 6d92fd32-d4c7-432c-86e1-005e1b20dae4))
  (gr_line (start 92.25 78.25) (end 109.75 78.25) (layer "Eco1.User") (width 0.25) (tstamp 7c563f81-a567-494e-81fe-f56c9d160244))
  (gr_line (start 101 69) (end 101 71) (layer "Eco1.User") (width 0.25) (tstamp 7ce00510-74a0-4927-a723-e7f3f4734a7e))
  (gr_line (start 84.5 62.75) (end 84.5 55.25) (layer "Eco1.User") (width 0.25) (tstamp 7fcd9c6e-acc7-4ae9-b273-8cc44c938b49))
  (gr_line (start 62.25 100.75) (end 62.25 117.25) (layer "Eco1.User") (width 0.25) (tstamp 80ef933b-667e-49cf-9f66-067bf3f909cf))
  (gr_line (start 109 89) (end 109 91) (layer "Eco1.User") (width 0.25) (tstamp 81a35367-3521-4259-9ecb-384c6dbf008e))
  (gr_line (start 90 89) (end 90 91) (layer "Eco1.User") (width 0.25) (tstamp 83a3f552-1e5c-4b1c-a1a2-7875fa65153b))
  (gr_line (start 63.5 116.5) (end 78.5 116.5) (layer "Eco1.User") (width 0.25) (tstamp 849ca6d5-3b02-4d39-aec8-25a1ba3ead35))
  (gr_line (start 78.5 82.5) (end 63.5 82.5) (layer "Eco1.User") (width 0.25) (tstamp 89a9c4a6-ae5f-431a-978e-b76381c068cf))
  (gr_line (start 78.5 116.5) (end 78.5 101.5) (layer "Eco1.User") (width 0.25) (tstamp 8d1ac7e0-0f44-4030-a9e2-076af253f08c))
  (gr_line (start 89 109) (end 91 109) (layer "Eco1.User") (width 0.25) (tstamp 90f4901e-3d42-400a-90cb-b7a0b770f101))
  (gr_line (start 97.5 97.5) (end 97.5 82.5) (layer "Eco1.User") (width 0.25) (tstamp 91a8e894-b4d8-4299-91a2-44a2e9243a48))
  (gr_line (start 117.75 81.75) (end 100.25 81.75) (layer "Eco1.User") (width 0.25) (tstamp 966fd471-47aa-4ad8-96a0-da7e581389ba))
  (gr_line (start 100 70) (end 102 70) (layer "Eco1.User") (width 0.25) (tstamp 99b263dc-33e2-44fe-90e4-c0a11122b415))
  (gr_line (start 84.5 55.25) (end 75.5 55.25) (layer "Eco1.User") (width 0.25) (tstamp 9ad52624-6e22-45bd-8f48-2537a2253099))
  (gr_line (start 97.5 82.5) (end 82.5 82.5) (layer "Eco1.User") (width 0.25) (tstamp 9bf90b30-29a3-4ab0-be3c-7322f9cc0434))
  (gr_line (start 92.25 61.75) (end 92.25 78.25) (layer "Eco1.User") (width 0.25) (tstamp 9c65b250-e5f7-405d-923f-c0cae182fca9))
  (gr_line (start 79.75 98.25) (end 79.75 81.75) (layer "Eco1.User") (width 0.25) (tstamp 9c75d523-99b6-4951-b4f2-06437f87ad49))
  (gr_line (start 63.5 97.5) (end 78.5 97.5) (layer "Eco1.User") (width 0.25) (tstamp a2521235-fd04-4537-a8b7-fabc9d2e2081))
  (gr_line (start 82.5 97.5) (end 97.5 97.5) (layer "Eco1.User") (width 0.25) (tstamp a68a2f6b-514d-463d-925b-977136f1832e))
  (gr_line (start 79.75 100.75) (end 62.25 100.75) (layer "Eco1.User") (width 0.25) (tstamp ae4ab255-ae03-4429-8e49-afb6e34af458))
  (gr_line (start 78.5 101.5) (end 63.5 101.5) (layer "Eco1.User") (width 0.25) (tstamp aefe9419-c428-47a2-8f25-a4b9f21d13a4))
  (gr_line (start 71 89) (end 71 91) (layer "Eco1.User") (width 0.25) (tstamp af241642-b1f9-4c94-8dfb-53e2c3c2acd0))
  (gr_line (start 108 109) (end 110 109) (layer "Eco1.User") (width 0.25) (tstamp b86e0e48-7071-4e7d-ba04-f065127ca721))
  (gr_line (start 100.25 100.75) (end 100.25 117.25) (layer "Eco1.User") (width 0.25) (tstamp b9f88da0-733c-46cd-b018-f989e6715bc4))
  (gr_line (start 89 77) (end 89 59) (layer "Eco1.User") (width 0.25) (tstamp ba0dab8c-90c5-4f31-a45b-d4cd373352df))
  (gr_line (start 97.5 116.5) (end 97.5 101.5) (layer "Eco1.User") (width 0.25) (tstamp bbaf45c6-7add-4bdf-89a6-367d820087e7))
  (gr_line (start 108 90) (end 110 90) (layer "Eco1.User") (width 0.25) (tstamp c2bc72c2-75cc-4f32-b9d6-a0de70b916f2))
  (gr_line (start 70 90) (end 72 90) (layer "Eco1.User") (width 0.25) (tstamp c2e0d952-133c-4bba-864c-8adb9ceb446d))
  (gr_line (start 93.5 77.5) (end 108.5 77.5) (layer "Eco1.User") (width 0.25) (tstamp c4cb8561-b307-4c0c-9747-52e558387982))
  (gr_line (start 62.25 98.25) (end 79.75 98.25) (layer "Eco1.User") (width 0.25) (tstamp c5c80015-a62a-478d-bd2a-c70660a1d4f4))
  (gr_line (start 116.5 82.5) (end 101.5 82.5) (layer "Eco1.User") (width 0.25) (tstamp cb72f117-1e1f-4cb5-9d43-21bde5feb011))
  (gr_line (start 81.25 81.75) (end 81.25 98.25) (layer "Eco1.User") (width 0.25) (tstamp cc46a0b7-ca1f-4120-a5e8-be65dbd5bcc6))
  (gr_line (start 79.75 117.25) (end 79.75 100.75) (layer "Eco1.User") (width 0.25) (tstamp d220d004-5b5e-4062-bf2a-bfdc2f5d9e02))
  (gr_line (start 98.75 117.25) (end 98.75 100.75) (layer "Eco1.User") (width 0.25) (tstamp d329ff75-9360-4fc8-993c-77c1dc921022))
  (gr_line (start 109 108) (end 109 110) (layer "Eco1.User") (width 0.25) (tstamp dc00f95b-71d3-42b7-8e10-a7bb42b50eaa))
  (gr_line (start 98.75 100.75) (end 81.25 100.75) (layer "Eco1.User") (width 0.25) (tstamp e001dadd-47cf-48f9-8c96-c26187084f34))
  (gr_line (start 62.25 81.75) (end 62.25 98.25) (layer "Eco1.User") (width 0.25) (tstamp e5408128-86fe-4fbe-b012-df8817593b57))
  (gr_line (start 98.75 98.25) (end 98.75 81.75) (layer "Eco1.User") (width 0.25) (tstamp ee02dcde-dd8a-4346-a171-eed4bfde98cc))
  (gr_line (start 100.25 98.25) (end 117.75 98.25) (layer "Eco1.User") (width 0.25) (tstamp ef6d3adf-5627-46f6-b460-054c9774a941))
  (gr_line (start 75.5 55.25) (end 75.5 62.75) (layer "Eco1.User") (width 0.25) (tstamp f868a947-5781-4c85-9ed5-22faf2f6b667))
  (gr_line (start 109.75 61.75) (end 92.25 61.75) (layer "Eco1.User") (width 0.25) (tstamp fa514070-f477-4aad-b0c6-3b8eca622146))
  (gr_line (start 116.5 116.5) (end 116.5 101.5) (layer "Eco1.User") (width 0.25) (tstamp fdfcb2a7-0159-4260-bd12-340cba348fa3))
  (gr_rect (start 165 80) (end 175 90) (layer "Edge.Cuts") (width 0.1) (fill none) (tstamp 0a8d8bd6-53ac-4001-bc2a-78ce86fe644b))
  (gr_arc (start 140 90) (mid 135 85) (end 140 80) (layer "Edge.Cuts") (width 0.1) (tstamp 0b7ddc7d-b31f-40bc-84a4-dbb6a27870e6))
  (gr_line (start 175 115) (end 175 105) (layer "Edge.Cuts") (width 0.25) (tstamp 0db4a747-b255-442d-ba4d-05d54485e4c6))
  (gr_curve (pts (xy 167.353952 107.663485) (xy 168.334742 106.171102) (xy 169.669483 105.342204) (xy 171.335798 105.049428)) (layer "Edge.Cuts") (width 0.25) (tstamp 11f22cf5-e080-45ff-b2e0-bdcc583e0ac1))
  (gr_arc (start 160 90) (mid 150 100) (end 140 90) (layer "Edge.Cuts") (width 0.1) (tstamp 16e2fe45-6b6f-49de-b250-cd6b92ad01ad))
  (gr_line (start 129.5 77.5) (end 131.5 61.5) (layer "Edge.Cuts") (width 0.1) (tstamp 18096e20-401e-4636-8571-d4d3e3175b55))
  (gr_line (start 183 114) (end 183 64) (layer "Edge.Cuts") (width 0.25) (tstamp 25cff6b2-27f4-4957-aaa1-3a2d40f50f31))
  (gr_line (start 118.5 78.5) (end 129.5 77.5) (layer "Edge.Cuts") (width 0.1) (tstamp 4ae5fcd0-df0f-4dff-a8d1-320cb4cdcd7e))
  (gr_line (start 140 75) (end 135 70) (layer "Edge.Cuts") (width 0.1) (tstamp 53551728-edd0-4ee7-ab3f-3c816e208ca6))
  (gr_curve (pts (xy 159.316285 109.871674) (xy 165.746326 111.311735) (xy 166.373163 109.155867) (xy 167.353952 107.663485)) (layer "Edge.Cuts") (width 0.25) (tstamp 53b5a077-3d5e-4c6d-9680-574a4a95c5e7))
  (gr_line (start 135 70) (end 135 60) (layer "Edge.Cuts") (width 0.1) (tstamp 55c67711-27b6-4524-863a-94dfb2629a6e))
  (gr_line (start 131.5 61.5) (end 121.5 67.5) (layer "Edge.Cuts") (width 0.1) (tstamp 5d1bf213-afd2-4966-ad70-7ccfbc36d7db))
  (gr_line (start 160 85) (end 160 90) (layer "Edge.Cuts") (width 0.1) (tstamp 63a50518-df1b-491c-b768-0c711ebbc1b7))
  (gr_line (start 145 65) (end 155 65) (layer "Edge.Cuts") (width 0.1) (tstamp 6f6ab660-cf30-4f0c-988a-86f0e11da476))
  (gr_line (start 155 65) (end 155 75) (layer "Edge.Cuts") (width 0.1) (tstamp 7b087164-ec5e-4826-a6e6-8fd7ec669d14))
  (gr_line (start 145 60) (end 145 65) (layer "Edge.Cuts") (width 0.1) (tstamp 7c145b05-4a56-4421-a3a0-f5a426c0049e))
  (gr_line (start 155 80) (end 140 80) (layer "Edge.Cuts") (width 0.1) (tstamp 89a3f09b-dce8-4e29-a350-722a395715ab))
  (gr_arc (start 183 114) (mid 180.656854 119.656854) (end 175 122) (layer "Edge.Cuts") (width 0.25) (tstamp 8ad186f2-7228-4dcd-8d28-6b7df60b6a9d))
  (gr_circle (center 134.646048 108.336515) (end 144.646048 108.336515) (layer "Edge.Cuts") (width 0.1) (fill none) (tstamp 8dca186d-b45c-4208-9dbf-d1b26b6068e8))
  (gr_poly
    (pts
      (xy 176 64)
      (xy 176 71)
      (xy 170 75)
      (xy 160 70)
      (xy 160 63)
      (xy 167 59)
    ) (layer "Edge.Cuts") (width 0.1) (fill none) (tstamp 929de0df-4994-4306-a770-2eb840028ee3))
  (gr_arc (start 56 64) (mid 58.343146 58.343146) (end 64 56) (layer "Edge.Cuts") (width 0.25) (tstamp 9586a667-1410-47d6-980c-4c022d93cf71))
  (gr_line (start 64 122) (end 175 122) (layer "Edge.Cuts") (width 0.25) (tstamp 96c7fc24-efea-47e2-a687-e44e00c633ea))
  (gr_curve (pts (xy 171.335798 105.049428) (xy 173.002112 104.756653) (xy 175 105) (xy 175 105)) (layer "Edge.Cuts") (width 0.25) (tstamp 9b7ce56f-b162-4d3d-b4bb-f8e7c5eb1779))
  (gr_arc (start 155 80) (mid 158.535534 81.464466) (end 160 85) (layer "Edge.Cuts") (width 0.1) (tstamp ac109389-39a7-4a79-8412-4efd7e46b852))
  (gr_arc (start 175 56) (mid 180.656854 58.343146) (end 183 64) (layer "Edge.Cuts") (width 0.25) (tstamp b72d5453-c6b2-45cb-a4f1-640a687bca5b))
  (gr_line (start 155 115) (end 175 115) (layer "Edge.Cuts") (width 0.25) (tstamp b8c5ca27-a9ed-4319-854e-2719e6d7f086))
  (gr_line (start 175 56) (end 64 56) (layer "Edge.Cuts") (width 0.25) (tstamp bbb02581-679c-447a-87d6-f70a06b11c90))
  (gr_line (start 159.316285 109.871674) (end 155 115) (layer "Edge.Cuts") (width 0.25) (tstamp bd41eb1c-e6db-4bb3-8137-f9866b431725))
  (gr_line (start 135 60) (end 145 60) (layer "Edge.Cuts") (width 0.1) (tstamp be890fe9-ee15-4473-97c9-285eecc29e7b))
  (gr_line (start 155 75) (end 140 75) (layer "Edge.Cuts") (width 0.1) (tstamp c2bdf8a6-f556-4094-ade6-563e5844edb6))
  (gr_arc (start 64 122) (mid 58.343146 119.656854) (end 56 114) (layer "Edge.Cuts") (width 0.25) (tstamp ce729fdf-92a1-4de0-8593-079f0a63a76e))
  (gr_line (start 121.5 67.5) (end 118.5 78.5) (layer "Edge.Cuts") (width 0.1) (tstamp e56669c3-afc7-4b89-b65d-6843b1bd5bde))
  (gr_line (start 56 64) (end 56 114) (layer "Edge.Cuts") (width 0.25) (tstamp fdbf2a78-2fe7-4112-891f-99bb1e4b2013))
  (gr_text "KeyDrip7" (at 103 115) (layer "B.SilkS") (tstamp 658e5567-30d7-4ef6-83e8-2915f4ffd457)
    (effects (font (size 3 3) (thickness 0.3)) (justify mirror))
  )
  (gr_text "Quick trial board for Kermite" (at 99 119) (layer "B.SilkS") (tstamp a236279b-8302-4394-9684-68d94cb0f4fc)
    (effects (font (size 1.2 1.2) (thickness 0.2)) (justify mirror))
  )
  (gr_text "JLCJLCJLCJLC" (at 72 119) (layer "B.SilkS") (tstamp a470eaf9-2977-4b0d-9975-14fd1763c0c3)
    (effects (font (size 1 1) (thickness 0.2)) (justify mirror))
  )

  (segment (start 107 72.5) (end 94.5 72.5) (width 0.3) (layer "B.Cu") (net 1) (tstamp 30d11468-6f1d-4cfd-bff9-2ea321ab6d27))
  (segment (start 109.3 70.2) (end 107 72.5) (width 0.3) (layer "B.Cu") (net 1) (tstamp 421cc337-a33d-4164-9e09-6416d1844504))
  (segment (start 90 68) (end 87.62 68) (width 0.3) (layer "B.Cu") (net 1) (tstamp 89ef2cf4-3c2b-4e54-9380-81eda086a887))
  (segment (start 94.5 72.5) (end 90 68) (width 0.3) (layer "B.Cu") (net 1) (tstamp bd9e83af-4e58-4755-bec4-2e169ab3f559))
  (segment (start 109.3 66.3) (end 109.3 70.2) (width 0.3) (layer "B.Cu") (net 1) (tstamp f591cbbb-6a17-4c61-aa09-8b7a309f6857))
  (segment (start 81 79) (end 79.3 80.7) (width 0.3) (layer "B.Cu") (net 3) (tstamp 0a49eeea-40b6-4e8b-b576-a89ee32045b3))
  (segment (start 81 67.5) (end 81 79) (width 0.3) (layer "B.Cu") (net 3) (tstamp 127046a9-78ef-473f-baf1-6c8b45f448be))
  (segment (start 72.38 65.46) (end 78.96 65.46) (width 0.3) (layer "B.Cu") (net 3) (tstamp 1ae1549c-c8bf-4bdc-b85c-d850751ccbd4))
  (segment (start 78.96 65.46) (end 81 67.5) (width 0.3) (layer "B.Cu") (net 3) (tstamp 29520da6-28dc-45ba-a269-3a84772ed1e7))
  (segment (start 79.3 80.7) (end 79.3 86.3) (width 0.3) (layer "B.Cu") (net 3) (tstamp efd14b1e-b3dc-40c0-a16f-db01f7314754))
  (segment (start 82 76.5) (end 84.5 79) (width 0.3) (layer "B.Cu") (net 4) (tstamp 017e619c-7bad-4037-8c55-335e8e80b638))
  (segment (start 98.3 81.8) (end 98.3 86.3) (width 0.3) (layer "B.Cu") (net 4) (tstamp 147a7313-20b5-4311-9f3f-576acd12aee5))
  (segment (start 84.5 79) (end 95.5 79) (width 0.3) (layer "B.Cu") (net 4) (tstamp 25d63473-cc08-4e97-87e7-8d27c94ba2b9))
  (segment (start 79.92 62.92) (end 82 65) (width 0.3) (layer "B.Cu") (net 4) (tstamp 856eb179-b272-47a7-a438-12e548d546b5))
  (segment (start 82 65) (end 82 76.5) (width 0.3) (layer "B.Cu") (net 4) (tstamp 97f0ea54-003a-43b2-8f50-9232d9546fa0))
  (segment (start 72.38 62.92) (end 79.92 62.92) (width 0.3) (layer "B.Cu") (net 4) (tstamp 9cc2a945-739c-4d28-b9df-14ce7fafb84e))
  (segment (start 95.5 79) (end 98.3 81.8) (width 0.3) (layer "B.Cu") (net 4) (tstamp cf5a7d53-2af3-43e8-9fec-ff709ad17d67))
  (segment (start 83 76) (end 83 62.5) (width 0.3) (layer "B.Cu") (net 5) (tstamp 13d4558e-d5aa-47b2-965d-f1a0bc1ac3ab))
  (segment (start 117.3 81.8) (end 113.5 78) (width 0.3) (layer "B.Cu") (net 5) (tstamp 1e4e23ef-9134-46bc-975d-4427696b1548))
  (segment (start 72.38 60.38) (end 80.88 60.38) (width 0.3) (layer "B.Cu") (net 5) (tstamp 365fbc57-2f04-4cce-8e23-d99b4742307a))
  (segment (start 85 78) (end 83 76) (width 0.3) (layer "B.Cu") (net 5) (tstamp 46d54881-0138-4b05-969e-4306e1f8a5b5))
  (segment (start 117.3 86.3) (end 117.3 81.8) (width 0.3) (layer "B.Cu") (net 5) (tstamp be196fcb-e196-4bcf-9503-ef0b1e4d28d5))
  (segment (start 80.88 60.38) (end 83 62.5) (width 0.3) (layer "B.Cu") (net 5) (tstamp f92bf4eb-5adf-4f7d-ade6-fdd37b827d71))
  (segment (start 113.5 78) (end 85 78) (width 0.3) (layer "B.Cu") (net 5) (tstamp ffd6ee32-7875-444c-b036-ab69c2f58fa6))
  (segment (start 77 97.5) (end 65 97.5) (width 0.3) (layer "B.Cu") (net 6) (tstamp 06618d1a-63ff-406d-87fa-3855e6c20c43))
  (segment (start 79.3 99.8) (end 77 97.5) (width 0.3) (layer "B.Cu") (net 6) (tstamp 0deb387f-1b28-40b8-a90f-423e0d4e0809))
  (segment (start 71.38 68) (end 72.38 68) (width 0.3) (layer "B.Cu") (net 6) (tstamp 28edb826-5067-4f19-85ba-e811c1bd0921))
  (segment (start 79.3 105.3) (end 79.3 99.8) (width 0.3) (layer "B.Cu") (net 6) (tstamp 4a559161-2e7e-4923-9c27-d3825233584c))
  (segment (start 65 97.5) (end 61.5 94) (width 0.3) (layer "B.Cu") (net 6) (tstamp 4fc29986-e6b3-4b14-acb3-4718e093258a))
  (segment (start 61.5 94) (end 61.5 77.88) (width 0.3) (layer "B.Cu") (net 6) (tstamp c29d9ac8-2291-4eae-a370-a1b0c2a2da4a))
  (segment (start 61.5 77.88) (end 71.38 68) (width 0.3) (layer "B.Cu") (net 6) (tstamp c8dac28e-6ac2-4c57-890c-2d6115c4693c))
  (segment (start 98.3 99.8) (end 95 96.5) (width 0.3) (layer "B.Cu") (net 7) (tstamp 317de74e-fbd1-44cc-9350-eeac8f5e9dd8))
  (segment (start 62.5 93.5) (end 62.5 79.42) (width 0.3) (layer "B.Cu") (net 7) (tstamp 5a0a238d-802a-496e-b583-5489fc4a3faf))
  (segment (start 62.5 79.42) (end 71.38 70.54) (width 0.3) (layer "B.Cu") (net 7) (tstamp 6fb9abf4-97e4-4645-82c4-4bd40ecc22f3))
  (segment (start 71.38 70.54) (end 72.38 70.54) (width 0.3) (layer "B.Cu") (net 7) (tstamp 860e8c66-ed73-458c-97a3-2ea54ae0a9c2))
  (segment (start 95 96.5) (end 65.5 96.5) (width 0.3) (layer "B.Cu") (net 7) (tstamp a4603508-394c-444c-b9d8-dc0f33e07252))
  (segment (start 98.3 105.3) (end 98.3 99.8) (width 0.3) (layer "B.Cu") (net 7) (tstamp ab41bb89-5fa8-41a9-a1cc-63d6966eb9a4))
  (segment (start 65.5 96.5) (end 62.5 93.5) (width 0.3) (layer "B.Cu") (net 7) (tstamp facd4f4d-bcff-492e-a1e9-f95d3ba9d53e))
  (segment (start 66 95.5) (end 63.5 93) (width 0.3) (layer "B.Cu") (net 8) (tstamp 16f50b0e-653b-4ecc-8ce8-67954e480466))
  (segment (start 117.3 105.3) (end 117.3 99.3) (width 0.3) (layer "B.Cu") (net 8) (tstamp 43514a91-7e49-476e-91d8-840fa1935fcc))
  (segment (start 71.38 73.08) (end 72.38 73.08) (width 0.3) (layer "B.Cu") (net 8) (tstamp 6d5a2c05-4047-46c5-ba7d-0f029e33fb15))
  (segment (start 63.5 80.96) (end 71.38 73.08) (width 0.3) (layer "B.Cu") (net 8) (tstamp 799e8f60-cde9-4b43-866d-916842833c99))
  (segment (start 63.5 93) (end 63.5 80.96) (width 0.3) (layer "B.Cu") (net 8) (tstamp c6a892c0-81a1-4e38-9ac6-d653de90c3d4))
  (segment (start 117.3 99.3) (end 113.5 95.5) (width 0.3) (layer "B.Cu") (net 8) (tstamp e6a0c203-0973-4269-92b9-b7a37fb9124c))
  (segment (start 113.5 95.5) (end 66 95.5) (width 0.3) (layer "B.Cu") (net 8) (tstamp f362f7af-4a8c-48dc-b859-fe7876c1847a))

  (zone (net 2) (net_name "GND") (layer "F.Cu") (tstamp e7bfb4ea-4ad2-478a-9551-ddb2d9a4c0d2) (hatch edge 0.508)
    (connect_pads (clearance 0.508))
    (min_thickness 0.254) (filled_areas_thickness no)
    (fill (thermal_gap 0.508) (thermal_bridge_width 0.508))
    (polygon
      (pts
        (xy 188 126)
        (xy 53 126)
        (xy 53 53)
        (xy 188 53)
      )
    )
  )
  (zone (net 2) (net_name "GND") (layer "B.Cu") (tstamp 0f5e2d74-bd24-4b39-b204-0c5f4f137831) (hatch edge 0.508)
    (connect_pads (clearance 0.508))
    (min_thickness 0.254) (filled_areas_thickness no)
    (fill (thermal_gap 0.508) (thermal_bridge_width 0.508))
    (polygon
      (pts
        (xy 186 125)
        (xy 52 125)
        (xy 52 52)
        (xy 186 52)
      )
    )
  )
  (group "" (id 95521181-3b14-45a2-b526-ba3225ce3df5)
    (members
      0db4a747-b255-442d-ba4d-05d54485e4c6
      11f22cf5-e080-45ff-b2e0-bdcc583e0ac1
      53b5a077-3d5e-4c6d-9680-574a4a95c5e7
      9b7ce56f-b162-4d3d-b4bb-f8e7c5eb1779
      b8c5ca27-a9ed-4319-854e-2719e6d7f086
      bd41eb1c-e6db-4bb3-8137-f9866b431725
    )
  )
  (group "" (id 961dc6d6-60ee-40b5-8b94-a391f5541fdd)
    (members
      0336e61a-f2bb-41af-9905-bfc534a31e87
      066c7b9e-3d35-47e1-940d-0c6dda8755f8
      0ab2f29e-f633-4eda-b8e4-8f907ca60e88
      0f77db64-49ce-4ce7-8c07-5e31ea9cae4e
      136705fb-c0a6-4a36-a672-5ebce80ebeb8
      138b47fd-cb85-4545-8f59-ce24ca7d61e0
      16787596-b54e-40ab-9802-1c1a9cda9bbb
      1939b3c7-1f1f-482a-916e-0952f74cf170
      1b416fe2-08c7-4a32-a55a-86a217a7342d
      1f6fae7d-b202-4906-9fa0-47f5fe191cf6
      25fff06d-4a05-4112-a63e-7067993670f7
      264f964a-1324-4cfa-ac5c-5074230326d3
      26722522-aefc-46d8-9892-092c672cecc2
      28dc68c0-413e-4cf7-b709-0aeea3627cfb
      2b29d1ef-7dbb-4b72-a0be-53ba9db28754
      2b51e30c-6174-44a7-947b-2b142ddd5b74
      2cc2f750-8176-4bf9-aa04-31d8be356ce6
      30b24746-144d-42e3-8df8-df03714741aa
      334ea2f4-62fe-49cc-9f1e-767e3ed40505
      346d341f-2e69-444c-a9f3-390199bef53d
      3ac482c7-92eb-48df-a6af-aafa25d96212
      3be2c22b-d929-4c31-a603-0fc0292f5a13
      3d111cd6-721c-435b-8398-5c3737e2c016
      3ebb2471-e58e-48c8-bd97-05a0313e874d
      4786de45-e123-4647-8886-46a1766320bc
      499ee4cf-c539-42cf-ae33-b9ab273dd6f9
      4c46366f-55f2-46f0-87ca-d2cbc135b1bd
      4ce03e7c-ea90-4388-8e2c-5d383b6767ef
      5087eaa2-9e4b-48ee-958e-fa778ec4336f
      52943e25-a830-4057-bc2a-9c72a1109c07
      5a81fbe3-b1ba-4bc0-87f5-0ec59656e1a7
      5bdd52e7-1ab8-4309-a04b-6f3d17b3a7ed
      5cad8245-0d68-483d-88b5-453bbd41bcea
      62f25e20-9774-4016-8fdf-318973027397
      64f8683b-ab58-4158-bc5d-ec6576c0f333
      652cb69d-71ea-41d0-bd23-5f5c71fb3264
      668c2930-ce67-4eba-a204-cdd743ea7275
      690e6026-7ef4-4af7-a6bb-5755b1c0a94b
      693b7933-5f55-4374-848f-311aa5c064f9
      6d92fd32-d4c7-432c-86e1-005e1b20dae4
      7c563f81-a567-494e-81fe-f56c9d160244
      7ce00510-74a0-4927-a723-e7f3f4734a7e
      7fcd9c6e-acc7-4ae9-b273-8cc44c938b49
      80ef933b-667e-49cf-9f66-067bf3f909cf
      81a35367-3521-4259-9ecb-384c6dbf008e
      83a3f552-1e5c-4b1c-a1a2-7875fa65153b
      849ca6d5-3b02-4d39-aec8-25a1ba3ead35
      89a9c4a6-ae5f-431a-978e-b76381c068cf
      8d1ac7e0-0f44-4030-a9e2-076af253f08c
      90f4901e-3d42-400a-90cb-b7a0b770f101
      91a8e894-b4d8-4299-91a2-44a2e9243a48
      966fd471-47aa-4ad8-96a0-da7e581389ba
      99b263dc-33e2-44fe-90e4-c0a11122b415
      9ad52624-6e22-45bd-8f48-2537a2253099
      9bf90b30-29a3-4ab0-be3c-7322f9cc0434
      9c65b250-e5f7-405d-923f-c0cae182fca9
      9c75d523-99b6-4951-b4f2-06437f87ad49
      a2521235-fd04-4537-a8b7-fabc9d2e2081
      a68a2f6b-514d-463d-925b-977136f1832e
      ae4ab255-ae03-4429-8e49-afb6e34af458
      aefe9419-c428-47a2-8f25-a4b9f21d13a4
      af241642-b1f9-4c94-8dfb-53e2c3c2acd0
      b86e0e48-7071-4e7d-ba04-f065127ca721
      b9f88da0-733c-46cd-b018-f989e6715bc4
      ba0dab8c-90c5-4f31-a45b-d4cd373352df
      bbaf45c6-7add-4bdf-89a6-367d820087e7
      c2bc72c2-75cc-4f32-b9d6-a0de70b916f2
      c2e0d952-133c-4bba-864c-8adb9ceb446d
      c4cb8561-b307-4c0c-9747-52e558387982
      c5c80015-a62a-478d-bd2a-c70660a1d4f4
      cb72f117-1e1f-4cb5-9d43-21bde5feb011
      cc46a0b7-ca1f-4120-a5e8-be65dbd5bcc6
      d220d004-5b5e-4062-bf2a-bfdc2f5d9e02
      d329ff75-9360-4fc8-993c-77c1dc921022
      dc00f95b-71d3-42b7-8e10-a7bb42b50eaa
      e001dadd-47cf-48f9-8c96-c26187084f34
      e5408128-86fe-4fbe-b012-df8817593b57
      ee02dcde-dd8a-4346-a171-eed4bfde98cc
      ef6d3adf-5627-46f6-b460-054c9774a941
      f868a947-5781-4c85-9ed5-22faf2f6b667
      fa514070-f477-4aad-b0c6-3b8eca622146
      fdfcb2a7-0159-4260-bd12-340cba348fa3
    )
  )
  (group "" (id d9054027-137e-488b-952e-16e66c8a7b23)
    (members
      2519586c-8085-4fb6-aee4-20d8cd1d2d5e
      89669163-72d8-46f0-be3a-691de782e3c8
      9c5a2585-27f5-44e3-9870-a2d0ca2b316b
      a2e6eaa7-6819-4725-b1ba-dd4cdce74ed2
    )
  )
)
`;

export const kicadPcbTestData_sp2104 = `
(kicad_pcb (version 20171130) (host pcbnew "(5.1.9-0-10_14)")

  (general
    (thickness 1.6)
    (drawings 142)
    (tracks 657)
    (zones 0)
    (modules 79)
    (nets 52)
  )

  (page A4)
  (layers
    (0 F.Cu signal)
    (31 B.Cu signal)
    (32 B.Adhes user)
    (33 F.Adhes user)
    (34 B.Paste user)
    (35 F.Paste user)
    (36 B.SilkS user)
    (37 F.SilkS user)
    (38 B.Mask user)
    (39 F.Mask user)
    (40 Dwgs.User user)
    (41 Cmts.User user)
    (42 Eco1.User user)
    (43 Eco2.User user)
    (44 Edge.Cuts user)
    (45 Margin user)
    (46 B.CrtYd user)
    (47 F.CrtYd user)
    (48 B.Fab user)
    (49 F.Fab user)
  )

  (setup
    (last_trace_width 0.25)
    (trace_clearance 0.2)
    (zone_clearance 1)
    (zone_45_only no)
    (trace_min 0.2)
    (via_size 0.8)
    (via_drill 0.4)
    (via_min_size 0.4)
    (via_min_drill 0.3)
    (uvia_size 0.3)
    (uvia_drill 0.1)
    (uvias_allowed no)
    (uvia_min_size 0.2)
    (uvia_min_drill 0.1)
    (edge_width 0.1)
    (segment_width 0.2)
    (pcb_text_width 0.3)
    (pcb_text_size 1.5 1.5)
    (mod_edge_width 0.15)
    (mod_text_size 1 1)
    (mod_text_width 0.15)
    (pad_size 1.524 1.524)
    (pad_drill 0.762)
    (pad_to_mask_clearance 0)
    (aux_axis_origin 0 0)
    (visible_elements FFFFFF7F)
    (pcbplotparams
      (layerselection 0x010fc_ffffffff)
      (usegerberextensions false)
      (usegerberattributes false)
      (usegerberadvancedattributes false)
      (creategerberjobfile false)
      (excludeedgelayer true)
      (linewidth 0.100000)
      (plotframeref false)
      (viasonmask false)
      (mode 1)
      (useauxorigin false)
      (hpglpennumber 1)
      (hpglpenspeed 20)
      (hpglpendiameter 15.000000)
      (psnegative false)
      (psa4output false)
      (plotreference true)
      (plotvalue true)
      (plotinvisibletext false)
      (padsonsilk false)
      (subtractmaskfromsilk false)
      (outputformat 1)
      (mirror false)
      (drillshape 0)
      (scaleselection 1)
      (outputdirectory "out/"))
  )

  (net 0 "")
  (net 1 "Net-(D1-Pad2)")
  (net 2 row0)
  (net 3 "Net-(D2-Pad2)")
  (net 4 "Net-(D3-Pad2)")
  (net 5 "Net-(D4-Pad2)")
  (net 6 "Net-(D5-Pad2)")
  (net 7 "Net-(D6-Pad2)")
  (net 8 "Net-(D7-Pad2)")
  (net 9 "Net-(D8-Pad2)")
  (net 10 row1)
  (net 11 "Net-(D9-Pad2)")
  (net 12 "Net-(D10-Pad2)")
  (net 13 "Net-(D11-Pad2)")
  (net 14 "Net-(D12-Pad2)")
  (net 15 "Net-(D13-Pad2)")
  (net 16 "Net-(D14-Pad2)")
  (net 17 "Net-(D15-Pad2)")
  (net 18 "Net-(D16-Pad2)")
  (net 19 row2)
  (net 20 "Net-(D17-Pad2)")
  (net 21 "Net-(D18-Pad2)")
  (net 22 "Net-(D19-Pad2)")
  (net 23 "Net-(D20-Pad2)")
  (net 24 "Net-(D21-Pad2)")
  (net 25 "Net-(D22-Pad2)")
  (net 26 "Net-(D23-Pad2)")
  (net 27 "Net-(D24-Pad2)")
  (net 28 row3)
  (net 29 "Net-(D25-Pad2)")
  (net 30 "Net-(D26-Pad2)")
  (net 31 "Net-(D27-Pad2)")
  (net 32 "Net-(D28-Pad2)")
  (net 33 VDD)
  (net 34 data)
  (net 35 GND)
  (net 36 debug_tx_led)
  (net 37 col0)
  (net 38 col1)
  (net 39 col2)
  (net 40 col3)
  (net 41 col4)
  (net 42 col5)
  (net 43 col6)
  (net 44 reset_sw)
  (net 45 "Net-(U1-Pad24)")
  (net 46 "Net-(J1-Pad1)")
  (net 47 i2c_sda)
  (net 48 uart1_tx)
  (net 49 i2c_scl)
  (net 50 uart1_rx)
  (net 51 ex1)

  (net_class Default "これはデフォルトのネット クラスです。"
    (clearance 0.2)
    (trace_width 0.25)
    (via_dia 0.8)
    (via_drill 0.4)
    (uvia_dia 0.3)
    (uvia_drill 0.1)
    (add_net GND)
    (add_net "Net-(D1-Pad2)")
    (add_net "Net-(D10-Pad2)")
    (add_net "Net-(D11-Pad2)")
    (add_net "Net-(D12-Pad2)")
    (add_net "Net-(D13-Pad2)")
    (add_net "Net-(D14-Pad2)")
    (add_net "Net-(D15-Pad2)")
    (add_net "Net-(D16-Pad2)")
    (add_net "Net-(D17-Pad2)")
    (add_net "Net-(D18-Pad2)")
    (add_net "Net-(D19-Pad2)")
    (add_net "Net-(D2-Pad2)")
    (add_net "Net-(D20-Pad2)")
    (add_net "Net-(D21-Pad2)")
    (add_net "Net-(D22-Pad2)")
    (add_net "Net-(D23-Pad2)")
    (add_net "Net-(D24-Pad2)")
    (add_net "Net-(D25-Pad2)")
    (add_net "Net-(D26-Pad2)")
    (add_net "Net-(D27-Pad2)")
    (add_net "Net-(D28-Pad2)")
    (add_net "Net-(D3-Pad2)")
    (add_net "Net-(D4-Pad2)")
    (add_net "Net-(D5-Pad2)")
    (add_net "Net-(D6-Pad2)")
    (add_net "Net-(D7-Pad2)")
    (add_net "Net-(D8-Pad2)")
    (add_net "Net-(D9-Pad2)")
    (add_net "Net-(J1-Pad1)")
    (add_net "Net-(U1-Pad24)")
    (add_net VDD)
    (add_net col0)
    (add_net col1)
    (add_net col2)
    (add_net col3)
    (add_net col4)
    (add_net col5)
    (add_net col6)
    (add_net data)
    (add_net debug_tx_led)
    (add_net ex1)
    (add_net i2c_scl)
    (add_net i2c_sda)
    (add_net reset_sw)
    (add_net row0)
    (add_net row1)
    (add_net row2)
    (add_net row3)
    (add_net uart1_rx)
    (add_net uart1_tx)
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BEEB)
    (at 154 73)
    (path /5F6B2760)
    (fp_text reference KEY28 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 32 "Net-(D28-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 43 col6))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 32 "Net-(D28-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 43 col6))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BECD)
    (at 135 73)
    (path /5DED0093)
    (fp_text reference KEY27 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 31 "Net-(D27-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 42 col5))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 31 "Net-(D27-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 42 col5))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BEAF)
    (at 116 73)
    (path /5DED0099)
    (fp_text reference KEY26 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 30 "Net-(D26-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 41 col4))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 30 "Net-(D26-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 41 col4))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BE91)
    (at 97 73)
    (path /5DED009F)
    (fp_text reference KEY25 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 29 "Net-(D25-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 40 col3))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 29 "Net-(D25-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 40 col3))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BE73)
    (at 78 73)
    (path /5DED00A5)
    (fp_text reference KEY24 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 27 "Net-(D24-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 39 col2))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 27 "Net-(D24-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 39 col2))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BE55)
    (at 59 73)
    (path /5DED00AB)
    (fp_text reference KEY23 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 26 "Net-(D23-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 38 col1))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 26 "Net-(D23-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 38 col1))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BE37)
    (at 40 73)
    (path /5DED00B1)
    (fp_text reference KEY22 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 25 "Net-(D22-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 37 col0))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 25 "Net-(D22-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 37 col0))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BE19)
    (at 154 52)
    (path /5F6B276D)
    (fp_text reference KEY21 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 24 "Net-(D21-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 43 col6))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 24 "Net-(D21-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 43 col6))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BDFB)
    (at 135 52)
    (path /5DECB052)
    (fp_text reference KEY20 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 23 "Net-(D20-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 42 col5))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 23 "Net-(D20-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 42 col5))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BDDD)
    (at 116 52)
    (path /5DECB058)
    (fp_text reference KEY19 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 22 "Net-(D19-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 41 col4))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 22 "Net-(D19-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 41 col4))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BDBF)
    (at 97 52)
    (path /5DECB05E)
    (fp_text reference KEY18 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 21 "Net-(D18-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 40 col3))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 21 "Net-(D18-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 40 col3))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BDA1)
    (at 78 52)
    (path /5DECB064)
    (fp_text reference KEY17 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 20 "Net-(D17-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 39 col2))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 20 "Net-(D17-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 39 col2))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BD83)
    (at 59 52)
    (path /5DECB06A)
    (fp_text reference KEY16 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 18 "Net-(D16-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 38 col1))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 18 "Net-(D16-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 38 col1))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BD65)
    (at 40 52)
    (path /5DECB070)
    (fp_text reference KEY15 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 17 "Net-(D15-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 37 col0))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 17 "Net-(D15-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 37 col0))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BD47)
    (at 154 34)
    (path /5F6B277A)
    (fp_text reference KEY14 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 16 "Net-(D14-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 43 col6))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 16 "Net-(D14-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 43 col6))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BD29)
    (at 135 34)
    (path /5DEC97D9)
    (fp_text reference KEY13 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 15 "Net-(D13-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 42 col5))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 15 "Net-(D13-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 42 col5))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BD0B)
    (at 116 34)
    (path /5DEC97DF)
    (fp_text reference KEY12 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 14 "Net-(D12-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 41 col4))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 14 "Net-(D12-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 41 col4))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BCED)
    (at 97 34)
    (path /5DEC97E5)
    (fp_text reference KEY11 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 13 "Net-(D11-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 40 col3))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 13 "Net-(D11-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 40 col3))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BCCF)
    (at 78 34)
    (path /5DEC97EB)
    (fp_text reference KEY10 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 12 "Net-(D10-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 39 col2))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 12 "Net-(D10-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 39 col2))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BCB1)
    (at 59 34)
    (path /5DEC97F1)
    (fp_text reference KEY9 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 11 "Net-(D9-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 38 col1))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 11 "Net-(D9-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 38 col1))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BC93)
    (at 40 34)
    (path /5DEC97F7)
    (fp_text reference KEY8 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 9 "Net-(D8-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 37 col0))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 9 "Net-(D8-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 37 col0))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BC75)
    (at 154 16)
    (path /5F6B2787)
    (fp_text reference KEY7 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 8 "Net-(D7-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 43 col6))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 8 "Net-(D7-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 43 col6))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BC57)
    (at 135 16)
    (path /5DEB28FF)
    (fp_text reference KEY6 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 7 "Net-(D6-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 42 col5))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 7 "Net-(D6-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 42 col5))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BC39)
    (at 116 16)
    (path /5DEB47D9)
    (fp_text reference KEY5 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 6 "Net-(D5-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 41 col4))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 6 "Net-(D5-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 41 col4))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BC1B)
    (at 97 16)
    (path /5DEB4874)
    (fp_text reference KEY4 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 5 "Net-(D4-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 40 col3))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 5 "Net-(D4-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 40 col3))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BBFD)
    (at 78 16)
    (path /5DEB4A23)
    (fp_text reference KEY3 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 4 "Net-(D3-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 39 col2))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 4 "Net-(D3-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 39 col2))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BBDF)
    (at 59 16)
    (path /5DEB4B31)
    (fp_text reference KEY2 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 3 "Net-(D2-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 38 col1))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 3 "Net-(D2-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 38 col1))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:choc_socket_0414 (layer F.Cu) (tedit 6076B7FB) (tstamp 6074BBC1)
    (at 40 16)
    (path /5DEB4D64)
    (fp_text reference KEY1 (at 0 9) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -9) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_arc (start -0.3 1.3) (end -0.2 3.57) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_arc (start -3.6 7.35) (end -3.5 6.03) (angle 90) (layer B.SilkS) (width 0.15))
    (fp_line (start 8.5 8) (end 8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 8) (end 8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start -8.5 -8) (end -8.5 8) (layer F.Fab) (width 0.15))
    (fp_line (start 8.5 -8) (end -8.5 -8) (layer F.Fab) (width 0.15))
    (fp_line (start -7 7) (end -7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 7) (end -7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start 7 -7) (end 7 7) (layer Eco2.User) (width 0.15))
    (fp_line (start -7 -7) (end 7 -7) (layer Eco2.User) (width 0.15))
    (fp_line (start 2.275 8.225) (end -2.275 8.225) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.275 3.575) (end -0.275 3.575) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.575 1.375) (end -7.275 1.375) (layer B.SilkS) (width 0.15))
    (fp_line (start -3.5 6.025) (end -7.275 6.025) (layer B.SilkS) (width 0.15))
    (fp_line (start 2.3 3.6) (end 2.3 8.2) (layer B.SilkS) (width 0.15))
    (fp_line (start -7.275 1.4) (end -7.275 6) (layer B.SilkS) (width 0.15))
    (fp_line (start -2.28 7.5) (end -2.28 8.2) (layer B.SilkS) (width 0.15))
    (pad "" thru_hole oval (at -5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at -3.2 5.9) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 1 "Net-(D1-Pad2)"))
    (pad 1 thru_hole rect (at 8.2 3.7) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 37 col0))
    (pad "" thru_hole oval (at 5 -5.15) (size 2.4 1.6) (drill oval 1.2 0.6) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at -5.5 0 90) (size 2.4 2.4) (drill 1.8) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 0 90) (size 5.8 5.8) (drill 5) (layers *.Cu *.Mask))
    (pad "" np_thru_hole circle (at 0 5.9 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
    (pad 2 thru_hole rect (at 3.2 5.9 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 1 "Net-(D1-Pad2)"))
    (pad 1 thru_hole rect (at -8.2 3.7 180) (size 2 3) (drill 0.3) (layers *.Cu *.Mask)
      (net 37 col0))
    (pad "" np_thru_hole circle (at 5 3.7 90) (size 3.2 3.2) (drill 2.95) (layers *.Cu *.Mask))
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B7EF)
    (at 48 12.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEBD7AD)
    (attr smd)
    (fp_text reference D1 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 1 "Net-(D1-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 2 row0))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B809)
    (at 67 12.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEBD400)
    (attr smd)
    (fp_text reference D2 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 3 "Net-(D2-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 2 row0))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B823)
    (at 86 12.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEBD099)
    (attr smd)
    (fp_text reference D3 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 4 "Net-(D3-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 2 row0))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B83D)
    (at 105 12.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEBCCCE)
    (attr smd)
    (fp_text reference D4 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 5 "Net-(D4-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 2 row0))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B857)
    (at 124 12.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEBC7DC)
    (attr smd)
    (fp_text reference D5 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 6 "Net-(D5-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 2 row0))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B871)
    (at 143 12.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEB5E22)
    (attr smd)
    (fp_text reference D6 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 7 "Net-(D6-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 2 row0))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B88B)
    (at 162 12.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5F6B2781)
    (attr smd)
    (fp_text reference D7 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 8 "Net-(D7-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 2 row0))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B8A5)
    (at 48 30.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEC981C)
    (attr smd)
    (fp_text reference D8 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 9 "Net-(D8-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 10 row1))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B8BF)
    (at 67 30.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEC9816)
    (attr smd)
    (fp_text reference D9 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 11 "Net-(D9-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 10 row1))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B8D9)
    (at 86 30.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEC9810)
    (attr smd)
    (fp_text reference D10 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 12 "Net-(D10-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 10 row1))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B8F3)
    (at 105 30.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEC980A)
    (attr smd)
    (fp_text reference D11 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 13 "Net-(D11-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 10 row1))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B90D)
    (at 124 30.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEC9804)
    (attr smd)
    (fp_text reference D12 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 14 "Net-(D12-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 10 row1))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B927)
    (at 143 30.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DEC97FD)
    (attr smd)
    (fp_text reference D13 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 15 "Net-(D13-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 10 row1))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B941)
    (at 162 30.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5F6B2774)
    (attr smd)
    (fp_text reference D14 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 16 "Net-(D14-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 10 row1))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B95B)
    (at 48 48.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DECB095)
    (attr smd)
    (fp_text reference D15 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 17 "Net-(D15-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 19 row2))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B975)
    (at 67 48.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DECB08F)
    (attr smd)
    (fp_text reference D16 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 18 "Net-(D16-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 19 row2))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B98F)
    (at 86 48.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DECB089)
    (attr smd)
    (fp_text reference D17 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 20 "Net-(D17-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 19 row2))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B9A9)
    (at 105 48.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DECB083)
    (attr smd)
    (fp_text reference D18 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 21 "Net-(D18-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 19 row2))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B9C3)
    (at 124 48.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DECB07D)
    (attr smd)
    (fp_text reference D19 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 22 "Net-(D19-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 19 row2))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B9DD)
    (at 143 48.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DECB076)
    (attr smd)
    (fp_text reference D20 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 23 "Net-(D20-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 19 row2))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074B9F7)
    (at 162 48.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5F6B2767)
    (attr smd)
    (fp_text reference D21 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 24 "Net-(D21-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 19 row2))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074BA11)
    (at 48 69.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DED00D6)
    (attr smd)
    (fp_text reference D22 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 25 "Net-(D22-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 28 row3))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074BA2B)
    (at 67 69.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DED00D0)
    (attr smd)
    (fp_text reference D23 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 26 "Net-(D23-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 28 row3))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074BA45)
    (at 86 69.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DED00CA)
    (attr smd)
    (fp_text reference D24 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 27 "Net-(D24-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 28 row3))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074BA5F)
    (at 105 69.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DED00C4)
    (attr smd)
    (fp_text reference D25 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 29 "Net-(D25-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 28 row3))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074BA79)
    (at 124 69.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DED00BE)
    (attr smd)
    (fp_text reference D26 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 30 "Net-(D26-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 28 row3))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074BA93)
    (at 143 69.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5DED00B7)
    (attr smd)
    (fp_text reference D27 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 31 "Net-(D27-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 28 row3))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:D_0805_2012_mod (layer F.Cu) (tedit 5F64D2BA) (tstamp 6074BAAD)
    (at 162 69.5 270)
    (descr "Diode SMD 0805 (2012 Metric), square (rectangular) end terminal, IPC_7351 nominal, (Body size source: https://docs.google.com/spreadsheets/d/1BsfQQcO9C6DZCsRaXUlFlo91Tg2WpOkGARC1WS5S8t0/edit?usp=sharing), generated with kicad-footprint-generator")
    (tags "diode handsolder")
    (path /5F6B275A)
    (attr smd)
    (fp_text reference D28 (at 0 -1.65 270) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value D (at 0 1.65 270) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text user %R (at 0 0 270) (layer F.Fab)
      (effects (font (size 0.5 0.5) (thickness 0.08)))
    )
    (fp_line (start -0.25 -0.5) (end -0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 -0.5) (end 0.25 0) (layer F.SilkS) (width 0.12))
    (fp_line (start 0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.25 0) (end 0.25 -0.5) (layer F.SilkS) (width 0.12))
    (fp_line (start 1 -0.6) (end -0.7 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -0.7 -0.6) (end -1 -0.3) (layer F.Fab) (width 0.1))
    (fp_line (start -1 -0.3) (end -1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -1 0.6) (end 1 0.6) (layer F.Fab) (width 0.1))
    (fp_line (start 1 0.6) (end 1 -0.6) (layer F.Fab) (width 0.1))
    (fp_line (start -2.159 0.95) (end -2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.159 -0.95) (end 2.159 -0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 -0.95) (end 2.159 0.95) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.159 0.95) (end -2.159 0.95) (layer F.CrtYd) (width 0.05))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 270) (size 0.1 0.1) (layers B.Cu))
    (pad 2 thru_hole roundrect (at 1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 32 "Net-(D28-Pad2)"))
    (pad 1 thru_hole roundrect (at -1.55 0 270) (size 1.6 1.4) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.217)
      (net 28 row3))
    (model \${KISYS3DMOD}/Diode_SMD.3dshapes/D_0805_2012Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:ResetSW (layer F.Cu) (tedit 6076AF35) (tstamp 60773F33)
    (at 23 43 180)
    (path /5E044F7D)
    (fp_text reference SW1 (at 0 2) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value SW_KEY (at 0 -2) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_line (start -3 2.75) (end -3 -0.75) (layer Dwgs.User) (width 0.12))
    (fp_line (start 3 -0.75) (end -3 -0.75) (layer Dwgs.User) (width 0.12))
    (fp_line (start 3 2.75) (end 3 -0.75) (layer Dwgs.User) (width 0.12))
    (fp_line (start -3 2.75) (end 3 2.75) (layer Dwgs.User) (width 0.12))
    (pad 2 thru_hole oval (at -3.5 1 180) (size 1.8 4) (drill 1.3) (layers *.Cu *.Mask)
      (net 35 GND))
    (pad 1 thru_hole oval (at 3.5 1 180) (size 1.8 4) (drill 1.3) (layers *.Cu *.Mask)
      (net 44 reset_sw))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60773F07)
    (at 16.5 45.5)
    (path /6084D327)
    (fp_text reference J1 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 46 "Net-(J1-Pad1)"))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60775D44)
    (at 3 10.5)
    (path /5F722C9D)
    (fp_text reference J3 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 36 debug_tx_led))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60775D48)
    (at 3 19.5)
    (path /6076C1D4)
    (fp_text reference J4 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 47 i2c_sda))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60775D4C)
    (at 3 26.5)
    (path /6083ACBB)
    (fp_text reference J5 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 48 uart1_tx))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60775D50)
    (at 3 23)
    (path /60770226)
    (fp_text reference J6 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 49 i2c_scl))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60775D54)
    (at 3 30)
    (path /6083ACC2)
    (fp_text reference J7 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 50 uart1_rx))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60775D58)
    (at 38 3.5)
    (path /607CDFF4)
    (fp_text reference J8 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 51 ex1))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60775D5C)
    (at 3 15)
    (path /6081D54C)
    (fp_text reference J9 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 33 VDD))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60775D60)
    (at 34.5 3.5)
    (path /607EDCA9)
    (fp_text reference J10 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 33 VDD))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60775D64)
    (at 41.5 3.5)
    (path /6081D552)
    (fp_text reference J11 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 35 GND))
  )

  (module local_footprints:pad1 (layer F.Cu) (tedit 6076AA45) (tstamp 60775D68)
    (at 3 34.5)
    (path /607F3380)
    (fp_text reference J12 (at 0 1.75) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value Conn_01x01_Female (at 0 -1.75) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad 1 thru_hole roundrect (at 0 0 90) (size 1.8 1.8) (drill 0.8) (layers *.Cu *.Mask) (roundrect_rratio 0.25)
      (net 35 GND))
  )

  (module local_footprints:promicro_flip (layer B.Cu) (tedit 5E0D8C93) (tstamp 6074BF66)
    (at 19 19.5 180)
    (descr "24-lead though-hole mounted DIP package, row spacing 15.24 mm (600 mils)")
    (tags "THT DIP DIL PDIP 2.54mm 15.24mm 600mil")
    (path /5DEB0857)
    (fp_text reference U1 (at 0 0) (layer B.SilkS)
      (effects (font (size 1 1) (thickness 0.15)) (justify mirror))
    )
    (fp_text value "ProMicro RP2040" (at 0 -8) (layer B.SilkS) hide
      (effects (font (size 1 1) (thickness 0.15)) (justify mirror))
    )
    (fp_line (start -9 -15.5) (end -9 17.5) (layer B.SilkS) (width 0.12))
    (fp_line (start -9 17.5) (end 9 17.5) (layer B.SilkS) (width 0.12))
    (fp_line (start 9 17.5) (end 9 -15.5) (layer B.SilkS) (width 0.12))
    (fp_line (start -9 -15.5) (end 9 -15.5) (layer B.SilkS) (width 0.12))
    (fp_line (start 3.5 19) (end -3.5 19) (layer B.SilkS) (width 0.12))
    (fp_line (start -3.5 19) (end -3.5 14) (layer B.SilkS) (width 0.12))
    (fp_line (start -3.5 14) (end 3.5 14) (layer B.SilkS) (width 0.12))
    (fp_line (start 3.5 14) (end 3.5 19) (layer B.SilkS) (width 0.12))
    (fp_line (start 7.4 15.5) (end 6.9 15.5) (layer B.SilkS) (width 0.12))
    (fp_line (start 6.9 15.5) (end 6.9 16.75) (layer B.SilkS) (width 0.12))
    (fp_line (start 7.4 16.75) (end 6.9 16.75) (layer B.SilkS) (width 0.12))
    (fp_line (start 6.9 16.75) (end 7.4 16.75) (layer B.SilkS) (width 0.12))
    (fp_line (start 7.4 16.75) (end 7.4 15.5) (layer B.SilkS) (width 0.12))
    (fp_line (start 7.9 15.5) (end 7.9 16.75) (layer B.SilkS) (width 0.12))
    (fp_line (start 7.9 16.75) (end 8.4 16.75) (layer B.SilkS) (width 0.12))
    (fp_line (start 8.4 16.75) (end 8.4 15.5) (layer B.SilkS) (width 0.12))
    (fp_line (start 8.4 15.5) (end 7.9 15.5) (layer B.SilkS) (width 0.12))
    (pad 1 thru_hole rect (at 7.62 13.97 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 36 debug_tx_led))
    (pad 13 thru_hole oval (at -7.62 -13.97 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 43 col6))
    (pad 2 thru_hole oval (at 7.62 11.43 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 34 data))
    (pad 14 thru_hole oval (at -7.62 -11.43 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 42 col5))
    (pad 3 thru_hole oval (at 7.62 8.89 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 35 GND))
    (pad 15 thru_hole oval (at -7.62 -8.89 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 41 col4))
    (pad 4 thru_hole oval (at 7.62 6.35 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 35 GND))
    (pad 16 thru_hole oval (at -7.62 -6.35 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 40 col3))
    (pad 5 thru_hole oval (at 7.62 3.81 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 47 i2c_sda))
    (pad 17 thru_hole oval (at -7.62 -3.81 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 39 col2))
    (pad 6 thru_hole oval (at 7.62 1.27 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 49 i2c_scl))
    (pad 18 thru_hole oval (at -7.62 -1.27 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 38 col1))
    (pad 7 thru_hole oval (at 7.62 -1.27 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 48 uart1_tx))
    (pad 19 thru_hole oval (at -7.62 1.27 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 37 col0))
    (pad 8 thru_hole oval (at 7.62 -3.81 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 50 uart1_rx))
    (pad 20 thru_hole oval (at -7.62 3.81 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 51 ex1))
    (pad 9 thru_hole oval (at 7.62 -6.35 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 2 row0))
    (pad 21 thru_hole oval (at -7.62 6.35 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 33 VDD))
    (pad 10 thru_hole oval (at 7.62 -8.89 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 10 row1))
    (pad 22 thru_hole oval (at -7.62 8.89 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 44 reset_sw))
    (pad 11 thru_hole oval (at 7.62 -11.43 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 19 row2))
    (pad 23 thru_hole oval (at -7.62 11.43 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 35 GND))
    (pad 12 thru_hole oval (at 7.62 -13.97 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 28 row3))
    (pad 24 thru_hole oval (at -7.62 13.97 180) (size 1.6 1.6) (drill 0.8) (layers *.Cu *.Mask)
      (net 45 "Net-(U1-Pad24)"))
  )

  (module local_footprints:R_1206_3216Metric_TH (layer F.Cu) (tedit 5F64D2E3) (tstamp 6074BF2A)
    (at 15.4 10.5 180)
    (tags resistor)
    (path /5ECE7329)
    (attr smd)
    (fp_text reference R3 (at 0 -1.82) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value 4k7 (at 0 1.82) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_line (start 2.28 1.12) (end -2.28 1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.28 -1.12) (end 2.28 1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.28 -1.12) (end 2.28 -1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.28 1.12) (end -2.28 -1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start -0.602064 0.91) (end 0.602064 0.91) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.602064 -0.91) (end 0.602064 -0.91) (layer F.SilkS) (width 0.12))
    (fp_line (start 1.6 0.8) (end -1.6 0.8) (layer F.Fab) (width 0.1))
    (fp_line (start 1.6 -0.8) (end 1.6 0.8) (layer F.Fab) (width 0.1))
    (fp_line (start -1.6 -0.8) (end 1.6 -0.8) (layer F.Fab) (width 0.1))
    (fp_line (start -1.6 0.8) (end -1.6 -0.8) (layer F.Fab) (width 0.1))
    (fp_text user %R (at 0 0) (layer F.Fab)
      (effects (font (size 0.8 0.8) (thickness 0.12)))
    )
    (pad 2 thru_hole roundrect (at 1.4 0 180) (size 1.25 1.75) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.2)
      (net 34 data))
    (pad 1 thru_hole roundrect (at -1.4 0 180) (size 1.25 1.75) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.2)
      (net 33 VDD))
    (pad "" smd circle (at 0 -0.6 180) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 180) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 180) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 180) (size 0.1 0.1) (layers B.Cu))
    (model \${KISYS3DMOD}/Resistor_SMD.3dshapes/R_1206_3216Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:R_1206_3216Metric_TH (layer F.Cu) (tedit 5F64D2E3) (tstamp 6074BF15)
    (at 15.4 15 180)
    (tags resistor)
    (path /60793FAF)
    (attr smd)
    (fp_text reference R2 (at 0 -1.82) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value 4k7 (at 0 1.82) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_line (start -1.6 0.8) (end -1.6 -0.8) (layer F.Fab) (width 0.1))
    (fp_line (start -1.6 -0.8) (end 1.6 -0.8) (layer F.Fab) (width 0.1))
    (fp_line (start 1.6 -0.8) (end 1.6 0.8) (layer F.Fab) (width 0.1))
    (fp_line (start 1.6 0.8) (end -1.6 0.8) (layer F.Fab) (width 0.1))
    (fp_line (start -0.602064 -0.91) (end 0.602064 -0.91) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.602064 0.91) (end 0.602064 0.91) (layer F.SilkS) (width 0.12))
    (fp_line (start -2.28 1.12) (end -2.28 -1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.28 -1.12) (end 2.28 -1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.28 -1.12) (end 2.28 1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.28 1.12) (end -2.28 1.12) (layer F.CrtYd) (width 0.05))
    (fp_text user %R (at 0 0) (layer F.Fab)
      (effects (font (size 0.8 0.8) (thickness 0.12)))
    )
    (pad "" smd circle (at 0 -0.6 180) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 0.6 180) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 0.6 180) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 -0.6 180) (size 0.1 0.1) (layers F.Cu))
    (pad 1 thru_hole roundrect (at -1.4 0 180) (size 1.25 1.75) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.2)
      (net 33 VDD))
    (pad 2 thru_hole roundrect (at 1.4 0 180) (size 1.25 1.75) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.2)
      (net 47 i2c_sda))
    (model \${KISYS3DMOD}/Resistor_SMD.3dshapes/R_1206_3216Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:R_1206_3216Metric_TH (layer F.Cu) (tedit 5F64D2E3) (tstamp 6074BF00)
    (at 15.4 18 180)
    (tags resistor)
    (path /60797F8F)
    (attr smd)
    (fp_text reference R1 (at 0 -1.82) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value 4k7 (at 0 1.82) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_line (start 2.28 1.12) (end -2.28 1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start 2.28 -1.12) (end 2.28 1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.28 -1.12) (end 2.28 -1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start -2.28 1.12) (end -2.28 -1.12) (layer F.CrtYd) (width 0.05))
    (fp_line (start -0.602064 0.91) (end 0.602064 0.91) (layer F.SilkS) (width 0.12))
    (fp_line (start -0.602064 -0.91) (end 0.602064 -0.91) (layer F.SilkS) (width 0.12))
    (fp_line (start 1.6 0.8) (end -1.6 0.8) (layer F.Fab) (width 0.1))
    (fp_line (start 1.6 -0.8) (end 1.6 0.8) (layer F.Fab) (width 0.1))
    (fp_line (start -1.6 -0.8) (end 1.6 -0.8) (layer F.Fab) (width 0.1))
    (fp_line (start -1.6 0.8) (end -1.6 -0.8) (layer F.Fab) (width 0.1))
    (fp_text user %R (at 0 0) (layer F.Fab)
      (effects (font (size 0.8 0.8) (thickness 0.12)))
    )
    (pad 2 thru_hole roundrect (at 1.4 0 180) (size 1.25 1.75) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.2)
      (net 49 i2c_scl))
    (pad 1 thru_hole roundrect (at -1.4 0 180) (size 1.25 1.75) (drill 0.5) (layers *.Cu *.Mask) (roundrect_rratio 0.2)
      (net 33 VDD))
    (pad "" smd circle (at 0 -0.6 180) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 180) (size 0.1 0.1) (layers F.Cu))
    (pad "" smd circle (at 0 0.6 180) (size 0.1 0.1) (layers B.Cu))
    (pad "" smd circle (at 0 -0.6 180) (size 0.1 0.1) (layers B.Cu))
    (model \${KISYS3DMOD}/Resistor_SMD.3dshapes/R_1206_3216Metric.wrl
      (at (xyz 0 0 0))
      (scale (xyz 1 1 1))
      (rotate (xyz 0 0 0))
    )
  )

  (module local_footprints:MJ-4PP-9 (layer F.Cu) (tedit 5D823F21) (tstamp 6074BADB)
    (at 2 41.5 90)
    (path /5ECA6208)
    (fp_text reference J2 (at -0.85 4.95 90) (layer F.Fab)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value MJ-4PP-9 (at 0 14 90) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_line (start -4.75 12) (end -4.75 0) (layer B.SilkS) (width 0.15))
    (fp_line (start 1.25 12) (end -4.75 12) (layer B.SilkS) (width 0.15))
    (fp_line (start 1.25 0) (end 1.25 12) (layer B.SilkS) (width 0.15))
    (fp_line (start -4.75 0) (end 1.25 0) (layer B.SilkS) (width 0.15))
    (fp_line (start -3 0) (end 3 0) (layer F.SilkS) (width 0.15))
    (fp_line (start 3 0) (end 3 12) (layer F.SilkS) (width 0.15))
    (fp_line (start 3 12) (end -3 12) (layer F.SilkS) (width 0.15))
    (fp_line (start -3 12) (end -3 0) (layer F.SilkS) (width 0.15))
    (fp_text user TRRS (at -0.8255 6.4135 90) (layer B.SilkS)
      (effects (font (size 1 1) (thickness 0.15)) (justify mirror))
    )
    (fp_text user TRRS (at -0.75 6.45 90) (layer F.SilkS)
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad "" np_thru_hole circle (at -1.75 8.5 90) (size 1.2 1.2) (drill 1.2) (layers *.Cu *.Mask F.SilkS))
    (pad "" np_thru_hole circle (at -1.75 1.5 90) (size 1.2 1.2) (drill 1.2) (layers *.Cu *.Mask F.SilkS))
    (pad T thru_hole oval (at -3.85 10.3 90) (size 1.7 2.5) (drill oval 1 1.5) (layers *.Cu *.Mask)
      (net 33 VDD) (clearance 0.15))
    (pad S thru_hole oval (at 0.35 11.8 90) (size 1.7 2.5) (drill oval 1 1.5) (layers *.Cu *.Mask)
      (net 46 "Net-(J1-Pad1)") (clearance 0.15))
    (pad R2 thru_hole oval (at -3.85 3.3 90) (size 1.7 2.5) (drill oval 1 1.5) (layers *.Cu *.Mask)
      (net 34 data))
    (pad R1 thru_hole oval (at -3.85 6.3 90) (size 1.7 2.5) (drill oval 1 1.5) (layers *.Cu *.Mask)
      (net 35 GND))
    (pad "" np_thru_hole circle (at 0 1.5 90) (size 1.2 1.2) (drill 1.2) (layers *.Cu *.Mask F.SilkS))
    (pad "" np_thru_hole circle (at 0 8.5 90) (size 1.2 1.2) (drill 1.2) (layers *.Cu *.Mask F.SilkS))
    (pad R2 thru_hole oval (at 2.1 3.3 90) (size 1.7 2.5) (drill oval 1 1.5) (layers *.Cu *.Mask)
      (net 34 data))
    (pad R1 thru_hole oval (at 2.1 6.3 90) (size 1.7 2.5) (drill oval 1 1.5) (layers *.Cu *.Mask)
      (net 35 GND))
    (pad T thru_hole oval (at 2.1 10.3 90) (size 1.7 2.5) (drill oval 1 1.5) (layers *.Cu *.Mask)
      (net 33 VDD) (clearance 0.15))
    (pad S thru_hole oval (at -2.1 11.8 90) (size 1.7 2.5) (drill oval 1 1.5) (layers *.Cu *.Mask)
      (net 46 "Net-(J1-Pad1)") (clearance 0.15))
    (model "../../../../../../Users/pluis/Documents/Magic Briefcase/Documents/KiCad/3d/AB2_TRS_3p5MM_PTH.wrl"
      (at (xyz 0 0 0))
      (scale (xyz 0.42 0.42 0.42))
      (rotate (xyz 0 0 90))
    )
  )

  (module local_footprints:hole2 (layer F.Cu) (tedit 5F222C31) (tstamp 60773EED)
    (at 86.5 4)
    (path /6078405D)
    (fp_text reference H1 (at 0 2.5) (layer F.SilkS) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value MountingHole (at 0 -2.25) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad "" thru_hole circle (at 0 0 90) (size 4 4) (drill 2.6) (layers *.Cu *.Mask))
  )

  (module local_footprints:hole2 (layer F.Cu) (tedit 5F222C31) (tstamp 60773EF2)
    (at 5 85)
    (path /6078DBD8)
    (fp_text reference H2 (at 0 2.5) (layer F.SilkS) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value MountingHole (at 0 -2.25) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad "" thru_hole circle (at 0 0 90) (size 4 4) (drill 2.6) (layers *.Cu *.Mask))
  )

  (module local_footprints:hole2 (layer F.Cu) (tedit 5F222C31) (tstamp 60773EF7)
    (at 5 4)
    (path /60793AF6)
    (fp_text reference H3 (at 0 2.5) (layer F.SilkS) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value MountingHole (at 0 -2.25) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad "" thru_hole circle (at 0 0 90) (size 4 4) (drill 2.6) (layers *.Cu *.Mask))
  )

  (module local_footprints:hole2 (layer F.Cu) (tedit 5F222C31) (tstamp 60773EFC)
    (at 86.5 85)
    (path /60799A71)
    (fp_text reference H4 (at 0 2.5) (layer F.SilkS) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value MountingHole (at 0 -2.25) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad "" thru_hole circle (at 0 0 90) (size 4 4) (drill 2.6) (layers *.Cu *.Mask))
  )

  (module local_footprints:hole2 (layer F.Cu) (tedit 5F222C31) (tstamp 60773F01)
    (at 168 4)
    (path /6079F934)
    (fp_text reference H5 (at 0 2.5) (layer F.SilkS) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value MountingHole (at 0 -2.25) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad "" thru_hole circle (at 0 0 90) (size 4 4) (drill 2.6) (layers *.Cu *.Mask))
  )

  (module local_footprints:hole2 (layer F.Cu) (tedit 5F222C31) (tstamp 60773F06)
    (at 168 85)
    (path /607A5839)
    (fp_text reference H6 (at 0 2.5) (layer F.SilkS) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (fp_text value MountingHole (at 0 -2.25) (layer F.Fab) hide
      (effects (font (size 1 1) (thickness 0.15)))
    )
    (pad "" thru_hole circle (at 0 0 90) (size 4 4) (drill 2.6) (layers *.Cu *.Mask))
  )

  (gr_line (start 13.75 35.25) (end 24.25 35.25) (layer Edge.Cuts) (width 0.1) (tstamp 6077496A))
  (gr_line (start 13.75 29.75) (end 13.75 35.25) (layer Edge.Cuts) (width 0.1))
  (gr_line (start 24.25 29.75) (end 13.75 29.75) (layer Edge.Cuts) (width 0.1))
  (gr_line (start 24.25 35.25) (end 24.25 29.75) (layer Edge.Cuts) (width 0.1))
  (gr_line (start 0 1) (end 0 -1) (layer Eco1.User) (width 0.01))
  (gr_line (start 1 0) (end -1 0) (layer Eco1.User) (width 0.01))
  (gr_circle (center 168 85) (end 169.5 85) (layer Eco1.User) (width 0.01))
  (gr_circle (center 86.5 85) (end 88 85) (layer Eco1.User) (width 0.01))
  (gr_circle (center 5 85) (end 6.5 85) (layer Eco1.User) (width 0.01))
  (gr_circle (center 5 4) (end 6.5 4) (layer Eco1.User) (width 0.01))
  (gr_circle (center 86.5 4) (end 88 4) (layer Eco1.User) (width 0.01))
  (gr_circle (center 168 4) (end 169.5 4) (layer Eco1.User) (width 0.01))
  (gr_line (start 14 30) (end 14 35) (layer Eco1.User) (width 0.01))
  (gr_line (start 24 30) (end 14 30) (layer Eco1.User) (width 0.01))
  (gr_line (start 24 35) (end 24 30) (layer Eco1.User) (width 0.01))
  (gr_line (start 14 35) (end 24 35) (layer Eco1.User) (width 0.01))
  (gr_line (start 0 39) (end 0 45) (layer Eco1.User) (width 0.01))
  (gr_line (start 14 39) (end 0 39) (layer Eco1.User) (width 0.01))
  (gr_line (start 14 45) (end 14 39) (layer Eco1.User) (width 0.01))
  (gr_line (start 0 45) (end 14 45) (layer Eco1.User) (width 0.01))
  (gr_line (start 28 35) (end 28 2) (layer Eco1.User) (width 0.01))
  (gr_line (start 10 35) (end 28 35) (layer Eco1.User) (width 0.01))
  (gr_line (start 10 2) (end 10 35) (layer Eco1.User) (width 0.01))
  (gr_line (start 28 2) (end 10 2) (layer Eco1.User) (width 0.01))
  (gr_line (start 162.75 81.25) (end 162.75 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 145.25 81.25) (end 162.75 81.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 145.25 64.75) (end 145.25 81.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 162.75 64.75) (end 145.25 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 162.75 60.25) (end 162.75 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 145.25 60.25) (end 162.75 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 145.25 43.75) (end 145.25 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 162.75 43.75) (end 145.25 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 162.75 42.25) (end 162.75 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 145.25 42.25) (end 162.75 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 145.25 25.75) (end 145.25 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 162.75 25.75) (end 145.25 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 162.75 24.25) (end 162.75 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 145.25 24.25) (end 162.75 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 145.25 7.75) (end 145.25 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 162.75 7.75) (end 145.25 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 143.75 81.25) (end 143.75 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 126.250001 64.75) (end 126.250001 81.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 143.75 64.75) (end 126.250001 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 124.750001 81.25) (end 124.750001 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 107.25 64.75) (end 107.25 81.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 124.750001 64.75) (end 107.25 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 105.75 81.25) (end 105.75 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 88.25 64.75) (end 88.25 81.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 105.75 64.75) (end 88.25 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 143.75 60.25) (end 143.75 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 126.250001 60.25) (end 143.75 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 126.250001 43.75) (end 126.250001 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 143.75 43.75) (end 126.250001 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 124.750001 60.25) (end 124.750001 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 107.25 60.25) (end 124.750001 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 107.25 43.75) (end 107.25 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 124.750001 43.75) (end 107.25 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 105.75 60.25) (end 105.75 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 88.25 60.25) (end 105.75 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 88.25 43.75) (end 88.25 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 105.75 43.75) (end 88.25 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 86.75 81.25) (end 86.75 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 69.25 64.75) (end 69.25 81.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 86.75 64.75) (end 69.25 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 67.75 81.25) (end 67.75 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 50.25 64.75) (end 50.25 81.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 67.75 64.75) (end 50.25 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 48.75 81.25) (end 48.75 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 31.25 64.75) (end 31.25 81.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 48.75 64.75) (end 31.25 64.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 86.75 60.25) (end 86.75 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 69.25 60.25) (end 86.75 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 69.25 43.75) (end 69.25 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 86.75 43.75) (end 69.25 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 67.75 60.25) (end 67.75 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 50.25 60.25) (end 67.75 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 50.25 43.75) (end 50.25 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 67.75 43.75) (end 50.25 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 48.75 60.25) (end 48.75 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 31.25 60.25) (end 48.75 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 31.25 43.75) (end 31.25 60.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 48.75 43.75) (end 31.25 43.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 143.75 42.25) (end 143.75 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 126.250001 42.25) (end 143.75 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 126.250001 25.75) (end 126.250001 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 143.75 25.75) (end 126.250001 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 124.750001 42.25) (end 124.750001 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 107.25 42.25) (end 124.750001 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 107.25 25.75) (end 107.25 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 124.750001 25.75) (end 107.25 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 105.75 42.25) (end 105.75 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 88.25 42.25) (end 105.75 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 88.25 25.75) (end 88.25 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 105.75 25.75) (end 88.25 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 143.75 24.25) (end 143.75 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 126.250001 24.25) (end 143.75 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 126.250001 7.75) (end 126.250001 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 143.75 7.75) (end 126.250001 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 124.750001 24.25) (end 124.750001 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 107.25 24.25) (end 124.750001 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 107.25 7.75) (end 107.25 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 124.750001 7.75) (end 107.25 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 105.75 24.25) (end 105.75 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 88.25 24.25) (end 105.75 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 88.25 7.75) (end 88.25 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 105.75 7.75) (end 88.25 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 86.75 42.25) (end 86.75 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 69.25 42.25) (end 86.75 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 69.25 25.75) (end 69.25 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 86.75 25.75) (end 69.25 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 67.75 42.25) (end 67.75 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 50.25 42.25) (end 67.75 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 50.25 25.75) (end 50.25 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 67.75 25.75) (end 50.25 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 48.75 42.25) (end 48.75 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 31.25 42.25) (end 48.75 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 31.25 25.75) (end 31.25 42.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 48.75 25.75) (end 31.25 25.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 86.75 24.25) (end 86.75 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 69.25 24.25) (end 86.75 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 69.25 7.75) (end 69.25 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 86.75 7.75) (end 69.25 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 67.75 24.25) (end 67.75 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 50.25 24.25) (end 67.75 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 50.25 7.75) (end 50.25 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 67.75 7.75) (end 50.25 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 48.75 24.25) (end 48.75 7.75) (layer Eco1.User) (width 0.01))
  (gr_line (start 31.25 24.25) (end 48.75 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 31.25 7.75) (end 31.25 24.25) (layer Eco1.User) (width 0.01))
  (gr_line (start 48.75 7.75) (end 31.25 7.75) (layer Eco1.User) (width 0.01))
  (gr_arc (start 4 85) (end 0 85) (angle -90) (layer Edge.Cuts) (width 0.01))
  (gr_arc (start 169 85) (end 169 89) (angle -90) (layer Edge.Cuts) (width 0.01))
  (gr_arc (start 169 4) (end 173 4) (angle -90) (layer Edge.Cuts) (width 0.01))
  (gr_arc (start 4 4) (end 4 0) (angle -90) (layer Edge.Cuts) (width 0.01))
  (gr_line (start 4 0) (end 14 0) (layer Edge.Cuts) (width 0.01))
  (gr_line (start 169 0) (end 24 0) (layer Edge.Cuts) (width 0.01))
  (gr_line (start 4 89) (end 169 89) (layer Edge.Cuts) (width 0.01))
  (gr_line (start 173 85) (end 173 4) (layer Edge.Cuts) (width 0.01))
  (gr_line (start 0 85) (end 0 4) (layer Edge.Cuts) (width 0.01))
  (gr_line (start 14 0) (end 14 8) (layer Edge.Cuts) (width 0.01))
  (gr_line (start 24 8) (end 24 0) (layer Edge.Cuts) (width 0.01))
  (gr_line (start 14 8) (end 24 8) (layer Edge.Cuts) (width 0.01))

  (segment (start 36.8 20.7) (end 36.8 21.9) (width 0.25) (layer B.Cu) (net 1))
  (segment (start 38 19.5) (end 36.8 20.7) (width 0.25) (layer B.Cu) (net 1))
  (segment (start 43.2 21.9) (end 43.2 20.7) (width 0.25) (layer B.Cu) (net 1))
  (segment (start 41.5 19.5) (end 38 19.5) (width 0.25) (layer B.Cu) (net 1))
  (segment (start 43.5 18) (end 42 19.5) (width 0.25) (layer B.Cu) (net 1))
  (segment (start 42 19.5) (end 41.5 19.5) (width 0.25) (layer B.Cu) (net 1))
  (segment (start 43.5 15) (end 43.5 18) (width 0.25) (layer B.Cu) (net 1))
  (segment (start 48 14.05) (end 44.45 14.05) (width 0.25) (layer B.Cu) (net 1))
  (segment (start 44.45 14.05) (end 43.5 15) (width 0.25) (layer B.Cu) (net 1))
  (segment (start 43.2 20.7) (end 42 19.5) (width 0.25) (layer B.Cu) (net 1))
  (segment (start 162 10.95) (end 162 9.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 162 9.5) (end 161 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 48 9.5) (end 48 10.95) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 49 8.5) (end 48 9.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 11.38 25.85) (end 14.65 25.85) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 14.65 25.85) (end 23.5 17) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 23.5 17) (end 29 17) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 29 17) (end 33.5 12.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 46.45 12.5) (end 48 10.95) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 33.5 12.5) (end 46.45 12.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 67 10.95) (end 67 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 67 8.5) (end 49 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 86 10.95) (end 86 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 86 8.5) (end 67 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 105 10.95) (end 105 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 105 8.5) (end 86 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 124 10.95) (end 124 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 124 8.5) (end 105 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 143 10.95) (end 143 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 143 8.5) (end 124 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 161 8.5) (end 143 8.5) (width 0.25) (layer F.Cu) (net 2))
  (segment (start 67 14.05) (end 63.45 14.05) (width 0.25) (layer B.Cu) (net 3))
  (segment (start 63.45 14.05) (end 62.5 15) (width 0.25) (layer B.Cu) (net 3))
  (segment (start 62.5 15) (end 62.5 18) (width 0.25) (layer B.Cu) (net 3))
  (segment (start 62.5 18) (end 61 19.5) (width 0.25) (layer B.Cu) (net 3))
  (segment (start 61 19.5) (end 57 19.5) (width 0.25) (layer B.Cu) (net 3))
  (segment (start 55.8 20.7) (end 55.8 21.9) (width 0.25) (layer B.Cu) (net 3))
  (segment (start 57 19.5) (end 55.8 20.7) (width 0.25) (layer B.Cu) (net 3))
  (segment (start 62.2 20.7) (end 61 19.5) (width 0.25) (layer B.Cu) (net 3))
  (segment (start 62.2 21.9) (end 62.2 20.7) (width 0.25) (layer B.Cu) (net 3))
  (segment (start 86 14.05) (end 82.45 14.05) (width 0.25) (layer B.Cu) (net 4))
  (segment (start 82.45 14.05) (end 81.5 15) (width 0.25) (layer B.Cu) (net 4))
  (segment (start 81.5 15) (end 81.5 18) (width 0.25) (layer B.Cu) (net 4))
  (segment (start 81.5 18) (end 80 19.5) (width 0.25) (layer B.Cu) (net 4))
  (segment (start 80 19.5) (end 76 19.5) (width 0.25) (layer B.Cu) (net 4))
  (segment (start 74.8 20.7) (end 74.8 21.9) (width 0.25) (layer B.Cu) (net 4))
  (segment (start 76 19.5) (end 74.8 20.7) (width 0.25) (layer B.Cu) (net 4))
  (segment (start 81.2 20.7) (end 80 19.5) (width 0.25) (layer B.Cu) (net 4))
  (segment (start 81.2 21.9) (end 81.2 20.7) (width 0.25) (layer B.Cu) (net 4))
  (segment (start 105 14.05) (end 101.45 14.05) (width 0.25) (layer B.Cu) (net 5))
  (segment (start 101.45 14.05) (end 100.5 15) (width 0.25) (layer B.Cu) (net 5))
  (segment (start 100.5 15) (end 100.5 18) (width 0.25) (layer B.Cu) (net 5))
  (segment (start 100.5 18) (end 99 19.5) (width 0.25) (layer B.Cu) (net 5))
  (segment (start 99 19.5) (end 95 19.5) (width 0.25) (layer B.Cu) (net 5))
  (segment (start 93.8 20.7) (end 93.8 21.9) (width 0.25) (layer B.Cu) (net 5))
  (segment (start 95 19.5) (end 93.8 20.7) (width 0.25) (layer B.Cu) (net 5))
  (segment (start 100.2 20.7) (end 99 19.5) (width 0.25) (layer B.Cu) (net 5))
  (segment (start 100.2 21.9) (end 100.2 20.7) (width 0.25) (layer B.Cu) (net 5))
  (segment (start 124 14.05) (end 120.45 14.05) (width 0.25) (layer B.Cu) (net 6))
  (segment (start 120.45 14.05) (end 119.5 15) (width 0.25) (layer B.Cu) (net 6))
  (segment (start 119.5 15) (end 119.5 18) (width 0.25) (layer B.Cu) (net 6))
  (segment (start 119.5 18) (end 118 19.5) (width 0.25) (layer B.Cu) (net 6))
  (segment (start 118 19.5) (end 114 19.5) (width 0.25) (layer B.Cu) (net 6))
  (segment (start 112.8 20.7) (end 112.8 21.9) (width 0.25) (layer B.Cu) (net 6))
  (segment (start 114 19.5) (end 112.8 20.7) (width 0.25) (layer B.Cu) (net 6))
  (segment (start 119.2 21.9) (end 119.2 20.7) (width 0.25) (layer B.Cu) (net 6))
  (segment (start 119.2 20.7) (end 118 19.5) (width 0.25) (layer B.Cu) (net 6))
  (segment (start 143 14.05) (end 139.45 14.05) (width 0.25) (layer B.Cu) (net 7))
  (segment (start 139.45 14.05) (end 138.5 15) (width 0.25) (layer B.Cu) (net 7))
  (segment (start 138.5 15) (end 138.5 18) (width 0.25) (layer B.Cu) (net 7))
  (segment (start 138.5 18) (end 137 19.5) (width 0.25) (layer B.Cu) (net 7))
  (segment (start 137 19.5) (end 133 19.5) (width 0.25) (layer B.Cu) (net 7))
  (segment (start 131.8 20.7) (end 131.8 21.9) (width 0.25) (layer B.Cu) (net 7))
  (segment (start 133 19.5) (end 131.8 20.7) (width 0.25) (layer B.Cu) (net 7))
  (segment (start 138.2 21.9) (end 138.2 20.7) (width 0.25) (layer B.Cu) (net 7))
  (segment (start 138.2 20.7) (end 137 19.5) (width 0.25) (layer B.Cu) (net 7))
  (segment (start 162 14.05) (end 158.45 14.05) (width 0.25) (layer B.Cu) (net 8))
  (segment (start 158.45 14.05) (end 157.5 15) (width 0.25) (layer B.Cu) (net 8))
  (segment (start 157.5 15) (end 157.5 18) (width 0.25) (layer B.Cu) (net 8))
  (segment (start 157.5 18) (end 156 19.5) (width 0.25) (layer B.Cu) (net 8))
  (segment (start 156 19.5) (end 152 19.5) (width 0.25) (layer B.Cu) (net 8))
  (segment (start 150.8 20.7) (end 150.8 21.9) (width 0.25) (layer B.Cu) (net 8))
  (segment (start 152 19.5) (end 150.8 20.7) (width 0.25) (layer B.Cu) (net 8))
  (segment (start 157.2 21.9) (end 157.2 20.7) (width 0.25) (layer B.Cu) (net 8))
  (segment (start 157.2 20.7) (end 156 19.5) (width 0.25) (layer B.Cu) (net 8))
  (segment (start 48 32.05) (end 44.45 32.05) (width 0.25) (layer B.Cu) (net 9))
  (segment (start 44.45 32.05) (end 43.5 33) (width 0.25) (layer B.Cu) (net 9))
  (segment (start 43.5 33) (end 43.5 36) (width 0.25) (layer B.Cu) (net 9))
  (segment (start 43.5 36) (end 42 37.5) (width 0.25) (layer B.Cu) (net 9))
  (segment (start 42 37.5) (end 38 37.5) (width 0.25) (layer B.Cu) (net 9))
  (segment (start 36.8 38.7) (end 36.8 39.9) (width 0.25) (layer B.Cu) (net 9))
  (segment (start 38 37.5) (end 36.8 38.7) (width 0.25) (layer B.Cu) (net 9))
  (segment (start 43.2 38.7) (end 42 37.5) (width 0.25) (layer B.Cu) (net 9))
  (segment (start 43.2 39.9) (end 43.2 38.7) (width 0.25) (layer B.Cu) (net 9))
  (segment (start 23.89 28.39) (end 11.38 28.39) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 25.28 27) (end 23.89 28.39) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 162 28.5) (end 160.5 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 162 28.95) (end 162 28.5) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 48 28.95) (end 48 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 48 27) (end 25.28 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 67 28.95) (end 67 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 86 28.95) (end 86 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 86 27) (end 48 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 105 28.95) (end 105 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 105 27) (end 86 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 124 28.95) (end 124 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 124 27) (end 105 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 143 28.95) (end 143 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 143 27) (end 124 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 160.5 27) (end 143 27) (width 0.25) (layer F.Cu) (net 10))
  (segment (start 67 32.05) (end 63.45 32.05) (width 0.25) (layer B.Cu) (net 11))
  (segment (start 63.45 32.05) (end 62.5 33) (width 0.25) (layer B.Cu) (net 11))
  (segment (start 62.5 33) (end 62.5 36) (width 0.25) (layer B.Cu) (net 11))
  (segment (start 62.5 36) (end 61 37.5) (width 0.25) (layer B.Cu) (net 11))
  (segment (start 61 37.5) (end 57 37.5) (width 0.25) (layer B.Cu) (net 11))
  (segment (start 55.8 38.7) (end 55.8 39.9) (width 0.25) (layer B.Cu) (net 11))
  (segment (start 57 37.5) (end 55.8 38.7) (width 0.25) (layer B.Cu) (net 11))
  (segment (start 62.2 39.9) (end 62.2 38.7) (width 0.25) (layer B.Cu) (net 11))
  (segment (start 62.2 38.7) (end 61 37.5) (width 0.25) (layer B.Cu) (net 11))
  (segment (start 76 37.5) (end 74.8 38.7) (width 0.25) (layer B.Cu) (net 12))
  (segment (start 82.45 32.05) (end 81.5 33) (width 0.25) (layer B.Cu) (net 12))
  (segment (start 81.5 36) (end 80 37.5) (width 0.25) (layer B.Cu) (net 12))
  (segment (start 81.5 33) (end 81.5 36) (width 0.25) (layer B.Cu) (net 12))
  (segment (start 74.8 38.7) (end 74.8 39.9) (width 0.25) (layer B.Cu) (net 12))
  (segment (start 80 37.5) (end 76 37.5) (width 0.25) (layer B.Cu) (net 12))
  (segment (start 86 32.05) (end 82.45 32.05) (width 0.25) (layer B.Cu) (net 12))
  (segment (start 81.2 38.7) (end 80 37.5) (width 0.25) (layer B.Cu) (net 12))
  (segment (start 81.2 39.9) (end 81.2 38.7) (width 0.25) (layer B.Cu) (net 12))
  (segment (start 105 32.05) (end 101.45 32.05) (width 0.25) (layer B.Cu) (net 13))
  (segment (start 101.45 32.05) (end 100.5 33) (width 0.25) (layer B.Cu) (net 13))
  (segment (start 100.5 33) (end 100.5 36) (width 0.25) (layer B.Cu) (net 13))
  (segment (start 100.5 36) (end 99 37.5) (width 0.25) (layer B.Cu) (net 13))
  (segment (start 99 37.5) (end 95 37.5) (width 0.25) (layer B.Cu) (net 13))
  (segment (start 93.8 38.7) (end 93.8 39.9) (width 0.25) (layer B.Cu) (net 13))
  (segment (start 95 37.5) (end 93.8 38.7) (width 0.25) (layer B.Cu) (net 13))
  (segment (start 100.2 38.7) (end 99 37.5) (width 0.25) (layer B.Cu) (net 13))
  (segment (start 100.2 39.9) (end 100.2 38.7) (width 0.25) (layer B.Cu) (net 13))
  (segment (start 124 32.05) (end 120.45 32.05) (width 0.25) (layer B.Cu) (net 14))
  (segment (start 120.45 32.05) (end 119.5 33) (width 0.25) (layer B.Cu) (net 14))
  (segment (start 119.5 33) (end 119.5 36) (width 0.25) (layer B.Cu) (net 14))
  (segment (start 119.5 36) (end 118 37.5) (width 0.25) (layer B.Cu) (net 14))
  (segment (start 118 37.5) (end 114 37.5) (width 0.25) (layer B.Cu) (net 14))
  (segment (start 112.8 38.7) (end 112.8 39.9) (width 0.25) (layer B.Cu) (net 14))
  (segment (start 114 37.5) (end 112.8 38.7) (width 0.25) (layer B.Cu) (net 14))
  (segment (start 119.2 39.9) (end 119.2 38.7) (width 0.25) (layer B.Cu) (net 14))
  (segment (start 119.2 38.7) (end 118 37.5) (width 0.25) (layer B.Cu) (net 14))
  (segment (start 143 32.05) (end 139.45 32.05) (width 0.25) (layer B.Cu) (net 15))
  (segment (start 139.45 32.05) (end 138.5 33) (width 0.25) (layer B.Cu) (net 15))
  (segment (start 138.5 33) (end 138.5 36) (width 0.25) (layer B.Cu) (net 15))
  (segment (start 138.5 36) (end 137 37.5) (width 0.25) (layer B.Cu) (net 15))
  (segment (start 138.2 39.9) (end 138.2 38.7) (width 0.25) (layer B.Cu) (net 15))
  (segment (start 133 37.5) (end 131.8 38.7) (width 0.25) (layer B.Cu) (net 15))
  (segment (start 137 37.5) (end 133 37.5) (width 0.25) (layer B.Cu) (net 15))
  (segment (start 131.8 38.7) (end 131.8 39.9) (width 0.25) (layer B.Cu) (net 15))
  (segment (start 138.2 38.7) (end 137 37.5) (width 0.25) (layer B.Cu) (net 15))
  (segment (start 162 32.05) (end 158.45 32.05) (width 0.25) (layer B.Cu) (net 16))
  (segment (start 158.45 32.05) (end 157.5 33) (width 0.25) (layer B.Cu) (net 16))
  (segment (start 157.5 33) (end 157.5 36) (width 0.25) (layer B.Cu) (net 16))
  (segment (start 157.5 36) (end 156 37.5) (width 0.25) (layer B.Cu) (net 16))
  (segment (start 156 37.5) (end 152 37.5) (width 0.25) (layer B.Cu) (net 16))
  (segment (start 150.8 38.7) (end 150.8 39.9) (width 0.25) (layer B.Cu) (net 16))
  (segment (start 152 37.5) (end 150.8 38.7) (width 0.25) (layer B.Cu) (net 16))
  (segment (start 157.2 38.7) (end 156 37.5) (width 0.25) (layer B.Cu) (net 16))
  (segment (start 157.2 39.9) (end 157.2 38.7) (width 0.25) (layer B.Cu) (net 16))
  (segment (start 48 50.05) (end 44.45 50.05) (width 0.25) (layer B.Cu) (net 17))
  (segment (start 44.45 50.05) (end 43.5 51) (width 0.25) (layer B.Cu) (net 17))
  (segment (start 43.5 51) (end 43.5 54) (width 0.25) (layer B.Cu) (net 17))
  (segment (start 43.5 54) (end 42 55.5) (width 0.25) (layer B.Cu) (net 17))
  (segment (start 42 55.5) (end 38 55.5) (width 0.25) (layer B.Cu) (net 17))
  (segment (start 36.8 56.7) (end 36.8 57.9) (width 0.25) (layer B.Cu) (net 17))
  (segment (start 38 55.5) (end 36.8 56.7) (width 0.25) (layer B.Cu) (net 17))
  (segment (start 43.2 56.7) (end 42 55.5) (width 0.25) (layer B.Cu) (net 17))
  (segment (start 43.2 57.9) (end 43.2 56.7) (width 0.25) (layer B.Cu) (net 17))
  (segment (start 67 50.05) (end 63.45 50.05) (width 0.25) (layer B.Cu) (net 18))
  (segment (start 63.45 50.05) (end 62.5 51) (width 0.25) (layer B.Cu) (net 18))
  (segment (start 62.5 51) (end 62.5 54) (width 0.25) (layer B.Cu) (net 18))
  (segment (start 62.5 54) (end 61 55.5) (width 0.25) (layer B.Cu) (net 18))
  (segment (start 61 55.5) (end 57 55.5) (width 0.25) (layer B.Cu) (net 18))
  (segment (start 55.8 56.7) (end 55.8 57.9) (width 0.25) (layer B.Cu) (net 18))
  (segment (start 57 55.5) (end 55.8 56.7) (width 0.25) (layer B.Cu) (net 18))
  (segment (start 62.2 57.9) (end 62.2 56.7) (width 0.25) (layer B.Cu) (net 18))
  (segment (start 62.2 56.7) (end 61 55.5) (width 0.25) (layer B.Cu) (net 18))
  (segment (start 13 32.55) (end 11.38 30.93) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 13 35.75) (end 13 32.55) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 17 39.75) (end 13 35.75) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 162 46.95) (end 162 46.5) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 17 42.5) (end 17 39.75) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 19.75 45.25) (end 17 42.5) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 162 46.5) (end 160.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 124 46.95) (end 124 45.5) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 124 45.5) (end 123.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 143 45.5) (end 143.25 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 143 46.95) (end 143 45.5) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 143.25 45.25) (end 123.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 160.75 45.25) (end 143.25 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 105 46.95) (end 105 45.5) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 105 45.5) (end 104.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 123.75 45.25) (end 104.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 86 45.5) (end 85.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 86 46.95) (end 86 45.5) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 104.75 45.25) (end 85.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 67 45.5) (end 66.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 67 46.95) (end 67 45.5) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 85.75 45.25) (end 66.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 48 45.5) (end 47.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 48 46.95) (end 48 45.5) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 47.75 45.25) (end 19.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 66.75 45.25) (end 47.75 45.25) (width 0.25) (layer F.Cu) (net 19))
  (segment (start 86 50.05) (end 82.45 50.05) (width 0.25) (layer B.Cu) (net 20))
  (segment (start 82.45 50.05) (end 81.5 51) (width 0.25) (layer B.Cu) (net 20))
  (segment (start 81.5 51) (end 81.5 54) (width 0.25) (layer B.Cu) (net 20))
  (segment (start 81.5 54) (end 80 55.5) (width 0.25) (layer B.Cu) (net 20))
  (segment (start 80 55.5) (end 76 55.5) (width 0.25) (layer B.Cu) (net 20))
  (segment (start 74.8 56.7) (end 74.8 57.9) (width 0.25) (layer B.Cu) (net 20))
  (segment (start 76 55.5) (end 74.8 56.7) (width 0.25) (layer B.Cu) (net 20))
  (segment (start 81.2 57.9) (end 81.2 56.7) (width 0.25) (layer B.Cu) (net 20))
  (segment (start 81.2 56.7) (end 80 55.5) (width 0.25) (layer B.Cu) (net 20))
  (segment (start 105 50.05) (end 101.45 50.05) (width 0.25) (layer B.Cu) (net 21))
  (segment (start 101.45 50.05) (end 100.5 51) (width 0.25) (layer B.Cu) (net 21))
  (segment (start 100.5 51) (end 100.5 54) (width 0.25) (layer B.Cu) (net 21))
  (segment (start 100.5 54) (end 99 55.5) (width 0.25) (layer B.Cu) (net 21))
  (segment (start 99 55.5) (end 95 55.5) (width 0.25) (layer B.Cu) (net 21))
  (segment (start 93.8 56.7) (end 93.8 57.9) (width 0.25) (layer B.Cu) (net 21))
  (segment (start 95 55.5) (end 93.8 56.7) (width 0.25) (layer B.Cu) (net 21))
  (segment (start 100.2 56.7) (end 99 55.5) (width 0.25) (layer B.Cu) (net 21))
  (segment (start 100.2 57.9) (end 100.2 56.7) (width 0.25) (layer B.Cu) (net 21))
  (segment (start 124 50.05) (end 120.45 50.05) (width 0.25) (layer B.Cu) (net 22))
  (segment (start 120.45 50.05) (end 119.5 51) (width 0.25) (layer B.Cu) (net 22))
  (segment (start 119.5 51) (end 119.5 54) (width 0.25) (layer B.Cu) (net 22))
  (segment (start 119.5 54) (end 118 55.5) (width 0.25) (layer B.Cu) (net 22))
  (segment (start 118 55.5) (end 114 55.5) (width 0.25) (layer B.Cu) (net 22))
  (segment (start 112.8 56.7) (end 112.8 57.9) (width 0.25) (layer B.Cu) (net 22))
  (segment (start 114 55.5) (end 112.8 56.7) (width 0.25) (layer B.Cu) (net 22))
  (segment (start 119.2 56.7) (end 118 55.5) (width 0.25) (layer B.Cu) (net 22))
  (segment (start 119.2 57.9) (end 119.2 56.7) (width 0.25) (layer B.Cu) (net 22))
  (segment (start 143 50.05) (end 139.45 50.05) (width 0.25) (layer B.Cu) (net 23))
  (segment (start 139.45 50.05) (end 138.5 51) (width 0.25) (layer B.Cu) (net 23))
  (segment (start 138.5 51) (end 138.5 54) (width 0.25) (layer B.Cu) (net 23))
  (segment (start 138.5 54) (end 137 55.5) (width 0.25) (layer B.Cu) (net 23))
  (segment (start 137 55.5) (end 133 55.5) (width 0.25) (layer B.Cu) (net 23))
  (segment (start 131.8 56.7) (end 131.8 57.9) (width 0.25) (layer B.Cu) (net 23))
  (segment (start 133 55.5) (end 131.8 56.7) (width 0.25) (layer B.Cu) (net 23))
  (segment (start 138.2 56.7) (end 137 55.5) (width 0.25) (layer B.Cu) (net 23))
  (segment (start 138.2 57.9) (end 138.2 56.7) (width 0.25) (layer B.Cu) (net 23))
  (segment (start 162 50.05) (end 158.45 50.05) (width 0.25) (layer B.Cu) (net 24))
  (segment (start 158.45 50.05) (end 157.5 51) (width 0.25) (layer B.Cu) (net 24))
  (segment (start 157.5 51) (end 157.5 54) (width 0.25) (layer B.Cu) (net 24))
  (segment (start 157.5 54) (end 156 55.5) (width 0.25) (layer B.Cu) (net 24))
  (segment (start 156 55.5) (end 152 55.5) (width 0.25) (layer B.Cu) (net 24))
  (segment (start 150.8 56.7) (end 150.8 57.9) (width 0.25) (layer B.Cu) (net 24))
  (segment (start 152 55.5) (end 150.8 56.7) (width 0.25) (layer B.Cu) (net 24))
  (segment (start 157.2 57.9) (end 157.2 56.7) (width 0.25) (layer B.Cu) (net 24))
  (segment (start 157.2 56.7) (end 156 55.5) (width 0.25) (layer B.Cu) (net 24))
  (segment (start 48 71.05) (end 44.45 71.05) (width 0.25) (layer B.Cu) (net 25))
  (segment (start 44.45 71.05) (end 43.5 72) (width 0.25) (layer B.Cu) (net 25))
  (segment (start 43.5 72) (end 43.5 75) (width 0.25) (layer B.Cu) (net 25))
  (segment (start 43.5 75) (end 42 76.5) (width 0.25) (layer B.Cu) (net 25))
  (segment (start 42 76.5) (end 38 76.5) (width 0.25) (layer B.Cu) (net 25))
  (segment (start 36.8 77.7) (end 36.8 78.9) (width 0.25) (layer B.Cu) (net 25))
  (segment (start 38 76.5) (end 36.8 77.7) (width 0.25) (layer B.Cu) (net 25))
  (segment (start 43.2 77.7) (end 42 76.5) (width 0.25) (layer B.Cu) (net 25))
  (segment (start 43.2 78.9) (end 43.2 77.7) (width 0.25) (layer B.Cu) (net 25))
  (segment (start 55.8 77.7) (end 55.8 78.9) (width 0.25) (layer B.Cu) (net 26))
  (segment (start 57 76.5) (end 55.8 77.7) (width 0.25) (layer B.Cu) (net 26))
  (segment (start 62.6 74.9) (end 61 76.5) (width 0.25) (layer B.Cu) (net 26))
  (segment (start 61 76.5) (end 57 76.5) (width 0.25) (layer B.Cu) (net 26))
  (segment (start 62.6 72) (end 62.6 74.9) (width 0.25) (layer B.Cu) (net 26))
  (segment (start 63.55 71.05) (end 62.6 72) (width 0.25) (layer B.Cu) (net 26))
  (segment (start 67 71.05) (end 63.55 71.05) (width 0.25) (layer B.Cu) (net 26))
  (segment (start 62.2 77.7) (end 61 76.5) (width 0.25) (layer B.Cu) (net 26))
  (segment (start 62.2 78.9) (end 62.2 77.7) (width 0.25) (layer B.Cu) (net 26))
  (segment (start 86 71.05) (end 82.45 71.05) (width 0.25) (layer B.Cu) (net 27))
  (segment (start 82.45 71.05) (end 81.5 72) (width 0.25) (layer B.Cu) (net 27))
  (segment (start 81.5 72) (end 81.5 75) (width 0.25) (layer B.Cu) (net 27))
  (segment (start 81.5 75) (end 80 76.5) (width 0.25) (layer B.Cu) (net 27))
  (segment (start 80 76.5) (end 76 76.5) (width 0.25) (layer B.Cu) (net 27))
  (segment (start 74.8 77.7) (end 74.8 78.9) (width 0.25) (layer B.Cu) (net 27))
  (segment (start 76 76.5) (end 74.8 77.7) (width 0.25) (layer B.Cu) (net 27))
  (segment (start 81.2 78.9) (end 81.2 77.7) (width 0.25) (layer B.Cu) (net 27))
  (segment (start 81.2 77.7) (end 80 76.5) (width 0.25) (layer B.Cu) (net 27))
  (segment (start 16 42.5) (end 16 40.25) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 19.25 45.75) (end 16 42.5) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 19.25 51.25) (end 19.25 45.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 11.38 35.63) (end 11.38 33.47) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 16 40.25) (end 11.38 35.63) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 46.75 65.75) (end 33.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 33.75 65.75) (end 19.25 51.25) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 162 67.95) (end 162 67.5) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 162 67.5) (end 160.25 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 47.75 65.75) (end 46.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 48 66) (end 47.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 48 67.95) (end 48 66) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 67 66) (end 66.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 67 67.95) (end 67 66) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 66.75 65.75) (end 46.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 86 67.95) (end 86 66) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 86 66) (end 85.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 85.75 65.75) (end 66.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 105 66) (end 104.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 105 67.95) (end 105 66) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 104.75 65.75) (end 85.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 124 66) (end 123.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 124 67.95) (end 124 66) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 123.75 65.75) (end 104.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 143 66) (end 142.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 143 67.95) (end 143 66) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 142.75 65.75) (end 123.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 160.25 65.75) (end 142.75 65.75) (width 0.25) (layer F.Cu) (net 28))
  (segment (start 105 71.05) (end 101.45 71.05) (width 0.25) (layer B.Cu) (net 29))
  (segment (start 101.45 71.05) (end 100.5 72) (width 0.25) (layer B.Cu) (net 29))
  (segment (start 100.5 72) (end 100.5 75) (width 0.25) (layer B.Cu) (net 29))
  (segment (start 100.5 75) (end 99 76.5) (width 0.25) (layer B.Cu) (net 29))
  (segment (start 99 76.5) (end 95 76.5) (width 0.25) (layer B.Cu) (net 29))
  (segment (start 93.8 77.7) (end 93.8 78.9) (width 0.25) (layer B.Cu) (net 29))
  (segment (start 95 76.5) (end 93.8 77.7) (width 0.25) (layer B.Cu) (net 29))
  (segment (start 100.2 77.7) (end 99 76.5) (width 0.25) (layer B.Cu) (net 29))
  (segment (start 100.2 78.9) (end 100.2 77.7) (width 0.25) (layer B.Cu) (net 29))
  (segment (start 124 71.05) (end 120.45 71.05) (width 0.25) (layer B.Cu) (net 30))
  (segment (start 120.45 71.05) (end 119.5 72) (width 0.25) (layer B.Cu) (net 30))
  (segment (start 119.5 72) (end 119.5 75) (width 0.25) (layer B.Cu) (net 30))
  (segment (start 119.5 75) (end 118 76.5) (width 0.25) (layer B.Cu) (net 30))
  (segment (start 118 76.5) (end 114 76.5) (width 0.25) (layer B.Cu) (net 30))
  (segment (start 112.8 77.7) (end 112.8 78.9) (width 0.25) (layer B.Cu) (net 30))
  (segment (start 114 76.5) (end 112.8 77.7) (width 0.25) (layer B.Cu) (net 30))
  (segment (start 119.2 77.7) (end 118 76.5) (width 0.25) (layer B.Cu) (net 30))
  (segment (start 119.2 78.9) (end 119.2 77.7) (width 0.25) (layer B.Cu) (net 30))
  (segment (start 136.5 76.5) (end 133 76.5) (width 0.25) (layer B.Cu) (net 31))
  (segment (start 131.8 77.7) (end 131.8 78.9) (width 0.25) (layer B.Cu) (net 31))
  (segment (start 133 76.5) (end 131.8 77.7) (width 0.25) (layer B.Cu) (net 31))
  (segment (start 138.2 78.9) (end 138.2 77.7) (width 0.25) (layer B.Cu) (net 31))
  (segment (start 137 76.5) (end 136.5 76.5) (width 0.25) (layer B.Cu) (net 31))
  (segment (start 138.2 77.7) (end 137 76.5) (width 0.25) (layer B.Cu) (net 31))
  (segment (start 138.5 75) (end 137 76.5) (width 0.25) (layer B.Cu) (net 31))
  (segment (start 138.5 72) (end 138.5 75) (width 0.25) (layer B.Cu) (net 31))
  (segment (start 139.45 71.05) (end 138.5 72) (width 0.25) (layer B.Cu) (net 31))
  (segment (start 143 71.05) (end 139.45 71.05) (width 0.25) (layer B.Cu) (net 31))
  (segment (start 155.5 76.5) (end 152 76.5) (width 0.25) (layer B.Cu) (net 32))
  (segment (start 150.8 77.7) (end 150.8 78.9) (width 0.25) (layer B.Cu) (net 32))
  (segment (start 152 76.5) (end 150.8 77.7) (width 0.25) (layer B.Cu) (net 32))
  (segment (start 157.2 78.9) (end 157.2 77.7) (width 0.25) (layer B.Cu) (net 32))
  (segment (start 156 76.5) (end 155.5 76.5) (width 0.25) (layer B.Cu) (net 32))
  (segment (start 157.2 77.7) (end 156 76.5) (width 0.25) (layer B.Cu) (net 32))
  (segment (start 157.5 75) (end 156 76.5) (width 0.25) (layer B.Cu) (net 32))
  (segment (start 157.5 72) (end 157.5 75) (width 0.25) (layer B.Cu) (net 32))
  (segment (start 158.45 71.05) (end 157.5 72) (width 0.25) (layer B.Cu) (net 32))
  (segment (start 162 71.05) (end 158.45 71.05) (width 0.25) (layer B.Cu) (net 32))
  (segment (start 12.3 45.35) (end 12.3 44.8) (width 0.25) (layer B.Cu) (net 33))
  (segment (start 12.3 44.8) (end 12 44.5) (width 0.25) (layer B.Cu) (net 33))
  (segment (start 12 39.7) (end 12.3 39.4) (width 0.25) (layer B.Cu) (net 33))
  (segment (start 12 44.5) (end 12 39.7) (width 0.25) (layer B.Cu) (net 33))
  (segment (start 16.8 15) (end 16.8 18) (width 0.25) (layer B.Cu) (net 33))
  (segment (start 16.8 15) (end 16.8 10.5) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 13 38.7) (end 12.3 39.4) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 11.9 39.4) (end 12.3 39.4) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 6.5 34) (end 11.9 39.4) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 6.5 16.5) (end 6.5 34) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 5 15) (end 6.5 16.5) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 3 15) (end 5 15) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 12.3 39.4) (end 12.3 37.7) (width 0.25) (layer B.Cu) (net 33))
  (segment (start 12.3 37.7) (end 13 37) (width 0.25) (layer B.Cu) (net 33))
  (segment (start 13 37) (end 13 26) (width 0.25) (layer B.Cu) (net 33))
  (segment (start 16.8 22.2) (end 16.8 18) (width 0.25) (layer B.Cu) (net 33))
  (segment (start 13 26) (end 16.8 22.2) (width 0.25) (layer B.Cu) (net 33))
  (segment (start 16.8 15) (end 20 15) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 21.85 13.15) (end 26.62 13.15) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 20 15) (end 21.85 13.15) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 26.62 13.15) (end 27.35 13.15) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 34.5 6) (end 34.5 3.5) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 27.35 13.15) (end 34.5 6) (width 0.25) (layer F.Cu) (net 33))
  (segment (start 5.3 45.35) (end 5.3 39.4) (width 0.25) (layer B.Cu) (net 34))
  (segment (start 5.3 39.4) (end 5.3 38.7) (width 0.25) (layer F.Cu) (net 34))
  (segment (start 5.3 39.4) (end 5.3 39.2) (width 0.25) (layer F.Cu) (net 34))
  (segment (start 5.3 37.7) (end 5.3 39.4) (width 0.25) (layer B.Cu) (net 34))
  (segment (start 9 34) (end 5.3 37.7) (width 0.25) (layer B.Cu) (net 34))
  (segment (start 9 33.75) (end 9 34) (width 0.25) (layer B.Cu) (net 34))
  (segment (start 15 11.5) (end 14 10.5) (width 0.25) (layer F.Cu) (net 34))
  (segment (start 15 20.25) (end 15 11.5) (width 0.25) (layer F.Cu) (net 34))
  (segment (start 13.25 22) (end 15 20.25) (width 0.25) (layer F.Cu) (net 34))
  (segment (start 10.25 22) (end 13.25 22) (width 0.25) (layer F.Cu) (net 34))
  (segment (start 9 23.25) (end 10.25 22) (width 0.25) (layer F.Cu) (net 34))
  (segment (start 9 33.75) (end 9 23.25) (width 0.25) (layer F.Cu) (net 34))
  (via (at 9 33.75) (size 0.8) (drill 0.4) (layers F.Cu B.Cu) (net 34))
  (segment (start 14 10) (end 14 10.5) (width 0.25) (layer B.Cu) (net 34))
  (segment (start 12.07 8.07) (end 14 10) (width 0.25) (layer B.Cu) (net 34))
  (segment (start 11.38 8.07) (end 12.07 8.07) (width 0.25) (layer B.Cu) (net 34))
  (segment (start 8.3 45.35) (end 8.3 39.4) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 11.38 10.61) (end 11.38 13.15) (width 0.25) (layer F.Cu) (net 35))
  (segment (start 26.36 8.07) (end 26.62 8.07) (width 0.25) (layer F.Cu) (net 35))
  (segment (start 11.38 13.15) (end 18.85 13.15) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 18.85 13.15) (end 22 10) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 24.69 10) (end 26.62 8.07) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 22 10) (end 24.69 10) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 8 14.5) (end 9.35 13.15) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 9.35 13.15) (end 11.38 13.15) (width 0.25) (layer B.Cu) (net 35))
  (via (at 8 14.5) (size 0.8) (drill 0.4) (layers F.Cu B.Cu) (net 35))
  (segment (start 8 27) (end 8 14.5) (width 0.25) (layer F.Cu) (net 35))
  (via (at 8 27) (size 0.8) (drill 0.4) (layers F.Cu B.Cu) (net 35))
  (segment (start 8 39.1) (end 8.3 39.4) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 3 34.5) (end 4 34.5) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 8 30.5) (end 8 27) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 4 34.5) (end 8 30.5) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 8.3 39.4) (end 8.3 38.3) (width 0.25) (layer F.Cu) (net 35))
  (segment (start 8.3 38.3) (end 4.5 34.5) (width 0.25) (layer F.Cu) (net 35))
  (segment (start 4.5 34.5) (end 3 34.5) (width 0.25) (layer F.Cu) (net 35))
  (segment (start 26.5 40.5) (end 26.5 42) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 8.3 39.4) (end 8.6 39.4) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 26.5 46.5) (end 26.5 42) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 8.3 46.8) (end 9 47.5) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 8.3 45.35) (end 8.3 46.8) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 9 47.5) (end 25.5 47.5) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 25.5 47.5) (end 26.5 46.5) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 26.62 8.07) (end 39.43 8.07) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 39.43 8.07) (end 41.5 6) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 41.5 6) (end 41.5 3.5) (width 0.25) (layer B.Cu) (net 35))
  (segment (start 6.5 10.5) (end 11.38 5.62) (width 0.25) (layer B.Cu) (net 36))
  (segment (start 11.38 5.62) (end 11.38 5.53) (width 0.25) (layer B.Cu) (net 36))
  (segment (start 3 10.5) (end 6.5 10.5) (width 0.25) (layer B.Cu) (net 36))
  (segment (start 31.8 76.7) (end 31.8 55.7) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 31.8 55.7) (end 31.8 37.7) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 31.8 37.7) (end 31.8 19.7) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 30.33 18.23) (end 31.8 19.7) (width 0.25) (layer F.Cu) (net 37))
  (segment (start 26.62 18.23) (end 30.33 18.23) (width 0.25) (layer F.Cu) (net 37))
  (segment (start 48.2 37.7) (end 48.2 35.8) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 48.2 35.8) (end 49.5 34.5) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 49.5 34.5) (end 49.5 23) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 48.2 21.7) (end 48.2 19.7) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 49.5 23) (end 48.2 21.7) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 48.2 37.7) (end 48.2 40.7) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 48.2 40.7) (end 49.5 42) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 49.5 42) (end 49.5 52.5) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 48.2 53.8) (end 48.2 55.7) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 49.5 52.5) (end 48.2 53.8) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 48.2 79.3) (end 48.2 76.7) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 46 81.5) (end 48.2 79.3) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 34 81.5) (end 46 81.5) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 31.8 79.3) (end 34 81.5) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 31.8 76.7) (end 31.8 79.3) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 48.2 55.7) (end 48.2 58.2) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 48.2 58.2) (end 49.5 59.5) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 49.5 59.5) (end 49.5 73) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 48.2 74.3) (end 48.2 76.7) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 49.5 73) (end 48.2 74.3) (width 0.25) (layer B.Cu) (net 37))
  (segment (start 50.8 19.7) (end 50.8 37.7) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 50.8 37.7) (end 50.8 55.7) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 50.8 55.7) (end 50.8 76.7) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 50.5 20) (end 50.8 19.7) (width 0.25) (layer F.Cu) (net 38))
  (segment (start 50.5 22.5) (end 50.5 20) (width 0.25) (layer F.Cu) (net 38))
  (segment (start 49 24) (end 50.5 22.5) (width 0.25) (layer F.Cu) (net 38))
  (segment (start 32.5 24) (end 49 24) (width 0.25) (layer F.Cu) (net 38))
  (segment (start 29.27 20.77) (end 32.5 24) (width 0.25) (layer F.Cu) (net 38))
  (segment (start 26.62 20.77) (end 29.27 20.77) (width 0.25) (layer F.Cu) (net 38))
  (segment (start 67.2 19.7) (end 67.2 23.7) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 67.2 23.7) (end 68.5 25) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 68.5 25) (end 68.5 33.5) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 67.2 34.8) (end 67.2 37.7) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 68.5 33.5) (end 67.2 34.8) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 67.2 37.7) (end 67.2 40.2) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 67.2 40.2) (end 68.5 41.5) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 68.5 41.5) (end 68.5 51) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 67.2 52.3) (end 67.2 55.7) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 68.5 51) (end 67.2 52.3) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 67.2 55.7) (end 67.2 57.2) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 67.2 57.2) (end 68.5 58.5) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 68.5 58.5) (end 68.5 73.5) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 67.2 74.8) (end 67.2 76.7) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 68.5 73.5) (end 67.2 74.8) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 67.2 79.8) (end 67.2 76.7) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 52.5 81.5) (end 65.5 81.5) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 65.5 81.5) (end 67.2 79.8) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 50.8 79.8) (end 52.5 81.5) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 50.8 76.7) (end 50.8 79.8) (width 0.25) (layer B.Cu) (net 38))
  (segment (start 69.8 19.7) (end 69.8 37.7) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 69.8 37.7) (end 69.8 55.7) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 69.8 55.7) (end 69.8 76.7) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 69.5 20) (end 69.8 19.7) (width 0.25) (layer F.Cu) (net 39))
  (segment (start 69.5 23) (end 69.5 20) (width 0.25) (layer F.Cu) (net 39))
  (segment (start 67.5 25) (end 69.5 23) (width 0.25) (layer F.Cu) (net 39))
  (segment (start 32.5 25) (end 67.5 25) (width 0.25) (layer F.Cu) (net 39))
  (segment (start 30.81 23.31) (end 32.5 25) (width 0.25) (layer F.Cu) (net 39))
  (segment (start 26.62 23.31) (end 30.81 23.31) (width 0.25) (layer F.Cu) (net 39))
  (segment (start 84 81.5) (end 86.2 79.3) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 69.8 79.3) (end 72 81.5) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 86.2 79.3) (end 86.2 76.7) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 72 81.5) (end 84 81.5) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 69.8 76.7) (end 69.8 79.3) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 86.2 55.7) (end 86.2 58.2) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 86.2 58.2) (end 87.5 59.5) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 87.5 59.5) (end 87.5 73.5) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 86.2 74.8) (end 86.2 76.7) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 87.5 73.5) (end 86.2 74.8) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 86.2 19.7) (end 86.2 21.7) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 86.2 21.7) (end 87.5 23) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 87.5 23) (end 87.5 34.5) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 86.2 35.8) (end 86.2 37.7) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 87.5 34.5) (end 86.2 35.8) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 86.2 37.7) (end 86.2 39.7) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 86.2 39.7) (end 87.5 41) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 87.5 41) (end 87.5 52) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 86.2 53.3) (end 86.2 55.7) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 87.5 52) (end 86.2 53.3) (width 0.25) (layer B.Cu) (net 39))
  (segment (start 88.8 76.7) (end 88.8 55.7) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 88.8 55.7) (end 88.8 37.7) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 88.8 37.7) (end 88.8 19.7) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 88.5 20) (end 88.8 19.7) (width 0.25) (layer F.Cu) (net 40))
  (segment (start 88.5 22.5) (end 88.5 20) (width 0.25) (layer F.Cu) (net 40))
  (segment (start 85 26) (end 88.5 22.5) (width 0.25) (layer F.Cu) (net 40))
  (segment (start 26.77 26) (end 85 26) (width 0.25) (layer F.Cu) (net 40))
  (segment (start 26.62 25.85) (end 26.77 26) (width 0.25) (layer F.Cu) (net 40))
  (segment (start 88.8 76.7) (end 88.8 79.3) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 88.8 79.3) (end 91 81.5) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 91 81.5) (end 103 81.5) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 105.2 79.3) (end 105.2 76.7) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 103 81.5) (end 105.2 79.3) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 105.2 55.7) (end 105.2 58.2) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 105.2 58.2) (end 106.5 59.5) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 106.5 59.5) (end 106.5 73) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 105.2 74.3) (end 105.2 76.7) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 106.5 73) (end 105.2 74.3) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 105.2 37.7) (end 105.2 39.7) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 105.2 39.7) (end 106.5 41) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 106.5 41) (end 106.5 51) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 105.2 52.3) (end 105.2 55.7) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 106.5 51) (end 105.2 52.3) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 105.2 19.7) (end 105.2 21.7) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 105.2 21.7) (end 106.5 23) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 106.5 23) (end 106.5 33.5) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 105.2 34.8) (end 105.2 37.7) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 106.5 33.5) (end 105.2 34.8) (width 0.25) (layer B.Cu) (net 40))
  (segment (start 107.8 19.7) (end 107.8 37.7) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 107.8 37.7) (end 107.8 55.7) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 107.8 55.7) (end 107.8 76.7) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 107.5 20) (end 107.8 19.7) (width 0.25) (layer F.Cu) (net 41))
  (segment (start 107.5 38) (end 107.8 37.7) (width 0.25) (layer F.Cu) (net 41))
  (segment (start 107.5 41) (end 107.5 38) (width 0.25) (layer F.Cu) (net 41))
  (segment (start 106 42.5) (end 107.5 41) (width 0.25) (layer F.Cu) (net 41))
  (segment (start 33 42.5) (end 106 42.5) (width 0.25) (layer F.Cu) (net 41))
  (segment (start 30 39.5) (end 33 42.5) (width 0.25) (layer F.Cu) (net 41))
  (segment (start 30 31) (end 30 39.5) (width 0.25) (layer F.Cu) (net 41))
  (segment (start 27.39 28.39) (end 30 31) (width 0.25) (layer F.Cu) (net 41))
  (segment (start 26.62 28.39) (end 27.39 28.39) (width 0.25) (layer F.Cu) (net 41))
  (segment (start 122 81.5) (end 124.2 79.3) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 110 81.5) (end 122 81.5) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 124.2 79.3) (end 124.2 76.7) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 107.8 79.3) (end 110 81.5) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 107.8 76.7) (end 107.8 79.3) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 124.2 55.7) (end 124.2 58.2) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 124.2 58.2) (end 125.5 59.5) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 125.5 59.5) (end 125.5 72.5) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 124.2 73.8) (end 124.2 76.7) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 125.5 72.5) (end 124.2 73.8) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 124.2 37.7) (end 124.2 39.7) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 124.2 39.7) (end 125.5 41) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 125.5 41) (end 125.5 51.5) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 124.2 52.8) (end 124.2 55.7) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 125.5 51.5) (end 124.2 52.8) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 124.2 19.7) (end 124.2 21.7) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 124.2 21.7) (end 125.5 23) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 125.5 23) (end 125.5 33.5) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 124.2 34.8) (end 124.2 37.7) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 125.5 33.5) (end 124.2 34.8) (width 0.25) (layer B.Cu) (net 41))
  (segment (start 126.5 38) (end 126.8 37.7) (width 0.25) (layer F.Cu) (net 42))
  (segment (start 126.5 41) (end 126.5 38) (width 0.25) (layer F.Cu) (net 42))
  (segment (start 124 43.5) (end 126.5 41) (width 0.25) (layer F.Cu) (net 42))
  (segment (start 33 43.5) (end 124 43.5) (width 0.25) (layer F.Cu) (net 42))
  (segment (start 29 39.5) (end 33 43.5) (width 0.25) (layer F.Cu) (net 42))
  (segment (start 29 32) (end 29 39.5) (width 0.25) (layer F.Cu) (net 42))
  (segment (start 27.93 30.93) (end 29 32) (width 0.25) (layer F.Cu) (net 42))
  (segment (start 26.62 30.93) (end 27.93 30.93) (width 0.25) (layer F.Cu) (net 42))
  (segment (start 126.8 76.7) (end 126.8 79.3) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 126.8 79.3) (end 129 81.5) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 129 81.5) (end 141 81.5) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 143.2 79.3) (end 143.2 76.7) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 141 81.5) (end 143.2 79.3) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 126.8 55.7) (end 126.8 76.7) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 143.2 55.7) (end 143.2 57.7) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 143.2 57.7) (end 144.5 59) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 144.5 59) (end 144.5 73) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 143.2 74.3) (end 143.2 76.7) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 144.5 73) (end 143.2 74.3) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 126.8 55.7) (end 126.8 37.7) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 126.8 37.7) (end 126.8 19.7) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 143.2 19.7) (end 143.2 21.7) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 143.2 21.7) (end 144.5 23) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 144.5 23) (end 144.5 34) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 143.2 35.3) (end 143.2 37.7) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 144.5 34) (end 143.2 35.3) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 143.2 37.7) (end 143.2 39.7) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 143.2 39.7) (end 144.5 41) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 144.5 41) (end 144.5 52) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 143.2 53.3) (end 143.2 55.7) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 144.5 52) (end 143.2 53.3) (width 0.25) (layer B.Cu) (net 42))
  (segment (start 145.5 38) (end 145.8 37.7) (width 0.25) (layer F.Cu) (net 43))
  (segment (start 142 44.5) (end 145.5 41) (width 0.25) (layer F.Cu) (net 43))
  (segment (start 28 39.5) (end 33 44.5) (width 0.25) (layer F.Cu) (net 43))
  (segment (start 26.62 33.47) (end 26.97 33.47) (width 0.25) (layer F.Cu) (net 43))
  (segment (start 33 44.5) (end 142 44.5) (width 0.25) (layer F.Cu) (net 43))
  (segment (start 145.5 41) (end 145.5 38) (width 0.25) (layer F.Cu) (net 43))
  (segment (start 28 34.5) (end 28 39.5) (width 0.25) (layer F.Cu) (net 43))
  (segment (start 26.97 33.47) (end 28 34.5) (width 0.25) (layer F.Cu) (net 43))
  (segment (start 145.8 76.7) (end 145.8 79.3) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 145.8 79.3) (end 148 81.5) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 148 81.5) (end 160 81.5) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 162.2 79.3) (end 162.2 76.7) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 160 81.5) (end 162.2 79.3) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 145.8 55.7) (end 145.8 76.7) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 162.2 73.8) (end 162.2 76.7) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 163.5 72.5) (end 162.2 73.8) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 162.2 58.2) (end 163.5 59.5) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 163.5 59.5) (end 163.5 72.5) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 162.2 55.7) (end 162.2 58.2) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 162.2 37.7) (end 162.2 41.2) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 162.2 41.2) (end 163.5 42.5) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 163.5 42.5) (end 163.5 52) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 162.2 53.3) (end 162.2 55.7) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 163.5 52) (end 162.2 53.3) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 162.2 19.7) (end 162.2 21.7) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 162.2 21.7) (end 163.5 23) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 163.5 23) (end 163.5 34) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 162.2 35.3) (end 162.2 37.7) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 163.5 34) (end 162.2 35.3) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 145.8 19.7) (end 145.8 37.7) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 145.8 37.7) (end 145.8 55.7) (width 0.25) (layer B.Cu) (net 43))
  (segment (start 26.14 10.61) (end 26.62 10.61) (width 0.25) (layer F.Cu) (net 44))
  (segment (start 25.89 10.61) (end 26.62 10.61) (width 0.25) (layer B.Cu) (net 44))
  (segment (start 24 12.5) (end 25.89 10.61) (width 0.25) (layer B.Cu) (net 44))
  (segment (start 24 28) (end 24 12.5) (width 0.25) (layer B.Cu) (net 44))
  (segment (start 25 29) (end 24 28) (width 0.25) (layer B.Cu) (net 44))
  (segment (start 25 36) (end 25 29) (width 0.25) (layer B.Cu) (net 44))
  (segment (start 24 37) (end 25 36) (width 0.25) (layer B.Cu) (net 44))
  (segment (start 22 37) (end 24 37) (width 0.25) (layer B.Cu) (net 44))
  (segment (start 19.5 39.5) (end 22 37) (width 0.25) (layer B.Cu) (net 44))
  (segment (start 19.5 42) (end 19.5 39.5) (width 0.25) (layer B.Cu) (net 44))
  (segment (start 13.8 43.6) (end 13.8 41.15) (width 0.25) (layer B.Cu) (net 46))
  (segment (start 15.7 45.5) (end 13.8 43.6) (width 0.25) (layer B.Cu) (net 46))
  (segment (start 16.5 45.5) (end 15.7 45.5) (width 0.25) (layer B.Cu) (net 46))
  (segment (start 3 19.5) (end 5 19.5) (width 0.25) (layer B.Cu) (net 47))
  (segment (start 8.81 15.69) (end 11.38 15.69) (width 0.25) (layer B.Cu) (net 47))
  (segment (start 5 19.5) (end 8.81 15.69) (width 0.25) (layer B.Cu) (net 47))
  (segment (start 13.31 15.69) (end 14 15) (width 0.25) (layer B.Cu) (net 47))
  (segment (start 11.38 15.69) (end 13.31 15.69) (width 0.25) (layer B.Cu) (net 47))
  (segment (start 3 26.5) (end 4 26.5) (width 0.25) (layer B.Cu) (net 48))
  (segment (start 9.73 20.77) (end 11.38 20.77) (width 0.25) (layer B.Cu) (net 48))
  (segment (start 4 26.5) (end 9.73 20.77) (width 0.25) (layer B.Cu) (net 48))
  (segment (start 3 23) (end 4.5 23) (width 0.25) (layer B.Cu) (net 49))
  (segment (start 9.27 18.23) (end 11.38 18.23) (width 0.25) (layer B.Cu) (net 49))
  (segment (start 4.5 23) (end 9.27 18.23) (width 0.25) (layer B.Cu) (net 49))
  (segment (start 13.77 18.23) (end 14 18) (width 0.25) (layer B.Cu) (net 49))
  (segment (start 11.38 18.23) (end 13.77 18.23) (width 0.25) (layer B.Cu) (net 49))
  (segment (start 9.69 23.31) (end 11.38 23.31) (width 0.25) (layer B.Cu) (net 50))
  (segment (start 3 30) (end 9.69 23.31) (width 0.25) (layer B.Cu) (net 50))
  (segment (start 26.62 15.69) (end 26.62 15.38) (width 0.25) (layer B.Cu) (net 51))
  (segment (start 26.62 15.69) (end 27.31 15.69) (width 0.25) (layer B.Cu) (net 51))
  (segment (start 26.62 15.69) (end 26.62 15.38) (width 0.25) (layer F.Cu) (net 51))
  (segment (start 26.62 15.38) (end 35.5 6.5) (width 0.25) (layer F.Cu) (net 51))
  (segment (start 35.5 6.5) (end 37 6.5) (width 0.25) (layer F.Cu) (net 51))
  (segment (start 38 5.5) (end 38 3.5) (width 0.25) (layer F.Cu) (net 51))
  (segment (start 37 6.5) (end 38 5.5) (width 0.25) (layer F.Cu) (net 51))

  (zone (net 35) (net_name GND) (layer F.Cu) (tstamp 60771F0B) (hatch edge 0.508)
    (connect_pads (clearance 1))
    (min_thickness 0.254)
    (fill yes (arc_segments 32) (thermal_gap 1) (thermal_bridge_width 0.508))
    (polygon
      (pts
        (xy 174 90) (xy -1 90) (xy -1 -1) (xy 174 -1)
      )
    )
    (filled_polygon
      (pts
        (xy 85.01881 1.228889) (xy 84.506654 1.571101) (xy 84.071101 2.006654) (xy 83.728889 2.51881) (xy 83.493169 3.087888)
        (xy 83.373 3.692017) (xy 83.373 4.307983) (xy 83.493169 4.912112) (xy 83.728889 5.48119) (xy 84.071101 5.993346)
        (xy 84.506654 6.428899) (xy 85.01881 6.771111) (xy 85.587888 7.006831) (xy 86.192017 7.127) (xy 86.807983 7.127)
        (xy 87.412112 7.006831) (xy 87.98119 6.771111) (xy 88.493346 6.428899) (xy 88.928899 5.993346) (xy 89.271111 5.48119)
        (xy 89.506831 4.912112) (xy 89.627 4.307983) (xy 89.627 3.692017) (xy 89.506831 3.087888) (xy 89.271111 2.51881)
        (xy 88.928899 2.006654) (xy 88.493346 1.571101) (xy 87.98119 1.228889) (xy 87.747279 1.132) (xy 166.752721 1.132)
        (xy 166.51881 1.228889) (xy 166.006654 1.571101) (xy 165.571101 2.006654) (xy 165.228889 2.51881) (xy 164.993169 3.087888)
        (xy 164.873 3.692017) (xy 164.873 4.307983) (xy 164.993169 4.912112) (xy 165.228889 5.48119) (xy 165.571101 5.993346)
        (xy 166.006654 6.428899) (xy 166.51881 6.771111) (xy 167.087888 7.006831) (xy 167.692017 7.127) (xy 168.307983 7.127)
        (xy 168.912112 7.006831) (xy 169.48119 6.771111) (xy 169.993346 6.428899) (xy 170.428899 5.993346) (xy 170.771111 5.48119)
        (xy 171.006831 4.912112) (xy 171.127 4.307983) (xy 171.127 3.692017) (xy 171.006831 3.087888) (xy 170.771111 2.51881)
        (xy 170.428899 2.006654) (xy 169.993346 1.571101) (xy 169.48119 1.228889) (xy 169.341135 1.170876) (xy 169.556005 1.191944)
        (xy 170.090842 1.353422) (xy 170.584125 1.615705) (xy 171.017065 1.968802) (xy 171.373179 2.39927) (xy 171.6389 2.890711)
        (xy 171.804104 3.424397) (xy 171.868001 4.032336) (xy 171.868 84.94464) (xy 171.808055 85.556005) (xy 171.646578 86.090845)
        (xy 171.384297 86.584122) (xy 171.031198 87.017065) (xy 170.60073 87.373179) (xy 170.109291 87.6389) (xy 169.575602 87.804104)
        (xy 169.342352 87.82862) (xy 169.48119 87.771111) (xy 169.993346 87.428899) (xy 170.428899 86.993346) (xy 170.771111 86.48119)
        (xy 171.006831 85.912112) (xy 171.127 85.307983) (xy 171.127 84.692017) (xy 171.006831 84.087888) (xy 170.771111 83.51881)
        (xy 170.428899 83.006654) (xy 169.993346 82.571101) (xy 169.48119 82.228889) (xy 168.912112 81.993169) (xy 168.307983 81.873)
        (xy 167.692017 81.873) (xy 167.087888 81.993169) (xy 166.51881 82.228889) (xy 166.006654 82.571101) (xy 165.571101 83.006654)
        (xy 165.228889 83.51881) (xy 164.993169 84.087888) (xy 164.873 84.692017) (xy 164.873 85.307983) (xy 164.993169 85.912112)
        (xy 165.228889 86.48119) (xy 165.571101 86.993346) (xy 166.006654 87.428899) (xy 166.51881 87.771111) (xy 166.752721 87.868)
        (xy 87.747279 87.868) (xy 87.98119 87.771111) (xy 88.493346 87.428899) (xy 88.928899 86.993346) (xy 89.271111 86.48119)
        (xy 89.506831 85.912112) (xy 89.627 85.307983) (xy 89.627 84.692017) (xy 89.506831 84.087888) (xy 89.271111 83.51881)
        (xy 88.928899 83.006654) (xy 88.493346 82.571101) (xy 87.98119 82.228889) (xy 87.412112 81.993169) (xy 86.807983 81.873)
        (xy 86.192017 81.873) (xy 85.587888 81.993169) (xy 85.01881 82.228889) (xy 84.506654 82.571101) (xy 84.071101 83.006654)
        (xy 83.728889 83.51881) (xy 83.493169 84.087888) (xy 83.373 84.692017) (xy 83.373 85.307983) (xy 83.493169 85.912112)
        (xy 83.728889 86.48119) (xy 84.071101 86.993346) (xy 84.506654 87.428899) (xy 85.01881 87.771111) (xy 85.252721 87.868)
        (xy 6.247279 87.868) (xy 6.48119 87.771111) (xy 6.993346 87.428899) (xy 7.428899 86.993346) (xy 7.771111 86.48119)
        (xy 8.006831 85.912112) (xy 8.127 85.307983) (xy 8.127 84.692017) (xy 8.006831 84.087888) (xy 7.771111 83.51881)
        (xy 7.428899 83.006654) (xy 6.993346 82.571101) (xy 6.48119 82.228889) (xy 5.912112 81.993169) (xy 5.307983 81.873)
        (xy 4.692017 81.873) (xy 4.087888 81.993169) (xy 3.51881 82.228889) (xy 3.006654 82.571101) (xy 2.571101 83.006654)
        (xy 2.228889 83.51881) (xy 1.993169 84.087888) (xy 1.873 84.692017) (xy 1.873 85.307983) (xy 1.993169 85.912112)
        (xy 2.228889 86.48119) (xy 2.571101 86.993346) (xy 3.006654 87.428899) (xy 3.51881 87.771111) (xy 3.658865 87.829124)
        (xy 3.443995 87.808055) (xy 2.909155 87.646578) (xy 2.415878 87.384297) (xy 1.982935 87.031198) (xy 1.626821 86.60073)
        (xy 1.3611 86.109291) (xy 1.195896 85.575602) (xy 1.132 84.967673) (xy 1.132 35.979766) (xy 1.1584 36.029157)
        (xy 1.299235 36.200765) (xy 1.470843 36.3416) (xy 1.666629 36.44625) (xy 1.879069 36.510693) (xy 2.1 36.532453)
        (xy 2.59125 36.527) (xy 2.873 36.24525) (xy 2.873 34.627) (xy 3.127 34.627) (xy 3.127 36.24525)
        (xy 3.40875 36.527) (xy 3.9 36.532453) (xy 4.120931 36.510693) (xy 4.333371 36.44625) (xy 4.529157 36.3416)
        (xy 4.700765 36.200765) (xy 4.8416 36.029157) (xy 4.94625 35.833371) (xy 5.010693 35.620931) (xy 5.032453 35.4)
        (xy 5.027 34.90875) (xy 4.74525 34.627) (xy 3.127 34.627) (xy 2.873 34.627) (xy 2.853 34.627)
        (xy 2.853 34.373) (xy 2.873 34.373) (xy 2.873 32.75475) (xy 3.127 32.75475) (xy 3.127 34.373)
        (xy 4.74525 34.373) (xy 5.027 34.09125) (xy 5.032453 33.6) (xy 5.010693 33.379069) (xy 4.94625 33.166629)
        (xy 4.8416 32.970843) (xy 4.700765 32.799235) (xy 4.529157 32.6584) (xy 4.333371 32.55375) (xy 4.120931 32.489307)
        (xy 3.9 32.467547) (xy 3.40875 32.473) (xy 3.127 32.75475) (xy 2.873 32.75475) (xy 2.59125 32.473)
        (xy 2.1 32.467547) (xy 1.879069 32.489307) (xy 1.666629 32.55375) (xy 1.470843 32.6584) (xy 1.299235 32.799235)
        (xy 1.1584 32.970843) (xy 1.132 33.020234) (xy 1.132 31.13789) (xy 1.234238 31.329164) (xy 1.431037 31.568963)
        (xy 1.670836 31.765762) (xy 1.944421 31.911996) (xy 2.241279 32.002047) (xy 2.55 32.032453) (xy 3.45 32.032453)
        (xy 3.758721 32.002047) (xy 4.055579 31.911996) (xy 4.329164 31.765762) (xy 4.568963 31.568963) (xy 4.765762 31.329164)
        (xy 4.911996 31.055579) (xy 5.002047 30.758721) (xy 5.032453 30.45) (xy 5.032453 29.55) (xy 5.002047 29.241279)
        (xy 4.911996 28.944421) (xy 4.765762 28.670836) (xy 4.568963 28.431037) (xy 4.34837 28.25) (xy 4.568963 28.068963)
        (xy 4.765762 27.829164) (xy 4.911996 27.555579) (xy 5.002047 27.258721) (xy 5.032453 26.95) (xy 5.032453 26.05)
        (xy 5.002047 25.741279) (xy 4.911996 25.444421) (xy 4.765762 25.170836) (xy 4.568963 24.931037) (xy 4.34837 24.75)
        (xy 4.568963 24.568963) (xy 4.765762 24.329164) (xy 4.911996 24.055579) (xy 5.002047 23.758721) (xy 5.032453 23.45)
        (xy 5.032453 22.55) (xy 5.002047 22.241279) (xy 4.911996 21.944421) (xy 4.765762 21.670836) (xy 4.568963 21.431037)
        (xy 4.34837 21.25) (xy 4.568963 21.068963) (xy 4.765762 20.829164) (xy 4.911996 20.555579) (xy 5.002047 20.258721)
        (xy 5.032453 19.95) (xy 5.032453 19.05) (xy 5.002047 18.741279) (xy 4.911996 18.444421) (xy 4.765762 18.170836)
        (xy 4.568963 17.931037) (xy 4.329164 17.734238) (xy 4.055579 17.588004) (xy 3.758721 17.497953) (xy 3.45 17.467547)
        (xy 2.55 17.467547) (xy 2.241279 17.497953) (xy 1.944421 17.588004) (xy 1.670836 17.734238) (xy 1.431037 17.931037)
        (xy 1.234238 18.170836) (xy 1.132 18.36211) (xy 1.132 16.13789) (xy 1.234238 16.329164) (xy 1.431037 16.568963)
        (xy 1.670836 16.765762) (xy 1.944421 16.911996) (xy 2.241279 17.002047) (xy 2.55 17.032453) (xy 3.45 17.032453)
        (xy 3.758721 17.002047) (xy 4.055579 16.911996) (xy 4.329164 16.765762) (xy 4.568963 16.568963) (xy 4.672368 16.442964)
        (xy 5.248 17.018596) (xy 5.248001 33.938494) (xy 5.241943 34) (xy 5.266117 34.245434) (xy 5.337707 34.481437)
        (xy 5.453964 34.698938) (xy 5.472891 34.722) (xy 5.61042 34.889581) (xy 5.658188 34.928783) (xy 8.152405 37.423)
        (xy 7.773 37.423) (xy 7.389747 37.485764) (xy 7.026102 37.622091) (xy 6.811847 37.754938) (xy 6.803676 37.748232)
        (xy 6.460226 37.564653) (xy 6.08756 37.451606) (xy 5.797116 37.423) (xy 4.802884 37.423) (xy 4.51244 37.451606)
        (xy 4.139774 37.564653) (xy 3.796324 37.748232) (xy 3.495286 37.995286) (xy 3.248232 38.296324) (xy 3.064653 38.639774)
        (xy 2.951606 39.01244) (xy 2.913435 39.4) (xy 2.951606 39.78756) (xy 2.970551 39.850014) (xy 2.681959 39.969553)
        (xy 2.399102 40.158552) (xy 2.158552 40.399102) (xy 1.969553 40.681959) (xy 1.839368 40.996253) (xy 1.773 41.329905)
        (xy 1.773 41.670095) (xy 1.839368 42.003747) (xy 1.969553 42.318041) (xy 2.007612 42.375) (xy 1.969553 42.431959)
        (xy 1.839368 42.746253) (xy 1.773 43.079905) (xy 1.773 43.420095) (xy 1.839368 43.753747) (xy 1.969553 44.068041)
        (xy 2.158552 44.350898) (xy 2.399102 44.591448) (xy 2.681959 44.780447) (xy 2.970551 44.899986) (xy 2.951606 44.96244)
        (xy 2.913435 45.35) (xy 2.951606 45.73756) (xy 3.064653 46.110226) (xy 3.248232 46.453676) (xy 3.495286 46.754714)
        (xy 3.796324 47.001768) (xy 4.139774 47.185347) (xy 4.51244 47.298394) (xy 4.802884 47.327) (xy 5.797116 47.327)
        (xy 6.08756 47.298394) (xy 6.460226 47.185347) (xy 6.803676 47.001768) (xy 6.811847 46.995062) (xy 7.026102 47.127909)
        (xy 7.389747 47.264236) (xy 7.773 47.327) (xy 8.173 47.327) (xy 8.173 45.477) (xy 8.153 45.477)
        (xy 8.153 45.223) (xy 8.173 45.223) (xy 8.173 43.373) (xy 7.773 43.373) (xy 7.389747 43.435764)
        (xy 7.026102 43.572091) (xy 6.811847 43.704938) (xy 6.803676 43.698232) (xy 6.460226 43.514653) (xy 6.08756 43.401606)
        (xy 5.797116 43.373) (xy 5.227 43.373) (xy 5.227 43.079905) (xy 5.160632 42.746253) (xy 5.030447 42.431959)
        (xy 4.992388 42.375) (xy 5.030447 42.318041) (xy 5.160632 42.003747) (xy 5.227 41.670095) (xy 5.227 41.377)
        (xy 5.797116 41.377) (xy 6.08756 41.348394) (xy 6.460226 41.235347) (xy 6.803676 41.051768) (xy 6.811847 41.045062)
        (xy 7.026102 41.177909) (xy 7.389747 41.314236) (xy 7.773 41.377) (xy 8.173 41.377) (xy 8.173 39.527)
        (xy 8.153 39.527) (xy 8.153 39.273) (xy 8.173 39.273) (xy 8.173 39.253) (xy 8.427 39.253)
        (xy 8.427 39.273) (xy 8.447 39.273) (xy 8.447 39.527) (xy 8.427 39.527) (xy 8.427 41.377)
        (xy 8.773 41.377) (xy 8.773 41.670095) (xy 8.839368 42.003747) (xy 8.969553 42.318041) (xy 9.007612 42.375)
        (xy 8.969553 42.431959) (xy 8.839368 42.746253) (xy 8.773 43.079905) (xy 8.773 43.373) (xy 8.427 43.373)
        (xy 8.427 45.223) (xy 8.447 45.223) (xy 8.447 45.477) (xy 8.427 45.477) (xy 8.427 47.327)
        (xy 8.827 47.327) (xy 9.210253 47.264236) (xy 9.573898 47.127909) (xy 9.903959 46.923258) (xy 10.187753 46.658148)
        (xy 10.294322 46.509838) (xy 10.495286 46.754714) (xy 10.796324 47.001768) (xy 11.139774 47.185347) (xy 11.51244 47.298394)
        (xy 11.802884 47.327) (xy 12.797116 47.327) (xy 13.08756 47.298394) (xy 13.460226 47.185347) (xy 13.803676 47.001768)
        (xy 14.104714 46.754714) (xy 14.351768 46.453676) (xy 14.491421 46.192404) (xy 14.497953 46.258721) (xy 14.588004 46.555579)
        (xy 14.734238 46.829164) (xy 14.931037 47.068963) (xy 15.170836 47.265762) (xy 15.444421 47.411996) (xy 15.741279 47.502047)
        (xy 16.05 47.532453) (xy 16.95 47.532453) (xy 17.258721 47.502047) (xy 17.555579 47.411996) (xy 17.829164 47.265762)
        (xy 17.998001 47.127201) (xy 17.998 51.188504) (xy 17.991943 51.25) (xy 17.998 51.311496) (xy 17.998 51.311497)
        (xy 18.016116 51.495434) (xy 18.087707 51.731437) (xy 18.203964 51.948938) (xy 18.360419 52.139581) (xy 18.408192 52.178787)
        (xy 32.821213 66.591808) (xy 32.860419 66.639581) (xy 33.003888 66.757322) (xy 32.990006 66.774237) (xy 32.811071 67.109001)
        (xy 32.700883 67.472242) (xy 32.663677 67.85) (xy 32.700883 68.227758) (xy 32.811071 68.590999) (xy 32.990006 68.925763)
        (xy 33.230813 69.219187) (xy 33.524237 69.459994) (xy 33.859001 69.638929) (xy 34.222242 69.749117) (xy 34.505342 69.777)
        (xy 35.494658 69.777) (xy 35.777758 69.749117) (xy 36.140999 69.638929) (xy 36.475763 69.459994) (xy 36.769187 69.219187)
        (xy 37.009994 68.925763) (xy 37.188929 68.590999) (xy 37.299117 68.227758) (xy 37.336323 67.85) (xy 37.299117 67.472242)
        (xy 37.188929 67.109001) (xy 37.131736 67.002) (xy 42.868264 67.002) (xy 42.811071 67.109001) (xy 42.700883 67.472242)
        (xy 42.663677 67.85) (xy 42.700883 68.227758) (xy 42.811071 68.590999) (xy 42.990006 68.925763) (xy 43.230813 69.219187)
        (xy 43.524237 69.459994) (xy 43.859001 69.638929) (xy 44.222242 69.749117) (xy 44.505342 69.777) (xy 45.494658 69.777)
        (xy 45.777758 69.749117) (xy 46.140999 69.638929) (xy 46.223 69.595099) (xy 46.223 69.615924) (xy 46.268231 69.843318)
        (xy 46.309543 69.943053) (xy 46.276875 70.00417) (xy 46.195144 70.273601) (xy 46.167547 70.5538) (xy 46.167547 70.760195)
        (xy 45.729189 70.673) (xy 45.270811 70.673) (xy 44.821239 70.762426) (xy 44.397752 70.93784) (xy 44.016624 71.192501)
        (xy 43.72917 71.479955) (xy 43.568681 71.0925) (xy 43.127975 70.432937) (xy 42.567063 69.872025) (xy 41.9075 69.431319)
        (xy 41.174633 69.127755) (xy 40.396625 68.973) (xy 39.603375 68.973) (xy 38.825367 69.127755) (xy 38.0925 69.431319)
        (xy 37.432937 69.872025) (xy 36.872025 70.432937) (xy 36.431319 71.0925) (xy 36.27083 71.479955) (xy 35.983376 71.192501)
        (xy 35.602248 70.93784) (xy 35.178761 70.762426) (xy 34.729189 70.673) (xy 34.270811 70.673) (xy 33.821239 70.762426)
        (xy 33.397752 70.93784) (xy 33.016624 71.192501) (xy 32.692501 71.516624) (xy 32.43784 71.897752) (xy 32.262426 72.321239)
        (xy 32.173 72.770811) (xy 32.173 73.229189) (xy 32.262426 73.678761) (xy 32.423466 74.067547) (xy 30.8 74.067547)
        (xy 30.579069 74.089307) (xy 30.366629 74.15375) (xy 30.170843 74.2584) (xy 29.999235 74.399235) (xy 29.8584 74.570843)
        (xy 29.75375 74.766629) (xy 29.689307 74.979069) (xy 29.667547 75.2) (xy 29.667547 78.2) (xy 29.689307 78.420931)
        (xy 29.75375 78.633371) (xy 29.8584 78.829157) (xy 29.999235 79.000765) (xy 30.170843 79.1416) (xy 30.366629 79.24625)
        (xy 30.579069 79.310693) (xy 30.8 79.332453) (xy 32.8 79.332453) (xy 33.020931 79.310693) (xy 33.233371 79.24625)
        (xy 33.429157 79.1416) (xy 33.571191 79.025035) (xy 33.708281 79.116636) (xy 34.204563 79.322203) (xy 34.667547 79.414296)
        (xy 34.667547 80.4) (xy 34.689307 80.620931) (xy 34.75375 80.833371) (xy 34.8584 81.029157) (xy 34.999235 81.200765)
        (xy 35.170843 81.3416) (xy 35.366629 81.44625) (xy 35.579069 81.510693) (xy 35.8 81.532453) (xy 37.8 81.532453)
        (xy 38.020931 81.510693) (xy 38.233371 81.44625) (xy 38.429157 81.3416) (xy 38.571191 81.225035) (xy 38.708281 81.316636)
        (xy 39.204563 81.522203) (xy 39.731414 81.627) (xy 40.268586 81.627) (xy 40.795437 81.522203) (xy 41.291719 81.316636)
        (xy 41.428809 81.225035) (xy 41.570843 81.3416) (xy 41.766629 81.44625) (xy 41.979069 81.510693) (xy 42.2 81.532453)
        (xy 44.2 81.532453) (xy 44.420931 81.510693) (xy 44.633371 81.44625) (xy 44.829157 81.3416) (xy 45.000765 81.200765)
        (xy 45.1416 81.029157) (xy 45.24625 80.833371) (xy 45.310693 80.620931) (xy 45.332453 80.4) (xy 45.332453 79.414296)
        (xy 45.795437 79.322203) (xy 46.291719 79.116636) (xy 46.428809 79.025035) (xy 46.570843 79.1416) (xy 46.766629 79.24625)
        (xy 46.979069 79.310693) (xy 47.2 79.332453) (xy 49.2 79.332453) (xy 49.420931 79.310693) (xy 49.5 79.286708)
        (xy 49.579069 79.310693) (xy 49.8 79.332453) (xy 51.8 79.332453) (xy 52.020931 79.310693) (xy 52.233371 79.24625)
        (xy 52.429157 79.1416) (xy 52.571191 79.025035) (xy 52.708281 79.116636) (xy 53.204563 79.322203) (xy 53.667547 79.414296)
        (xy 53.667547 80.4) (xy 53.689307 80.620931) (xy 53.75375 80.833371) (xy 53.8584 81.029157) (xy 53.999235 81.200765)
        (xy 54.170843 81.3416) (xy 54.366629 81.44625) (xy 54.579069 81.510693) (xy 54.8 81.532453) (xy 56.8 81.532453)
        (xy 57.020931 81.510693) (xy 57.233371 81.44625) (xy 57.429157 81.3416) (xy 57.571191 81.225035) (xy 57.708281 81.316636)
        (xy 58.204563 81.522203) (xy 58.731414 81.627) (xy 59.268586 81.627) (xy 59.795437 81.522203) (xy 60.291719 81.316636)
        (xy 60.428809 81.225035) (xy 60.570843 81.3416) (xy 60.766629 81.44625) (xy 60.979069 81.510693) (xy 61.2 81.532453)
        (xy 63.2 81.532453) (xy 63.420931 81.510693) (xy 63.633371 81.44625) (xy 63.829157 81.3416) (xy 64.000765 81.200765)
        (xy 64.1416 81.029157) (xy 64.24625 80.833371) (xy 64.310693 80.620931) (xy 64.332453 80.4) (xy 64.332453 79.414296)
        (xy 64.795437 79.322203) (xy 65.291719 79.116636) (xy 65.428809 79.025035) (xy 65.570843 79.1416) (xy 65.766629 79.24625)
        (xy 65.979069 79.310693) (xy 66.2 79.332453) (xy 68.2 79.332453) (xy 68.420931 79.310693) (xy 68.5 79.286708)
        (xy 68.579069 79.310693) (xy 68.8 79.332453) (xy 70.8 79.332453) (xy 71.020931 79.310693) (xy 71.233371 79.24625)
        (xy 71.429157 79.1416) (xy 71.571191 79.025035) (xy 71.708281 79.116636) (xy 72.204563 79.322203) (xy 72.667547 79.414296)
        (xy 72.667547 80.4) (xy 72.689307 80.620931) (xy 72.75375 80.833371) (xy 72.8584 81.029157) (xy 72.999235 81.200765)
        (xy 73.170843 81.3416) (xy 73.366629 81.44625) (xy 73.579069 81.510693) (xy 73.8 81.532453) (xy 75.8 81.532453)
        (xy 76.020931 81.510693) (xy 76.233371 81.44625) (xy 76.429157 81.3416) (xy 76.571191 81.225035) (xy 76.708281 81.316636)
        (xy 77.204563 81.522203) (xy 77.731414 81.627) (xy 78.268586 81.627) (xy 78.795437 81.522203) (xy 79.291719 81.316636)
        (xy 79.428809 81.225035) (xy 79.570843 81.3416) (xy 79.766629 81.44625) (xy 79.979069 81.510693) (xy 80.2 81.532453)
        (xy 82.2 81.532453) (xy 82.420931 81.510693) (xy 82.633371 81.44625) (xy 82.829157 81.3416) (xy 83.000765 81.200765)
        (xy 83.1416 81.029157) (xy 83.24625 80.833371) (xy 83.310693 80.620931) (xy 83.332453 80.4) (xy 83.332453 79.414296)
        (xy 83.795437 79.322203) (xy 84.291719 79.116636) (xy 84.428809 79.025035) (xy 84.570843 79.1416) (xy 84.766629 79.24625)
        (xy 84.979069 79.310693) (xy 85.2 79.332453) (xy 87.2 79.332453) (xy 87.420931 79.310693) (xy 87.5 79.286708)
        (xy 87.579069 79.310693) (xy 87.8 79.332453) (xy 89.8 79.332453) (xy 90.020931 79.310693) (xy 90.233371 79.24625)
        (xy 90.429157 79.1416) (xy 90.571191 79.025035) (xy 90.708281 79.116636) (xy 91.204563 79.322203) (xy 91.667547 79.414296)
        (xy 91.667547 80.4) (xy 91.689307 80.620931) (xy 91.75375 80.833371) (xy 91.8584 81.029157) (xy 91.999235 81.200765)
        (xy 92.170843 81.3416) (xy 92.366629 81.44625) (xy 92.579069 81.510693) (xy 92.8 81.532453) (xy 94.8 81.532453)
        (xy 95.020931 81.510693) (xy 95.233371 81.44625) (xy 95.429157 81.3416) (xy 95.571191 81.225035) (xy 95.708281 81.316636)
        (xy 96.204563 81.522203) (xy 96.731414 81.627) (xy 97.268586 81.627) (xy 97.795437 81.522203) (xy 98.291719 81.316636)
        (xy 98.428809 81.225035) (xy 98.570843 81.3416) (xy 98.766629 81.44625) (xy 98.979069 81.510693) (xy 99.2 81.532453)
        (xy 101.2 81.532453) (xy 101.420931 81.510693) (xy 101.633371 81.44625) (xy 101.829157 81.3416) (xy 102.000765 81.200765)
        (xy 102.1416 81.029157) (xy 102.24625 80.833371) (xy 102.310693 80.620931) (xy 102.332453 80.4) (xy 102.332453 79.414296)
        (xy 102.795437 79.322203) (xy 103.291719 79.116636) (xy 103.428809 79.025035) (xy 103.570843 79.1416) (xy 103.766629 79.24625)
        (xy 103.979069 79.310693) (xy 104.2 79.332453) (xy 106.2 79.332453) (xy 106.420931 79.310693) (xy 106.5 79.286708)
        (xy 106.579069 79.310693) (xy 106.8 79.332453) (xy 108.8 79.332453) (xy 109.020931 79.310693) (xy 109.233371 79.24625)
        (xy 109.429157 79.1416) (xy 109.571191 79.025035) (xy 109.708281 79.116636) (xy 110.204563 79.322203) (xy 110.667547 79.414296)
        (xy 110.667547 80.4) (xy 110.689307 80.620931) (xy 110.75375 80.833371) (xy 110.8584 81.029157) (xy 110.999235 81.200765)
        (xy 111.170843 81.3416) (xy 111.366629 81.44625) (xy 111.579069 81.510693) (xy 111.8 81.532453) (xy 113.8 81.532453)
        (xy 114.020931 81.510693) (xy 114.233371 81.44625) (xy 114.429157 81.3416) (xy 114.571191 81.225035) (xy 114.708281 81.316636)
        (xy 115.204563 81.522203) (xy 115.731414 81.627) (xy 116.268586 81.627) (xy 116.795437 81.522203) (xy 117.291719 81.316636)
        (xy 117.428809 81.225035) (xy 117.570843 81.3416) (xy 117.766629 81.44625) (xy 117.979069 81.510693) (xy 118.2 81.532453)
        (xy 120.2 81.532453) (xy 120.420931 81.510693) (xy 120.633371 81.44625) (xy 120.829157 81.3416) (xy 121.000765 81.200765)
        (xy 121.1416 81.029157) (xy 121.24625 80.833371) (xy 121.310693 80.620931) (xy 121.332453 80.4) (xy 121.332453 79.414296)
        (xy 121.795437 79.322203) (xy 122.291719 79.116636) (xy 122.428809 79.025035) (xy 122.570843 79.1416) (xy 122.766629 79.24625)
        (xy 122.979069 79.310693) (xy 123.2 79.332453) (xy 125.2 79.332453) (xy 125.420931 79.310693) (xy 125.5 79.286708)
        (xy 125.579069 79.310693) (xy 125.8 79.332453) (xy 127.8 79.332453) (xy 128.020931 79.310693) (xy 128.233371 79.24625)
        (xy 128.429157 79.1416) (xy 128.571191 79.025035) (xy 128.708281 79.116636) (xy 129.204563 79.322203) (xy 129.667547 79.414296)
        (xy 129.667547 80.4) (xy 129.689307 80.620931) (xy 129.75375 80.833371) (xy 129.8584 81.029157) (xy 129.999235 81.200765)
        (xy 130.170843 81.3416) (xy 130.366629 81.44625) (xy 130.579069 81.510693) (xy 130.8 81.532453) (xy 132.8 81.532453)
        (xy 133.020931 81.510693) (xy 133.233371 81.44625) (xy 133.429157 81.3416) (xy 133.571191 81.225035) (xy 133.708281 81.316636)
        (xy 134.204563 81.522203) (xy 134.731414 81.627) (xy 135.268586 81.627) (xy 135.795437 81.522203) (xy 136.291719 81.316636)
        (xy 136.428809 81.225035) (xy 136.570843 81.3416) (xy 136.766629 81.44625) (xy 136.979069 81.510693) (xy 137.2 81.532453)
        (xy 139.2 81.532453) (xy 139.420931 81.510693) (xy 139.633371 81.44625) (xy 139.829157 81.3416) (xy 140.000765 81.200765)
        (xy 140.1416 81.029157) (xy 140.24625 80.833371) (xy 140.310693 80.620931) (xy 140.332453 80.4) (xy 140.332453 79.414296)
        (xy 140.795437 79.322203) (xy 141.291719 79.116636) (xy 141.428809 79.025035) (xy 141.570843 79.1416) (xy 141.766629 79.24625)
        (xy 141.979069 79.310693) (xy 142.2 79.332453) (xy 144.2 79.332453) (xy 144.420931 79.310693) (xy 144.5 79.286708)
        (xy 144.579069 79.310693) (xy 144.8 79.332453) (xy 146.8 79.332453) (xy 147.020931 79.310693) (xy 147.233371 79.24625)
        (xy 147.429157 79.1416) (xy 147.571191 79.025035) (xy 147.708281 79.116636) (xy 148.204563 79.322203) (xy 148.667547 79.414296)
        (xy 148.667547 80.4) (xy 148.689307 80.620931) (xy 148.75375 80.833371) (xy 148.8584 81.029157) (xy 148.999235 81.200765)
        (xy 149.170843 81.3416) (xy 149.366629 81.44625) (xy 149.579069 81.510693) (xy 149.8 81.532453) (xy 151.8 81.532453)
        (xy 152.020931 81.510693) (xy 152.233371 81.44625) (xy 152.429157 81.3416) (xy 152.571191 81.225035) (xy 152.708281 81.316636)
        (xy 153.204563 81.522203) (xy 153.731414 81.627) (xy 154.268586 81.627) (xy 154.795437 81.522203) (xy 155.291719 81.316636)
        (xy 155.428809 81.225035) (xy 155.570843 81.3416) (xy 155.766629 81.44625) (xy 155.979069 81.510693) (xy 156.2 81.532453)
        (xy 158.2 81.532453) (xy 158.420931 81.510693) (xy 158.633371 81.44625) (xy 158.829157 81.3416) (xy 159.000765 81.200765)
        (xy 159.1416 81.029157) (xy 159.24625 80.833371) (xy 159.310693 80.620931) (xy 159.332453 80.4) (xy 159.332453 79.414296)
        (xy 159.795437 79.322203) (xy 160.291719 79.116636) (xy 160.428809 79.025035) (xy 160.570843 79.1416) (xy 160.766629 79.24625)
        (xy 160.979069 79.310693) (xy 161.2 79.332453) (xy 163.2 79.332453) (xy 163.420931 79.310693) (xy 163.633371 79.24625)
        (xy 163.829157 79.1416) (xy 164.000765 79.000765) (xy 164.1416 78.829157) (xy 164.24625 78.633371) (xy 164.310693 78.420931)
        (xy 164.332453 78.2) (xy 164.332453 75.2) (xy 164.310693 74.979069) (xy 164.24625 74.766629) (xy 164.1416 74.570843)
        (xy 164.000765 74.399235) (xy 163.829157 74.2584) (xy 163.633371 74.15375) (xy 163.420931 74.089307) (xy 163.2 74.067547)
        (xy 161.576534 74.067547) (xy 161.737574 73.678761) (xy 161.827 73.229189) (xy 161.827 72.982453) (xy 162.3962 72.982453)
        (xy 162.676399 72.954856) (xy 162.94583 72.873125) (xy 163.194139 72.740401) (xy 163.411784 72.561784) (xy 163.590401 72.344139)
        (xy 163.723125 72.09583) (xy 163.804856 71.826399) (xy 163.832453 71.5462) (xy 163.832453 70.5538) (xy 163.804856 70.273601)
        (xy 163.723125 70.00417) (xy 163.690457 69.943053) (xy 163.731769 69.843318) (xy 163.777 69.615924) (xy 163.777 69.384076)
        (xy 163.731769 69.156682) (xy 163.690457 69.056947) (xy 163.723125 68.99583) (xy 163.804856 68.726399) (xy 163.832453 68.4462)
        (xy 163.832453 67.4538) (xy 163.804856 67.173601) (xy 163.723125 66.90417) (xy 163.590401 66.655861) (xy 163.411784 66.438216)
        (xy 163.194139 66.259599) (xy 162.94583 66.126875) (xy 162.676399 66.045144) (xy 162.3962 66.017547) (xy 162.288142 66.017547)
        (xy 161.178787 64.908192) (xy 161.139581 64.860419) (xy 160.948939 64.703964) (xy 160.731438 64.587707) (xy 160.495435 64.516116)
        (xy 160.311498 64.498) (xy 160.311496 64.498) (xy 160.25 64.491943) (xy 160.188504 64.498) (xy 142.811496 64.498)
        (xy 142.75 64.491943) (xy 142.688504 64.498) (xy 123.811496 64.498) (xy 123.75 64.491943) (xy 123.688504 64.498)
        (xy 104.811496 64.498) (xy 104.75 64.491943) (xy 104.688504 64.498) (xy 85.811496 64.498) (xy 85.75 64.491943)
        (xy 85.688504 64.498) (xy 66.811496 64.498) (xy 66.75 64.491943) (xy 66.688504 64.498) (xy 47.811496 64.498)
        (xy 47.75 64.491943) (xy 47.688504 64.498) (xy 34.268595 64.498) (xy 20.502 50.731405) (xy 20.502 46.502)
        (xy 32.697952 46.502) (xy 32.663677 46.85) (xy 32.700883 47.227758) (xy 32.811071 47.590999) (xy 32.990006 47.925763)
        (xy 33.230813 48.219187) (xy 33.524237 48.459994) (xy 33.859001 48.638929) (xy 34.222242 48.749117) (xy 34.505342 48.777)
        (xy 35.494658 48.777) (xy 35.777758 48.749117) (xy 36.140999 48.638929) (xy 36.475763 48.459994) (xy 36.769187 48.219187)
        (xy 37.009994 47.925763) (xy 37.188929 47.590999) (xy 37.299117 47.227758) (xy 37.336323 46.85) (xy 37.302048 46.502)
        (xy 42.697952 46.502) (xy 42.663677 46.85) (xy 42.700883 47.227758) (xy 42.811071 47.590999) (xy 42.990006 47.925763)
        (xy 43.230813 48.219187) (xy 43.524237 48.459994) (xy 43.859001 48.638929) (xy 44.222242 48.749117) (xy 44.505342 48.777)
        (xy 45.494658 48.777) (xy 45.777758 48.749117) (xy 46.140999 48.638929) (xy 46.223 48.595099) (xy 46.223 48.615924)
        (xy 46.268231 48.843318) (xy 46.309543 48.943053) (xy 46.276875 49.00417) (xy 46.195144 49.273601) (xy 46.167547 49.5538)
        (xy 46.167547 49.760195) (xy 45.729189 49.673) (xy 45.270811 49.673) (xy 44.821239 49.762426) (xy 44.397752 49.93784)
        (xy 44.016624 50.192501) (xy 43.72917 50.479955) (xy 43.568681 50.0925) (xy 43.127975 49.432937) (xy 42.567063 48.872025)
        (xy 41.9075 48.431319) (xy 41.174633 48.127755) (xy 40.396625 47.973) (xy 39.603375 47.973) (xy 38.825367 48.127755)
        (xy 38.0925 48.431319) (xy 37.432937 48.872025) (xy 36.872025 49.432937) (xy 36.431319 50.0925) (xy 36.27083 50.479955)
        (xy 35.983376 50.192501) (xy 35.602248 49.93784) (xy 35.178761 49.762426) (xy 34.729189 49.673) (xy 34.270811 49.673)
        (xy 33.821239 49.762426) (xy 33.397752 49.93784) (xy 33.016624 50.192501) (xy 32.692501 50.516624) (xy 32.43784 50.897752)
        (xy 32.262426 51.321239) (xy 32.173 51.770811) (xy 32.173 52.229189) (xy 32.262426 52.678761) (xy 32.423466 53.067547)
        (xy 30.8 53.067547) (xy 30.579069 53.089307) (xy 30.366629 53.15375) (xy 30.170843 53.2584) (xy 29.999235 53.399235)
        (xy 29.8584 53.570843) (xy 29.75375 53.766629) (xy 29.689307 53.979069) (xy 29.667547 54.2) (xy 29.667547 57.2)
        (xy 29.689307 57.420931) (xy 29.75375 57.633371) (xy 29.8584 57.829157) (xy 29.999235 58.000765) (xy 30.170843 58.1416)
        (xy 30.366629 58.24625) (xy 30.579069 58.310693) (xy 30.8 58.332453) (xy 32.8 58.332453) (xy 33.020931 58.310693)
        (xy 33.233371 58.24625) (xy 33.429157 58.1416) (xy 33.571191 58.025035) (xy 33.708281 58.116636) (xy 34.204563 58.322203)
        (xy 34.667547 58.414296) (xy 34.667547 59.4) (xy 34.689307 59.620931) (xy 34.75375 59.833371) (xy 34.8584 60.029157)
        (xy 34.999235 60.200765) (xy 35.170843 60.3416) (xy 35.366629 60.44625) (xy 35.579069 60.510693) (xy 35.8 60.532453)
        (xy 37.8 60.532453) (xy 38.020931 60.510693) (xy 38.233371 60.44625) (xy 38.429157 60.3416) (xy 38.571191 60.225035)
        (xy 38.708281 60.316636) (xy 39.204563 60.522203) (xy 39.731414 60.627) (xy 40.268586 60.627) (xy 40.795437 60.522203)
        (xy 41.291719 60.316636) (xy 41.428809 60.225035) (xy 41.570843 60.3416) (xy 41.766629 60.44625) (xy 41.979069 60.510693)
        (xy 42.2 60.532453) (xy 44.2 60.532453) (xy 44.420931 60.510693) (xy 44.633371 60.44625) (xy 44.829157 60.3416)
        (xy 45.000765 60.200765) (xy 45.1416 60.029157) (xy 45.24625 59.833371) (xy 45.310693 59.620931) (xy 45.332453 59.4)
        (xy 45.332453 58.414296) (xy 45.795437 58.322203) (xy 46.291719 58.116636) (xy 46.428809 58.025035) (xy 46.570843 58.1416)
        (xy 46.766629 58.24625) (xy 46.979069 58.310693) (xy 47.2 58.332453) (xy 49.2 58.332453) (xy 49.420931 58.310693)
        (xy 49.5 58.286708) (xy 49.579069 58.310693) (xy 49.8 58.332453) (xy 51.8 58.332453) (xy 52.020931 58.310693)
        (xy 52.233371 58.24625) (xy 52.429157 58.1416) (xy 52.571191 58.025035) (xy 52.708281 58.116636) (xy 53.204563 58.322203)
        (xy 53.667547 58.414296) (xy 53.667547 59.4) (xy 53.689307 59.620931) (xy 53.75375 59.833371) (xy 53.8584 60.029157)
        (xy 53.999235 60.200765) (xy 54.170843 60.3416) (xy 54.366629 60.44625) (xy 54.579069 60.510693) (xy 54.8 60.532453)
        (xy 56.8 60.532453) (xy 57.020931 60.510693) (xy 57.233371 60.44625) (xy 57.429157 60.3416) (xy 57.571191 60.225035)
        (xy 57.708281 60.316636) (xy 58.204563 60.522203) (xy 58.731414 60.627) (xy 59.268586 60.627) (xy 59.795437 60.522203)
        (xy 60.291719 60.316636) (xy 60.428809 60.225035) (xy 60.570843 60.3416) (xy 60.766629 60.44625) (xy 60.979069 60.510693)
        (xy 61.2 60.532453) (xy 63.2 60.532453) (xy 63.420931 60.510693) (xy 63.633371 60.44625) (xy 63.829157 60.3416)
        (xy 64.000765 60.200765) (xy 64.1416 60.029157) (xy 64.24625 59.833371) (xy 64.310693 59.620931) (xy 64.332453 59.4)
        (xy 64.332453 58.414296) (xy 64.795437 58.322203) (xy 65.291719 58.116636) (xy 65.428809 58.025035) (xy 65.570843 58.1416)
        (xy 65.766629 58.24625) (xy 65.979069 58.310693) (xy 66.2 58.332453) (xy 68.2 58.332453) (xy 68.420931 58.310693)
        (xy 68.5 58.286708) (xy 68.579069 58.310693) (xy 68.8 58.332453) (xy 70.8 58.332453) (xy 71.020931 58.310693)
        (xy 71.233371 58.24625) (xy 71.429157 58.1416) (xy 71.571191 58.025035) (xy 71.708281 58.116636) (xy 72.204563 58.322203)
        (xy 72.667547 58.414296) (xy 72.667547 59.4) (xy 72.689307 59.620931) (xy 72.75375 59.833371) (xy 72.8584 60.029157)
        (xy 72.999235 60.200765) (xy 73.170843 60.3416) (xy 73.366629 60.44625) (xy 73.579069 60.510693) (xy 73.8 60.532453)
        (xy 75.8 60.532453) (xy 76.020931 60.510693) (xy 76.233371 60.44625) (xy 76.429157 60.3416) (xy 76.571191 60.225035)
        (xy 76.708281 60.316636) (xy 77.204563 60.522203) (xy 77.731414 60.627) (xy 78.268586 60.627) (xy 78.795437 60.522203)
        (xy 79.291719 60.316636) (xy 79.428809 60.225035) (xy 79.570843 60.3416) (xy 79.766629 60.44625) (xy 79.979069 60.510693)
        (xy 80.2 60.532453) (xy 82.2 60.532453) (xy 82.420931 60.510693) (xy 82.633371 60.44625) (xy 82.829157 60.3416)
        (xy 83.000765 60.200765) (xy 83.1416 60.029157) (xy 83.24625 59.833371) (xy 83.310693 59.620931) (xy 83.332453 59.4)
        (xy 83.332453 58.414296) (xy 83.795437 58.322203) (xy 84.291719 58.116636) (xy 84.428809 58.025035) (xy 84.570843 58.1416)
        (xy 84.766629 58.24625) (xy 84.979069 58.310693) (xy 85.2 58.332453) (xy 87.2 58.332453) (xy 87.420931 58.310693)
        (xy 87.5 58.286708) (xy 87.579069 58.310693) (xy 87.8 58.332453) (xy 89.8 58.332453) (xy 90.020931 58.310693)
        (xy 90.233371 58.24625) (xy 90.429157 58.1416) (xy 90.571191 58.025035) (xy 90.708281 58.116636) (xy 91.204563 58.322203)
        (xy 91.667547 58.414296) (xy 91.667547 59.4) (xy 91.689307 59.620931) (xy 91.75375 59.833371) (xy 91.8584 60.029157)
        (xy 91.999235 60.200765) (xy 92.170843 60.3416) (xy 92.366629 60.44625) (xy 92.579069 60.510693) (xy 92.8 60.532453)
        (xy 94.8 60.532453) (xy 95.020931 60.510693) (xy 95.233371 60.44625) (xy 95.429157 60.3416) (xy 95.571191 60.225035)
        (xy 95.708281 60.316636) (xy 96.204563 60.522203) (xy 96.731414 60.627) (xy 97.268586 60.627) (xy 97.795437 60.522203)
        (xy 98.291719 60.316636) (xy 98.428809 60.225035) (xy 98.570843 60.3416) (xy 98.766629 60.44625) (xy 98.979069 60.510693)
        (xy 99.2 60.532453) (xy 101.2 60.532453) (xy 101.420931 60.510693) (xy 101.633371 60.44625) (xy 101.829157 60.3416)
        (xy 102.000765 60.200765) (xy 102.1416 60.029157) (xy 102.24625 59.833371) (xy 102.310693 59.620931) (xy 102.332453 59.4)
        (xy 102.332453 58.414296) (xy 102.795437 58.322203) (xy 103.291719 58.116636) (xy 103.428809 58.025035) (xy 103.570843 58.1416)
        (xy 103.766629 58.24625) (xy 103.979069 58.310693) (xy 104.2 58.332453) (xy 106.2 58.332453) (xy 106.420931 58.310693)
        (xy 106.5 58.286708) (xy 106.579069 58.310693) (xy 106.8 58.332453) (xy 108.8 58.332453) (xy 109.020931 58.310693)
        (xy 109.233371 58.24625) (xy 109.429157 58.1416) (xy 109.571191 58.025035) (xy 109.708281 58.116636) (xy 110.204563 58.322203)
        (xy 110.667547 58.414296) (xy 110.667547 59.4) (xy 110.689307 59.620931) (xy 110.75375 59.833371) (xy 110.8584 60.029157)
        (xy 110.999235 60.200765) (xy 111.170843 60.3416) (xy 111.366629 60.44625) (xy 111.579069 60.510693) (xy 111.8 60.532453)
        (xy 113.8 60.532453) (xy 114.020931 60.510693) (xy 114.233371 60.44625) (xy 114.429157 60.3416) (xy 114.571191 60.225035)
        (xy 114.708281 60.316636) (xy 115.204563 60.522203) (xy 115.731414 60.627) (xy 116.268586 60.627) (xy 116.795437 60.522203)
        (xy 117.291719 60.316636) (xy 117.428809 60.225035) (xy 117.570843 60.3416) (xy 117.766629 60.44625) (xy 117.979069 60.510693)
        (xy 118.2 60.532453) (xy 120.2 60.532453) (xy 120.420931 60.510693) (xy 120.633371 60.44625) (xy 120.829157 60.3416)
        (xy 121.000765 60.200765) (xy 121.1416 60.029157) (xy 121.24625 59.833371) (xy 121.310693 59.620931) (xy 121.332453 59.4)
        (xy 121.332453 58.414296) (xy 121.795437 58.322203) (xy 122.291719 58.116636) (xy 122.428809 58.025035) (xy 122.570843 58.1416)
        (xy 122.766629 58.24625) (xy 122.979069 58.310693) (xy 123.2 58.332453) (xy 125.2 58.332453) (xy 125.420931 58.310693)
        (xy 125.5 58.286708) (xy 125.579069 58.310693) (xy 125.8 58.332453) (xy 127.8 58.332453) (xy 128.020931 58.310693)
        (xy 128.233371 58.24625) (xy 128.429157 58.1416) (xy 128.571191 58.025035) (xy 128.708281 58.116636) (xy 129.204563 58.322203)
        (xy 129.667547 58.414296) (xy 129.667547 59.4) (xy 129.689307 59.620931) (xy 129.75375 59.833371) (xy 129.8584 60.029157)
        (xy 129.999235 60.200765) (xy 130.170843 60.3416) (xy 130.366629 60.44625) (xy 130.579069 60.510693) (xy 130.8 60.532453)
        (xy 132.8 60.532453) (xy 133.020931 60.510693) (xy 133.233371 60.44625) (xy 133.429157 60.3416) (xy 133.571191 60.225035)
        (xy 133.708281 60.316636) (xy 134.204563 60.522203) (xy 134.731414 60.627) (xy 135.268586 60.627) (xy 135.795437 60.522203)
        (xy 136.291719 60.316636) (xy 136.428809 60.225035) (xy 136.570843 60.3416) (xy 136.766629 60.44625) (xy 136.979069 60.510693)
        (xy 137.2 60.532453) (xy 139.2 60.532453) (xy 139.420931 60.510693) (xy 139.633371 60.44625) (xy 139.829157 60.3416)
        (xy 140.000765 60.200765) (xy 140.1416 60.029157) (xy 140.24625 59.833371) (xy 140.310693 59.620931) (xy 140.332453 59.4)
        (xy 140.332453 58.414296) (xy 140.795437 58.322203) (xy 141.291719 58.116636) (xy 141.428809 58.025035) (xy 141.570843 58.1416)
        (xy 141.766629 58.24625) (xy 141.979069 58.310693) (xy 142.2 58.332453) (xy 144.2 58.332453) (xy 144.420931 58.310693)
        (xy 144.5 58.286708) (xy 144.579069 58.310693) (xy 144.8 58.332453) (xy 146.8 58.332453) (xy 147.020931 58.310693)
        (xy 147.233371 58.24625) (xy 147.429157 58.1416) (xy 147.571191 58.025035) (xy 147.708281 58.116636) (xy 148.204563 58.322203)
        (xy 148.667547 58.414296) (xy 148.667547 59.4) (xy 148.689307 59.620931) (xy 148.75375 59.833371) (xy 148.8584 60.029157)
        (xy 148.999235 60.200765) (xy 149.170843 60.3416) (xy 149.366629 60.44625) (xy 149.579069 60.510693) (xy 149.8 60.532453)
        (xy 151.8 60.532453) (xy 152.020931 60.510693) (xy 152.233371 60.44625) (xy 152.429157 60.3416) (xy 152.571191 60.225035)
        (xy 152.708281 60.316636) (xy 153.204563 60.522203) (xy 153.731414 60.627) (xy 154.268586 60.627) (xy 154.795437 60.522203)
        (xy 155.291719 60.316636) (xy 155.428809 60.225035) (xy 155.570843 60.3416) (xy 155.766629 60.44625) (xy 155.979069 60.510693)
        (xy 156.2 60.532453) (xy 158.2 60.532453) (xy 158.420931 60.510693) (xy 158.633371 60.44625) (xy 158.829157 60.3416)
        (xy 159.000765 60.200765) (xy 159.1416 60.029157) (xy 159.24625 59.833371) (xy 159.310693 59.620931) (xy 159.332453 59.4)
        (xy 159.332453 58.414296) (xy 159.795437 58.322203) (xy 160.291719 58.116636) (xy 160.428809 58.025035) (xy 160.570843 58.1416)
        (xy 160.766629 58.24625) (xy 160.979069 58.310693) (xy 161.2 58.332453) (xy 163.2 58.332453) (xy 163.420931 58.310693)
        (xy 163.633371 58.24625) (xy 163.829157 58.1416) (xy 164.000765 58.000765) (xy 164.1416 57.829157) (xy 164.24625 57.633371)
        (xy 164.310693 57.420931) (xy 164.332453 57.2) (xy 164.332453 54.2) (xy 164.310693 53.979069) (xy 164.24625 53.766629)
        (xy 164.1416 53.570843) (xy 164.000765 53.399235) (xy 163.829157 53.2584) (xy 163.633371 53.15375) (xy 163.420931 53.089307)
        (xy 163.2 53.067547) (xy 161.576534 53.067547) (xy 161.737574 52.678761) (xy 161.827 52.229189) (xy 161.827 51.982453)
        (xy 162.3962 51.982453) (xy 162.676399 51.954856) (xy 162.94583 51.873125) (xy 163.194139 51.740401) (xy 163.411784 51.561784)
        (xy 163.590401 51.344139) (xy 163.723125 51.09583) (xy 163.804856 50.826399) (xy 163.832453 50.5462) (xy 163.832453 49.5538)
        (xy 163.804856 49.273601) (xy 163.723125 49.00417) (xy 163.690457 48.943053) (xy 163.731769 48.843318) (xy 163.777 48.615924)
        (xy 163.777 48.384076) (xy 163.731769 48.156682) (xy 163.690457 48.056947) (xy 163.723125 47.99583) (xy 163.804856 47.726399)
        (xy 163.832453 47.4462) (xy 163.832453 46.4538) (xy 163.804856 46.173601) (xy 163.723125 45.90417) (xy 163.590401 45.655861)
        (xy 163.411784 45.438216) (xy 163.194139 45.259599) (xy 162.94583 45.126875) (xy 162.676399 45.045144) (xy 162.3962 45.017547)
        (xy 162.288143 45.017547) (xy 161.678787 44.408192) (xy 161.639581 44.360419) (xy 161.448939 44.203964) (xy 161.231438 44.087707)
        (xy 160.995435 44.016116) (xy 160.811498 43.998) (xy 160.811496 43.998) (xy 160.75 43.991943) (xy 160.688504 43.998)
        (xy 144.272595 43.998) (xy 146.341814 41.928782) (xy 146.389581 41.889581) (xy 146.435711 41.833371) (xy 146.546036 41.69894)
        (xy 146.662293 41.481438) (xy 146.693974 41.377) (xy 146.733884 41.245435) (xy 146.752 41.061498) (xy 146.752 41.061497)
        (xy 146.758057 41.000001) (xy 146.752 40.938505) (xy 146.752 40.332453) (xy 146.8 40.332453) (xy 147.020931 40.310693)
        (xy 147.233371 40.24625) (xy 147.429157 40.1416) (xy 147.571191 40.025035) (xy 147.708281 40.116636) (xy 148.204563 40.322203)
        (xy 148.667547 40.414296) (xy 148.667547 41.4) (xy 148.689307 41.620931) (xy 148.75375 41.833371) (xy 148.8584 42.029157)
        (xy 148.999235 42.200765) (xy 149.170843 42.3416) (xy 149.366629 42.44625) (xy 149.579069 42.510693) (xy 149.8 42.532453)
        (xy 151.8 42.532453) (xy 152.020931 42.510693) (xy 152.233371 42.44625) (xy 152.429157 42.3416) (xy 152.571191 42.225035)
        (xy 152.708281 42.316636) (xy 153.204563 42.522203) (xy 153.731414 42.627) (xy 154.268586 42.627) (xy 154.795437 42.522203)
        (xy 155.291719 42.316636) (xy 155.428809 42.225035) (xy 155.570843 42.3416) (xy 155.766629 42.44625) (xy 155.979069 42.510693)
        (xy 156.2 42.532453) (xy 158.2 42.532453) (xy 158.420931 42.510693) (xy 158.633371 42.44625) (xy 158.829157 42.3416)
        (xy 159.000765 42.200765) (xy 159.1416 42.029157) (xy 159.24625 41.833371) (xy 159.310693 41.620931) (xy 159.332453 41.4)
        (xy 159.332453 40.414296) (xy 159.795437 40.322203) (xy 160.291719 40.116636) (xy 160.428809 40.025035) (xy 160.570843 40.1416)
        (xy 160.766629 40.24625) (xy 160.979069 40.310693) (xy 161.2 40.332453) (xy 163.2 40.332453) (xy 163.420931 40.310693)
        (xy 163.633371 40.24625) (xy 163.829157 40.1416) (xy 164.000765 40.000765) (xy 164.1416 39.829157) (xy 164.24625 39.633371)
        (xy 164.310693 39.420931) (xy 164.332453 39.2) (xy 164.332453 36.2) (xy 164.310693 35.979069) (xy 164.24625 35.766629)
        (xy 164.1416 35.570843) (xy 164.000765 35.399235) (xy 163.829157 35.2584) (xy 163.633371 35.15375) (xy 163.420931 35.089307)
        (xy 163.2 35.067547) (xy 161.576534 35.067547) (xy 161.737574 34.678761) (xy 161.827 34.229189) (xy 161.827 33.982453)
        (xy 162.3962 33.982453) (xy 162.676399 33.954856) (xy 162.94583 33.873125) (xy 163.194139 33.740401) (xy 163.411784 33.561784)
        (xy 163.590401 33.344139) (xy 163.723125 33.09583) (xy 163.804856 32.826399) (xy 163.832453 32.5462) (xy 163.832453 31.5538)
        (xy 163.804856 31.273601) (xy 163.723125 31.00417) (xy 163.690457 30.943053) (xy 163.731769 30.843318) (xy 163.777 30.615924)
        (xy 163.777 30.384076) (xy 163.731769 30.156682) (xy 163.690457 30.056947) (xy 163.723125 29.99583) (xy 163.804856 29.726399)
        (xy 163.832453 29.4462) (xy 163.832453 28.4538) (xy 163.804856 28.173601) (xy 163.723125 27.90417) (xy 163.590401 27.655861)
        (xy 163.411784 27.438216) (xy 163.194139 27.259599) (xy 162.94583 27.126875) (xy 162.676399 27.045144) (xy 162.3962 27.017547)
        (xy 162.288143 27.017547) (xy 161.428787 26.158192) (xy 161.389581 26.110419) (xy 161.198939 25.953964) (xy 160.981438 25.837707)
        (xy 160.745435 25.766116) (xy 160.561498 25.748) (xy 160.561496 25.748) (xy 160.5 25.741943) (xy 160.438504 25.748)
        (xy 143.061498 25.748) (xy 143 25.741943) (xy 142.938502 25.748) (xy 124.061498 25.748) (xy 124 25.741943)
        (xy 123.938502 25.748) (xy 105.061498 25.748) (xy 105 25.741943) (xy 104.938502 25.748) (xy 87.022595 25.748)
        (xy 89.341814 23.428782) (xy 89.389581 23.389581) (xy 89.454891 23.31) (xy 89.546036 23.19894) (xy 89.662293 22.981438)
        (xy 89.678266 22.928783) (xy 89.733884 22.745435) (xy 89.752 22.561498) (xy 89.752 22.561497) (xy 89.758057 22.500001)
        (xy 89.752 22.438505) (xy 89.752 22.332453) (xy 89.8 22.332453) (xy 90.020931 22.310693) (xy 90.233371 22.24625)
        (xy 90.429157 22.1416) (xy 90.571191 22.025035) (xy 90.708281 22.116636) (xy 91.204563 22.322203) (xy 91.667547 22.414296)
        (xy 91.667547 23.4) (xy 91.689307 23.620931) (xy 91.75375 23.833371) (xy 91.8584 24.029157) (xy 91.999235 24.200765)
        (xy 92.170843 24.3416) (xy 92.366629 24.44625) (xy 92.579069 24.510693) (xy 92.8 24.532453) (xy 94.8 24.532453)
        (xy 95.020931 24.510693) (xy 95.233371 24.44625) (xy 95.429157 24.3416) (xy 95.571191 24.225035) (xy 95.708281 24.316636)
        (xy 96.204563 24.522203) (xy 96.731414 24.627) (xy 97.268586 24.627) (xy 97.795437 24.522203) (xy 98.291719 24.316636)
        (xy 98.428809 24.225035) (xy 98.570843 24.3416) (xy 98.766629 24.44625) (xy 98.979069 24.510693) (xy 99.2 24.532453)
        (xy 101.2 24.532453) (xy 101.420931 24.510693) (xy 101.633371 24.44625) (xy 101.829157 24.3416) (xy 102.000765 24.200765)
        (xy 102.1416 24.029157) (xy 102.24625 23.833371) (xy 102.310693 23.620931) (xy 102.332453 23.4) (xy 102.332453 22.414296)
        (xy 102.795437 22.322203) (xy 103.291719 22.116636) (xy 103.428809 22.025035) (xy 103.570843 22.1416) (xy 103.766629 22.24625)
        (xy 103.979069 22.310693) (xy 104.2 22.332453) (xy 106.2 22.332453) (xy 106.420931 22.310693) (xy 106.5 22.286708)
        (xy 106.579069 22.310693) (xy 106.8 22.332453) (xy 108.8 22.332453) (xy 109.020931 22.310693) (xy 109.233371 22.24625)
        (xy 109.429157 22.1416) (xy 109.571191 22.025035) (xy 109.708281 22.116636) (xy 110.204563 22.322203) (xy 110.667547 22.414296)
        (xy 110.667547 23.4) (xy 110.689307 23.620931) (xy 110.75375 23.833371) (xy 110.8584 24.029157) (xy 110.999235 24.200765)
        (xy 111.170843 24.3416) (xy 111.366629 24.44625) (xy 111.579069 24.510693) (xy 111.8 24.532453) (xy 113.8 24.532453)
        (xy 114.020931 24.510693) (xy 114.233371 24.44625) (xy 114.429157 24.3416) (xy 114.571191 24.225035) (xy 114.708281 24.316636)
        (xy 115.204563 24.522203) (xy 115.731414 24.627) (xy 116.268586 24.627) (xy 116.795437 24.522203) (xy 117.291719 24.316636)
        (xy 117.428809 24.225035) (xy 117.570843 24.3416) (xy 117.766629 24.44625) (xy 117.979069 24.510693) (xy 118.2 24.532453)
        (xy 120.2 24.532453) (xy 120.420931 24.510693) (xy 120.633371 24.44625) (xy 120.829157 24.3416) (xy 121.000765 24.200765)
        (xy 121.1416 24.029157) (xy 121.24625 23.833371) (xy 121.310693 23.620931) (xy 121.332453 23.4) (xy 121.332453 22.414296)
        (xy 121.795437 22.322203) (xy 122.291719 22.116636) (xy 122.428809 22.025035) (xy 122.570843 22.1416) (xy 122.766629 22.24625)
        (xy 122.979069 22.310693) (xy 123.2 22.332453) (xy 125.2 22.332453) (xy 125.420931 22.310693) (xy 125.5 22.286708)
        (xy 125.579069 22.310693) (xy 125.8 22.332453) (xy 127.8 22.332453) (xy 128.020931 22.310693) (xy 128.233371 22.24625)
        (xy 128.429157 22.1416) (xy 128.571191 22.025035) (xy 128.708281 22.116636) (xy 129.204563 22.322203) (xy 129.667547 22.414296)
        (xy 129.667547 23.4) (xy 129.689307 23.620931) (xy 129.75375 23.833371) (xy 129.8584 24.029157) (xy 129.999235 24.200765)
        (xy 130.170843 24.3416) (xy 130.366629 24.44625) (xy 130.579069 24.510693) (xy 130.8 24.532453) (xy 132.8 24.532453)
        (xy 133.020931 24.510693) (xy 133.233371 24.44625) (xy 133.429157 24.3416) (xy 133.571191 24.225035) (xy 133.708281 24.316636)
        (xy 134.204563 24.522203) (xy 134.731414 24.627) (xy 135.268586 24.627) (xy 135.795437 24.522203) (xy 136.291719 24.316636)
        (xy 136.428809 24.225035) (xy 136.570843 24.3416) (xy 136.766629 24.44625) (xy 136.979069 24.510693) (xy 137.2 24.532453)
        (xy 139.2 24.532453) (xy 139.420931 24.510693) (xy 139.633371 24.44625) (xy 139.829157 24.3416) (xy 140.000765 24.200765)
        (xy 140.1416 24.029157) (xy 140.24625 23.833371) (xy 140.310693 23.620931) (xy 140.332453 23.4) (xy 140.332453 22.414296)
        (xy 140.795437 22.322203) (xy 141.291719 22.116636) (xy 141.428809 22.025035) (xy 141.570843 22.1416) (xy 141.766629 22.24625)
        (xy 141.979069 22.310693) (xy 142.2 22.332453) (xy 144.2 22.332453) (xy 144.420931 22.310693) (xy 144.5 22.286708)
        (xy 144.579069 22.310693) (xy 144.8 22.332453) (xy 146.8 22.332453) (xy 147.020931 22.310693) (xy 147.233371 22.24625)
        (xy 147.429157 22.1416) (xy 147.571191 22.025035) (xy 147.708281 22.116636) (xy 148.204563 22.322203) (xy 148.667547 22.414296)
        (xy 148.667547 23.4) (xy 148.689307 23.620931) (xy 148.75375 23.833371) (xy 148.8584 24.029157) (xy 148.999235 24.200765)
        (xy 149.170843 24.3416) (xy 149.366629 24.44625) (xy 149.579069 24.510693) (xy 149.8 24.532453) (xy 151.8 24.532453)
        (xy 152.020931 24.510693) (xy 152.233371 24.44625) (xy 152.429157 24.3416) (xy 152.571191 24.225035) (xy 152.708281 24.316636)
        (xy 153.204563 24.522203) (xy 153.731414 24.627) (xy 154.268586 24.627) (xy 154.795437 24.522203) (xy 155.291719 24.316636)
        (xy 155.428809 24.225035) (xy 155.570843 24.3416) (xy 155.766629 24.44625) (xy 155.979069 24.510693) (xy 156.2 24.532453)
        (xy 158.2 24.532453) (xy 158.420931 24.510693) (xy 158.633371 24.44625) (xy 158.829157 24.3416) (xy 159.000765 24.200765)
        (xy 159.1416 24.029157) (xy 159.24625 23.833371) (xy 159.310693 23.620931) (xy 159.332453 23.4) (xy 159.332453 22.414296)
        (xy 159.795437 22.322203) (xy 160.291719 22.116636) (xy 160.428809 22.025035) (xy 160.570843 22.1416) (xy 160.766629 22.24625)
        (xy 160.979069 22.310693) (xy 161.2 22.332453) (xy 163.2 22.332453) (xy 163.420931 22.310693) (xy 163.633371 22.24625)
        (xy 163.829157 22.1416) (xy 164.000765 22.000765) (xy 164.1416 21.829157) (xy 164.24625 21.633371) (xy 164.310693 21.420931)
        (xy 164.332453 21.2) (xy 164.332453 18.2) (xy 164.310693 17.979069) (xy 164.24625 17.766629) (xy 164.1416 17.570843)
        (xy 164.000765 17.399235) (xy 163.829157 17.2584) (xy 163.633371 17.15375) (xy 163.420931 17.089307) (xy 163.2 17.067547)
        (xy 161.576534 17.067547) (xy 161.737574 16.678761) (xy 161.827 16.229189) (xy 161.827 15.982453) (xy 162.3962 15.982453)
        (xy 162.676399 15.954856) (xy 162.94583 15.873125) (xy 163.194139 15.740401) (xy 163.411784 15.561784) (xy 163.590401 15.344139)
        (xy 163.723125 15.09583) (xy 163.804856 14.826399) (xy 163.832453 14.5462) (xy 163.832453 13.5538) (xy 163.804856 13.273601)
        (xy 163.723125 13.00417) (xy 163.690457 12.943053) (xy 163.731769 12.843318) (xy 163.777 12.615924) (xy 163.777 12.384076)
        (xy 163.731769 12.156682) (xy 163.690457 12.056947) (xy 163.723125 11.99583) (xy 163.804856 11.726399) (xy 163.832453 11.4462)
        (xy 163.832453 10.4538) (xy 163.804856 10.173601) (xy 163.723125 9.90417) (xy 163.590401 9.655861) (xy 163.411784 9.438216)
        (xy 163.237918 9.295528) (xy 163.233884 9.254565) (xy 163.162293 9.018562) (xy 163.046036 8.801061) (xy 162.889581 8.610419)
        (xy 162.841808 8.571213) (xy 161.928787 7.658192) (xy 161.889581 7.610419) (xy 161.698939 7.453964) (xy 161.481438 7.337707)
        (xy 161.245435 7.266116) (xy 161.061498 7.248) (xy 161.061496 7.248) (xy 161 7.241943) (xy 160.938504 7.248)
        (xy 143.061498 7.248) (xy 143 7.241943) (xy 142.938502 7.248) (xy 124.061498 7.248) (xy 124 7.241943)
        (xy 123.938502 7.248) (xy 105.061498 7.248) (xy 105 7.241943) (xy 104.938502 7.248) (xy 86.061498 7.248)
        (xy 86 7.241943) (xy 85.938502 7.248) (xy 67.061498 7.248) (xy 67 7.241943) (xy 66.938502 7.248)
        (xy 49.061496 7.248) (xy 49 7.241943) (xy 48.938504 7.248) (xy 48.938502 7.248) (xy 48.754565 7.266116)
        (xy 48.518562 7.337707) (xy 48.301061 7.453964) (xy 48.110419 7.610419) (xy 48.071213 7.658192) (xy 47.158192 8.571213)
        (xy 47.110419 8.610419) (xy 46.953964 8.801062) (xy 46.837707 9.018563) (xy 46.766116 9.254566) (xy 46.762082 9.295528)
        (xy 46.652749 9.385255) (xy 46.475763 9.240006) (xy 46.140999 9.061071) (xy 45.777758 8.950883) (xy 45.494658 8.923)
        (xy 44.505342 8.923) (xy 44.222242 8.950883) (xy 43.859001 9.061071) (xy 43.524237 9.240006) (xy 43.230813 9.480813)
        (xy 42.990006 9.774237) (xy 42.811071 10.109001) (xy 42.700883 10.472242) (xy 42.663677 10.85) (xy 42.700883 11.227758)
        (xy 42.707023 11.248) (xy 37.292977 11.248) (xy 37.299117 11.227758) (xy 37.336323 10.85) (xy 37.299117 10.472242)
        (xy 37.188929 10.109001) (xy 37.009994 9.774237) (xy 36.769187 9.480813) (xy 36.475763 9.240006) (xy 36.140999 9.061071)
        (xy 35.777758 8.950883) (xy 35.494658 8.923) (xy 34.847596 8.923) (xy 36.018596 7.752) (xy 36.938504 7.752)
        (xy 37 7.758057) (xy 37.061496 7.752) (xy 37.061498 7.752) (xy 37.245435 7.733884) (xy 37.481438 7.662293)
        (xy 37.698939 7.546036) (xy 37.889581 7.389581) (xy 37.928787 7.341808) (xy 38.841809 6.428786) (xy 38.889581 6.389581)
        (xy 39.046036 6.198939) (xy 39.162293 5.981438) (xy 39.233884 5.745435) (xy 39.252 5.561498) (xy 39.252 5.561496)
        (xy 39.258057 5.5) (xy 39.252 5.438504) (xy 39.252 5.307007) (xy 39.329164 5.265762) (xy 39.568963 5.068963)
        (xy 39.636009 4.987267) (xy 39.6584 5.029157) (xy 39.799235 5.200765) (xy 39.970843 5.3416) (xy 40.166629 5.44625)
        (xy 40.379069 5.510693) (xy 40.6 5.532453) (xy 41.09125 5.527) (xy 41.373 5.24525) (xy 41.373 3.627)
        (xy 41.627 3.627) (xy 41.627 5.24525) (xy 41.90875 5.527) (xy 42.4 5.532453) (xy 42.620931 5.510693)
        (xy 42.833371 5.44625) (xy 43.029157 5.3416) (xy 43.200765 5.200765) (xy 43.3416 5.029157) (xy 43.44625 4.833371)
        (xy 43.510693 4.620931) (xy 43.532453 4.4) (xy 43.527 3.90875) (xy 43.24525 3.627) (xy 41.627 3.627)
        (xy 41.373 3.627) (xy 41.353 3.627) (xy 41.353 3.373) (xy 41.373 3.373) (xy 41.373 1.75475)
        (xy 41.627 1.75475) (xy 41.627 3.373) (xy 43.24525 3.373) (xy 43.527 3.09125) (xy 43.532453 2.6)
        (xy 43.510693 2.379069) (xy 43.44625 2.166629) (xy 43.3416 1.970843) (xy 43.200765 1.799235) (xy 43.029157 1.6584)
        (xy 42.833371 1.55375) (xy 42.620931 1.489307) (xy 42.4 1.467547) (xy 41.90875 1.473) (xy 41.627 1.75475)
        (xy 41.373 1.75475) (xy 41.09125 1.473) (xy 40.6 1.467547) (xy 40.379069 1.489307) (xy 40.166629 1.55375)
        (xy 39.970843 1.6584) (xy 39.799235 1.799235) (xy 39.6584 1.970843) (xy 39.636009 2.012733) (xy 39.568963 1.931037)
        (xy 39.329164 1.734238) (xy 39.055579 1.588004) (xy 38.758721 1.497953) (xy 38.45 1.467547) (xy 37.55 1.467547)
        (xy 37.241279 1.497953) (xy 36.944421 1.588004) (xy 36.670836 1.734238) (xy 36.431037 1.931037) (xy 36.25 2.15163)
        (xy 36.068963 1.931037) (xy 35.829164 1.734238) (xy 35.555579 1.588004) (xy 35.258721 1.497953) (xy 34.95 1.467547)
        (xy 34.05 1.467547) (xy 33.741279 1.497953) (xy 33.444421 1.588004) (xy 33.170836 1.734238) (xy 32.931037 1.931037)
        (xy 32.734238 2.170836) (xy 32.588004 2.444421) (xy 32.497953 2.741279) (xy 32.467547 3.05) (xy 32.467547 3.95)
        (xy 32.497953 4.258721) (xy 32.588004 4.555579) (xy 32.734238 4.829164) (xy 32.931037 5.068963) (xy 33.170836 5.265762)
        (xy 33.248 5.307007) (xy 33.248 5.481404) (xy 28.507546 10.221858) (xy 28.472947 10.047915) (xy 28.327685 9.697223)
        (xy 28.116799 9.381609) (xy 28.067649 9.332459) (xy 28.250239 9.097458) (xy 28.419362 8.759672) (xy 28.49927 8.49623)
        (xy 28.260341 8.197) (xy 26.747 8.197) (xy 26.747 8.217) (xy 26.493 8.217) (xy 26.493 8.197)
        (xy 26.473 8.197) (xy 26.473 7.943) (xy 26.493 7.943) (xy 26.493 7.923) (xy 26.747 7.923)
        (xy 26.747 7.943) (xy 28.260341 7.943) (xy 28.49927 7.64377) (xy 28.419362 7.380328) (xy 28.250239 7.042542)
        (xy 28.067649 6.807541) (xy 28.116799 6.758391) (xy 28.327685 6.442777) (xy 28.472947 6.092085) (xy 28.547 5.719793)
        (xy 28.547 5.340207) (xy 28.472947 4.967915) (xy 28.327685 4.617223) (xy 28.116799 4.301609) (xy 27.848391 4.033201)
        (xy 27.532777 3.822315) (xy 27.182085 3.677053) (xy 26.809793 3.603) (xy 26.430207 3.603) (xy 26.057915 3.677053)
        (xy 25.707223 3.822315) (xy 25.391609 4.033201) (xy 25.132 4.29281) (xy 25.132 1.132) (xy 85.252721 1.132)
      )
    )
    (filled_polygon
      (pts
        (xy 25.707223 35.177685) (xy 26.057915 35.322947) (xy 26.430207 35.397) (xy 26.748 35.397) (xy 26.748001 39.068072)
        (xy 26.627 39.159377) (xy 26.627 41.873) (xy 28.527 41.873) (xy 28.527 41.797595) (xy 30.727405 43.998)
        (xy 28.321033 43.998) (xy 28.324103 43.993032) (xy 28.463275 43.620008) (xy 28.527 43.227) (xy 28.527 42.127)
        (xy 26.627 42.127) (xy 26.627 42.147) (xy 26.373 42.147) (xy 26.373 42.127) (xy 24.473 42.127)
        (xy 24.473 43.227) (xy 24.536725 43.620008) (xy 24.675897 43.993032) (xy 24.678967 43.998) (xy 21.318399 43.998)
        (xy 21.381764 43.879452) (xy 21.49767 43.497361) (xy 21.527 43.199571) (xy 21.527 40.800429) (xy 21.524299 40.773)
        (xy 24.473 40.773) (xy 24.473 41.873) (xy 26.373 41.873) (xy 26.373 39.159377) (xy 26.058094 38.921756)
        (xy 25.841632 38.978697) (xy 25.479455 39.144055) (xy 25.156497 39.376893) (xy 24.885169 39.668263) (xy 24.675897 40.006968)
        (xy 24.536725 40.379992) (xy 24.473 40.773) (xy 21.524299 40.773) (xy 21.49767 40.502639) (xy 21.381764 40.120548)
        (xy 21.193543 39.768411) (xy 20.94024 39.45976) (xy 20.631589 39.206457) (xy 20.279452 39.018236) (xy 19.897361 38.90233)
        (xy 19.5 38.863193) (xy 19.10264 38.90233) (xy 18.720549 39.018236) (xy 18.368412 39.206457) (xy 18.188294 39.354276)
        (xy 18.162293 39.268562) (xy 18.105491 39.162293) (xy 18.046036 39.05106) (xy 17.928783 38.908187) (xy 17.889581 38.860419)
        (xy 17.841813 38.821217) (xy 15.447595 36.427) (xy 24.192188 36.427) (xy 24.25 36.432694) (xy 24.307812 36.427)
        (xy 24.480732 36.409969) (xy 24.702597 36.342667) (xy 24.90707 36.233374) (xy 25.086291 36.086291) (xy 25.233374 35.90707)
        (xy 25.342667 35.702597) (xy 25.409969 35.480732) (xy 25.432694 35.25) (xy 25.427 35.192188) (xy 25.427 34.990446)
      )
    )
    (filled_polygon
      (pts
        (xy 12.868 3.836692) (xy 12.809157 3.7884) (xy 12.613371 3.68375) (xy 12.400931 3.619307) (xy 12.18 3.597547)
        (xy 10.58 3.597547) (xy 10.359069 3.619307) (xy 10.146629 3.68375) (xy 9.950843 3.7884) (xy 9.779235 3.929235)
        (xy 9.6384 4.100843) (xy 9.53375 4.296629) (xy 9.469307 4.509069) (xy 9.447547 4.73) (xy 9.447547 6.33)
        (xy 9.469307 6.550931) (xy 9.53375 6.763371) (xy 9.6384 6.959157) (xy 9.730044 7.070825) (xy 9.672315 7.157223)
        (xy 9.527053 7.507915) (xy 9.453 7.880207) (xy 9.453 8.259793) (xy 9.527053 8.632085) (xy 9.672315 8.982777)
        (xy 9.883201 9.298391) (xy 9.932351 9.347541) (xy 9.749761 9.582542) (xy 9.580638 9.920328) (xy 9.50073 10.18377)
        (xy 9.739659 10.483) (xy 11.253 10.483) (xy 11.253 10.463) (xy 11.507 10.463) (xy 11.507 10.483)
        (xy 11.527 10.483) (xy 11.527 10.737) (xy 11.507 10.737) (xy 11.507 13.023) (xy 11.527 13.023)
        (xy 11.527 13.277) (xy 11.507 13.277) (xy 11.507 13.297) (xy 11.253 13.297) (xy 11.253 13.277)
        (xy 9.739659 13.277) (xy 9.50073 13.57623) (xy 9.580638 13.839672) (xy 9.749761 14.177458) (xy 9.932351 14.412459)
        (xy 9.883201 14.461609) (xy 9.672315 14.777223) (xy 9.527053 15.127915) (xy 9.453 15.500207) (xy 9.453 15.879793)
        (xy 9.527053 16.252085) (xy 9.672315 16.602777) (xy 9.883201 16.918391) (xy 9.92481 16.96) (xy 9.883201 17.001609)
        (xy 9.672315 17.317223) (xy 9.527053 17.667915) (xy 9.453 18.040207) (xy 9.453 18.419793) (xy 9.527053 18.792085)
        (xy 9.672315 19.142777) (xy 9.883201 19.458391) (xy 9.92481 19.5) (xy 9.883201 19.541609) (xy 9.672315 19.857223)
        (xy 9.527053 20.207915) (xy 9.453 20.580207) (xy 9.453 20.959793) (xy 9.465764 21.023965) (xy 9.360419 21.110419)
        (xy 9.321217 21.158187) (xy 8.158187 22.321217) (xy 8.11042 22.360419) (xy 8.071218 22.408187) (xy 8.071217 22.408188)
        (xy 7.953964 22.551062) (xy 7.837707 22.768563) (xy 7.816733 22.837707) (xy 7.767502 23.000001) (xy 7.766117 23.004566)
        (xy 7.752 23.147893) (xy 7.752 16.561495) (xy 7.758057 16.499999) (xy 7.750772 16.426036) (xy 7.733884 16.254565)
        (xy 7.662293 16.018562) (xy 7.642992 15.982453) (xy 7.546036 15.80106) (xy 7.428783 15.658187) (xy 7.389581 15.610419)
        (xy 7.341814 15.571218) (xy 5.928787 14.158192) (xy 5.889581 14.110419) (xy 5.698939 13.953964) (xy 5.481438 13.837707)
        (xy 5.245435 13.766116) (xy 5.061498 13.748) (xy 5.061496 13.748) (xy 5 13.741943) (xy 4.938504 13.748)
        (xy 4.807007 13.748) (xy 4.765762 13.670836) (xy 4.568963 13.431037) (xy 4.329164 13.234238) (xy 4.055579 13.088004)
        (xy 3.758721 12.997953) (xy 3.45 12.967547) (xy 2.55 12.967547) (xy 2.241279 12.997953) (xy 1.944421 13.088004)
        (xy 1.670836 13.234238) (xy 1.431037 13.431037) (xy 1.234238 13.670836) (xy 1.132 13.86211) (xy 1.132 11.63789)
        (xy 1.234238 11.829164) (xy 1.431037 12.068963) (xy 1.670836 12.265762) (xy 1.944421 12.411996) (xy 2.241279 12.502047)
        (xy 2.55 12.532453) (xy 3.45 12.532453) (xy 3.758721 12.502047) (xy 4.055579 12.411996) (xy 4.329164 12.265762)
        (xy 4.568963 12.068963) (xy 4.765762 11.829164) (xy 4.911996 11.555579) (xy 5.002047 11.258721) (xy 5.02396 11.03623)
        (xy 9.50073 11.03623) (xy 9.580638 11.299672) (xy 9.749761 11.637458) (xy 9.93821 11.88) (xy 9.749761 12.122542)
        (xy 9.580638 12.460328) (xy 9.50073 12.72377) (xy 9.739659 13.023) (xy 11.253 13.023) (xy 11.253 10.737)
        (xy 9.739659 10.737) (xy 9.50073 11.03623) (xy 5.02396 11.03623) (xy 5.032453 10.95) (xy 5.032453 10.05)
        (xy 5.002047 9.741279) (xy 4.911996 9.444421) (xy 4.765762 9.170836) (xy 4.568963 8.931037) (xy 4.329164 8.734238)
        (xy 4.055579 8.588004) (xy 3.758721 8.497953) (xy 3.45 8.467547) (xy 2.55 8.467547) (xy 2.241279 8.497953)
        (xy 1.944421 8.588004) (xy 1.670836 8.734238) (xy 1.431037 8.931037) (xy 1.234238 9.170836) (xy 1.132 9.36211)
        (xy 1.132 4.055359) (xy 1.191944 3.443995) (xy 1.353422 2.909158) (xy 1.615705 2.415875) (xy 1.968802 1.982935)
        (xy 2.39927 1.626821) (xy 2.890711 1.3611) (xy 3.424397 1.195896) (xy 3.657648 1.171381) (xy 3.51881 1.228889)
        (xy 3.006654 1.571101) (xy 2.571101 2.006654) (xy 2.228889 2.51881) (xy 1.993169 3.087888) (xy 1.873 3.692017)
        (xy 1.873 4.307983) (xy 1.993169 4.912112) (xy 2.228889 5.48119) (xy 2.571101 5.993346) (xy 3.006654 6.428899)
        (xy 3.51881 6.771111) (xy 4.087888 7.006831) (xy 4.692017 7.127) (xy 5.307983 7.127) (xy 5.912112 7.006831)
        (xy 6.48119 6.771111) (xy 6.993346 6.428899) (xy 7.428899 5.993346) (xy 7.771111 5.48119) (xy 8.006831 4.912112)
        (xy 8.127 4.307983) (xy 8.127 3.692017) (xy 8.006831 3.087888) (xy 7.771111 2.51881) (xy 7.428899 2.006654)
        (xy 6.993346 1.571101) (xy 6.48119 1.228889) (xy 6.247279 1.132) (xy 12.868 1.132)
      )
    )
  )
  (zone (net 0) (net_name "") (layer B.Cu) (tstamp 60771F08) (hatch edge 0.508)
    (connect_pads (clearance 1))
    (min_thickness 0.254)
    (fill yes (arc_segments 32) (thermal_gap 1) (thermal_bridge_width 0.508))
    (polygon
      (pts
        (xy 174 89.5) (xy -1 89.5) (xy -1 -1.5) (xy 174 -1.5)
      )
    )
    (filled_polygon
      (pts
        (xy 85.01881 1.228889) (xy 84.506654 1.571101) (xy 84.071101 2.006654) (xy 83.728889 2.51881) (xy 83.493169 3.087888)
        (xy 83.373 3.692017) (xy 83.373 4.307983) (xy 83.493169 4.912112) (xy 83.728889 5.48119) (xy 84.071101 5.993346)
        (xy 84.506654 6.428899) (xy 85.01881 6.771111) (xy 85.587888 7.006831) (xy 86.192017 7.127) (xy 86.807983 7.127)
        (xy 87.412112 7.006831) (xy 87.98119 6.771111) (xy 88.493346 6.428899) (xy 88.928899 5.993346) (xy 89.271111 5.48119)
        (xy 89.506831 4.912112) (xy 89.627 4.307983) (xy 89.627 3.692017) (xy 89.506831 3.087888) (xy 89.271111 2.51881)
        (xy 88.928899 2.006654) (xy 88.493346 1.571101) (xy 87.98119 1.228889) (xy 87.747279 1.132) (xy 166.752721 1.132)
        (xy 166.51881 1.228889) (xy 166.006654 1.571101) (xy 165.571101 2.006654) (xy 165.228889 2.51881) (xy 164.993169 3.087888)
        (xy 164.873 3.692017) (xy 164.873 4.307983) (xy 164.993169 4.912112) (xy 165.228889 5.48119) (xy 165.571101 5.993346)
        (xy 166.006654 6.428899) (xy 166.51881 6.771111) (xy 167.087888 7.006831) (xy 167.692017 7.127) (xy 168.307983 7.127)
        (xy 168.912112 7.006831) (xy 169.48119 6.771111) (xy 169.993346 6.428899) (xy 170.428899 5.993346) (xy 170.771111 5.48119)
        (xy 171.006831 4.912112) (xy 171.127 4.307983) (xy 171.127 3.692017) (xy 171.006831 3.087888) (xy 170.771111 2.51881)
        (xy 170.428899 2.006654) (xy 169.993346 1.571101) (xy 169.48119 1.228889) (xy 169.341135 1.170876) (xy 169.556005 1.191944)
        (xy 170.090842 1.353422) (xy 170.584125 1.615705) (xy 171.017065 1.968802) (xy 171.373179 2.39927) (xy 171.6389 2.890711)
        (xy 171.804104 3.424397) (xy 171.868001 4.032336) (xy 171.868 84.94464) (xy 171.808055 85.556005) (xy 171.646578 86.090845)
        (xy 171.384297 86.584122) (xy 171.031198 87.017065) (xy 170.60073 87.373179) (xy 170.109291 87.6389) (xy 169.575602 87.804104)
        (xy 169.342352 87.82862) (xy 169.48119 87.771111) (xy 169.993346 87.428899) (xy 170.428899 86.993346) (xy 170.771111 86.48119)
        (xy 171.006831 85.912112) (xy 171.127 85.307983) (xy 171.127 84.692017) (xy 171.006831 84.087888) (xy 170.771111 83.51881)
        (xy 170.428899 83.006654) (xy 169.993346 82.571101) (xy 169.48119 82.228889) (xy 168.912112 81.993169) (xy 168.307983 81.873)
        (xy 167.692017 81.873) (xy 167.087888 81.993169) (xy 166.51881 82.228889) (xy 166.006654 82.571101) (xy 165.571101 83.006654)
        (xy 165.228889 83.51881) (xy 164.993169 84.087888) (xy 164.873 84.692017) (xy 164.873 85.307983) (xy 164.993169 85.912112)
        (xy 165.228889 86.48119) (xy 165.571101 86.993346) (xy 166.006654 87.428899) (xy 166.51881 87.771111) (xy 166.752721 87.868)
        (xy 87.747279 87.868) (xy 87.98119 87.771111) (xy 88.493346 87.428899) (xy 88.928899 86.993346) (xy 89.271111 86.48119)
        (xy 89.506831 85.912112) (xy 89.627 85.307983) (xy 89.627 84.692017) (xy 89.506831 84.087888) (xy 89.271111 83.51881)
        (xy 88.928899 83.006654) (xy 88.493346 82.571101) (xy 87.98119 82.228889) (xy 87.412112 81.993169) (xy 86.807983 81.873)
        (xy 86.192017 81.873) (xy 85.587888 81.993169) (xy 85.057896 82.212699) (xy 87.041809 80.228786) (xy 87.089581 80.189581)
        (xy 87.246036 79.998939) (xy 87.362293 79.781438) (xy 87.433884 79.545435) (xy 87.452 79.361498) (xy 87.452 79.361496)
        (xy 87.458057 79.3) (xy 87.458003 79.299447) (xy 87.5 79.286708) (xy 87.541997 79.299447) (xy 87.541943 79.3)
        (xy 87.566117 79.545434) (xy 87.637707 79.781437) (xy 87.753964 79.998938) (xy 87.753965 79.998939) (xy 87.91042 80.189581)
        (xy 87.958188 80.228783) (xy 90.071213 82.341808) (xy 90.110419 82.389581) (xy 90.301061 82.546036) (xy 90.518562 82.662293)
        (xy 90.754565 82.733884) (xy 90.938502 82.752) (xy 90.938504 82.752) (xy 91 82.758057) (xy 91.061496 82.752)
        (xy 102.938504 82.752) (xy 103 82.758057) (xy 103.061496 82.752) (xy 103.061498 82.752) (xy 103.245435 82.733884)
        (xy 103.481438 82.662293) (xy 103.698939 82.546036) (xy 103.889581 82.389581) (xy 103.928787 82.341808) (xy 106.041809 80.228786)
        (xy 106.089581 80.189581) (xy 106.246036 79.998939) (xy 106.362293 79.781438) (xy 106.433884 79.545435) (xy 106.452 79.361498)
        (xy 106.452 79.361496) (xy 106.458057 79.3) (xy 106.458003 79.299447) (xy 106.5 79.286708) (xy 106.541997 79.299447)
        (xy 106.541943 79.3) (xy 106.566117 79.545434) (xy 106.637707 79.781437) (xy 106.753964 79.998938) (xy 106.753965 79.998939)
        (xy 106.91042 80.189581) (xy 106.958188 80.228783) (xy 109.071213 82.341808) (xy 109.110419 82.389581) (xy 109.301061 82.546036)
        (xy 109.518562 82.662293) (xy 109.754565 82.733884) (xy 109.938502 82.752) (xy 109.938504 82.752) (xy 110 82.758057)
        (xy 110.061496 82.752) (xy 121.938504 82.752) (xy 122 82.758057) (xy 122.061496 82.752) (xy 122.061498 82.752)
        (xy 122.245435 82.733884) (xy 122.481438 82.662293) (xy 122.698939 82.546036) (xy 122.889581 82.389581) (xy 122.928787 82.341808)
        (xy 125.041809 80.228786) (xy 125.089581 80.189581) (xy 125.246036 79.998939) (xy 125.362293 79.781438) (xy 125.433884 79.545435)
        (xy 125.452 79.361498) (xy 125.452 79.361496) (xy 125.458057 79.3) (xy 125.458003 79.299447) (xy 125.5 79.286708)
        (xy 125.541997 79.299447) (xy 125.541943 79.3) (xy 125.566117 79.545434) (xy 125.637707 79.781437) (xy 125.753964 79.998938)
        (xy 125.753965 79.998939) (xy 125.91042 80.189581) (xy 125.958188 80.228783) (xy 128.071213 82.341808) (xy 128.110419 82.389581)
        (xy 128.301061 82.546036) (xy 128.518562 82.662293) (xy 128.754565 82.733884) (xy 128.938502 82.752) (xy 128.938504 82.752)
        (xy 129 82.758057) (xy 129.061496 82.752) (xy 140.938504 82.752) (xy 141 82.758057) (xy 141.061496 82.752)
        (xy 141.061498 82.752) (xy 141.245435 82.733884) (xy 141.481438 82.662293) (xy 141.698939 82.546036) (xy 141.889581 82.389581)
        (xy 141.928787 82.341808) (xy 144.041809 80.228786) (xy 144.089581 80.189581) (xy 144.246036 79.998939) (xy 144.362293 79.781438)
        (xy 144.433884 79.545435) (xy 144.452 79.361498) (xy 144.452 79.361496) (xy 144.458057 79.3) (xy 144.458003 79.299447)
        (xy 144.5 79.286708) (xy 144.541997 79.299447) (xy 144.541943 79.3) (xy 144.566117 79.545434) (xy 144.637707 79.781437)
        (xy 144.753964 79.998938) (xy 144.753965 79.998939) (xy 144.91042 80.189581) (xy 144.958188 80.228783) (xy 147.071213 82.341808)
        (xy 147.110419 82.389581) (xy 147.301061 82.546036) (xy 147.518562 82.662293) (xy 147.754565 82.733884) (xy 147.938502 82.752)
        (xy 147.938504 82.752) (xy 148 82.758057) (xy 148.061496 82.752) (xy 159.938504 82.752) (xy 160 82.758057)
        (xy 160.061496 82.752) (xy 160.061498 82.752) (xy 160.245435 82.733884) (xy 160.481438 82.662293) (xy 160.698939 82.546036)
        (xy 160.889581 82.389581) (xy 160.928787 82.341808) (xy 163.041809 80.228786) (xy 163.089581 80.189581) (xy 163.246036 79.998939)
        (xy 163.362293 79.781438) (xy 163.433884 79.545435) (xy 163.452 79.361498) (xy 163.452 79.361496) (xy 163.458057 79.3)
        (xy 163.458003 79.299447) (xy 163.633371 79.24625) (xy 163.829157 79.1416) (xy 164.000765 79.000765) (xy 164.1416 78.829157)
        (xy 164.24625 78.633371) (xy 164.310693 78.420931) (xy 164.332453 78.2) (xy 164.332453 75.2) (xy 164.310693 74.979069)
        (xy 164.24625 74.766629) (xy 164.1416 74.570843) (xy 164.000765 74.399235) (xy 163.829157 74.2584) (xy 163.633371 74.15375)
        (xy 163.620691 74.149904) (xy 164.341808 73.428787) (xy 164.389581 73.389581) (xy 164.546036 73.198939) (xy 164.662293 72.981438)
        (xy 164.733884 72.745435) (xy 164.752 72.561498) (xy 164.752 72.561496) (xy 164.758057 72.5) (xy 164.752 72.438504)
        (xy 164.752 59.561496) (xy 164.758057 59.5) (xy 164.748208 59.4) (xy 164.733884 59.254565) (xy 164.662293 59.018562)
        (xy 164.546036 58.801061) (xy 164.389581 58.610419) (xy 164.341809 58.571214) (xy 163.874765 58.10417) (xy 164.000765 58.000765)
        (xy 164.1416 57.829157) (xy 164.24625 57.633371) (xy 164.310693 57.420931) (xy 164.332453 57.2) (xy 164.332453 54.2)
        (xy 164.310693 53.979069) (xy 164.24625 53.766629) (xy 164.1416 53.570843) (xy 164.000765 53.399235) (xy 163.92969 53.340905)
        (xy 164.341808 52.928787) (xy 164.389581 52.889581) (xy 164.546036 52.698939) (xy 164.662293 52.481438) (xy 164.733884 52.245435)
        (xy 164.752 52.061498) (xy 164.752 52.061496) (xy 164.758057 52) (xy 164.752 51.938504) (xy 164.752 42.561496)
        (xy 164.758057 42.5) (xy 164.752 42.438502) (xy 164.733884 42.254565) (xy 164.662293 42.018562) (xy 164.546036 41.801061)
        (xy 164.389581 41.610419) (xy 164.341809 41.571214) (xy 163.452 40.681405) (xy 163.452 40.301268) (xy 163.633371 40.24625)
        (xy 163.829157 40.1416) (xy 164.000765 40.000765) (xy 164.1416 39.829157) (xy 164.24625 39.633371) (xy 164.310693 39.420931)
        (xy 164.332453 39.2) (xy 164.332453 36.2) (xy 164.310693 35.979069) (xy 164.24625 35.766629) (xy 164.1416 35.570843)
        (xy 164.000765 35.399235) (xy 163.92969 35.340905) (xy 164.341808 34.928787) (xy 164.389581 34.889581) (xy 164.546036 34.698939)
        (xy 164.662293 34.481438) (xy 164.733884 34.245435) (xy 164.752 34.061498) (xy 164.752 34.061496) (xy 164.758057 34)
        (xy 164.752 33.938504) (xy 164.752 23.061496) (xy 164.758057 23) (xy 164.744494 22.862293) (xy 164.733884 22.754565)
        (xy 164.662293 22.518562) (xy 164.546036 22.301061) (xy 164.389581 22.110419) (xy 164.341809 22.071214) (xy 164.122737 21.852142)
        (xy 164.1416 21.829157) (xy 164.24625 21.633371) (xy 164.310693 21.420931) (xy 164.332453 21.2) (xy 164.332453 18.2)
        (xy 164.310693 17.979069) (xy 164.24625 17.766629) (xy 164.1416 17.570843) (xy 164.000765 17.399235) (xy 163.829157 17.2584)
        (xy 163.633371 17.15375) (xy 163.420931 17.089307) (xy 163.2 17.067547) (xy 161.576534 17.067547) (xy 161.737574 16.678761)
        (xy 161.827 16.229189) (xy 161.827 15.982453) (xy 162.3962 15.982453) (xy 162.676399 15.954856) (xy 162.94583 15.873125)
        (xy 163.194139 15.740401) (xy 163.411784 15.561784) (xy 163.590401 15.344139) (xy 163.723125 15.09583) (xy 163.804856 14.826399)
        (xy 163.832453 14.5462) (xy 163.832453 13.5538) (xy 163.804856 13.273601) (xy 163.723125 13.00417) (xy 163.690457 12.943053)
        (xy 163.731769 12.843318) (xy 163.777 12.615924) (xy 163.777 12.384076) (xy 163.731769 12.156682) (xy 163.690457 12.056947)
        (xy 163.723125 11.99583) (xy 163.804856 11.726399) (xy 163.832453 11.4462) (xy 163.832453 10.4538) (xy 163.804856 10.173601)
        (xy 163.723125 9.90417) (xy 163.590401 9.655861) (xy 163.411784 9.438216) (xy 163.194139 9.259599) (xy 162.94583 9.126875)
        (xy 162.676399 9.045144) (xy 162.3962 9.017547) (xy 161.6038 9.017547) (xy 161.323601 9.045144) (xy 161.05417 9.126875)
        (xy 160.805861 9.259599) (xy 160.652749 9.385255) (xy 160.475763 9.240006) (xy 160.140999 9.061071) (xy 159.777758 8.950883)
        (xy 159.494658 8.923) (xy 158.505342 8.923) (xy 158.222242 8.950883) (xy 157.859001 9.061071) (xy 157.524237 9.240006)
        (xy 157.230813 9.480813) (xy 156.990006 9.774237) (xy 156.811071 10.109001) (xy 156.700883 10.472242) (xy 156.663677 10.85)
        (xy 156.700883 11.227758) (xy 156.811071 11.590999) (xy 156.990006 11.925763) (xy 157.230813 12.219187) (xy 157.524237 12.459994)
        (xy 157.859001 12.638929) (xy 158.222242 12.749117) (xy 158.505342 12.777) (xy 159.494658 12.777) (xy 159.777758 12.749117)
        (xy 160.140999 12.638929) (xy 160.223 12.595099) (xy 160.223 12.615924) (xy 160.259217 12.798) (xy 158.511496 12.798)
        (xy 158.45 12.791943) (xy 158.388504 12.798) (xy 158.388502 12.798) (xy 158.204565 12.816116) (xy 157.968562 12.887707)
        (xy 157.751061 13.003964) (xy 157.560419 13.160419) (xy 157.521213 13.208192) (xy 157.195464 13.533941) (xy 157.127975 13.432937)
        (xy 156.567063 12.872025) (xy 155.9075 12.431319) (xy 155.174633 12.127755) (xy 154.396625 11.973) (xy 153.603375 11.973)
        (xy 152.825367 12.127755) (xy 152.0925 12.431319) (xy 151.432937 12.872025) (xy 150.872025 13.432937) (xy 150.431319 14.0925)
        (xy 150.27083 14.479955) (xy 149.983376 14.192501) (xy 149.602248 13.93784) (xy 149.178761 13.762426) (xy 148.729189 13.673)
        (xy 148.270811 13.673) (xy 147.821239 13.762426) (xy 147.397752 13.93784) (xy 147.016624 14.192501) (xy 146.692501 14.516624)
        (xy 146.43784 14.897752) (xy 146.262426 15.321239) (xy 146.173 15.770811) (xy 146.173 16.229189) (xy 146.262426 16.678761)
        (xy 146.423466 17.067547) (xy 144.8 17.067547) (xy 144.579069 17.089307) (xy 144.5 17.113292) (xy 144.420931 17.089307)
        (xy 144.2 17.067547) (xy 142.576534 17.067547) (xy 142.737574 16.678761) (xy 142.827 16.229189) (xy 142.827 15.982453)
        (xy 143.3962 15.982453) (xy 143.676399 15.954856) (xy 143.94583 15.873125) (xy 144.194139 15.740401) (xy 144.411784 15.561784)
        (xy 144.590401 15.344139) (xy 144.723125 15.09583) (xy 144.804856 14.826399) (xy 144.832453 14.5462) (xy 144.832453 13.5538)
        (xy 144.804856 13.273601) (xy 144.723125 13.00417) (xy 144.690457 12.943053) (xy 144.731769 12.843318) (xy 144.777 12.615924)
        (xy 144.777 12.384076) (xy 144.731769 12.156682) (xy 144.690457 12.056947) (xy 144.723125 11.99583) (xy 144.804856 11.726399)
        (xy 144.832453 11.4462) (xy 144.832453 10.85) (xy 146.663677 10.85) (xy 146.700883 11.227758) (xy 146.811071 11.590999)
        (xy 146.990006 11.925763) (xy 147.230813 12.219187) (xy 147.524237 12.459994) (xy 147.859001 12.638929) (xy 148.222242 12.749117)
        (xy 148.505342 12.777) (xy 149.494658 12.777) (xy 149.777758 12.749117) (xy 150.140999 12.638929) (xy 150.475763 12.459994)
        (xy 150.769187 12.219187) (xy 151.009994 11.925763) (xy 151.188929 11.590999) (xy 151.299117 11.227758) (xy 151.336323 10.85)
        (xy 151.299117 10.472242) (xy 151.188929 10.109001) (xy 151.009994 9.774237) (xy 150.769187 9.480813) (xy 150.475763 9.240006)
        (xy 150.140999 9.061071) (xy 149.777758 8.950883) (xy 149.494658 8.923) (xy 148.505342 8.923) (xy 148.222242 8.950883)
        (xy 147.859001 9.061071) (xy 147.524237 9.240006) (xy 147.230813 9.480813) (xy 146.990006 9.774237) (xy 146.811071 10.109001)
        (xy 146.700883 10.472242) (xy 146.663677 10.85) (xy 144.832453 10.85) (xy 144.832453 10.4538) (xy 144.804856 10.173601)
        (xy 144.723125 9.90417) (xy 144.590401 9.655861) (xy 144.411784 9.438216) (xy 144.194139 9.259599) (xy 143.94583 9.126875)
        (xy 143.676399 9.045144) (xy 143.3962 9.017547) (xy 142.6038 9.017547) (xy 142.323601 9.045144) (xy 142.05417 9.126875)
        (xy 141.805861 9.259599) (xy 141.652749 9.385255) (xy 141.475763 9.240006) (xy 141.140999 9.061071) (xy 140.777758 8.950883)
        (xy 140.494658 8.923) (xy 139.505342 8.923) (xy 139.222242 8.950883) (xy 138.859001 9.061071) (xy 138.524237 9.240006)
        (xy 138.230813 9.480813) (xy 137.990006 9.774237) (xy 137.811071 10.109001) (xy 137.700883 10.472242) (xy 137.663677 10.85)
        (xy 137.700883 11.227758) (xy 137.811071 11.590999) (xy 137.990006 11.925763) (xy 138.230813 12.219187) (xy 138.524237 12.459994)
        (xy 138.859001 12.638929) (xy 139.222242 12.749117) (xy 139.505342 12.777) (xy 140.494658 12.777) (xy 140.777758 12.749117)
        (xy 141.140999 12.638929) (xy 141.223 12.595099) (xy 141.223 12.615924) (xy 141.259217 12.798) (xy 139.511496 12.798)
        (xy 139.45 12.791943) (xy 139.388504 12.798) (xy 139.388502 12.798) (xy 139.204565 12.816116) (xy 138.968562 12.887707)
        (xy 138.751061 13.003964) (xy 138.560419 13.160419) (xy 138.521213 13.208192) (xy 138.195464 13.533941) (xy 138.127975 13.432937)
        (xy 137.567063 12.872025) (xy 136.9075 12.431319) (xy 136.174633 12.127755) (xy 135.396625 11.973) (xy 134.603375 11.973)
        (xy 133.825367 12.127755) (xy 133.0925 12.431319) (xy 132.432937 12.872025) (xy 131.872025 13.432937) (xy 131.431319 14.0925)
        (xy 131.27083 14.479955) (xy 130.983376 14.192501) (xy 130.602248 13.93784) (xy 130.178761 13.762426) (xy 129.729189 13.673)
        (xy 129.270811 13.673) (xy 128.821239 13.762426) (xy 128.397752 13.93784) (xy 128.016624 14.192501) (xy 127.692501 14.516624)
        (xy 127.43784 14.897752) (xy 127.262426 15.321239) (xy 127.173 15.770811) (xy 127.173 16.229189) (xy 127.262426 16.678761)
        (xy 127.423466 17.067547) (xy 125.8 17.067547) (xy 125.579069 17.089307) (xy 125.5 17.113292) (xy 125.420931 17.089307)
        (xy 125.2 17.067547) (xy 123.576534 17.067547) (xy 123.737574 16.678761) (xy 123.827 16.229189) (xy 123.827 15.982453)
        (xy 124.3962 15.982453) (xy 124.676399 15.954856) (xy 124.94583 15.873125) (xy 125.194139 15.740401) (xy 125.411784 15.561784)
        (xy 125.590401 15.344139) (xy 125.723125 15.09583) (xy 125.804856 14.826399) (xy 125.832453 14.5462) (xy 125.832453 13.5538)
        (xy 125.804856 13.273601) (xy 125.723125 13.00417) (xy 125.690457 12.943053) (xy 125.731769 12.843318) (xy 125.777 12.615924)
        (xy 125.777 12.384076) (xy 125.731769 12.156682) (xy 125.690457 12.056947) (xy 125.723125 11.99583) (xy 125.804856 11.726399)
        (xy 125.832453 11.4462) (xy 125.832453 10.85) (xy 127.663677 10.85) (xy 127.700883 11.227758) (xy 127.811071 11.590999)
        (xy 127.990006 11.925763) (xy 128.230813 12.219187) (xy 128.524237 12.459994) (xy 128.859001 12.638929) (xy 129.222242 12.749117)
        (xy 129.505342 12.777) (xy 130.494658 12.777) (xy 130.777758 12.749117) (xy 131.140999 12.638929) (xy 131.475763 12.459994)
        (xy 131.769187 12.219187) (xy 132.009994 11.925763) (xy 132.188929 11.590999) (xy 132.299117 11.227758) (xy 132.336323 10.85)
        (xy 132.299117 10.472242) (xy 132.188929 10.109001) (xy 132.009994 9.774237) (xy 131.769187 9.480813) (xy 131.475763 9.240006)
        (xy 131.140999 9.061071) (xy 130.777758 8.950883) (xy 130.494658 8.923) (xy 129.505342 8.923) (xy 129.222242 8.950883)
        (xy 128.859001 9.061071) (xy 128.524237 9.240006) (xy 128.230813 9.480813) (xy 127.990006 9.774237) (xy 127.811071 10.109001)
        (xy 127.700883 10.472242) (xy 127.663677 10.85) (xy 125.832453 10.85) (xy 125.832453 10.4538) (xy 125.804856 10.173601)
        (xy 125.723125 9.90417) (xy 125.590401 9.655861) (xy 125.411784 9.438216) (xy 125.194139 9.259599) (xy 124.94583 9.126875)
        (xy 124.676399 9.045144) (xy 124.3962 9.017547) (xy 123.6038 9.017547) (xy 123.323601 9.045144) (xy 123.05417 9.126875)
        (xy 122.805861 9.259599) (xy 122.652749 9.385255) (xy 122.475763 9.240006) (xy 122.140999 9.061071) (xy 121.777758 8.950883)
        (xy 121.494658 8.923) (xy 120.505342 8.923) (xy 120.222242 8.950883) (xy 119.859001 9.061071) (xy 119.524237 9.240006)
        (xy 119.230813 9.480813) (xy 118.990006 9.774237) (xy 118.811071 10.109001) (xy 118.700883 10.472242) (xy 118.663677 10.85)
        (xy 118.700883 11.227758) (xy 118.811071 11.590999) (xy 118.990006 11.925763) (xy 119.230813 12.219187) (xy 119.524237 12.459994)
        (xy 119.859001 12.638929) (xy 120.222242 12.749117) (xy 120.505342 12.777) (xy 121.494658 12.777) (xy 121.777758 12.749117)
        (xy 122.140999 12.638929) (xy 122.223 12.595099) (xy 122.223 12.615924) (xy 122.259217 12.798) (xy 120.511496 12.798)
        (xy 120.45 12.791943) (xy 120.388504 12.798) (xy 120.388502 12.798) (xy 120.204565 12.816116) (xy 119.968562 12.887707)
        (xy 119.751061 13.003964) (xy 119.560419 13.160419) (xy 119.521213 13.208192) (xy 119.195464 13.533941) (xy 119.127975 13.432937)
        (xy 118.567063 12.872025) (xy 117.9075 12.431319) (xy 117.174633 12.127755) (xy 116.396625 11.973) (xy 115.603375 11.973)
        (xy 114.825367 12.127755) (xy 114.0925 12.431319) (xy 113.432937 12.872025) (xy 112.872025 13.432937) (xy 112.431319 14.0925)
        (xy 112.27083 14.479955) (xy 111.983376 14.192501) (xy 111.602248 13.93784) (xy 111.178761 13.762426) (xy 110.729189 13.673)
        (xy 110.270811 13.673) (xy 109.821239 13.762426) (xy 109.397752 13.93784) (xy 109.016624 14.192501) (xy 108.692501 14.516624)
        (xy 108.43784 14.897752) (xy 108.262426 15.321239) (xy 108.173 15.770811) (xy 108.173 16.229189) (xy 108.262426 16.678761)
        (xy 108.423466 17.067547) (xy 106.8 17.067547) (xy 106.579069 17.089307) (xy 106.5 17.113292) (xy 106.420931 17.089307)
        (xy 106.2 17.067547) (xy 104.576534 17.067547) (xy 104.737574 16.678761) (xy 104.827 16.229189) (xy 104.827 15.982453)
        (xy 105.3962 15.982453) (xy 105.676399 15.954856) (xy 105.94583 15.873125) (xy 106.194139 15.740401) (xy 106.411784 15.561784)
        (xy 106.590401 15.344139) (xy 106.723125 15.09583) (xy 106.804856 14.826399) (xy 106.832453 14.5462) (xy 106.832453 13.5538)
        (xy 106.804856 13.273601) (xy 106.723125 13.00417) (xy 106.690457 12.943053) (xy 106.731769 12.843318) (xy 106.777 12.615924)
        (xy 106.777 12.384076) (xy 106.731769 12.156682) (xy 106.690457 12.056947) (xy 106.723125 11.99583) (xy 106.804856 11.726399)
        (xy 106.832453 11.4462) (xy 106.832453 10.85) (xy 108.663677 10.85) (xy 108.700883 11.227758) (xy 108.811071 11.590999)
        (xy 108.990006 11.925763) (xy 109.230813 12.219187) (xy 109.524237 12.459994) (xy 109.859001 12.638929) (xy 110.222242 12.749117)
        (xy 110.505342 12.777) (xy 111.494658 12.777) (xy 111.777758 12.749117) (xy 112.140999 12.638929) (xy 112.475763 12.459994)
        (xy 112.769187 12.219187) (xy 113.009994 11.925763) (xy 113.188929 11.590999) (xy 113.299117 11.227758) (xy 113.336323 10.85)
        (xy 113.299117 10.472242) (xy 113.188929 10.109001) (xy 113.009994 9.774237) (xy 112.769187 9.480813) (xy 112.475763 9.240006)
        (xy 112.140999 9.061071) (xy 111.777758 8.950883) (xy 111.494658 8.923) (xy 110.505342 8.923) (xy 110.222242 8.950883)
        (xy 109.859001 9.061071) (xy 109.524237 9.240006) (xy 109.230813 9.480813) (xy 108.990006 9.774237) (xy 108.811071 10.109001)
        (xy 108.700883 10.472242) (xy 108.663677 10.85) (xy 106.832453 10.85) (xy 106.832453 10.4538) (xy 106.804856 10.173601)
        (xy 106.723125 9.90417) (xy 106.590401 9.655861) (xy 106.411784 9.438216) (xy 106.194139 9.259599) (xy 105.94583 9.126875)
        (xy 105.676399 9.045144) (xy 105.3962 9.017547) (xy 104.6038 9.017547) (xy 104.323601 9.045144) (xy 104.05417 9.126875)
        (xy 103.805861 9.259599) (xy 103.652749 9.385255) (xy 103.475763 9.240006) (xy 103.140999 9.061071) (xy 102.777758 8.950883)
        (xy 102.494658 8.923) (xy 101.505342 8.923) (xy 101.222242 8.950883) (xy 100.859001 9.061071) (xy 100.524237 9.240006)
        (xy 100.230813 9.480813) (xy 99.990006 9.774237) (xy 99.811071 10.109001) (xy 99.700883 10.472242) (xy 99.663677 10.85)
        (xy 99.700883 11.227758) (xy 99.811071 11.590999) (xy 99.990006 11.925763) (xy 100.230813 12.219187) (xy 100.524237 12.459994)
        (xy 100.859001 12.638929) (xy 101.222242 12.749117) (xy 101.505342 12.777) (xy 102.494658 12.777) (xy 102.777758 12.749117)
        (xy 103.140999 12.638929) (xy 103.223 12.595099) (xy 103.223 12.615924) (xy 103.259217 12.798) (xy 101.511496 12.798)
        (xy 101.45 12.791943) (xy 101.388504 12.798) (xy 101.388502 12.798) (xy 101.204565 12.816116) (xy 100.968562 12.887707)
        (xy 100.751061 13.003964) (xy 100.560419 13.160419) (xy 100.521213 13.208192) (xy 100.195464 13.533941) (xy 100.127975 13.432937)
        (xy 99.567063 12.872025) (xy 98.9075 12.431319) (xy 98.174633 12.127755) (xy 97.396625 11.973) (xy 96.603375 11.973)
        (xy 95.825367 12.127755) (xy 95.0925 12.431319) (xy 94.432937 12.872025) (xy 93.872025 13.432937) (xy 93.431319 14.0925)
        (xy 93.27083 14.479955) (xy 92.983376 14.192501) (xy 92.602248 13.93784) (xy 92.178761 13.762426) (xy 91.729189 13.673)
        (xy 91.270811 13.673) (xy 90.821239 13.762426) (xy 90.397752 13.93784) (xy 90.016624 14.192501) (xy 89.692501 14.516624)
        (xy 89.43784 14.897752) (xy 89.262426 15.321239) (xy 89.173 15.770811) (xy 89.173 16.229189) (xy 89.262426 16.678761)
        (xy 89.423466 17.067547) (xy 87.8 17.067547) (xy 87.579069 17.089307) (xy 87.5 17.113292) (xy 87.420931 17.089307)
        (xy 87.2 17.067547) (xy 85.576534 17.067547) (xy 85.737574 16.678761) (xy 85.827 16.229189) (xy 85.827 15.982453)
        (xy 86.3962 15.982453) (xy 86.676399 15.954856) (xy 86.94583 15.873125) (xy 87.194139 15.740401) (xy 87.411784 15.561784)
        (xy 87.590401 15.344139) (xy 87.723125 15.09583) (xy 87.804856 14.826399) (xy 87.832453 14.5462) (xy 87.832453 13.5538)
        (xy 87.804856 13.273601) (xy 87.723125 13.00417) (xy 87.690457 12.943053) (xy 87.731769 12.843318) (xy 87.777 12.615924)
        (xy 87.777 12.384076) (xy 87.731769 12.156682) (xy 87.690457 12.056947) (xy 87.723125 11.99583) (xy 87.804856 11.726399)
        (xy 87.832453 11.4462) (xy 87.832453 10.85) (xy 89.663677 10.85) (xy 89.700883 11.227758) (xy 89.811071 11.590999)
        (xy 89.990006 11.925763) (xy 90.230813 12.219187) (xy 90.524237 12.459994) (xy 90.859001 12.638929) (xy 91.222242 12.749117)
        (xy 91.505342 12.777) (xy 92.494658 12.777) (xy 92.777758 12.749117) (xy 93.140999 12.638929) (xy 93.475763 12.459994)
        (xy 93.769187 12.219187) (xy 94.009994 11.925763) (xy 94.188929 11.590999) (xy 94.299117 11.227758) (xy 94.336323 10.85)
        (xy 94.299117 10.472242) (xy 94.188929 10.109001) (xy 94.009994 9.774237) (xy 93.769187 9.480813) (xy 93.475763 9.240006)
        (xy 93.140999 9.061071) (xy 92.777758 8.950883) (xy 92.494658 8.923) (xy 91.505342 8.923) (xy 91.222242 8.950883)
        (xy 90.859001 9.061071) (xy 90.524237 9.240006) (xy 90.230813 9.480813) (xy 89.990006 9.774237) (xy 89.811071 10.109001)
        (xy 89.700883 10.472242) (xy 89.663677 10.85) (xy 87.832453 10.85) (xy 87.832453 10.4538) (xy 87.804856 10.173601)
        (xy 87.723125 9.90417) (xy 87.590401 9.655861) (xy 87.411784 9.438216) (xy 87.194139 9.259599) (xy 86.94583 9.126875)
        (xy 86.676399 9.045144) (xy 86.3962 9.017547) (xy 85.6038 9.017547) (xy 85.323601 9.045144) (xy 85.05417 9.126875)
        (xy 84.805861 9.259599) (xy 84.652749 9.385255) (xy 84.475763 9.240006) (xy 84.140999 9.061071) (xy 83.777758 8.950883)
        (xy 83.494658 8.923) (xy 82.505342 8.923) (xy 82.222242 8.950883) (xy 81.859001 9.061071) (xy 81.524237 9.240006)
        (xy 81.230813 9.480813) (xy 80.990006 9.774237) (xy 80.811071 10.109001) (xy 80.700883 10.472242) (xy 80.663677 10.85)
        (xy 80.700883 11.227758) (xy 80.811071 11.590999) (xy 80.990006 11.925763) (xy 81.230813 12.219187) (xy 81.524237 12.459994)
        (xy 81.859001 12.638929) (xy 82.222242 12.749117) (xy 82.505342 12.777) (xy 83.494658 12.777) (xy 83.777758 12.749117)
        (xy 84.140999 12.638929) (xy 84.223 12.595099) (xy 84.223 12.615924) (xy 84.259217 12.798) (xy 82.511496 12.798)
        (xy 82.45 12.791943) (xy 82.388504 12.798) (xy 82.388502 12.798) (xy 82.204565 12.816116) (xy 81.968562 12.887707)
        (xy 81.751061 13.003964) (xy 81.560419 13.160419) (xy 81.521213 13.208192) (xy 81.195464 13.533941) (xy 81.127975 13.432937)
        (xy 80.567063 12.872025) (xy 79.9075 12.431319) (xy 79.174633 12.127755) (xy 78.396625 11.973) (xy 77.603375 11.973)
        (xy 76.825367 12.127755) (xy 76.0925 12.431319) (xy 75.432937 12.872025) (xy 74.872025 13.432937) (xy 74.431319 14.0925)
        (xy 74.27083 14.479955) (xy 73.983376 14.192501) (xy 73.602248 13.93784) (xy 73.178761 13.762426) (xy 72.729189 13.673)
        (xy 72.270811 13.673) (xy 71.821239 13.762426) (xy 71.397752 13.93784) (xy 71.016624 14.192501) (xy 70.692501 14.516624)
        (xy 70.43784 14.897752) (xy 70.262426 15.321239) (xy 70.173 15.770811) (xy 70.173 16.229189) (xy 70.262426 16.678761)
        (xy 70.423466 17.067547) (xy 68.8 17.067547) (xy 68.579069 17.089307) (xy 68.5 17.113292) (xy 68.420931 17.089307)
        (xy 68.2 17.067547) (xy 66.576534 17.067547) (xy 66.737574 16.678761) (xy 66.827 16.229189) (xy 66.827 15.982453)
        (xy 67.3962 15.982453) (xy 67.676399 15.954856) (xy 67.94583 15.873125) (xy 68.194139 15.740401) (xy 68.411784 15.561784)
        (xy 68.590401 15.344139) (xy 68.723125 15.09583) (xy 68.804856 14.826399) (xy 68.832453 14.5462) (xy 68.832453 13.5538)
        (xy 68.804856 13.273601) (xy 68.723125 13.00417) (xy 68.690457 12.943053) (xy 68.731769 12.843318) (xy 68.777 12.615924)
        (xy 68.777 12.384076) (xy 68.731769 12.156682) (xy 68.690457 12.056947) (xy 68.723125 11.99583) (xy 68.804856 11.726399)
        (xy 68.832453 11.4462) (xy 68.832453 10.85) (xy 70.663677 10.85) (xy 70.700883 11.227758) (xy 70.811071 11.590999)
        (xy 70.990006 11.925763) (xy 71.230813 12.219187) (xy 71.524237 12.459994) (xy 71.859001 12.638929) (xy 72.222242 12.749117)
        (xy 72.505342 12.777) (xy 73.494658 12.777) (xy 73.777758 12.749117) (xy 74.140999 12.638929) (xy 74.475763 12.459994)
        (xy 74.769187 12.219187) (xy 75.009994 11.925763) (xy 75.188929 11.590999) (xy 75.299117 11.227758) (xy 75.336323 10.85)
        (xy 75.299117 10.472242) (xy 75.188929 10.109001) (xy 75.009994 9.774237) (xy 74.769187 9.480813) (xy 74.475763 9.240006)
        (xy 74.140999 9.061071) (xy 73.777758 8.950883) (xy 73.494658 8.923) (xy 72.505342 8.923) (xy 72.222242 8.950883)
        (xy 71.859001 9.061071) (xy 71.524237 9.240006) (xy 71.230813 9.480813) (xy 70.990006 9.774237) (xy 70.811071 10.109001)
        (xy 70.700883 10.472242) (xy 70.663677 10.85) (xy 68.832453 10.85) (xy 68.832453 10.4538) (xy 68.804856 10.173601)
        (xy 68.723125 9.90417) (xy 68.590401 9.655861) (xy 68.411784 9.438216) (xy 68.194139 9.259599) (xy 67.94583 9.126875)
        (xy 67.676399 9.045144) (xy 67.3962 9.017547) (xy 66.6038 9.017547) (xy 66.323601 9.045144) (xy 66.05417 9.126875)
        (xy 65.805861 9.259599) (xy 65.652749 9.385255) (xy 65.475763 9.240006) (xy 65.140999 9.061071) (xy 64.777758 8.950883)
        (xy 64.494658 8.923) (xy 63.505342 8.923) (xy 63.222242 8.950883) (xy 62.859001 9.061071) (xy 62.524237 9.240006)
        (xy 62.230813 9.480813) (xy 61.990006 9.774237) (xy 61.811071 10.109001) (xy 61.700883 10.472242) (xy 61.663677 10.85)
        (xy 61.700883 11.227758) (xy 61.811071 11.590999) (xy 61.990006 11.925763) (xy 62.230813 12.219187) (xy 62.524237 12.459994)
        (xy 62.859001 12.638929) (xy 63.222242 12.749117) (xy 63.505342 12.777) (xy 64.494658 12.777) (xy 64.777758 12.749117)
        (xy 65.140999 12.638929) (xy 65.223 12.595099) (xy 65.223 12.615924) (xy 65.259217 12.798) (xy 63.511496 12.798)
        (xy 63.45 12.791943) (xy 63.388504 12.798) (xy 63.388502 12.798) (xy 63.204565 12.816116) (xy 62.968562 12.887707)
        (xy 62.751061 13.003964) (xy 62.560419 13.160419) (xy 62.521213 13.208192) (xy 62.195464 13.533941) (xy 62.127975 13.432937)
        (xy 61.567063 12.872025) (xy 60.9075 12.431319) (xy 60.174633 12.127755) (xy 59.396625 11.973) (xy 58.603375 11.973)
        (xy 57.825367 12.127755) (xy 57.0925 12.431319) (xy 56.432937 12.872025) (xy 55.872025 13.432937) (xy 55.431319 14.0925)
        (xy 55.27083 14.479955) (xy 54.983376 14.192501) (xy 54.602248 13.93784) (xy 54.178761 13.762426) (xy 53.729189 13.673)
        (xy 53.270811 13.673) (xy 52.821239 13.762426) (xy 52.397752 13.93784) (xy 52.016624 14.192501) (xy 51.692501 14.516624)
        (xy 51.43784 14.897752) (xy 51.262426 15.321239) (xy 51.173 15.770811) (xy 51.173 16.229189) (xy 51.262426 16.678761)
        (xy 51.423466 17.067547) (xy 49.8 17.067547) (xy 49.579069 17.089307) (xy 49.5 17.113292) (xy 49.420931 17.089307)
        (xy 49.2 17.067547) (xy 47.576534 17.067547) (xy 47.737574 16.678761) (xy 47.827 16.229189) (xy 47.827 15.982453)
        (xy 48.3962 15.982453) (xy 48.676399 15.954856) (xy 48.94583 15.873125) (xy 49.194139 15.740401) (xy 49.411784 15.561784)
        (xy 49.590401 15.344139) (xy 49.723125 15.09583) (xy 49.804856 14.826399) (xy 49.832453 14.5462) (xy 49.832453 13.5538)
        (xy 49.804856 13.273601) (xy 49.723125 13.00417) (xy 49.690457 12.943053) (xy 49.731769 12.843318) (xy 49.777 12.615924)
        (xy 49.777 12.384076) (xy 49.731769 12.156682) (xy 49.690457 12.056947) (xy 49.723125 11.99583) (xy 49.804856 11.726399)
        (xy 49.832453 11.4462) (xy 49.832453 10.85) (xy 51.663677 10.85) (xy 51.700883 11.227758) (xy 51.811071 11.590999)
        (xy 51.990006 11.925763) (xy 52.230813 12.219187) (xy 52.524237 12.459994) (xy 52.859001 12.638929) (xy 53.222242 12.749117)
        (xy 53.505342 12.777) (xy 54.494658 12.777) (xy 54.777758 12.749117) (xy 55.140999 12.638929) (xy 55.475763 12.459994)
        (xy 55.769187 12.219187) (xy 56.009994 11.925763) (xy 56.188929 11.590999) (xy 56.299117 11.227758) (xy 56.336323 10.85)
        (xy 56.299117 10.472242) (xy 56.188929 10.109001) (xy 56.009994 9.774237) (xy 55.769187 9.480813) (xy 55.475763 9.240006)
        (xy 55.140999 9.061071) (xy 54.777758 8.950883) (xy 54.494658 8.923) (xy 53.505342 8.923) (xy 53.222242 8.950883)
        (xy 52.859001 9.061071) (xy 52.524237 9.240006) (xy 52.230813 9.480813) (xy 51.990006 9.774237) (xy 51.811071 10.109001)
        (xy 51.700883 10.472242) (xy 51.663677 10.85) (xy 49.832453 10.85) (xy 49.832453 10.4538) (xy 49.804856 10.173601)
        (xy 49.723125 9.90417) (xy 49.590401 9.655861) (xy 49.411784 9.438216) (xy 49.194139 9.259599) (xy 48.94583 9.126875)
        (xy 48.676399 9.045144) (xy 48.3962 9.017547) (xy 47.6038 9.017547) (xy 47.323601 9.045144) (xy 47.05417 9.126875)
        (xy 46.805861 9.259599) (xy 46.652749 9.385255) (xy 46.475763 9.240006) (xy 46.140999 9.061071) (xy 45.777758 8.950883)
        (xy 45.494658 8.923) (xy 44.505342 8.923) (xy 44.222242 8.950883) (xy 43.859001 9.061071) (xy 43.524237 9.240006)
        (xy 43.230813 9.480813) (xy 42.990006 9.774237) (xy 42.811071 10.109001) (xy 42.700883 10.472242) (xy 42.663677 10.85)
        (xy 42.700883 11.227758) (xy 42.811071 11.590999) (xy 42.990006 11.925763) (xy 43.230813 12.219187) (xy 43.524237 12.459994)
        (xy 43.859001 12.638929) (xy 44.222242 12.749117) (xy 44.505342 12.777) (xy 45.494658 12.777) (xy 45.777758 12.749117)
        (xy 46.140999 12.638929) (xy 46.223 12.595099) (xy 46.223 12.615924) (xy 46.259217 12.798) (xy 44.511496 12.798)
        (xy 44.45 12.791943) (xy 44.388504 12.798) (xy 44.388502 12.798) (xy 44.204565 12.816116) (xy 43.968562 12.887707)
        (xy 43.751061 13.003964) (xy 43.560419 13.160419) (xy 43.521213 13.208192) (xy 43.195464 13.533941) (xy 43.127975 13.432937)
        (xy 42.567063 12.872025) (xy 41.9075 12.431319) (xy 41.174633 12.127755) (xy 40.396625 11.973) (xy 39.603375 11.973)
        (xy 38.825367 12.127755) (xy 38.0925 12.431319) (xy 37.432937 12.872025) (xy 36.872025 13.432937) (xy 36.431319 14.0925)
        (xy 36.27083 14.479955) (xy 35.983376 14.192501) (xy 35.602248 13.93784) (xy 35.178761 13.762426) (xy 34.729189 13.673)
        (xy 34.270811 13.673) (xy 33.821239 13.762426) (xy 33.397752 13.93784) (xy 33.016624 14.192501) (xy 32.692501 14.516624)
        (xy 32.43784 14.897752) (xy 32.262426 15.321239) (xy 32.173 15.770811) (xy 32.173 16.229189) (xy 32.262426 16.678761)
        (xy 32.423466 17.067547) (xy 30.8 17.067547) (xy 30.579069 17.089307) (xy 30.366629 17.15375) (xy 30.170843 17.2584)
        (xy 29.999235 17.399235) (xy 29.8584 17.570843) (xy 29.75375 17.766629) (xy 29.689307 17.979069) (xy 29.667547 18.2)
        (xy 29.667547 21.2) (xy 29.689307 21.420931) (xy 29.75375 21.633371) (xy 29.8584 21.829157) (xy 29.999235 22.000765)
        (xy 30.170843 22.1416) (xy 30.366629 22.24625) (xy 30.548001 22.301269) (xy 30.548 35.098732) (xy 30.366629 35.15375)
        (xy 30.170843 35.2584) (xy 29.999235 35.399235) (xy 29.8584 35.570843) (xy 29.75375 35.766629) (xy 29.689307 35.979069)
        (xy 29.667547 36.2) (xy 29.667547 39.2) (xy 29.689307 39.420931) (xy 29.75375 39.633371) (xy 29.8584 39.829157)
        (xy 29.999235 40.000765) (xy 30.170843 40.1416) (xy 30.366629 40.24625) (xy 30.548001 40.301269) (xy 30.548 53.098732)
        (xy 30.366629 53.15375) (xy 30.170843 53.2584) (xy 29.999235 53.399235) (xy 29.8584 53.570843) (xy 29.75375 53.766629)
        (xy 29.689307 53.979069) (xy 29.667547 54.2) (xy 29.667547 57.2) (xy 29.689307 57.420931) (xy 29.75375 57.633371)
        (xy 29.8584 57.829157) (xy 29.999235 58.000765) (xy 30.170843 58.1416) (xy 30.366629 58.24625) (xy 30.548001 58.301269)
        (xy 30.548 74.098732) (xy 30.366629 74.15375) (xy 30.170843 74.2584) (xy 29.999235 74.399235) (xy 29.8584 74.570843)
        (xy 29.75375 74.766629) (xy 29.689307 74.979069) (xy 29.667547 75.2) (xy 29.667547 78.2) (xy 29.689307 78.420931)
        (xy 29.75375 78.633371) (xy 29.8584 78.829157) (xy 29.999235 79.000765) (xy 30.170843 79.1416) (xy 30.366629 79.24625)
        (xy 30.541997 79.299447) (xy 30.541943 79.3) (xy 30.566117 79.545434) (xy 30.637707 79.781437) (xy 30.753964 79.998938)
        (xy 30.753965 79.998939) (xy 30.91042 80.189581) (xy 30.958188 80.228783) (xy 33.071213 82.341808) (xy 33.110419 82.389581)
        (xy 33.301061 82.546036) (xy 33.518562 82.662293) (xy 33.754565 82.733884) (xy 33.938502 82.752) (xy 33.938504 82.752)
        (xy 34 82.758057) (xy 34.061496 82.752) (xy 45.938504 82.752) (xy 46 82.758057) (xy 46.061496 82.752)
        (xy 46.061498 82.752) (xy 46.245435 82.733884) (xy 46.481438 82.662293) (xy 46.698939 82.546036) (xy 46.889581 82.389581)
        (xy 46.928787 82.341808) (xy 49.041809 80.228786) (xy 49.089581 80.189581) (xy 49.246036 79.998939) (xy 49.362293 79.781438)
        (xy 49.433884 79.545435) (xy 49.452 79.361498) (xy 49.452 79.361496) (xy 49.458057 79.3) (xy 49.458003 79.299447)
        (xy 49.5 79.286708) (xy 49.548001 79.301269) (xy 49.548001 79.738495) (xy 49.541943 79.8) (xy 49.566117 80.045434)
        (xy 49.637707 80.281437) (xy 49.753964 80.498938) (xy 49.802482 80.558057) (xy 49.91042 80.689581) (xy 49.958188 80.728783)
        (xy 51.571217 82.341813) (xy 51.610419 82.389581) (xy 51.658187 82.428783) (xy 51.80106 82.546036) (xy 52.018562 82.662293)
        (xy 52.254565 82.733884) (xy 52.438502 82.752) (xy 52.438503 82.752) (xy 52.499999 82.758057) (xy 52.561495 82.752)
        (xy 65.438504 82.752) (xy 65.5 82.758057) (xy 65.561496 82.752) (xy 65.561498 82.752) (xy 65.745435 82.733884)
        (xy 65.981438 82.662293) (xy 66.198939 82.546036) (xy 66.389581 82.389581) (xy 66.428787 82.341808) (xy 68.041814 80.728782)
        (xy 68.089581 80.689581) (xy 68.154547 80.610419) (xy 68.246036 80.49894) (xy 68.362293 80.281438) (xy 68.389509 80.191719)
        (xy 68.433884 80.045435) (xy 68.452 79.861498) (xy 68.452 79.861497) (xy 68.458057 79.800001) (xy 68.452 79.738505)
        (xy 68.452 79.301268) (xy 68.5 79.286708) (xy 68.541997 79.299447) (xy 68.541943 79.3) (xy 68.566117 79.545434)
        (xy 68.637707 79.781437) (xy 68.753964 79.998938) (xy 68.753965 79.998939) (xy 68.91042 80.189581) (xy 68.958188 80.228783)
        (xy 71.071213 82.341808) (xy 71.110419 82.389581) (xy 71.301061 82.546036) (xy 71.518562 82.662293) (xy 71.754565 82.733884)
        (xy 71.938502 82.752) (xy 71.938504 82.752) (xy 72 82.758057) (xy 72.061496 82.752) (xy 83.938504 82.752)
        (xy 84 82.758057) (xy 84.061496 82.752) (xy 84.061498 82.752) (xy 84.245435 82.733884) (xy 84.386734 82.691021)
        (xy 84.071101 83.006654) (xy 83.728889 83.51881) (xy 83.493169 84.087888) (xy 83.373 84.692017) (xy 83.373 85.307983)
        (xy 83.493169 85.912112) (xy 83.728889 86.48119) (xy 84.071101 86.993346) (xy 84.506654 87.428899) (xy 85.01881 87.771111)
        (xy 85.252721 87.868) (xy 6.247279 87.868) (xy 6.48119 87.771111) (xy 6.993346 87.428899) (xy 7.428899 86.993346)
        (xy 7.771111 86.48119) (xy 8.006831 85.912112) (xy 8.127 85.307983) (xy 8.127 84.692017) (xy 8.006831 84.087888)
        (xy 7.771111 83.51881) (xy 7.428899 83.006654) (xy 6.993346 82.571101) (xy 6.48119 82.228889) (xy 5.912112 81.993169)
        (xy 5.307983 81.873) (xy 4.692017 81.873) (xy 4.087888 81.993169) (xy 3.51881 82.228889) (xy 3.006654 82.571101)
        (xy 2.571101 83.006654) (xy 2.228889 83.51881) (xy 1.993169 84.087888) (xy 1.873 84.692017) (xy 1.873 85.307983)
        (xy 1.993169 85.912112) (xy 2.228889 86.48119) (xy 2.571101 86.993346) (xy 3.006654 87.428899) (xy 3.51881 87.771111)
        (xy 3.658865 87.829124) (xy 3.443995 87.808055) (xy 2.909155 87.646578) (xy 2.415878 87.384297) (xy 1.982935 87.031198)
        (xy 1.626821 86.60073) (xy 1.3611 86.109291) (xy 1.195896 85.575602) (xy 1.132 84.967673) (xy 1.132 35.63789)
        (xy 1.234238 35.829164) (xy 1.431037 36.068963) (xy 1.670836 36.265762) (xy 1.944421 36.411996) (xy 2.241279 36.502047)
        (xy 2.55 36.532453) (xy 3.45 36.532453) (xy 3.758721 36.502047) (xy 4.055579 36.411996) (xy 4.329164 36.265762)
        (xy 4.568963 36.068963) (xy 4.765762 35.829164) (xy 4.911996 35.555579) (xy 4.997768 35.272827) (xy 8.841814 31.428782)
        (xy 8.889581 31.389581) (xy 8.984763 31.273601) (xy 9.046036 31.19894) (xy 9.162293 30.981438) (xy 9.178266 30.928783)
        (xy 9.233884 30.745435) (xy 9.252 30.561498) (xy 9.252 30.561497) (xy 9.258057 30.500001) (xy 9.252 30.438505)
        (xy 9.252 27.874778) (xy 9.35321 27.723306) (xy 9.468319 27.44541) (xy 9.527 27.150396) (xy 9.527 26.849604)
        (xy 9.468319 26.55459) (xy 9.35321 26.276694) (xy 9.186099 26.026594) (xy 8.973406 25.813901) (xy 8.963388 25.807207)
        (xy 9.55843 25.212165) (xy 9.527053 25.287915) (xy 9.453 25.660207) (xy 9.453 26.039793) (xy 9.527053 26.412085)
        (xy 9.672315 26.762777) (xy 9.883201 27.078391) (xy 9.92481 27.12) (xy 9.883201 27.161609) (xy 9.672315 27.477223)
        (xy 9.527053 27.827915) (xy 9.453 28.200207) (xy 9.453 28.579793) (xy 9.527053 28.952085) (xy 9.672315 29.302777)
        (xy 9.883201 29.618391) (xy 9.92481 29.66) (xy 9.883201 29.701609) (xy 9.672315 30.017223) (xy 9.527053 30.367915)
        (xy 9.453 30.740207) (xy 9.453 31.119793) (xy 9.527053 31.492085) (xy 9.672315 31.842777) (xy 9.883201 32.158391)
        (xy 9.92481 32.2) (xy 9.883201 32.241609) (xy 9.762164 32.422754) (xy 9.723306 32.39679) (xy 9.44541 32.281681)
        (xy 9.150396 32.223) (xy 8.849604 32.223) (xy 8.55459 32.281681) (xy 8.276694 32.39679) (xy 8.026594 32.563901)
        (xy 7.813901 32.776594) (xy 7.64679 33.026694) (xy 7.531681 33.30459) (xy 7.473 33.599604) (xy 7.473 33.756404)
        (xy 4.458192 36.771213) (xy 4.410419 36.810419) (xy 4.253964 37.001062) (xy 4.137707 37.218563) (xy 4.066116 37.454566)
        (xy 4.055274 37.564653) (xy 4.050578 37.61233) (xy 3.796324 37.748232) (xy 3.495286 37.995286) (xy 3.248232 38.296324)
        (xy 3.064653 38.639774) (xy 2.951606 39.01244) (xy 2.913435 39.4) (xy 2.951606 39.78756) (xy 2.970551 39.850014)
        (xy 2.681959 39.969553) (xy 2.399102 40.158552) (xy 2.158552 40.399102) (xy 1.969553 40.681959) (xy 1.839368 40.996253)
        (xy 1.773 41.329905) (xy 1.773 41.670095) (xy 1.839368 42.003747) (xy 1.969553 42.318041) (xy 2.007612 42.375)
        (xy 1.969553 42.431959) (xy 1.839368 42.746253) (xy 1.773 43.079905) (xy 1.773 43.420095) (xy 1.839368 43.753747)
        (xy 1.969553 44.068041) (xy 2.158552 44.350898) (xy 2.399102 44.591448) (xy 2.681959 44.780447) (xy 2.970551 44.899986)
        (xy 2.951606 44.96244) (xy 2.913435 45.35) (xy 2.951606 45.73756) (xy 3.064653 46.110226) (xy 3.248232 46.453676)
        (xy 3.495286 46.754714) (xy 3.796324 47.001768) (xy 4.139774 47.185347) (xy 4.51244 47.298394) (xy 4.802884 47.327)
        (xy 5.797116 47.327) (xy 6.08756 47.298394) (xy 6.460226 47.185347) (xy 6.8 47.003733) (xy 7.102518 47.165433)
        (xy 7.108559 47.185347) (xy 7.137707 47.281437) (xy 7.253964 47.498938) (xy 7.256516 47.502047) (xy 7.41042 47.689581)
        (xy 7.458188 47.728783) (xy 8.071209 48.341803) (xy 8.110419 48.389581) (xy 8.256202 48.509221) (xy 8.30106 48.546036)
        (xy 8.376822 48.586531) (xy 8.518562 48.662293) (xy 8.754565 48.733884) (xy 8.938502 48.752) (xy 8.938503 48.752)
        (xy 8.999999 48.758057) (xy 9.061495 48.752) (xy 25.438504 48.752) (xy 25.5 48.758057) (xy 25.561496 48.752)
        (xy 25.561498 48.752) (xy 25.745435 48.733884) (xy 25.981438 48.662293) (xy 26.198939 48.546036) (xy 26.389581 48.389581)
        (xy 26.428787 48.341808) (xy 27.341809 47.428786) (xy 27.389581 47.389581) (xy 27.546036 47.198939) (xy 27.662293 46.981438)
        (xy 27.733884 46.745435) (xy 27.752 46.561498) (xy 27.752 46.561496) (xy 27.758057 46.5) (xy 27.752 46.438504)
        (xy 27.752 44.694724) (xy 27.94024 44.54024) (xy 28.193543 44.231589) (xy 28.381764 43.879452) (xy 28.49767 43.497361)
        (xy 28.527 43.199571) (xy 28.527 40.800429) (xy 28.49767 40.502639) (xy 28.381764 40.120548) (xy 28.193543 39.768411)
        (xy 27.94024 39.45976) (xy 27.631589 39.206457) (xy 27.279452 39.018236) (xy 26.897361 38.90233) (xy 26.5 38.863193)
        (xy 26.10264 38.90233) (xy 25.720549 39.018236) (xy 25.368412 39.206457) (xy 25.059761 39.45976) (xy 24.806458 39.768411)
        (xy 24.618237 40.120548) (xy 24.502331 40.502639) (xy 24.473001 40.800429) (xy 24.473 43.19957) (xy 24.50233 43.49736)
        (xy 24.618236 43.879451) (xy 24.806457 44.231589) (xy 25.05976 44.54024) (xy 25.248 44.694725) (xy 25.248 45.981405)
        (xy 24.981405 46.248) (xy 18.503103 46.248) (xy 18.532453 45.95) (xy 18.532453 45.05) (xy 18.514907 44.871846)
        (xy 18.720548 44.981764) (xy 19.102639 45.09767) (xy 19.5 45.136807) (xy 19.89736 45.09767) (xy 20.279451 44.981764)
        (xy 20.631589 44.793543) (xy 20.94024 44.54024) (xy 21.193543 44.231589) (xy 21.381764 43.879452) (xy 21.49767 43.497361)
        (xy 21.527 43.199571) (xy 21.527 40.800429) (xy 21.49767 40.502639) (xy 21.381764 40.120548) (xy 21.193543 39.768411)
        (xy 21.107287 39.663308) (xy 22.518595 38.252) (xy 23.938504 38.252) (xy 24 38.258057) (xy 24.061496 38.252)
        (xy 24.061498 38.252) (xy 24.245435 38.233884) (xy 24.481438 38.162293) (xy 24.698939 38.046036) (xy 24.889581 37.889581)
        (xy 24.928787 37.841808) (xy 25.841809 36.928786) (xy 25.889581 36.889581) (xy 26.046036 36.698939) (xy 26.162293 36.481438)
        (xy 26.233884 36.245435) (xy 26.252 36.061498) (xy 26.252 36.061496) (xy 26.258057 36) (xy 26.252 35.938504)
        (xy 26.252 35.361553) (xy 26.430207 35.397) (xy 26.809793 35.397) (xy 27.182085 35.322947) (xy 27.532777 35.177685)
        (xy 27.848391 34.966799) (xy 28.116799 34.698391) (xy 28.327685 34.382777) (xy 28.472947 34.032085) (xy 28.547 33.659793)
        (xy 28.547 33.280207) (xy 28.472947 32.907915) (xy 28.327685 32.557223) (xy 28.116799 32.241609) (xy 28.07519 32.2)
        (xy 28.116799 32.158391) (xy 28.327685 31.842777) (xy 28.472947 31.492085) (xy 28.547 31.119793) (xy 28.547 30.740207)
        (xy 28.472947 30.367915) (xy 28.327685 30.017223) (xy 28.116799 29.701609) (xy 28.07519 29.66) (xy 28.116799 29.618391)
        (xy 28.327685 29.302777) (xy 28.472947 28.952085) (xy 28.547 28.579793) (xy 28.547 28.200207) (xy 28.472947 27.827915)
        (xy 28.327685 27.477223) (xy 28.116799 27.161609) (xy 28.07519 27.12) (xy 28.116799 27.078391) (xy 28.327685 26.762777)
        (xy 28.472947 26.412085) (xy 28.547 26.039793) (xy 28.547 25.660207) (xy 28.472947 25.287915) (xy 28.327685 24.937223)
        (xy 28.116799 24.621609) (xy 28.07519 24.58) (xy 28.116799 24.538391) (xy 28.327685 24.222777) (xy 28.472947 23.872085)
        (xy 28.547 23.499793) (xy 28.547 23.120207) (xy 28.472947 22.747915) (xy 28.327685 22.397223) (xy 28.116799 22.081609)
        (xy 28.07519 22.04) (xy 28.116799 21.998391) (xy 28.327685 21.682777) (xy 28.472947 21.332085) (xy 28.547 20.959793)
        (xy 28.547 20.580207) (xy 28.472947 20.207915) (xy 28.327685 19.857223) (xy 28.116799 19.541609) (xy 28.07519 19.5)
        (xy 28.116799 19.458391) (xy 28.327685 19.142777) (xy 28.472947 18.792085) (xy 28.547 18.419793) (xy 28.547 18.040207)
        (xy 28.472947 17.667915) (xy 28.327685 17.317223) (xy 28.116799 17.001609) (xy 28.07519 16.96) (xy 28.116799 16.918391)
        (xy 28.327685 16.602777) (xy 28.472947 16.252085) (xy 28.520787 16.011575) (xy 28.543884 15.935435) (xy 28.568057 15.69)
        (xy 28.543884 15.444565) (xy 28.520787 15.368425) (xy 28.472947 15.127915) (xy 28.327685 14.777223) (xy 28.116799 14.461609)
        (xy 28.07519 14.42) (xy 28.116799 14.378391) (xy 28.327685 14.062777) (xy 28.472947 13.712085) (xy 28.547 13.339793)
        (xy 28.547 12.960207) (xy 28.472947 12.587915) (xy 28.327685 12.237223) (xy 28.116799 11.921609) (xy 28.07519 11.88)
        (xy 28.116799 11.838391) (xy 28.327685 11.522777) (xy 28.472947 11.172085) (xy 28.547 10.799793) (xy 28.547 10.420207)
        (xy 28.472947 10.047915) (xy 28.327685 9.697223) (xy 28.116799 9.381609) (xy 28.07519 9.34) (xy 28.09319 9.322)
        (xy 33.424327 9.322) (xy 33.230813 9.480813) (xy 32.990006 9.774237) (xy 32.811071 10.109001) (xy 32.700883 10.472242)
        (xy 32.663677 10.85) (xy 32.700883 11.227758) (xy 32.811071 11.590999) (xy 32.990006 11.925763) (xy 33.230813 12.219187)
        (xy 33.524237 12.459994) (xy 33.859001 12.638929) (xy 34.222242 12.749117) (xy 34.505342 12.777) (xy 35.494658 12.777)
        (xy 35.777758 12.749117) (xy 36.140999 12.638929) (xy 36.475763 12.459994) (xy 36.769187 12.219187) (xy 37.009994 11.925763)
        (xy 37.188929 11.590999) (xy 37.299117 11.227758) (xy 37.336323 10.85) (xy 37.299117 10.472242) (xy 37.188929 10.109001)
        (xy 37.009994 9.774237) (xy 36.769187 9.480813) (xy 36.575673 9.322) (xy 39.368504 9.322) (xy 39.43 9.328057)
        (xy 39.491496 9.322) (xy 39.491498 9.322) (xy 39.675435 9.303884) (xy 39.911438 9.232293) (xy 40.128939 9.116036)
        (xy 40.319581 8.959581) (xy 40.358787 8.911808) (xy 42.341814 6.928782) (xy 42.389581 6.889581) (xy 42.47763 6.782293)
        (xy 42.546036 6.69894) (xy 42.662293 6.481438) (xy 42.674021 6.442777) (xy 42.733884 6.245435) (xy 42.752 6.061498)
        (xy 42.752 6.061497) (xy 42.758057 6.000001) (xy 42.752 5.938505) (xy 42.752 5.307007) (xy 42.829164 5.265762)
        (xy 43.068963 5.068963) (xy 43.265762 4.829164) (xy 43.411996 4.555579) (xy 43.502047 4.258721) (xy 43.532453 3.95)
        (xy 43.532453 3.05) (xy 43.502047 2.741279) (xy 43.411996 2.444421) (xy 43.265762 2.170836) (xy 43.068963 1.931037)
        (xy 42.829164 1.734238) (xy 42.555579 1.588004) (xy 42.258721 1.497953) (xy 41.95 1.467547) (xy 41.05 1.467547)
        (xy 40.741279 1.497953) (xy 40.444421 1.588004) (xy 40.170836 1.734238) (xy 39.931037 1.931037) (xy 39.75 2.15163)
        (xy 39.568963 1.931037) (xy 39.329164 1.734238) (xy 39.055579 1.588004) (xy 38.758721 1.497953) (xy 38.45 1.467547)
        (xy 37.55 1.467547) (xy 37.241279 1.497953) (xy 36.944421 1.588004) (xy 36.670836 1.734238) (xy 36.431037 1.931037)
        (xy 36.25 2.15163) (xy 36.068963 1.931037) (xy 35.829164 1.734238) (xy 35.555579 1.588004) (xy 35.258721 1.497953)
        (xy 34.95 1.467547) (xy 34.05 1.467547) (xy 33.741279 1.497953) (xy 33.444421 1.588004) (xy 33.170836 1.734238)
        (xy 32.931037 1.931037) (xy 32.734238 2.170836) (xy 32.588004 2.444421) (xy 32.497953 2.741279) (xy 32.467547 3.05)
        (xy 32.467547 3.95) (xy 32.497953 4.258721) (xy 32.588004 4.555579) (xy 32.734238 4.829164) (xy 32.931037 5.068963)
        (xy 33.170836 5.265762) (xy 33.444421 5.411996) (xy 33.741279 5.502047) (xy 34.05 5.532453) (xy 34.95 5.532453)
        (xy 35.258721 5.502047) (xy 35.555579 5.411996) (xy 35.829164 5.265762) (xy 36.068963 5.068963) (xy 36.25 4.84837)
        (xy 36.431037 5.068963) (xy 36.670836 5.265762) (xy 36.944421 5.411996) (xy 37.241279 5.502047) (xy 37.55 5.532453)
        (xy 38.45 5.532453) (xy 38.758721 5.502047) (xy 39.055579 5.411996) (xy 39.329164 5.265762) (xy 39.568963 5.068963)
        (xy 39.75 4.84837) (xy 39.931037 5.068963) (xy 40.170836 5.265762) (xy 40.248 5.307007) (xy 40.248 5.481404)
        (xy 38.911405 6.818) (xy 28.09319 6.818) (xy 28.07519 6.8) (xy 28.116799 6.758391) (xy 28.327685 6.442777)
        (xy 28.472947 6.092085) (xy 28.547 5.719793) (xy 28.547 5.340207) (xy 28.472947 4.967915) (xy 28.327685 4.617223)
        (xy 28.116799 4.301609) (xy 27.848391 4.033201) (xy 27.532777 3.822315) (xy 27.182085 3.677053) (xy 26.809793 3.603)
        (xy 26.430207 3.603) (xy 26.057915 3.677053) (xy 25.707223 3.822315) (xy 25.391609 4.033201) (xy 25.132 4.29281)
        (xy 25.132 1.132) (xy 85.252721 1.132)
      )
    )
    (filled_polygon
      (pts
        (xy 84.570843 79.1416) (xy 84.581897 79.147508) (xy 83.481405 80.248) (xy 83.332453 80.248) (xy 83.332453 79.414296)
        (xy 83.795437 79.322203) (xy 84.291719 79.116636) (xy 84.428809 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 103.570843 79.1416) (xy 103.581897 79.147508) (xy 102.481405 80.248) (xy 102.332453 80.248) (xy 102.332453 79.414296)
        (xy 102.795437 79.322203) (xy 103.291719 79.116636) (xy 103.428809 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 160.570843 79.1416) (xy 160.581897 79.147508) (xy 159.481405 80.248) (xy 159.332453 80.248) (xy 159.332453 79.414296)
        (xy 159.795437 79.322203) (xy 160.291719 79.116636) (xy 160.428809 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 147.708281 79.116636) (xy 148.204563 79.322203) (xy 148.667547 79.414296) (xy 148.667547 80.248) (xy 148.518595 80.248)
        (xy 147.418103 79.147508) (xy 147.429157 79.1416) (xy 147.571191 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 52.708281 79.116636) (xy 53.204563 79.322203) (xy 53.667547 79.414296) (xy 53.667547 80.248) (xy 53.018596 80.248)
        (xy 52.06724 79.296645) (xy 52.233371 79.24625) (xy 52.429157 79.1416) (xy 52.571191 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 128.708281 79.116636) (xy 129.204563 79.322203) (xy 129.667547 79.414296) (xy 129.667547 80.248) (xy 129.518595 80.248)
        (xy 128.418103 79.147508) (xy 128.429157 79.1416) (xy 128.571191 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 46.570843 79.1416) (xy 46.581897 79.147508) (xy 45.481405 80.248) (xy 45.332453 80.248) (xy 45.332453 79.414296)
        (xy 45.795437 79.322203) (xy 46.291719 79.116636) (xy 46.428809 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 141.570843 79.1416) (xy 141.581897 79.147508) (xy 140.481405 80.248) (xy 140.332453 80.248) (xy 140.332453 79.414296)
        (xy 140.795437 79.322203) (xy 141.291719 79.116636) (xy 141.428809 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 65.570843 79.1416) (xy 65.766629 79.24625) (xy 65.932759 79.296645) (xy 64.981405 80.248) (xy 64.332453 80.248)
        (xy 64.332453 79.414296) (xy 64.795437 79.322203) (xy 65.291719 79.116636) (xy 65.428809 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 109.708281 79.116636) (xy 110.204563 79.322203) (xy 110.667547 79.414296) (xy 110.667547 80.248) (xy 110.518595 80.248)
        (xy 109.418103 79.147508) (xy 109.429157 79.1416) (xy 109.571191 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 122.570843 79.1416) (xy 122.581897 79.147508) (xy 121.481405 80.248) (xy 121.332453 80.248) (xy 121.332453 79.414296)
        (xy 121.795437 79.322203) (xy 122.291719 79.116636) (xy 122.428809 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 90.708281 79.116636) (xy 91.204563 79.322203) (xy 91.667547 79.414296) (xy 91.667547 80.248) (xy 91.518595 80.248)
        (xy 90.418103 79.147508) (xy 90.429157 79.1416) (xy 90.571191 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 33.708281 79.116636) (xy 34.204563 79.322203) (xy 34.667547 79.414296) (xy 34.667547 80.248) (xy 34.518595 80.248)
        (xy 33.418103 79.147508) (xy 33.429157 79.1416) (xy 33.571191 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 71.708281 79.116636) (xy 72.204563 79.322203) (xy 72.667547 79.414296) (xy 72.667547 80.248) (xy 72.518595 80.248)
        (xy 71.418103 79.147508) (xy 71.429157 79.1416) (xy 71.571191 79.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 66.78399 73.445415) (xy 66.827 73.229189) (xy 66.827 72.982453) (xy 67.246952 72.982453)
      )
    )
    (filled_polygon
      (pts
        (xy 85.78399 73.445415) (xy 85.827 73.229189) (xy 85.827 72.982453) (xy 86.246952 72.982453)
      )
    )
    (filled_polygon
      (pts
        (xy 160.570843 58.1416) (xy 160.766629 58.24625) (xy 160.952038 58.302493) (xy 160.964038 58.424331) (xy 160.966117 58.445435)
        (xy 160.969946 58.458057) (xy 161.037707 58.681437) (xy 161.153964 58.898938) (xy 161.252137 59.018562) (xy 161.31042 59.089581)
        (xy 161.358188 59.128783) (xy 162.248 60.018595) (xy 162.248001 66.017547) (xy 161.6038 66.017547) (xy 161.323601 66.045144)
        (xy 161.05417 66.126875) (xy 160.805861 66.259599) (xy 160.652749 66.385255) (xy 160.475763 66.240006) (xy 160.140999 66.061071)
        (xy 159.777758 65.950883) (xy 159.494658 65.923) (xy 158.505342 65.923) (xy 158.222242 65.950883) (xy 157.859001 66.061071)
        (xy 157.524237 66.240006) (xy 157.230813 66.480813) (xy 156.990006 66.774237) (xy 156.811071 67.109001) (xy 156.700883 67.472242)
        (xy 156.663677 67.85) (xy 156.700883 68.227758) (xy 156.811071 68.590999) (xy 156.990006 68.925763) (xy 157.230813 69.219187)
        (xy 157.524237 69.459994) (xy 157.859001 69.638929) (xy 158.222242 69.749117) (xy 158.505342 69.777) (xy 159.494658 69.777)
        (xy 159.777758 69.749117) (xy 160.140999 69.638929) (xy 160.223 69.595099) (xy 160.223 69.615924) (xy 160.259217 69.798)
        (xy 158.511496 69.798) (xy 158.45 69.791943) (xy 158.388504 69.798) (xy 158.388502 69.798) (xy 158.204565 69.816116)
        (xy 157.968562 69.887707) (xy 157.751061 70.003964) (xy 157.560419 70.160419) (xy 157.521213 70.208192) (xy 157.195464 70.533941)
        (xy 157.127975 70.432937) (xy 156.567063 69.872025) (xy 155.9075 69.431319) (xy 155.174633 69.127755) (xy 154.396625 68.973)
        (xy 153.603375 68.973) (xy 152.825367 69.127755) (xy 152.0925 69.431319) (xy 151.432937 69.872025) (xy 150.872025 70.432937)
        (xy 150.431319 71.0925) (xy 150.27083 71.479955) (xy 149.983376 71.192501) (xy 149.602248 70.93784) (xy 149.178761 70.762426)
        (xy 148.729189 70.673) (xy 148.270811 70.673) (xy 147.821239 70.762426) (xy 147.397752 70.93784) (xy 147.052 71.168864)
        (xy 147.052 69.001303) (xy 147.230813 69.219187) (xy 147.524237 69.459994) (xy 147.859001 69.638929) (xy 148.222242 69.749117)
        (xy 148.505342 69.777) (xy 149.494658 69.777) (xy 149.777758 69.749117) (xy 150.140999 69.638929) (xy 150.475763 69.459994)
        (xy 150.769187 69.219187) (xy 151.009994 68.925763) (xy 151.188929 68.590999) (xy 151.299117 68.227758) (xy 151.336323 67.85)
        (xy 151.299117 67.472242) (xy 151.188929 67.109001) (xy 151.009994 66.774237) (xy 150.769187 66.480813) (xy 150.475763 66.240006)
        (xy 150.140999 66.061071) (xy 149.777758 65.950883) (xy 149.494658 65.923) (xy 148.505342 65.923) (xy 148.222242 65.950883)
        (xy 147.859001 66.061071) (xy 147.524237 66.240006) (xy 147.230813 66.480813) (xy 147.052 66.698697) (xy 147.052 58.301268)
        (xy 147.233371 58.24625) (xy 147.429157 58.1416) (xy 147.571191 58.025035) (xy 147.708281 58.116636) (xy 148.204563 58.322203)
        (xy 148.667547 58.414296) (xy 148.667547 59.4) (xy 148.689307 59.620931) (xy 148.75375 59.833371) (xy 148.8584 60.029157)
        (xy 148.999235 60.200765) (xy 149.170843 60.3416) (xy 149.366629 60.44625) (xy 149.579069 60.510693) (xy 149.8 60.532453)
        (xy 151.8 60.532453) (xy 152.020931 60.510693) (xy 152.233371 60.44625) (xy 152.429157 60.3416) (xy 152.571191 60.225035)
        (xy 152.708281 60.316636) (xy 153.204563 60.522203) (xy 153.731414 60.627) (xy 154.268586 60.627) (xy 154.795437 60.522203)
        (xy 155.291719 60.316636) (xy 155.428809 60.225035) (xy 155.570843 60.3416) (xy 155.766629 60.44625) (xy 155.979069 60.510693)
        (xy 156.2 60.532453) (xy 158.2 60.532453) (xy 158.420931 60.510693) (xy 158.633371 60.44625) (xy 158.829157 60.3416)
        (xy 159.000765 60.200765) (xy 159.1416 60.029157) (xy 159.24625 59.833371) (xy 159.310693 59.620931) (xy 159.332453 59.4)
        (xy 159.332453 58.414296) (xy 159.795437 58.322203) (xy 160.291719 58.116636) (xy 160.428809 58.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 103.570843 58.1416) (xy 103.766629 58.24625) (xy 103.952038 58.302493) (xy 103.964038 58.424331) (xy 103.966117 58.445435)
        (xy 103.969946 58.458057) (xy 104.037707 58.681437) (xy 104.153964 58.898938) (xy 104.252137 59.018562) (xy 104.31042 59.089581)
        (xy 104.358188 59.128783) (xy 105.248 60.018595) (xy 105.248 66.017547) (xy 104.6038 66.017547) (xy 104.323601 66.045144)
        (xy 104.05417 66.126875) (xy 103.805861 66.259599) (xy 103.652749 66.385255) (xy 103.475763 66.240006) (xy 103.140999 66.061071)
        (xy 102.777758 65.950883) (xy 102.494658 65.923) (xy 101.505342 65.923) (xy 101.222242 65.950883) (xy 100.859001 66.061071)
        (xy 100.524237 66.240006) (xy 100.230813 66.480813) (xy 99.990006 66.774237) (xy 99.811071 67.109001) (xy 99.700883 67.472242)
        (xy 99.663677 67.85) (xy 99.700883 68.227758) (xy 99.811071 68.590999) (xy 99.990006 68.925763) (xy 100.230813 69.219187)
        (xy 100.524237 69.459994) (xy 100.859001 69.638929) (xy 101.222242 69.749117) (xy 101.505342 69.777) (xy 102.494658 69.777)
        (xy 102.777758 69.749117) (xy 103.140999 69.638929) (xy 103.223 69.595099) (xy 103.223 69.615924) (xy 103.259217 69.798)
        (xy 101.511496 69.798) (xy 101.45 69.791943) (xy 101.388504 69.798) (xy 101.388502 69.798) (xy 101.204565 69.816116)
        (xy 100.968562 69.887707) (xy 100.751061 70.003964) (xy 100.560419 70.160419) (xy 100.521213 70.208192) (xy 100.195464 70.533941)
        (xy 100.127975 70.432937) (xy 99.567063 69.872025) (xy 98.9075 69.431319) (xy 98.174633 69.127755) (xy 97.396625 68.973)
        (xy 96.603375 68.973) (xy 95.825367 69.127755) (xy 95.0925 69.431319) (xy 94.432937 69.872025) (xy 93.872025 70.432937)
        (xy 93.431319 71.0925) (xy 93.27083 71.479955) (xy 92.983376 71.192501) (xy 92.602248 70.93784) (xy 92.178761 70.762426)
        (xy 91.729189 70.673) (xy 91.270811 70.673) (xy 90.821239 70.762426) (xy 90.397752 70.93784) (xy 90.052 71.168864)
        (xy 90.052 69.001303) (xy 90.230813 69.219187) (xy 90.524237 69.459994) (xy 90.859001 69.638929) (xy 91.222242 69.749117)
        (xy 91.505342 69.777) (xy 92.494658 69.777) (xy 92.777758 69.749117) (xy 93.140999 69.638929) (xy 93.475763 69.459994)
        (xy 93.769187 69.219187) (xy 94.009994 68.925763) (xy 94.188929 68.590999) (xy 94.299117 68.227758) (xy 94.336323 67.85)
        (xy 94.299117 67.472242) (xy 94.188929 67.109001) (xy 94.009994 66.774237) (xy 93.769187 66.480813) (xy 93.475763 66.240006)
        (xy 93.140999 66.061071) (xy 92.777758 65.950883) (xy 92.494658 65.923) (xy 91.505342 65.923) (xy 91.222242 65.950883)
        (xy 90.859001 66.061071) (xy 90.524237 66.240006) (xy 90.230813 66.480813) (xy 90.052 66.698697) (xy 90.052 58.301268)
        (xy 90.233371 58.24625) (xy 90.429157 58.1416) (xy 90.571191 58.025035) (xy 90.708281 58.116636) (xy 91.204563 58.322203)
        (xy 91.667547 58.414296) (xy 91.667547 59.4) (xy 91.689307 59.620931) (xy 91.75375 59.833371) (xy 91.8584 60.029157)
        (xy 91.999235 60.200765) (xy 92.170843 60.3416) (xy 92.366629 60.44625) (xy 92.579069 60.510693) (xy 92.8 60.532453)
        (xy 94.8 60.532453) (xy 95.020931 60.510693) (xy 95.233371 60.44625) (xy 95.429157 60.3416) (xy 95.571191 60.225035)
        (xy 95.708281 60.316636) (xy 96.204563 60.522203) (xy 96.731414 60.627) (xy 97.268586 60.627) (xy 97.795437 60.522203)
        (xy 98.291719 60.316636) (xy 98.428809 60.225035) (xy 98.570843 60.3416) (xy 98.766629 60.44625) (xy 98.979069 60.510693)
        (xy 99.2 60.532453) (xy 101.2 60.532453) (xy 101.420931 60.510693) (xy 101.633371 60.44625) (xy 101.829157 60.3416)
        (xy 102.000765 60.200765) (xy 102.1416 60.029157) (xy 102.24625 59.833371) (xy 102.310693 59.620931) (xy 102.332453 59.4)
        (xy 102.332453 58.414296) (xy 102.795437 58.322203) (xy 103.291719 58.116636) (xy 103.428809 58.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 141.570843 58.1416) (xy 141.766629 58.24625) (xy 141.979069 58.310693) (xy 142.113894 58.323972) (xy 142.153964 58.398938)
        (xy 142.252137 58.518562) (xy 142.31042 58.589581) (xy 142.358188 58.628783) (xy 143.248 59.518595) (xy 143.248001 66.017547)
        (xy 142.6038 66.017547) (xy 142.323601 66.045144) (xy 142.05417 66.126875) (xy 141.805861 66.259599) (xy 141.652749 66.385255)
        (xy 141.475763 66.240006) (xy 141.140999 66.061071) (xy 140.777758 65.950883) (xy 140.494658 65.923) (xy 139.505342 65.923)
        (xy 139.222242 65.950883) (xy 138.859001 66.061071) (xy 138.524237 66.240006) (xy 138.230813 66.480813) (xy 137.990006 66.774237)
        (xy 137.811071 67.109001) (xy 137.700883 67.472242) (xy 137.663677 67.85) (xy 137.700883 68.227758) (xy 137.811071 68.590999)
        (xy 137.990006 68.925763) (xy 138.230813 69.219187) (xy 138.524237 69.459994) (xy 138.859001 69.638929) (xy 139.222242 69.749117)
        (xy 139.505342 69.777) (xy 140.494658 69.777) (xy 140.777758 69.749117) (xy 141.140999 69.638929) (xy 141.223 69.595099)
        (xy 141.223 69.615924) (xy 141.259217 69.798) (xy 139.511496 69.798) (xy 139.45 69.791943) (xy 139.388504 69.798)
        (xy 139.388502 69.798) (xy 139.204565 69.816116) (xy 138.968562 69.887707) (xy 138.751061 70.003964) (xy 138.560419 70.160419)
        (xy 138.521213 70.208192) (xy 138.195464 70.533941) (xy 138.127975 70.432937) (xy 137.567063 69.872025) (xy 136.9075 69.431319)
        (xy 136.174633 69.127755) (xy 135.396625 68.973) (xy 134.603375 68.973) (xy 133.825367 69.127755) (xy 133.0925 69.431319)
        (xy 132.432937 69.872025) (xy 131.872025 70.432937) (xy 131.431319 71.0925) (xy 131.27083 71.479955) (xy 130.983376 71.192501)
        (xy 130.602248 70.93784) (xy 130.178761 70.762426) (xy 129.729189 70.673) (xy 129.270811 70.673) (xy 128.821239 70.762426)
        (xy 128.397752 70.93784) (xy 128.052 71.168864) (xy 128.052 69.001303) (xy 128.230813 69.219187) (xy 128.524237 69.459994)
        (xy 128.859001 69.638929) (xy 129.222242 69.749117) (xy 129.505342 69.777) (xy 130.494658 69.777) (xy 130.777758 69.749117)
        (xy 131.140999 69.638929) (xy 131.475763 69.459994) (xy 131.769187 69.219187) (xy 132.009994 68.925763) (xy 132.188929 68.590999)
        (xy 132.299117 68.227758) (xy 132.336323 67.85) (xy 132.299117 67.472242) (xy 132.188929 67.109001) (xy 132.009994 66.774237)
        (xy 131.769187 66.480813) (xy 131.475763 66.240006) (xy 131.140999 66.061071) (xy 130.777758 65.950883) (xy 130.494658 65.923)
        (xy 129.505342 65.923) (xy 129.222242 65.950883) (xy 128.859001 66.061071) (xy 128.524237 66.240006) (xy 128.230813 66.480813)
        (xy 128.052 66.698697) (xy 128.052 58.301268) (xy 128.233371 58.24625) (xy 128.429157 58.1416) (xy 128.571191 58.025035)
        (xy 128.708281 58.116636) (xy 129.204563 58.322203) (xy 129.667547 58.414296) (xy 129.667547 59.4) (xy 129.689307 59.620931)
        (xy 129.75375 59.833371) (xy 129.8584 60.029157) (xy 129.999235 60.200765) (xy 130.170843 60.3416) (xy 130.366629 60.44625)
        (xy 130.579069 60.510693) (xy 130.8 60.532453) (xy 132.8 60.532453) (xy 133.020931 60.510693) (xy 133.233371 60.44625)
        (xy 133.429157 60.3416) (xy 133.571191 60.225035) (xy 133.708281 60.316636) (xy 134.204563 60.522203) (xy 134.731414 60.627)
        (xy 135.268586 60.627) (xy 135.795437 60.522203) (xy 136.291719 60.316636) (xy 136.428809 60.225035) (xy 136.570843 60.3416)
        (xy 136.766629 60.44625) (xy 136.979069 60.510693) (xy 137.2 60.532453) (xy 139.2 60.532453) (xy 139.420931 60.510693)
        (xy 139.633371 60.44625) (xy 139.829157 60.3416) (xy 140.000765 60.200765) (xy 140.1416 60.029157) (xy 140.24625 59.833371)
        (xy 140.310693 59.620931) (xy 140.332453 59.4) (xy 140.332453 58.414296) (xy 140.795437 58.322203) (xy 141.291719 58.116636)
        (xy 141.428809 58.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 84.570843 58.1416) (xy 84.766629 58.24625) (xy 84.952038 58.302493) (xy 84.964038 58.424331) (xy 84.966117 58.445435)
        (xy 84.969946 58.458057) (xy 85.037707 58.681437) (xy 85.153964 58.898938) (xy 85.252137 59.018562) (xy 85.31042 59.089581)
        (xy 85.358188 59.128783) (xy 86.248 60.018595) (xy 86.248 66.017547) (xy 85.6038 66.017547) (xy 85.323601 66.045144)
        (xy 85.05417 66.126875) (xy 84.805861 66.259599) (xy 84.652749 66.385255) (xy 84.475763 66.240006) (xy 84.140999 66.061071)
        (xy 83.777758 65.950883) (xy 83.494658 65.923) (xy 82.505342 65.923) (xy 82.222242 65.950883) (xy 81.859001 66.061071)
        (xy 81.524237 66.240006) (xy 81.230813 66.480813) (xy 80.990006 66.774237) (xy 80.811071 67.109001) (xy 80.700883 67.472242)
        (xy 80.663677 67.85) (xy 80.700883 68.227758) (xy 80.811071 68.590999) (xy 80.990006 68.925763) (xy 81.230813 69.219187)
        (xy 81.524237 69.459994) (xy 81.859001 69.638929) (xy 82.222242 69.749117) (xy 82.505342 69.777) (xy 83.494658 69.777)
        (xy 83.777758 69.749117) (xy 84.140999 69.638929) (xy 84.223 69.595099) (xy 84.223 69.615924) (xy 84.259217 69.798)
        (xy 82.511496 69.798) (xy 82.45 69.791943) (xy 82.388504 69.798) (xy 82.388502 69.798) (xy 82.204565 69.816116)
        (xy 81.968562 69.887707) (xy 81.751061 70.003964) (xy 81.560419 70.160419) (xy 81.521213 70.208192) (xy 81.195464 70.533941)
        (xy 81.127975 70.432937) (xy 80.567063 69.872025) (xy 79.9075 69.431319) (xy 79.174633 69.127755) (xy 78.396625 68.973)
        (xy 77.603375 68.973) (xy 76.825367 69.127755) (xy 76.0925 69.431319) (xy 75.432937 69.872025) (xy 74.872025 70.432937)
        (xy 74.431319 71.0925) (xy 74.27083 71.479955) (xy 73.983376 71.192501) (xy 73.602248 70.93784) (xy 73.178761 70.762426)
        (xy 72.729189 70.673) (xy 72.270811 70.673) (xy 71.821239 70.762426) (xy 71.397752 70.93784) (xy 71.052 71.168864)
        (xy 71.052 69.001303) (xy 71.230813 69.219187) (xy 71.524237 69.459994) (xy 71.859001 69.638929) (xy 72.222242 69.749117)
        (xy 72.505342 69.777) (xy 73.494658 69.777) (xy 73.777758 69.749117) (xy 74.140999 69.638929) (xy 74.475763 69.459994)
        (xy 74.769187 69.219187) (xy 75.009994 68.925763) (xy 75.188929 68.590999) (xy 75.299117 68.227758) (xy 75.336323 67.85)
        (xy 75.299117 67.472242) (xy 75.188929 67.109001) (xy 75.009994 66.774237) (xy 74.769187 66.480813) (xy 74.475763 66.240006)
        (xy 74.140999 66.061071) (xy 73.777758 65.950883) (xy 73.494658 65.923) (xy 72.505342 65.923) (xy 72.222242 65.950883)
        (xy 71.859001 66.061071) (xy 71.524237 66.240006) (xy 71.230813 66.480813) (xy 71.052 66.698697) (xy 71.052 58.301268)
        (xy 71.233371 58.24625) (xy 71.429157 58.1416) (xy 71.571191 58.025035) (xy 71.708281 58.116636) (xy 72.204563 58.322203)
        (xy 72.667547 58.414296) (xy 72.667547 59.4) (xy 72.689307 59.620931) (xy 72.75375 59.833371) (xy 72.8584 60.029157)
        (xy 72.999235 60.200765) (xy 73.170843 60.3416) (xy 73.366629 60.44625) (xy 73.579069 60.510693) (xy 73.8 60.532453)
        (xy 75.8 60.532453) (xy 76.020931 60.510693) (xy 76.233371 60.44625) (xy 76.429157 60.3416) (xy 76.571191 60.225035)
        (xy 76.708281 60.316636) (xy 77.204563 60.522203) (xy 77.731414 60.627) (xy 78.268586 60.627) (xy 78.795437 60.522203)
        (xy 79.291719 60.316636) (xy 79.428809 60.225035) (xy 79.570843 60.3416) (xy 79.766629 60.44625) (xy 79.979069 60.510693)
        (xy 80.2 60.532453) (xy 82.2 60.532453) (xy 82.420931 60.510693) (xy 82.633371 60.44625) (xy 82.829157 60.3416)
        (xy 83.000765 60.200765) (xy 83.1416 60.029157) (xy 83.24625 59.833371) (xy 83.310693 59.620931) (xy 83.332453 59.4)
        (xy 83.332453 58.414296) (xy 83.795437 58.322203) (xy 84.291719 58.116636) (xy 84.428809 58.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 122.570843 58.1416) (xy 122.766629 58.24625) (xy 122.952038 58.302493) (xy 122.964038 58.424331) (xy 122.966117 58.445435)
        (xy 122.969946 58.458057) (xy 123.037707 58.681437) (xy 123.153964 58.898938) (xy 123.252137 59.018562) (xy 123.31042 59.089581)
        (xy 123.358188 59.128783) (xy 124.248 60.018595) (xy 124.248001 66.017547) (xy 123.6038 66.017547) (xy 123.323601 66.045144)
        (xy 123.05417 66.126875) (xy 122.805861 66.259599) (xy 122.652749 66.385255) (xy 122.475763 66.240006) (xy 122.140999 66.061071)
        (xy 121.777758 65.950883) (xy 121.494658 65.923) (xy 120.505342 65.923) (xy 120.222242 65.950883) (xy 119.859001 66.061071)
        (xy 119.524237 66.240006) (xy 119.230813 66.480813) (xy 118.990006 66.774237) (xy 118.811071 67.109001) (xy 118.700883 67.472242)
        (xy 118.663677 67.85) (xy 118.700883 68.227758) (xy 118.811071 68.590999) (xy 118.990006 68.925763) (xy 119.230813 69.219187)
        (xy 119.524237 69.459994) (xy 119.859001 69.638929) (xy 120.222242 69.749117) (xy 120.505342 69.777) (xy 121.494658 69.777)
        (xy 121.777758 69.749117) (xy 122.140999 69.638929) (xy 122.223 69.595099) (xy 122.223 69.615924) (xy 122.259217 69.798)
        (xy 120.511496 69.798) (xy 120.45 69.791943) (xy 120.388504 69.798) (xy 120.388502 69.798) (xy 120.204565 69.816116)
        (xy 119.968562 69.887707) (xy 119.751061 70.003964) (xy 119.560419 70.160419) (xy 119.521213 70.208192) (xy 119.195464 70.533941)
        (xy 119.127975 70.432937) (xy 118.567063 69.872025) (xy 117.9075 69.431319) (xy 117.174633 69.127755) (xy 116.396625 68.973)
        (xy 115.603375 68.973) (xy 114.825367 69.127755) (xy 114.0925 69.431319) (xy 113.432937 69.872025) (xy 112.872025 70.432937)
        (xy 112.431319 71.0925) (xy 112.27083 71.479955) (xy 111.983376 71.192501) (xy 111.602248 70.93784) (xy 111.178761 70.762426)
        (xy 110.729189 70.673) (xy 110.270811 70.673) (xy 109.821239 70.762426) (xy 109.397752 70.93784) (xy 109.052 71.168864)
        (xy 109.052 69.001303) (xy 109.230813 69.219187) (xy 109.524237 69.459994) (xy 109.859001 69.638929) (xy 110.222242 69.749117)
        (xy 110.505342 69.777) (xy 111.494658 69.777) (xy 111.777758 69.749117) (xy 112.140999 69.638929) (xy 112.475763 69.459994)
        (xy 112.769187 69.219187) (xy 113.009994 68.925763) (xy 113.188929 68.590999) (xy 113.299117 68.227758) (xy 113.336323 67.85)
        (xy 113.299117 67.472242) (xy 113.188929 67.109001) (xy 113.009994 66.774237) (xy 112.769187 66.480813) (xy 112.475763 66.240006)
        (xy 112.140999 66.061071) (xy 111.777758 65.950883) (xy 111.494658 65.923) (xy 110.505342 65.923) (xy 110.222242 65.950883)
        (xy 109.859001 66.061071) (xy 109.524237 66.240006) (xy 109.230813 66.480813) (xy 109.052 66.698697) (xy 109.052 58.301268)
        (xy 109.233371 58.24625) (xy 109.429157 58.1416) (xy 109.571191 58.025035) (xy 109.708281 58.116636) (xy 110.204563 58.322203)
        (xy 110.667547 58.414296) (xy 110.667547 59.4) (xy 110.689307 59.620931) (xy 110.75375 59.833371) (xy 110.8584 60.029157)
        (xy 110.999235 60.200765) (xy 111.170843 60.3416) (xy 111.366629 60.44625) (xy 111.579069 60.510693) (xy 111.8 60.532453)
        (xy 113.8 60.532453) (xy 114.020931 60.510693) (xy 114.233371 60.44625) (xy 114.429157 60.3416) (xy 114.571191 60.225035)
        (xy 114.708281 60.316636) (xy 115.204563 60.522203) (xy 115.731414 60.627) (xy 116.268586 60.627) (xy 116.795437 60.522203)
        (xy 117.291719 60.316636) (xy 117.428809 60.225035) (xy 117.570843 60.3416) (xy 117.766629 60.44625) (xy 117.979069 60.510693)
        (xy 118.2 60.532453) (xy 120.2 60.532453) (xy 120.420931 60.510693) (xy 120.633371 60.44625) (xy 120.829157 60.3416)
        (xy 121.000765 60.200765) (xy 121.1416 60.029157) (xy 121.24625 59.833371) (xy 121.310693 59.620931) (xy 121.332453 59.4)
        (xy 121.332453 58.414296) (xy 121.795437 58.322203) (xy 122.291719 58.116636) (xy 122.428809 58.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 46.570843 58.1416) (xy 46.766629 58.24625) (xy 46.952038 58.302493) (xy 46.964038 58.424331) (xy 46.966117 58.445435)
        (xy 46.969946 58.458057) (xy 47.037707 58.681437) (xy 47.153964 58.898938) (xy 47.252137 59.018562) (xy 47.31042 59.089581)
        (xy 47.358188 59.128783) (xy 48.248 60.018595) (xy 48.248 66.017547) (xy 47.6038 66.017547) (xy 47.323601 66.045144)
        (xy 47.05417 66.126875) (xy 46.805861 66.259599) (xy 46.652749 66.385255) (xy 46.475763 66.240006) (xy 46.140999 66.061071)
        (xy 45.777758 65.950883) (xy 45.494658 65.923) (xy 44.505342 65.923) (xy 44.222242 65.950883) (xy 43.859001 66.061071)
        (xy 43.524237 66.240006) (xy 43.230813 66.480813) (xy 42.990006 66.774237) (xy 42.811071 67.109001) (xy 42.700883 67.472242)
        (xy 42.663677 67.85) (xy 42.700883 68.227758) (xy 42.811071 68.590999) (xy 42.990006 68.925763) (xy 43.230813 69.219187)
        (xy 43.524237 69.459994) (xy 43.859001 69.638929) (xy 44.222242 69.749117) (xy 44.505342 69.777) (xy 45.494658 69.777)
        (xy 45.777758 69.749117) (xy 46.140999 69.638929) (xy 46.223 69.595099) (xy 46.223 69.615924) (xy 46.259217 69.798)
        (xy 44.511496 69.798) (xy 44.45 69.791943) (xy 44.388504 69.798) (xy 44.388502 69.798) (xy 44.204565 69.816116)
        (xy 43.968562 69.887707) (xy 43.751061 70.003964) (xy 43.560419 70.160419) (xy 43.521213 70.208192) (xy 43.195464 70.533941)
        (xy 43.127975 70.432937) (xy 42.567063 69.872025) (xy 41.9075 69.431319) (xy 41.174633 69.127755) (xy 40.396625 68.973)
        (xy 39.603375 68.973) (xy 38.825367 69.127755) (xy 38.0925 69.431319) (xy 37.432937 69.872025) (xy 36.872025 70.432937)
        (xy 36.431319 71.0925) (xy 36.27083 71.479955) (xy 35.983376 71.192501) (xy 35.602248 70.93784) (xy 35.178761 70.762426)
        (xy 34.729189 70.673) (xy 34.270811 70.673) (xy 33.821239 70.762426) (xy 33.397752 70.93784) (xy 33.052 71.168864)
        (xy 33.052 69.001303) (xy 33.230813 69.219187) (xy 33.524237 69.459994) (xy 33.859001 69.638929) (xy 34.222242 69.749117)
        (xy 34.505342 69.777) (xy 35.494658 69.777) (xy 35.777758 69.749117) (xy 36.140999 69.638929) (xy 36.475763 69.459994)
        (xy 36.769187 69.219187) (xy 37.009994 68.925763) (xy 37.188929 68.590999) (xy 37.299117 68.227758) (xy 37.336323 67.85)
        (xy 37.299117 67.472242) (xy 37.188929 67.109001) (xy 37.009994 66.774237) (xy 36.769187 66.480813) (xy 36.475763 66.240006)
        (xy 36.140999 66.061071) (xy 35.777758 65.950883) (xy 35.494658 65.923) (xy 34.505342 65.923) (xy 34.222242 65.950883)
        (xy 33.859001 66.061071) (xy 33.524237 66.240006) (xy 33.230813 66.480813) (xy 33.052 66.698697) (xy 33.052 58.301268)
        (xy 33.233371 58.24625) (xy 33.429157 58.1416) (xy 33.571191 58.025035) (xy 33.708281 58.116636) (xy 34.204563 58.322203)
        (xy 34.667547 58.414296) (xy 34.667547 59.4) (xy 34.689307 59.620931) (xy 34.75375 59.833371) (xy 34.8584 60.029157)
        (xy 34.999235 60.200765) (xy 35.170843 60.3416) (xy 35.366629 60.44625) (xy 35.579069 60.510693) (xy 35.8 60.532453)
        (xy 37.8 60.532453) (xy 38.020931 60.510693) (xy 38.233371 60.44625) (xy 38.429157 60.3416) (xy 38.571191 60.225035)
        (xy 38.708281 60.316636) (xy 39.204563 60.522203) (xy 39.731414 60.627) (xy 40.268586 60.627) (xy 40.795437 60.522203)
        (xy 41.291719 60.316636) (xy 41.428809 60.225035) (xy 41.570843 60.3416) (xy 41.766629 60.44625) (xy 41.979069 60.510693)
        (xy 42.2 60.532453) (xy 44.2 60.532453) (xy 44.420931 60.510693) (xy 44.633371 60.44625) (xy 44.829157 60.3416)
        (xy 45.000765 60.200765) (xy 45.1416 60.029157) (xy 45.24625 59.833371) (xy 45.310693 59.620931) (xy 45.332453 59.4)
        (xy 45.332453 58.414296) (xy 45.795437 58.322203) (xy 46.291719 58.116636) (xy 46.428809 58.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 65.570843 58.1416) (xy 65.766629 58.24625) (xy 65.979069 58.310693) (xy 66.2 58.332453) (xy 66.561858 58.332453)
        (xy 67.248 59.018595) (xy 67.248001 66.017547) (xy 66.6038 66.017547) (xy 66.323601 66.045144) (xy 66.05417 66.126875)
        (xy 65.805861 66.259599) (xy 65.652749 66.385255) (xy 65.475763 66.240006) (xy 65.140999 66.061071) (xy 64.777758 65.950883)
        (xy 64.494658 65.923) (xy 63.505342 65.923) (xy 63.222242 65.950883) (xy 62.859001 66.061071) (xy 62.524237 66.240006)
        (xy 62.230813 66.480813) (xy 61.990006 66.774237) (xy 61.811071 67.109001) (xy 61.700883 67.472242) (xy 61.663677 67.85)
        (xy 61.700883 68.227758) (xy 61.811071 68.590999) (xy 61.990006 68.925763) (xy 62.230813 69.219187) (xy 62.524237 69.459994)
        (xy 62.859001 69.638929) (xy 63.222242 69.749117) (xy 63.505342 69.777) (xy 64.494658 69.777) (xy 64.777758 69.749117)
        (xy 65.140999 69.638929) (xy 65.223 69.595099) (xy 65.223 69.615924) (xy 65.259217 69.798) (xy 63.611496 69.798)
        (xy 63.55 69.791943) (xy 63.488504 69.798) (xy 63.488502 69.798) (xy 63.304565 69.816116) (xy 63.068562 69.887707)
        (xy 62.851061 70.003964) (xy 62.660419 70.160419) (xy 62.621213 70.208192) (xy 62.235518 70.593887) (xy 62.127975 70.432937)
        (xy 61.567063 69.872025) (xy 60.9075 69.431319) (xy 60.174633 69.127755) (xy 59.396625 68.973) (xy 58.603375 68.973)
        (xy 57.825367 69.127755) (xy 57.0925 69.431319) (xy 56.432937 69.872025) (xy 55.872025 70.432937) (xy 55.431319 71.0925)
        (xy 55.27083 71.479955) (xy 54.983376 71.192501) (xy 54.602248 70.93784) (xy 54.178761 70.762426) (xy 53.729189 70.673)
        (xy 53.270811 70.673) (xy 52.821239 70.762426) (xy 52.397752 70.93784) (xy 52.052 71.168864) (xy 52.052 69.001303)
        (xy 52.230813 69.219187) (xy 52.524237 69.459994) (xy 52.859001 69.638929) (xy 53.222242 69.749117) (xy 53.505342 69.777)
        (xy 54.494658 69.777) (xy 54.777758 69.749117) (xy 55.140999 69.638929) (xy 55.475763 69.459994) (xy 55.769187 69.219187)
        (xy 56.009994 68.925763) (xy 56.188929 68.590999) (xy 56.299117 68.227758) (xy 56.336323 67.85) (xy 56.299117 67.472242)
        (xy 56.188929 67.109001) (xy 56.009994 66.774237) (xy 55.769187 66.480813) (xy 55.475763 66.240006) (xy 55.140999 66.061071)
        (xy 54.777758 65.950883) (xy 54.494658 65.923) (xy 53.505342 65.923) (xy 53.222242 65.950883) (xy 52.859001 66.061071)
        (xy 52.524237 66.240006) (xy 52.230813 66.480813) (xy 52.052 66.698697) (xy 52.052 58.301268) (xy 52.233371 58.24625)
        (xy 52.429157 58.1416) (xy 52.571191 58.025035) (xy 52.708281 58.116636) (xy 53.204563 58.322203) (xy 53.667547 58.414296)
        (xy 53.667547 59.4) (xy 53.689307 59.620931) (xy 53.75375 59.833371) (xy 53.8584 60.029157) (xy 53.999235 60.200765)
        (xy 54.170843 60.3416) (xy 54.366629 60.44625) (xy 54.579069 60.510693) (xy 54.8 60.532453) (xy 56.8 60.532453)
        (xy 57.020931 60.510693) (xy 57.233371 60.44625) (xy 57.429157 60.3416) (xy 57.571191 60.225035) (xy 57.708281 60.316636)
        (xy 58.204563 60.522203) (xy 58.731414 60.627) (xy 59.268586 60.627) (xy 59.795437 60.522203) (xy 60.291719 60.316636)
        (xy 60.428809 60.225035) (xy 60.570843 60.3416) (xy 60.766629 60.44625) (xy 60.979069 60.510693) (xy 61.2 60.532453)
        (xy 63.2 60.532453) (xy 63.420931 60.510693) (xy 63.633371 60.44625) (xy 63.829157 60.3416) (xy 64.000765 60.200765)
        (xy 64.1416 60.029157) (xy 64.24625 59.833371) (xy 64.310693 59.620931) (xy 64.332453 59.4) (xy 64.332453 58.414296)
        (xy 64.795437 58.322203) (xy 65.291719 58.116636) (xy 65.428809 58.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 106.548001 53.098731) (xy 106.5 53.113292) (xy 106.452 53.098732) (xy 106.452 52.818595) (xy 106.548001 52.722594)
      )
    )
    (filled_polygon
      (pts
        (xy 68.548001 53.098731) (xy 68.5 53.113292) (xy 68.452 53.098732) (xy 68.452 52.818595) (xy 68.548001 52.722594)
      )
    )
    (filled_polygon
      (pts
        (xy 47.78399 52.445415) (xy 47.827 52.229189) (xy 47.827 51.982453) (xy 48.246952 51.982453)
      )
    )
    (filled_polygon
      (pts
        (xy 46.570843 40.1416) (xy 46.766629 40.24625) (xy 46.948001 40.301269) (xy 46.948001 40.638495) (xy 46.941943 40.7)
        (xy 46.962092 40.904565) (xy 46.966117 40.945435) (xy 46.968887 40.954566) (xy 47.037707 41.181437) (xy 47.153964 41.398938)
        (xy 47.267728 41.53756) (xy 47.31042 41.589581) (xy 47.358188 41.628783) (xy 48.248 42.518595) (xy 48.248 45.017547)
        (xy 47.6038 45.017547) (xy 47.323601 45.045144) (xy 47.05417 45.126875) (xy 46.805861 45.259599) (xy 46.652749 45.385255)
        (xy 46.475763 45.240006) (xy 46.140999 45.061071) (xy 45.777758 44.950883) (xy 45.494658 44.923) (xy 44.505342 44.923)
        (xy 44.222242 44.950883) (xy 43.859001 45.061071) (xy 43.524237 45.240006) (xy 43.230813 45.480813) (xy 42.990006 45.774237)
        (xy 42.811071 46.109001) (xy 42.700883 46.472242) (xy 42.663677 46.85) (xy 42.700883 47.227758) (xy 42.811071 47.590999)
        (xy 42.990006 47.925763) (xy 43.230813 48.219187) (xy 43.524237 48.459994) (xy 43.859001 48.638929) (xy 44.222242 48.749117)
        (xy 44.505342 48.777) (xy 45.494658 48.777) (xy 45.777758 48.749117) (xy 46.140999 48.638929) (xy 46.223 48.595099)
        (xy 46.223 48.615924) (xy 46.259217 48.798) (xy 44.511496 48.798) (xy 44.45 48.791943) (xy 44.388504 48.798)
        (xy 44.388502 48.798) (xy 44.204565 48.816116) (xy 43.968562 48.887707) (xy 43.751061 49.003964) (xy 43.560419 49.160419)
        (xy 43.521213 49.208192) (xy 43.195464 49.533941) (xy 43.127975 49.432937) (xy 42.567063 48.872025) (xy 41.9075 48.431319)
        (xy 41.174633 48.127755) (xy 40.396625 47.973) (xy 39.603375 47.973) (xy 38.825367 48.127755) (xy 38.0925 48.431319)
        (xy 37.432937 48.872025) (xy 36.872025 49.432937) (xy 36.431319 50.0925) (xy 36.27083 50.479955) (xy 35.983376 50.192501)
        (xy 35.602248 49.93784) (xy 35.178761 49.762426) (xy 34.729189 49.673) (xy 34.270811 49.673) (xy 33.821239 49.762426)
        (xy 33.397752 49.93784) (xy 33.052 50.168864) (xy 33.052 48.001303) (xy 33.230813 48.219187) (xy 33.524237 48.459994)
        (xy 33.859001 48.638929) (xy 34.222242 48.749117) (xy 34.505342 48.777) (xy 35.494658 48.777) (xy 35.777758 48.749117)
        (xy 36.140999 48.638929) (xy 36.475763 48.459994) (xy 36.769187 48.219187) (xy 37.009994 47.925763) (xy 37.188929 47.590999)
        (xy 37.299117 47.227758) (xy 37.336323 46.85) (xy 37.299117 46.472242) (xy 37.188929 46.109001) (xy 37.009994 45.774237)
        (xy 36.769187 45.480813) (xy 36.475763 45.240006) (xy 36.140999 45.061071) (xy 35.777758 44.950883) (xy 35.494658 44.923)
        (xy 34.505342 44.923) (xy 34.222242 44.950883) (xy 33.859001 45.061071) (xy 33.524237 45.240006) (xy 33.230813 45.480813)
        (xy 33.052 45.698697) (xy 33.052 40.301268) (xy 33.233371 40.24625) (xy 33.429157 40.1416) (xy 33.571191 40.025035)
        (xy 33.708281 40.116636) (xy 34.204563 40.322203) (xy 34.667547 40.414296) (xy 34.667547 41.4) (xy 34.689307 41.620931)
        (xy 34.75375 41.833371) (xy 34.8584 42.029157) (xy 34.999235 42.200765) (xy 35.170843 42.3416) (xy 35.366629 42.44625)
        (xy 35.579069 42.510693) (xy 35.8 42.532453) (xy 37.8 42.532453) (xy 38.020931 42.510693) (xy 38.233371 42.44625)
        (xy 38.429157 42.3416) (xy 38.571191 42.225035) (xy 38.708281 42.316636) (xy 39.204563 42.522203) (xy 39.731414 42.627)
        (xy 40.268586 42.627) (xy 40.795437 42.522203) (xy 41.291719 42.316636) (xy 41.428809 42.225035) (xy 41.570843 42.3416)
        (xy 41.766629 42.44625) (xy 41.979069 42.510693) (xy 42.2 42.532453) (xy 44.2 42.532453) (xy 44.420931 42.510693)
        (xy 44.633371 42.44625) (xy 44.829157 42.3416) (xy 45.000765 42.200765) (xy 45.1416 42.029157) (xy 45.24625 41.833371)
        (xy 45.310693 41.620931) (xy 45.332453 41.4) (xy 45.332453 40.414296) (xy 45.795437 40.322203) (xy 46.291719 40.116636)
        (xy 46.428809 40.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 160.570843 40.1416) (xy 160.766629 40.24625) (xy 160.948001 40.301269) (xy 160.948001 41.138495) (xy 160.941943 41.2)
        (xy 160.961642 41.4) (xy 160.966117 41.445435) (xy 160.969946 41.458057) (xy 161.037707 41.681437) (xy 161.153964 41.898938)
        (xy 161.260832 42.029157) (xy 161.31042 42.089581) (xy 161.358188 42.128783) (xy 162.248 43.018595) (xy 162.248 45.017547)
        (xy 161.6038 45.017547) (xy 161.323601 45.045144) (xy 161.05417 45.126875) (xy 160.805861 45.259599) (xy 160.652749 45.385255)
        (xy 160.475763 45.240006) (xy 160.140999 45.061071) (xy 159.777758 44.950883) (xy 159.494658 44.923) (xy 158.505342 44.923)
        (xy 158.222242 44.950883) (xy 157.859001 45.061071) (xy 157.524237 45.240006) (xy 157.230813 45.480813) (xy 156.990006 45.774237)
        (xy 156.811071 46.109001) (xy 156.700883 46.472242) (xy 156.663677 46.85) (xy 156.700883 47.227758) (xy 156.811071 47.590999)
        (xy 156.990006 47.925763) (xy 157.230813 48.219187) (xy 157.524237 48.459994) (xy 157.859001 48.638929) (xy 158.222242 48.749117)
        (xy 158.505342 48.777) (xy 159.494658 48.777) (xy 159.777758 48.749117) (xy 160.140999 48.638929) (xy 160.223 48.595099)
        (xy 160.223 48.615924) (xy 160.259217 48.798) (xy 158.511496 48.798) (xy 158.45 48.791943) (xy 158.388504 48.798)
        (xy 158.388502 48.798) (xy 158.204565 48.816116) (xy 157.968562 48.887707) (xy 157.751061 49.003964) (xy 157.560419 49.160419)
        (xy 157.521213 49.208192) (xy 157.195464 49.533941) (xy 157.127975 49.432937) (xy 156.567063 48.872025) (xy 155.9075 48.431319)
        (xy 155.174633 48.127755) (xy 154.396625 47.973) (xy 153.603375 47.973) (xy 152.825367 48.127755) (xy 152.0925 48.431319)
        (xy 151.432937 48.872025) (xy 150.872025 49.432937) (xy 150.431319 50.0925) (xy 150.27083 50.479955) (xy 149.983376 50.192501)
        (xy 149.602248 49.93784) (xy 149.178761 49.762426) (xy 148.729189 49.673) (xy 148.270811 49.673) (xy 147.821239 49.762426)
        (xy 147.397752 49.93784) (xy 147.052 50.168864) (xy 147.052 48.001303) (xy 147.230813 48.219187) (xy 147.524237 48.459994)
        (xy 147.859001 48.638929) (xy 148.222242 48.749117) (xy 148.505342 48.777) (xy 149.494658 48.777) (xy 149.777758 48.749117)
        (xy 150.140999 48.638929) (xy 150.475763 48.459994) (xy 150.769187 48.219187) (xy 151.009994 47.925763) (xy 151.188929 47.590999)
        (xy 151.299117 47.227758) (xy 151.336323 46.85) (xy 151.299117 46.472242) (xy 151.188929 46.109001) (xy 151.009994 45.774237)
        (xy 150.769187 45.480813) (xy 150.475763 45.240006) (xy 150.140999 45.061071) (xy 149.777758 44.950883) (xy 149.494658 44.923)
        (xy 148.505342 44.923) (xy 148.222242 44.950883) (xy 147.859001 45.061071) (xy 147.524237 45.240006) (xy 147.230813 45.480813)
        (xy 147.052 45.698697) (xy 147.052 40.301268) (xy 147.233371 40.24625) (xy 147.429157 40.1416) (xy 147.571191 40.025035)
        (xy 147.708281 40.116636) (xy 148.204563 40.322203) (xy 148.667547 40.414296) (xy 148.667547 41.4) (xy 148.689307 41.620931)
        (xy 148.75375 41.833371) (xy 148.8584 42.029157) (xy 148.999235 42.200765) (xy 149.170843 42.3416) (xy 149.366629 42.44625)
        (xy 149.579069 42.510693) (xy 149.8 42.532453) (xy 151.8 42.532453) (xy 152.020931 42.510693) (xy 152.233371 42.44625)
        (xy 152.429157 42.3416) (xy 152.571191 42.225035) (xy 152.708281 42.316636) (xy 153.204563 42.522203) (xy 153.731414 42.627)
        (xy 154.268586 42.627) (xy 154.795437 42.522203) (xy 155.291719 42.316636) (xy 155.428809 42.225035) (xy 155.570843 42.3416)
        (xy 155.766629 42.44625) (xy 155.979069 42.510693) (xy 156.2 42.532453) (xy 158.2 42.532453) (xy 158.420931 42.510693)
        (xy 158.633371 42.44625) (xy 158.829157 42.3416) (xy 159.000765 42.200765) (xy 159.1416 42.029157) (xy 159.24625 41.833371)
        (xy 159.310693 41.620931) (xy 159.332453 41.4) (xy 159.332453 40.414296) (xy 159.795437 40.322203) (xy 160.291719 40.116636)
        (xy 160.428809 40.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 84.570843 40.1416) (xy 84.766629 40.24625) (xy 84.979069 40.310693) (xy 85.113894 40.323972) (xy 85.153964 40.398938)
        (xy 85.252137 40.518562) (xy 85.31042 40.589581) (xy 85.358188 40.628783) (xy 86.248 41.518595) (xy 86.248 45.017547)
        (xy 85.6038 45.017547) (xy 85.323601 45.045144) (xy 85.05417 45.126875) (xy 84.805861 45.259599) (xy 84.652749 45.385255)
        (xy 84.475763 45.240006) (xy 84.140999 45.061071) (xy 83.777758 44.950883) (xy 83.494658 44.923) (xy 82.505342 44.923)
        (xy 82.222242 44.950883) (xy 81.859001 45.061071) (xy 81.524237 45.240006) (xy 81.230813 45.480813) (xy 80.990006 45.774237)
        (xy 80.811071 46.109001) (xy 80.700883 46.472242) (xy 80.663677 46.85) (xy 80.700883 47.227758) (xy 80.811071 47.590999)
        (xy 80.990006 47.925763) (xy 81.230813 48.219187) (xy 81.524237 48.459994) (xy 81.859001 48.638929) (xy 82.222242 48.749117)
        (xy 82.505342 48.777) (xy 83.494658 48.777) (xy 83.777758 48.749117) (xy 84.140999 48.638929) (xy 84.223 48.595099)
        (xy 84.223 48.615924) (xy 84.259217 48.798) (xy 82.511496 48.798) (xy 82.45 48.791943) (xy 82.388504 48.798)
        (xy 82.388502 48.798) (xy 82.204565 48.816116) (xy 81.968562 48.887707) (xy 81.751061 49.003964) (xy 81.560419 49.160419)
        (xy 81.521213 49.208192) (xy 81.195464 49.533941) (xy 81.127975 49.432937) (xy 80.567063 48.872025) (xy 79.9075 48.431319)
        (xy 79.174633 48.127755) (xy 78.396625 47.973) (xy 77.603375 47.973) (xy 76.825367 48.127755) (xy 76.0925 48.431319)
        (xy 75.432937 48.872025) (xy 74.872025 49.432937) (xy 74.431319 50.0925) (xy 74.27083 50.479955) (xy 73.983376 50.192501)
        (xy 73.602248 49.93784) (xy 73.178761 49.762426) (xy 72.729189 49.673) (xy 72.270811 49.673) (xy 71.821239 49.762426)
        (xy 71.397752 49.93784) (xy 71.052 50.168864) (xy 71.052 48.001303) (xy 71.230813 48.219187) (xy 71.524237 48.459994)
        (xy 71.859001 48.638929) (xy 72.222242 48.749117) (xy 72.505342 48.777) (xy 73.494658 48.777) (xy 73.777758 48.749117)
        (xy 74.140999 48.638929) (xy 74.475763 48.459994) (xy 74.769187 48.219187) (xy 75.009994 47.925763) (xy 75.188929 47.590999)
        (xy 75.299117 47.227758) (xy 75.336323 46.85) (xy 75.299117 46.472242) (xy 75.188929 46.109001) (xy 75.009994 45.774237)
        (xy 74.769187 45.480813) (xy 74.475763 45.240006) (xy 74.140999 45.061071) (xy 73.777758 44.950883) (xy 73.494658 44.923)
        (xy 72.505342 44.923) (xy 72.222242 44.950883) (xy 71.859001 45.061071) (xy 71.524237 45.240006) (xy 71.230813 45.480813)
        (xy 71.052 45.698697) (xy 71.052 40.301268) (xy 71.233371 40.24625) (xy 71.429157 40.1416) (xy 71.571191 40.025035)
        (xy 71.708281 40.116636) (xy 72.204563 40.322203) (xy 72.667547 40.414296) (xy 72.667547 41.4) (xy 72.689307 41.620931)
        (xy 72.75375 41.833371) (xy 72.8584 42.029157) (xy 72.999235 42.200765) (xy 73.170843 42.3416) (xy 73.366629 42.44625)
        (xy 73.579069 42.510693) (xy 73.8 42.532453) (xy 75.8 42.532453) (xy 76.020931 42.510693) (xy 76.233371 42.44625)
        (xy 76.429157 42.3416) (xy 76.571191 42.225035) (xy 76.708281 42.316636) (xy 77.204563 42.522203) (xy 77.731414 42.627)
        (xy 78.268586 42.627) (xy 78.795437 42.522203) (xy 79.291719 42.316636) (xy 79.428809 42.225035) (xy 79.570843 42.3416)
        (xy 79.766629 42.44625) (xy 79.979069 42.510693) (xy 80.2 42.532453) (xy 82.2 42.532453) (xy 82.420931 42.510693)
        (xy 82.633371 42.44625) (xy 82.829157 42.3416) (xy 83.000765 42.200765) (xy 83.1416 42.029157) (xy 83.24625 41.833371)
        (xy 83.310693 41.620931) (xy 83.332453 41.4) (xy 83.332453 40.414296) (xy 83.795437 40.322203) (xy 84.291719 40.116636)
        (xy 84.428809 40.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 65.570843 40.1416) (xy 65.766629 40.24625) (xy 65.952038 40.302493) (xy 65.961554 40.399102) (xy 65.966117 40.445435)
        (xy 65.968887 40.454566) (xy 66.037707 40.681437) (xy 66.153964 40.898938) (xy 66.252137 41.018562) (xy 66.31042 41.089581)
        (xy 66.358188 41.128783) (xy 67.248 42.018595) (xy 67.248 45.017547) (xy 66.6038 45.017547) (xy 66.323601 45.045144)
        (xy 66.05417 45.126875) (xy 65.805861 45.259599) (xy 65.652749 45.385255) (xy 65.475763 45.240006) (xy 65.140999 45.061071)
        (xy 64.777758 44.950883) (xy 64.494658 44.923) (xy 63.505342 44.923) (xy 63.222242 44.950883) (xy 62.859001 45.061071)
        (xy 62.524237 45.240006) (xy 62.230813 45.480813) (xy 61.990006 45.774237) (xy 61.811071 46.109001) (xy 61.700883 46.472242)
        (xy 61.663677 46.85) (xy 61.700883 47.227758) (xy 61.811071 47.590999) (xy 61.990006 47.925763) (xy 62.230813 48.219187)
        (xy 62.524237 48.459994) (xy 62.859001 48.638929) (xy 63.222242 48.749117) (xy 63.505342 48.777) (xy 64.494658 48.777)
        (xy 64.777758 48.749117) (xy 65.140999 48.638929) (xy 65.223 48.595099) (xy 65.223 48.615924) (xy 65.259217 48.798)
        (xy 63.511496 48.798) (xy 63.45 48.791943) (xy 63.388504 48.798) (xy 63.388502 48.798) (xy 63.204565 48.816116)
        (xy 62.968562 48.887707) (xy 62.751061 49.003964) (xy 62.560419 49.160419) (xy 62.521213 49.208192) (xy 62.195464 49.533941)
        (xy 62.127975 49.432937) (xy 61.567063 48.872025) (xy 60.9075 48.431319) (xy 60.174633 48.127755) (xy 59.396625 47.973)
        (xy 58.603375 47.973) (xy 57.825367 48.127755) (xy 57.0925 48.431319) (xy 56.432937 48.872025) (xy 55.872025 49.432937)
        (xy 55.431319 50.0925) (xy 55.27083 50.479955) (xy 54.983376 50.192501) (xy 54.602248 49.93784) (xy 54.178761 49.762426)
        (xy 53.729189 49.673) (xy 53.270811 49.673) (xy 52.821239 49.762426) (xy 52.397752 49.93784) (xy 52.052 50.168864)
        (xy 52.052 48.001303) (xy 52.230813 48.219187) (xy 52.524237 48.459994) (xy 52.859001 48.638929) (xy 53.222242 48.749117)
        (xy 53.505342 48.777) (xy 54.494658 48.777) (xy 54.777758 48.749117) (xy 55.140999 48.638929) (xy 55.475763 48.459994)
        (xy 55.769187 48.219187) (xy 56.009994 47.925763) (xy 56.188929 47.590999) (xy 56.299117 47.227758) (xy 56.336323 46.85)
        (xy 56.299117 46.472242) (xy 56.188929 46.109001) (xy 56.009994 45.774237) (xy 55.769187 45.480813) (xy 55.475763 45.240006)
        (xy 55.140999 45.061071) (xy 54.777758 44.950883) (xy 54.494658 44.923) (xy 53.505342 44.923) (xy 53.222242 44.950883)
        (xy 52.859001 45.061071) (xy 52.524237 45.240006) (xy 52.230813 45.480813) (xy 52.052 45.698697) (xy 52.052 40.301268)
        (xy 52.233371 40.24625) (xy 52.429157 40.1416) (xy 52.571191 40.025035) (xy 52.708281 40.116636) (xy 53.204563 40.322203)
        (xy 53.667547 40.414296) (xy 53.667547 41.4) (xy 53.689307 41.620931) (xy 53.75375 41.833371) (xy 53.8584 42.029157)
        (xy 53.999235 42.200765) (xy 54.170843 42.3416) (xy 54.366629 42.44625) (xy 54.579069 42.510693) (xy 54.8 42.532453)
        (xy 56.8 42.532453) (xy 57.020931 42.510693) (xy 57.233371 42.44625) (xy 57.429157 42.3416) (xy 57.571191 42.225035)
        (xy 57.708281 42.316636) (xy 58.204563 42.522203) (xy 58.731414 42.627) (xy 59.268586 42.627) (xy 59.795437 42.522203)
        (xy 60.291719 42.316636) (xy 60.428809 42.225035) (xy 60.570843 42.3416) (xy 60.766629 42.44625) (xy 60.979069 42.510693)
        (xy 61.2 42.532453) (xy 63.2 42.532453) (xy 63.420931 42.510693) (xy 63.633371 42.44625) (xy 63.829157 42.3416)
        (xy 64.000765 42.200765) (xy 64.1416 42.029157) (xy 64.24625 41.833371) (xy 64.310693 41.620931) (xy 64.332453 41.4)
        (xy 64.332453 40.414296) (xy 64.795437 40.322203) (xy 65.291719 40.116636) (xy 65.428809 40.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 122.570843 40.1416) (xy 122.766629 40.24625) (xy 122.979069 40.310693) (xy 123.113894 40.323972) (xy 123.153964 40.398938)
        (xy 123.252137 40.518562) (xy 123.31042 40.589581) (xy 123.358188 40.628783) (xy 124.248 41.518595) (xy 124.248 45.017547)
        (xy 123.6038 45.017547) (xy 123.323601 45.045144) (xy 123.05417 45.126875) (xy 122.805861 45.259599) (xy 122.652749 45.385255)
        (xy 122.475763 45.240006) (xy 122.140999 45.061071) (xy 121.777758 44.950883) (xy 121.494658 44.923) (xy 120.505342 44.923)
        (xy 120.222242 44.950883) (xy 119.859001 45.061071) (xy 119.524237 45.240006) (xy 119.230813 45.480813) (xy 118.990006 45.774237)
        (xy 118.811071 46.109001) (xy 118.700883 46.472242) (xy 118.663677 46.85) (xy 118.700883 47.227758) (xy 118.811071 47.590999)
        (xy 118.990006 47.925763) (xy 119.230813 48.219187) (xy 119.524237 48.459994) (xy 119.859001 48.638929) (xy 120.222242 48.749117)
        (xy 120.505342 48.777) (xy 121.494658 48.777) (xy 121.777758 48.749117) (xy 122.140999 48.638929) (xy 122.223 48.595099)
        (xy 122.223 48.615924) (xy 122.259217 48.798) (xy 120.511496 48.798) (xy 120.45 48.791943) (xy 120.388504 48.798)
        (xy 120.388502 48.798) (xy 120.204565 48.816116) (xy 119.968562 48.887707) (xy 119.751061 49.003964) (xy 119.560419 49.160419)
        (xy 119.521213 49.208192) (xy 119.195464 49.533941) (xy 119.127975 49.432937) (xy 118.567063 48.872025) (xy 117.9075 48.431319)
        (xy 117.174633 48.127755) (xy 116.396625 47.973) (xy 115.603375 47.973) (xy 114.825367 48.127755) (xy 114.0925 48.431319)
        (xy 113.432937 48.872025) (xy 112.872025 49.432937) (xy 112.431319 50.0925) (xy 112.27083 50.479955) (xy 111.983376 50.192501)
        (xy 111.602248 49.93784) (xy 111.178761 49.762426) (xy 110.729189 49.673) (xy 110.270811 49.673) (xy 109.821239 49.762426)
        (xy 109.397752 49.93784) (xy 109.052 50.168864) (xy 109.052 48.001303) (xy 109.230813 48.219187) (xy 109.524237 48.459994)
        (xy 109.859001 48.638929) (xy 110.222242 48.749117) (xy 110.505342 48.777) (xy 111.494658 48.777) (xy 111.777758 48.749117)
        (xy 112.140999 48.638929) (xy 112.475763 48.459994) (xy 112.769187 48.219187) (xy 113.009994 47.925763) (xy 113.188929 47.590999)
        (xy 113.299117 47.227758) (xy 113.336323 46.85) (xy 113.299117 46.472242) (xy 113.188929 46.109001) (xy 113.009994 45.774237)
        (xy 112.769187 45.480813) (xy 112.475763 45.240006) (xy 112.140999 45.061071) (xy 111.777758 44.950883) (xy 111.494658 44.923)
        (xy 110.505342 44.923) (xy 110.222242 44.950883) (xy 109.859001 45.061071) (xy 109.524237 45.240006) (xy 109.230813 45.480813)
        (xy 109.052 45.698697) (xy 109.052 40.301268) (xy 109.233371 40.24625) (xy 109.429157 40.1416) (xy 109.571191 40.025035)
        (xy 109.708281 40.116636) (xy 110.204563 40.322203) (xy 110.667547 40.414296) (xy 110.667547 41.4) (xy 110.689307 41.620931)
        (xy 110.75375 41.833371) (xy 110.8584 42.029157) (xy 110.999235 42.200765) (xy 111.170843 42.3416) (xy 111.366629 42.44625)
        (xy 111.579069 42.510693) (xy 111.8 42.532453) (xy 113.8 42.532453) (xy 114.020931 42.510693) (xy 114.233371 42.44625)
        (xy 114.429157 42.3416) (xy 114.571191 42.225035) (xy 114.708281 42.316636) (xy 115.204563 42.522203) (xy 115.731414 42.627)
        (xy 116.268586 42.627) (xy 116.795437 42.522203) (xy 117.291719 42.316636) (xy 117.428809 42.225035) (xy 117.570843 42.3416)
        (xy 117.766629 42.44625) (xy 117.979069 42.510693) (xy 118.2 42.532453) (xy 120.2 42.532453) (xy 120.420931 42.510693)
        (xy 120.633371 42.44625) (xy 120.829157 42.3416) (xy 121.000765 42.200765) (xy 121.1416 42.029157) (xy 121.24625 41.833371)
        (xy 121.310693 41.620931) (xy 121.332453 41.4) (xy 121.332453 40.414296) (xy 121.795437 40.322203) (xy 122.291719 40.116636)
        (xy 122.428809 40.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 103.570843 40.1416) (xy 103.766629 40.24625) (xy 103.979069 40.310693) (xy 104.113894 40.323972) (xy 104.153964 40.398938)
        (xy 104.252137 40.518562) (xy 104.31042 40.589581) (xy 104.358188 40.628783) (xy 105.248 41.518595) (xy 105.248 45.017547)
        (xy 104.6038 45.017547) (xy 104.323601 45.045144) (xy 104.05417 45.126875) (xy 103.805861 45.259599) (xy 103.652749 45.385255)
        (xy 103.475763 45.240006) (xy 103.140999 45.061071) (xy 102.777758 44.950883) (xy 102.494658 44.923) (xy 101.505342 44.923)
        (xy 101.222242 44.950883) (xy 100.859001 45.061071) (xy 100.524237 45.240006) (xy 100.230813 45.480813) (xy 99.990006 45.774237)
        (xy 99.811071 46.109001) (xy 99.700883 46.472242) (xy 99.663677 46.85) (xy 99.700883 47.227758) (xy 99.811071 47.590999)
        (xy 99.990006 47.925763) (xy 100.230813 48.219187) (xy 100.524237 48.459994) (xy 100.859001 48.638929) (xy 101.222242 48.749117)
        (xy 101.505342 48.777) (xy 102.494658 48.777) (xy 102.777758 48.749117) (xy 103.140999 48.638929) (xy 103.223 48.595099)
        (xy 103.223 48.615924) (xy 103.259217 48.798) (xy 101.511496 48.798) (xy 101.45 48.791943) (xy 101.388504 48.798)
        (xy 101.388502 48.798) (xy 101.204565 48.816116) (xy 100.968562 48.887707) (xy 100.751061 49.003964) (xy 100.560419 49.160419)
        (xy 100.521213 49.208192) (xy 100.195464 49.533941) (xy 100.127975 49.432937) (xy 99.567063 48.872025) (xy 98.9075 48.431319)
        (xy 98.174633 48.127755) (xy 97.396625 47.973) (xy 96.603375 47.973) (xy 95.825367 48.127755) (xy 95.0925 48.431319)
        (xy 94.432937 48.872025) (xy 93.872025 49.432937) (xy 93.431319 50.0925) (xy 93.27083 50.479955) (xy 92.983376 50.192501)
        (xy 92.602248 49.93784) (xy 92.178761 49.762426) (xy 91.729189 49.673) (xy 91.270811 49.673) (xy 90.821239 49.762426)
        (xy 90.397752 49.93784) (xy 90.052 50.168864) (xy 90.052 48.001303) (xy 90.230813 48.219187) (xy 90.524237 48.459994)
        (xy 90.859001 48.638929) (xy 91.222242 48.749117) (xy 91.505342 48.777) (xy 92.494658 48.777) (xy 92.777758 48.749117)
        (xy 93.140999 48.638929) (xy 93.475763 48.459994) (xy 93.769187 48.219187) (xy 94.009994 47.925763) (xy 94.188929 47.590999)
        (xy 94.299117 47.227758) (xy 94.336323 46.85) (xy 94.299117 46.472242) (xy 94.188929 46.109001) (xy 94.009994 45.774237)
        (xy 93.769187 45.480813) (xy 93.475763 45.240006) (xy 93.140999 45.061071) (xy 92.777758 44.950883) (xy 92.494658 44.923)
        (xy 91.505342 44.923) (xy 91.222242 44.950883) (xy 90.859001 45.061071) (xy 90.524237 45.240006) (xy 90.230813 45.480813)
        (xy 90.052 45.698697) (xy 90.052 40.301268) (xy 90.233371 40.24625) (xy 90.429157 40.1416) (xy 90.571191 40.025035)
        (xy 90.708281 40.116636) (xy 91.204563 40.322203) (xy 91.667547 40.414296) (xy 91.667547 41.4) (xy 91.689307 41.620931)
        (xy 91.75375 41.833371) (xy 91.8584 42.029157) (xy 91.999235 42.200765) (xy 92.170843 42.3416) (xy 92.366629 42.44625)
        (xy 92.579069 42.510693) (xy 92.8 42.532453) (xy 94.8 42.532453) (xy 95.020931 42.510693) (xy 95.233371 42.44625)
        (xy 95.429157 42.3416) (xy 95.571191 42.225035) (xy 95.708281 42.316636) (xy 96.204563 42.522203) (xy 96.731414 42.627)
        (xy 97.268586 42.627) (xy 97.795437 42.522203) (xy 98.291719 42.316636) (xy 98.428809 42.225035) (xy 98.570843 42.3416)
        (xy 98.766629 42.44625) (xy 98.979069 42.510693) (xy 99.2 42.532453) (xy 101.2 42.532453) (xy 101.420931 42.510693)
        (xy 101.633371 42.44625) (xy 101.829157 42.3416) (xy 102.000765 42.200765) (xy 102.1416 42.029157) (xy 102.24625 41.833371)
        (xy 102.310693 41.620931) (xy 102.332453 41.4) (xy 102.332453 40.414296) (xy 102.795437 40.322203) (xy 103.291719 40.116636)
        (xy 103.428809 40.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 141.570843 40.1416) (xy 141.766629 40.24625) (xy 141.979069 40.310693) (xy 142.113894 40.323972) (xy 142.153964 40.398938)
        (xy 142.252137 40.518562) (xy 142.31042 40.589581) (xy 142.358188 40.628783) (xy 143.248 41.518595) (xy 143.248 45.017547)
        (xy 142.6038 45.017547) (xy 142.323601 45.045144) (xy 142.05417 45.126875) (xy 141.805861 45.259599) (xy 141.652749 45.385255)
        (xy 141.475763 45.240006) (xy 141.140999 45.061071) (xy 140.777758 44.950883) (xy 140.494658 44.923) (xy 139.505342 44.923)
        (xy 139.222242 44.950883) (xy 138.859001 45.061071) (xy 138.524237 45.240006) (xy 138.230813 45.480813) (xy 137.990006 45.774237)
        (xy 137.811071 46.109001) (xy 137.700883 46.472242) (xy 137.663677 46.85) (xy 137.700883 47.227758) (xy 137.811071 47.590999)
        (xy 137.990006 47.925763) (xy 138.230813 48.219187) (xy 138.524237 48.459994) (xy 138.859001 48.638929) (xy 139.222242 48.749117)
        (xy 139.505342 48.777) (xy 140.494658 48.777) (xy 140.777758 48.749117) (xy 141.140999 48.638929) (xy 141.223 48.595099)
        (xy 141.223 48.615924) (xy 141.259217 48.798) (xy 139.511496 48.798) (xy 139.45 48.791943) (xy 139.388504 48.798)
        (xy 139.388502 48.798) (xy 139.204565 48.816116) (xy 138.968562 48.887707) (xy 138.751061 49.003964) (xy 138.560419 49.160419)
        (xy 138.521213 49.208192) (xy 138.195464 49.533941) (xy 138.127975 49.432937) (xy 137.567063 48.872025) (xy 136.9075 48.431319)
        (xy 136.174633 48.127755) (xy 135.396625 47.973) (xy 134.603375 47.973) (xy 133.825367 48.127755) (xy 133.0925 48.431319)
        (xy 132.432937 48.872025) (xy 131.872025 49.432937) (xy 131.431319 50.0925) (xy 131.27083 50.479955) (xy 130.983376 50.192501)
        (xy 130.602248 49.93784) (xy 130.178761 49.762426) (xy 129.729189 49.673) (xy 129.270811 49.673) (xy 128.821239 49.762426)
        (xy 128.397752 49.93784) (xy 128.052 50.168864) (xy 128.052 48.001303) (xy 128.230813 48.219187) (xy 128.524237 48.459994)
        (xy 128.859001 48.638929) (xy 129.222242 48.749117) (xy 129.505342 48.777) (xy 130.494658 48.777) (xy 130.777758 48.749117)
        (xy 131.140999 48.638929) (xy 131.475763 48.459994) (xy 131.769187 48.219187) (xy 132.009994 47.925763) (xy 132.188929 47.590999)
        (xy 132.299117 47.227758) (xy 132.336323 46.85) (xy 132.299117 46.472242) (xy 132.188929 46.109001) (xy 132.009994 45.774237)
        (xy 131.769187 45.480813) (xy 131.475763 45.240006) (xy 131.140999 45.061071) (xy 130.777758 44.950883) (xy 130.494658 44.923)
        (xy 129.505342 44.923) (xy 129.222242 44.950883) (xy 128.859001 45.061071) (xy 128.524237 45.240006) (xy 128.230813 45.480813)
        (xy 128.052 45.698697) (xy 128.052 40.301268) (xy 128.233371 40.24625) (xy 128.429157 40.1416) (xy 128.571191 40.025035)
        (xy 128.708281 40.116636) (xy 129.204563 40.322203) (xy 129.667547 40.414296) (xy 129.667547 41.4) (xy 129.689307 41.620931)
        (xy 129.75375 41.833371) (xy 129.8584 42.029157) (xy 129.999235 42.200765) (xy 130.170843 42.3416) (xy 130.366629 42.44625)
        (xy 130.579069 42.510693) (xy 130.8 42.532453) (xy 132.8 42.532453) (xy 133.020931 42.510693) (xy 133.233371 42.44625)
        (xy 133.429157 42.3416) (xy 133.571191 42.225035) (xy 133.708281 42.316636) (xy 134.204563 42.522203) (xy 134.731414 42.627)
        (xy 135.268586 42.627) (xy 135.795437 42.522203) (xy 136.291719 42.316636) (xy 136.428809 42.225035) (xy 136.570843 42.3416)
        (xy 136.766629 42.44625) (xy 136.979069 42.510693) (xy 137.2 42.532453) (xy 139.2 42.532453) (xy 139.420931 42.510693)
        (xy 139.633371 42.44625) (xy 139.829157 42.3416) (xy 140.000765 42.200765) (xy 140.1416 42.029157) (xy 140.24625 41.833371)
        (xy 140.310693 41.620931) (xy 140.332453 41.4) (xy 140.332453 40.414296) (xy 140.795437 40.322203) (xy 141.291719 40.116636)
        (xy 141.428809 40.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 14.496897 46.248) (xy 14.461705 46.248) (xy 14.491421 46.192404)
      )
    )
    (filled_polygon
      (pts
        (xy 7.048001 41.186293) (xy 7.048 43.563707) (xy 6.8 43.696267) (xy 6.552 43.563708) (xy 6.552 41.186292)
        (xy 6.8 41.053733)
      )
    )
    (filled_polygon
      (pts
        (xy 18.658188 38.571217) (xy 18.61042 38.610419) (xy 18.571218 38.658187) (xy 18.571217 38.658188) (xy 18.453964 38.801062)
        (xy 18.337707 39.018563) (xy 18.296634 39.153964) (xy 18.277039 39.218562) (xy 18.266117 39.254566) (xy 18.262276 39.29356)
        (xy 18.059761 39.45976) (xy 17.806458 39.768411) (xy 17.618237 40.120548) (xy 17.502331 40.502639) (xy 17.473001 40.800429)
        (xy 17.473 43.19957) (xy 17.50233 43.49736) (xy 17.527217 43.5794) (xy 17.258721 43.497953) (xy 16.95 43.467547)
        (xy 16.17352 43.467547) (xy 16.148394 43.21244) (xy 16.035347 42.839774) (xy 15.851768 42.496324) (xy 15.752201 42.375)
        (xy 15.851768 42.253676) (xy 16.035347 41.910226) (xy 16.148394 41.53756) (xy 16.186565 41.15) (xy 16.148394 40.76244)
        (xy 16.035347 40.389774) (xy 15.851768 40.046324) (xy 15.604714 39.745286) (xy 15.303676 39.498232) (xy 14.960226 39.314653)
        (xy 14.669472 39.226454) (xy 14.648394 39.01244) (xy 14.535347 38.639774) (xy 14.351768 38.296324) (xy 14.104714 37.995286)
        (xy 13.924325 37.847245) (xy 14.009221 37.743798) (xy 14.046036 37.69894) (xy 14.099329 37.599235) (xy 14.162293 37.481438)
        (xy 14.233884 37.245435) (xy 14.252 37.061498) (xy 14.252 37.061497) (xy 14.258057 37.000001) (xy 14.252 36.938505)
        (xy 14.252 36.427) (xy 20.802405 36.427)
      )
    )
    (filled_polygon
      (pts
        (xy 10.151609 34.966799) (xy 10.467223 35.177685) (xy 10.817915 35.322947) (xy 11.190207 35.397) (xy 11.569793 35.397)
        (xy 11.748 35.361553) (xy 11.748 36.481405) (xy 11.458188 36.771217) (xy 11.41042 36.810419) (xy 11.371218 36.858187)
        (xy 11.371217 36.858188) (xy 11.253964 37.001062) (xy 11.137707 37.218563) (xy 11.096699 37.35375) (xy 11.066117 37.454565)
        (xy 11.063281 37.483364) (xy 11.050578 37.61233) (xy 10.796324 37.748232) (xy 10.495286 37.995286) (xy 10.3 38.233244)
        (xy 10.104714 37.995286) (xy 9.803676 37.748232) (xy 9.460226 37.564653) (xy 9.08756 37.451606) (xy 8.797116 37.423)
        (xy 7.802884 37.423) (xy 7.51244 37.451606) (xy 7.234754 37.535841) (xy 9.627844 35.142752) (xy 9.723306 35.10321)
        (xy 9.973406 34.936099) (xy 10.047158 34.862348)
      )
    )
    (filled_polygon
      (pts
        (xy 85.78399 34.445415) (xy 85.827 34.229189) (xy 85.827 33.982453) (xy 86.246952 33.982453)
      )
    )
    (filled_polygon
      (pts
        (xy 47.78399 34.445415) (xy 47.827 34.229189) (xy 47.827 33.982453) (xy 48.246952 33.982453)
      )
    )
    (filled_polygon
      (pts
        (xy 6.748 29.981404) (xy 4.111507 32.617898) (xy 4.055579 32.588004) (xy 3.758721 32.497953) (xy 3.45 32.467547)
        (xy 2.55 32.467547) (xy 2.241279 32.497953) (xy 1.944421 32.588004) (xy 1.670836 32.734238) (xy 1.431037 32.931037)
        (xy 1.234238 33.170836) (xy 1.132 33.36211) (xy 1.132 31.13789) (xy 1.234238 31.329164) (xy 1.431037 31.568963)
        (xy 1.670836 31.765762) (xy 1.944421 31.911996) (xy 2.241279 32.002047) (xy 2.55 32.032453) (xy 3.45 32.032453)
        (xy 3.758721 32.002047) (xy 4.055579 31.911996) (xy 4.329164 31.765762) (xy 4.568963 31.568963) (xy 4.765762 31.329164)
        (xy 4.911996 31.055579) (xy 5.002047 30.758721) (xy 5.032453 30.45) (xy 5.032453 29.738142) (xy 6.748001 28.022594)
      )
    )
    (filled_polygon
      (pts
        (xy 160.570843 22.1416) (xy 160.766629 22.24625) (xy 160.979069 22.310693) (xy 161.113894 22.323972) (xy 161.153964 22.398938)
        (xy 161.252137 22.518562) (xy 161.31042 22.589581) (xy 161.358188 22.628783) (xy 162.248 23.518595) (xy 162.248 27.017547)
        (xy 161.6038 27.017547) (xy 161.323601 27.045144) (xy 161.05417 27.126875) (xy 160.805861 27.259599) (xy 160.652749 27.385255)
        (xy 160.475763 27.240006) (xy 160.140999 27.061071) (xy 159.777758 26.950883) (xy 159.494658 26.923) (xy 158.505342 26.923)
        (xy 158.222242 26.950883) (xy 157.859001 27.061071) (xy 157.524237 27.240006) (xy 157.230813 27.480813) (xy 156.990006 27.774237)
        (xy 156.811071 28.109001) (xy 156.700883 28.472242) (xy 156.663677 28.85) (xy 156.700883 29.227758) (xy 156.811071 29.590999)
        (xy 156.990006 29.925763) (xy 157.230813 30.219187) (xy 157.524237 30.459994) (xy 157.859001 30.638929) (xy 158.222242 30.749117)
        (xy 158.505342 30.777) (xy 159.494658 30.777) (xy 159.777758 30.749117) (xy 160.140999 30.638929) (xy 160.223 30.595099)
        (xy 160.223 30.615924) (xy 160.259217 30.798) (xy 158.511496 30.798) (xy 158.45 30.791943) (xy 158.388504 30.798)
        (xy 158.388502 30.798) (xy 158.204565 30.816116) (xy 157.968562 30.887707) (xy 157.751061 31.003964) (xy 157.560419 31.160419)
        (xy 157.521213 31.208192) (xy 157.195464 31.533941) (xy 157.127975 31.432937) (xy 156.567063 30.872025) (xy 155.9075 30.431319)
        (xy 155.174633 30.127755) (xy 154.396625 29.973) (xy 153.603375 29.973) (xy 152.825367 30.127755) (xy 152.0925 30.431319)
        (xy 151.432937 30.872025) (xy 150.872025 31.432937) (xy 150.431319 32.0925) (xy 150.27083 32.479955) (xy 149.983376 32.192501)
        (xy 149.602248 31.93784) (xy 149.178761 31.762426) (xy 148.729189 31.673) (xy 148.270811 31.673) (xy 147.821239 31.762426)
        (xy 147.397752 31.93784) (xy 147.052 32.168864) (xy 147.052 30.001303) (xy 147.230813 30.219187) (xy 147.524237 30.459994)
        (xy 147.859001 30.638929) (xy 148.222242 30.749117) (xy 148.505342 30.777) (xy 149.494658 30.777) (xy 149.777758 30.749117)
        (xy 150.140999 30.638929) (xy 150.475763 30.459994) (xy 150.769187 30.219187) (xy 151.009994 29.925763) (xy 151.188929 29.590999)
        (xy 151.299117 29.227758) (xy 151.336323 28.85) (xy 151.299117 28.472242) (xy 151.188929 28.109001) (xy 151.009994 27.774237)
        (xy 150.769187 27.480813) (xy 150.475763 27.240006) (xy 150.140999 27.061071) (xy 149.777758 26.950883) (xy 149.494658 26.923)
        (xy 148.505342 26.923) (xy 148.222242 26.950883) (xy 147.859001 27.061071) (xy 147.524237 27.240006) (xy 147.230813 27.480813)
        (xy 147.052 27.698697) (xy 147.052 22.301268) (xy 147.233371 22.24625) (xy 147.429157 22.1416) (xy 147.571191 22.025035)
        (xy 147.708281 22.116636) (xy 148.204563 22.322203) (xy 148.667547 22.414296) (xy 148.667547 23.4) (xy 148.689307 23.620931)
        (xy 148.75375 23.833371) (xy 148.8584 24.029157) (xy 148.999235 24.200765) (xy 149.170843 24.3416) (xy 149.366629 24.44625)
        (xy 149.579069 24.510693) (xy 149.8 24.532453) (xy 151.8 24.532453) (xy 152.020931 24.510693) (xy 152.233371 24.44625)
        (xy 152.429157 24.3416) (xy 152.571191 24.225035) (xy 152.708281 24.316636) (xy 153.204563 24.522203) (xy 153.731414 24.627)
        (xy 154.268586 24.627) (xy 154.795437 24.522203) (xy 155.291719 24.316636) (xy 155.428809 24.225035) (xy 155.570843 24.3416)
        (xy 155.766629 24.44625) (xy 155.979069 24.510693) (xy 156.2 24.532453) (xy 158.2 24.532453) (xy 158.420931 24.510693)
        (xy 158.633371 24.44625) (xy 158.829157 24.3416) (xy 159.000765 24.200765) (xy 159.1416 24.029157) (xy 159.24625 23.833371)
        (xy 159.310693 23.620931) (xy 159.332453 23.4) (xy 159.332453 22.414296) (xy 159.795437 22.322203) (xy 160.291719 22.116636)
        (xy 160.428809 22.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 84.570843 22.1416) (xy 84.766629 22.24625) (xy 84.979069 22.310693) (xy 85.113894 22.323972) (xy 85.153964 22.398938)
        (xy 85.252137 22.518562) (xy 85.31042 22.589581) (xy 85.358188 22.628783) (xy 86.248 23.518595) (xy 86.248 27.017547)
        (xy 85.6038 27.017547) (xy 85.323601 27.045144) (xy 85.05417 27.126875) (xy 84.805861 27.259599) (xy 84.652749 27.385255)
        (xy 84.475763 27.240006) (xy 84.140999 27.061071) (xy 83.777758 26.950883) (xy 83.494658 26.923) (xy 82.505342 26.923)
        (xy 82.222242 26.950883) (xy 81.859001 27.061071) (xy 81.524237 27.240006) (xy 81.230813 27.480813) (xy 80.990006 27.774237)
        (xy 80.811071 28.109001) (xy 80.700883 28.472242) (xy 80.663677 28.85) (xy 80.700883 29.227758) (xy 80.811071 29.590999)
        (xy 80.990006 29.925763) (xy 81.230813 30.219187) (xy 81.524237 30.459994) (xy 81.859001 30.638929) (xy 82.222242 30.749117)
        (xy 82.505342 30.777) (xy 83.494658 30.777) (xy 83.777758 30.749117) (xy 84.140999 30.638929) (xy 84.223 30.595099)
        (xy 84.223 30.615924) (xy 84.259217 30.798) (xy 82.511496 30.798) (xy 82.45 30.791943) (xy 82.388504 30.798)
        (xy 82.388502 30.798) (xy 82.204565 30.816116) (xy 81.968562 30.887707) (xy 81.751061 31.003964) (xy 81.560419 31.160419)
        (xy 81.521213 31.208192) (xy 81.195464 31.533941) (xy 81.127975 31.432937) (xy 80.567063 30.872025) (xy 79.9075 30.431319)
        (xy 79.174633 30.127755) (xy 78.396625 29.973) (xy 77.603375 29.973) (xy 76.825367 30.127755) (xy 76.0925 30.431319)
        (xy 75.432937 30.872025) (xy 74.872025 31.432937) (xy 74.431319 32.0925) (xy 74.27083 32.479955) (xy 73.983376 32.192501)
        (xy 73.602248 31.93784) (xy 73.178761 31.762426) (xy 72.729189 31.673) (xy 72.270811 31.673) (xy 71.821239 31.762426)
        (xy 71.397752 31.93784) (xy 71.052 32.168864) (xy 71.052 30.001303) (xy 71.230813 30.219187) (xy 71.524237 30.459994)
        (xy 71.859001 30.638929) (xy 72.222242 30.749117) (xy 72.505342 30.777) (xy 73.494658 30.777) (xy 73.777758 30.749117)
        (xy 74.140999 30.638929) (xy 74.475763 30.459994) (xy 74.769187 30.219187) (xy 75.009994 29.925763) (xy 75.188929 29.590999)
        (xy 75.299117 29.227758) (xy 75.336323 28.85) (xy 75.299117 28.472242) (xy 75.188929 28.109001) (xy 75.009994 27.774237)
        (xy 74.769187 27.480813) (xy 74.475763 27.240006) (xy 74.140999 27.061071) (xy 73.777758 26.950883) (xy 73.494658 26.923)
        (xy 72.505342 26.923) (xy 72.222242 26.950883) (xy 71.859001 27.061071) (xy 71.524237 27.240006) (xy 71.230813 27.480813)
        (xy 71.052 27.698697) (xy 71.052 22.301268) (xy 71.233371 22.24625) (xy 71.429157 22.1416) (xy 71.571191 22.025035)
        (xy 71.708281 22.116636) (xy 72.204563 22.322203) (xy 72.667547 22.414296) (xy 72.667547 23.4) (xy 72.689307 23.620931)
        (xy 72.75375 23.833371) (xy 72.8584 24.029157) (xy 72.999235 24.200765) (xy 73.170843 24.3416) (xy 73.366629 24.44625)
        (xy 73.579069 24.510693) (xy 73.8 24.532453) (xy 75.8 24.532453) (xy 76.020931 24.510693) (xy 76.233371 24.44625)
        (xy 76.429157 24.3416) (xy 76.571191 24.225035) (xy 76.708281 24.316636) (xy 77.204563 24.522203) (xy 77.731414 24.627)
        (xy 78.268586 24.627) (xy 78.795437 24.522203) (xy 79.291719 24.316636) (xy 79.428809 24.225035) (xy 79.570843 24.3416)
        (xy 79.766629 24.44625) (xy 79.979069 24.510693) (xy 80.2 24.532453) (xy 82.2 24.532453) (xy 82.420931 24.510693)
        (xy 82.633371 24.44625) (xy 82.829157 24.3416) (xy 83.000765 24.200765) (xy 83.1416 24.029157) (xy 83.24625 23.833371)
        (xy 83.310693 23.620931) (xy 83.332453 23.4) (xy 83.332453 22.414296) (xy 83.795437 22.322203) (xy 84.291719 22.116636)
        (xy 84.428809 22.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 122.570843 22.1416) (xy 122.766629 22.24625) (xy 122.979069 22.310693) (xy 123.113894 22.323972) (xy 123.153964 22.398938)
        (xy 123.252137 22.518562) (xy 123.31042 22.589581) (xy 123.358188 22.628783) (xy 124.248 23.518595) (xy 124.248 27.017547)
        (xy 123.6038 27.017547) (xy 123.323601 27.045144) (xy 123.05417 27.126875) (xy 122.805861 27.259599) (xy 122.652749 27.385255)
        (xy 122.475763 27.240006) (xy 122.140999 27.061071) (xy 121.777758 26.950883) (xy 121.494658 26.923) (xy 120.505342 26.923)
        (xy 120.222242 26.950883) (xy 119.859001 27.061071) (xy 119.524237 27.240006) (xy 119.230813 27.480813) (xy 118.990006 27.774237)
        (xy 118.811071 28.109001) (xy 118.700883 28.472242) (xy 118.663677 28.85) (xy 118.700883 29.227758) (xy 118.811071 29.590999)
        (xy 118.990006 29.925763) (xy 119.230813 30.219187) (xy 119.524237 30.459994) (xy 119.859001 30.638929) (xy 120.222242 30.749117)
        (xy 120.505342 30.777) (xy 121.494658 30.777) (xy 121.777758 30.749117) (xy 122.140999 30.638929) (xy 122.223 30.595099)
        (xy 122.223 30.615924) (xy 122.259217 30.798) (xy 120.511496 30.798) (xy 120.45 30.791943) (xy 120.388504 30.798)
        (xy 120.388502 30.798) (xy 120.204565 30.816116) (xy 119.968562 30.887707) (xy 119.751061 31.003964) (xy 119.560419 31.160419)
        (xy 119.521213 31.208192) (xy 119.195464 31.533941) (xy 119.127975 31.432937) (xy 118.567063 30.872025) (xy 117.9075 30.431319)
        (xy 117.174633 30.127755) (xy 116.396625 29.973) (xy 115.603375 29.973) (xy 114.825367 30.127755) (xy 114.0925 30.431319)
        (xy 113.432937 30.872025) (xy 112.872025 31.432937) (xy 112.431319 32.0925) (xy 112.27083 32.479955) (xy 111.983376 32.192501)
        (xy 111.602248 31.93784) (xy 111.178761 31.762426) (xy 110.729189 31.673) (xy 110.270811 31.673) (xy 109.821239 31.762426)
        (xy 109.397752 31.93784) (xy 109.052 32.168864) (xy 109.052 30.001303) (xy 109.230813 30.219187) (xy 109.524237 30.459994)
        (xy 109.859001 30.638929) (xy 110.222242 30.749117) (xy 110.505342 30.777) (xy 111.494658 30.777) (xy 111.777758 30.749117)
        (xy 112.140999 30.638929) (xy 112.475763 30.459994) (xy 112.769187 30.219187) (xy 113.009994 29.925763) (xy 113.188929 29.590999)
        (xy 113.299117 29.227758) (xy 113.336323 28.85) (xy 113.299117 28.472242) (xy 113.188929 28.109001) (xy 113.009994 27.774237)
        (xy 112.769187 27.480813) (xy 112.475763 27.240006) (xy 112.140999 27.061071) (xy 111.777758 26.950883) (xy 111.494658 26.923)
        (xy 110.505342 26.923) (xy 110.222242 26.950883) (xy 109.859001 27.061071) (xy 109.524237 27.240006) (xy 109.230813 27.480813)
        (xy 109.052 27.698697) (xy 109.052 22.301268) (xy 109.233371 22.24625) (xy 109.429157 22.1416) (xy 109.571191 22.025035)
        (xy 109.708281 22.116636) (xy 110.204563 22.322203) (xy 110.667547 22.414296) (xy 110.667547 23.4) (xy 110.689307 23.620931)
        (xy 110.75375 23.833371) (xy 110.8584 24.029157) (xy 110.999235 24.200765) (xy 111.170843 24.3416) (xy 111.366629 24.44625)
        (xy 111.579069 24.510693) (xy 111.8 24.532453) (xy 113.8 24.532453) (xy 114.020931 24.510693) (xy 114.233371 24.44625)
        (xy 114.429157 24.3416) (xy 114.571191 24.225035) (xy 114.708281 24.316636) (xy 115.204563 24.522203) (xy 115.731414 24.627)
        (xy 116.268586 24.627) (xy 116.795437 24.522203) (xy 117.291719 24.316636) (xy 117.428809 24.225035) (xy 117.570843 24.3416)
        (xy 117.766629 24.44625) (xy 117.979069 24.510693) (xy 118.2 24.532453) (xy 120.2 24.532453) (xy 120.420931 24.510693)
        (xy 120.633371 24.44625) (xy 120.829157 24.3416) (xy 121.000765 24.200765) (xy 121.1416 24.029157) (xy 121.24625 23.833371)
        (xy 121.310693 23.620931) (xy 121.332453 23.4) (xy 121.332453 22.414296) (xy 121.795437 22.322203) (xy 122.291719 22.116636)
        (xy 122.428809 22.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 65.570843 22.1416) (xy 65.766629 22.24625) (xy 65.948001 22.301269) (xy 65.948001 23.638495) (xy 65.941943 23.7)
        (xy 65.960616 23.88958) (xy 65.966117 23.945435) (xy 65.981775 23.997053) (xy 66.037707 24.181437) (xy 66.153964 24.398938)
        (xy 66.26841 24.538391) (xy 66.31042 24.589581) (xy 66.358188 24.628783) (xy 67.248 25.518595) (xy 67.248 27.017547)
        (xy 66.6038 27.017547) (xy 66.323601 27.045144) (xy 66.05417 27.126875) (xy 65.805861 27.259599) (xy 65.652749 27.385255)
        (xy 65.475763 27.240006) (xy 65.140999 27.061071) (xy 64.777758 26.950883) (xy 64.494658 26.923) (xy 63.505342 26.923)
        (xy 63.222242 26.950883) (xy 62.859001 27.061071) (xy 62.524237 27.240006) (xy 62.230813 27.480813) (xy 61.990006 27.774237)
        (xy 61.811071 28.109001) (xy 61.700883 28.472242) (xy 61.663677 28.85) (xy 61.700883 29.227758) (xy 61.811071 29.590999)
        (xy 61.990006 29.925763) (xy 62.230813 30.219187) (xy 62.524237 30.459994) (xy 62.859001 30.638929) (xy 63.222242 30.749117)
        (xy 63.505342 30.777) (xy 64.494658 30.777) (xy 64.777758 30.749117) (xy 65.140999 30.638929) (xy 65.223 30.595099)
        (xy 65.223 30.615924) (xy 65.259217 30.798) (xy 63.511496 30.798) (xy 63.45 30.791943) (xy 63.388504 30.798)
        (xy 63.388502 30.798) (xy 63.204565 30.816116) (xy 62.968562 30.887707) (xy 62.751061 31.003964) (xy 62.560419 31.160419)
        (xy 62.521213 31.208192) (xy 62.195464 31.533941) (xy 62.127975 31.432937) (xy 61.567063 30.872025) (xy 60.9075 30.431319)
        (xy 60.174633 30.127755) (xy 59.396625 29.973) (xy 58.603375 29.973) (xy 57.825367 30.127755) (xy 57.0925 30.431319)
        (xy 56.432937 30.872025) (xy 55.872025 31.432937) (xy 55.431319 32.0925) (xy 55.27083 32.479955) (xy 54.983376 32.192501)
        (xy 54.602248 31.93784) (xy 54.178761 31.762426) (xy 53.729189 31.673) (xy 53.270811 31.673) (xy 52.821239 31.762426)
        (xy 52.397752 31.93784) (xy 52.052 32.168864) (xy 52.052 30.001303) (xy 52.230813 30.219187) (xy 52.524237 30.459994)
        (xy 52.859001 30.638929) (xy 53.222242 30.749117) (xy 53.505342 30.777) (xy 54.494658 30.777) (xy 54.777758 30.749117)
        (xy 55.140999 30.638929) (xy 55.475763 30.459994) (xy 55.769187 30.219187) (xy 56.009994 29.925763) (xy 56.188929 29.590999)
        (xy 56.299117 29.227758) (xy 56.336323 28.85) (xy 56.299117 28.472242) (xy 56.188929 28.109001) (xy 56.009994 27.774237)
        (xy 55.769187 27.480813) (xy 55.475763 27.240006) (xy 55.140999 27.061071) (xy 54.777758 26.950883) (xy 54.494658 26.923)
        (xy 53.505342 26.923) (xy 53.222242 26.950883) (xy 52.859001 27.061071) (xy 52.524237 27.240006) (xy 52.230813 27.480813)
        (xy 52.052 27.698697) (xy 52.052 22.301268) (xy 52.233371 22.24625) (xy 52.429157 22.1416) (xy 52.571191 22.025035)
        (xy 52.708281 22.116636) (xy 53.204563 22.322203) (xy 53.667547 22.414296) (xy 53.667547 23.4) (xy 53.689307 23.620931)
        (xy 53.75375 23.833371) (xy 53.8584 24.029157) (xy 53.999235 24.200765) (xy 54.170843 24.3416) (xy 54.366629 24.44625)
        (xy 54.579069 24.510693) (xy 54.8 24.532453) (xy 56.8 24.532453) (xy 57.020931 24.510693) (xy 57.233371 24.44625)
        (xy 57.429157 24.3416) (xy 57.571191 24.225035) (xy 57.708281 24.316636) (xy 58.204563 24.522203) (xy 58.731414 24.627)
        (xy 59.268586 24.627) (xy 59.795437 24.522203) (xy 60.291719 24.316636) (xy 60.428809 24.225035) (xy 60.570843 24.3416)
        (xy 60.766629 24.44625) (xy 60.979069 24.510693) (xy 61.2 24.532453) (xy 63.2 24.532453) (xy 63.420931 24.510693)
        (xy 63.633371 24.44625) (xy 63.829157 24.3416) (xy 64.000765 24.200765) (xy 64.1416 24.029157) (xy 64.24625 23.833371)
        (xy 64.310693 23.620931) (xy 64.332453 23.4) (xy 64.332453 22.414296) (xy 64.795437 22.322203) (xy 65.291719 22.116636)
        (xy 65.428809 22.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 46.570843 22.1416) (xy 46.766629 22.24625) (xy 46.979069 22.310693) (xy 47.113894 22.323972) (xy 47.153964 22.398938)
        (xy 47.310419 22.589581) (xy 47.358192 22.628787) (xy 48.248001 23.518596) (xy 48.248001 27.017547) (xy 47.6038 27.017547)
        (xy 47.323601 27.045144) (xy 47.05417 27.126875) (xy 46.805861 27.259599) (xy 46.652749 27.385255) (xy 46.475763 27.240006)
        (xy 46.140999 27.061071) (xy 45.777758 26.950883) (xy 45.494658 26.923) (xy 44.505342 26.923) (xy 44.222242 26.950883)
        (xy 43.859001 27.061071) (xy 43.524237 27.240006) (xy 43.230813 27.480813) (xy 42.990006 27.774237) (xy 42.811071 28.109001)
        (xy 42.700883 28.472242) (xy 42.663677 28.85) (xy 42.700883 29.227758) (xy 42.811071 29.590999) (xy 42.990006 29.925763)
        (xy 43.230813 30.219187) (xy 43.524237 30.459994) (xy 43.859001 30.638929) (xy 44.222242 30.749117) (xy 44.505342 30.777)
        (xy 45.494658 30.777) (xy 45.777758 30.749117) (xy 46.140999 30.638929) (xy 46.223 30.595099) (xy 46.223 30.615924)
        (xy 46.259217 30.798) (xy 44.511496 30.798) (xy 44.45 30.791943) (xy 44.388504 30.798) (xy 44.388502 30.798)
        (xy 44.204565 30.816116) (xy 43.968562 30.887707) (xy 43.751061 31.003964) (xy 43.560419 31.160419) (xy 43.521213 31.208192)
        (xy 43.195464 31.533941) (xy 43.127975 31.432937) (xy 42.567063 30.872025) (xy 41.9075 30.431319) (xy 41.174633 30.127755)
        (xy 40.396625 29.973) (xy 39.603375 29.973) (xy 38.825367 30.127755) (xy 38.0925 30.431319) (xy 37.432937 30.872025)
        (xy 36.872025 31.432937) (xy 36.431319 32.0925) (xy 36.27083 32.479955) (xy 35.983376 32.192501) (xy 35.602248 31.93784)
        (xy 35.178761 31.762426) (xy 34.729189 31.673) (xy 34.270811 31.673) (xy 33.821239 31.762426) (xy 33.397752 31.93784)
        (xy 33.052 32.168864) (xy 33.052 30.001303) (xy 33.230813 30.219187) (xy 33.524237 30.459994) (xy 33.859001 30.638929)
        (xy 34.222242 30.749117) (xy 34.505342 30.777) (xy 35.494658 30.777) (xy 35.777758 30.749117) (xy 36.140999 30.638929)
        (xy 36.475763 30.459994) (xy 36.769187 30.219187) (xy 37.009994 29.925763) (xy 37.188929 29.590999) (xy 37.299117 29.227758)
        (xy 37.336323 28.85) (xy 37.299117 28.472242) (xy 37.188929 28.109001) (xy 37.009994 27.774237) (xy 36.769187 27.480813)
        (xy 36.475763 27.240006) (xy 36.140999 27.061071) (xy 35.777758 26.950883) (xy 35.494658 26.923) (xy 34.505342 26.923)
        (xy 34.222242 26.950883) (xy 33.859001 27.061071) (xy 33.524237 27.240006) (xy 33.230813 27.480813) (xy 33.052 27.698697)
        (xy 33.052 22.301268) (xy 33.233371 22.24625) (xy 33.429157 22.1416) (xy 33.571191 22.025035) (xy 33.708281 22.116636)
        (xy 34.204563 22.322203) (xy 34.667547 22.414296) (xy 34.667547 23.4) (xy 34.689307 23.620931) (xy 34.75375 23.833371)
        (xy 34.8584 24.029157) (xy 34.999235 24.200765) (xy 35.170843 24.3416) (xy 35.366629 24.44625) (xy 35.579069 24.510693)
        (xy 35.8 24.532453) (xy 37.8 24.532453) (xy 38.020931 24.510693) (xy 38.233371 24.44625) (xy 38.429157 24.3416)
        (xy 38.571191 24.225035) (xy 38.708281 24.316636) (xy 39.204563 24.522203) (xy 39.731414 24.627) (xy 40.268586 24.627)
        (xy 40.795437 24.522203) (xy 41.291719 24.316636) (xy 41.428809 24.225035) (xy 41.570843 24.3416) (xy 41.766629 24.44625)
        (xy 41.979069 24.510693) (xy 42.2 24.532453) (xy 44.2 24.532453) (xy 44.420931 24.510693) (xy 44.633371 24.44625)
        (xy 44.829157 24.3416) (xy 45.000765 24.200765) (xy 45.1416 24.029157) (xy 45.24625 23.833371) (xy 45.310693 23.620931)
        (xy 45.332453 23.4) (xy 45.332453 22.414296) (xy 45.795437 22.322203) (xy 46.291719 22.116636) (xy 46.428809 22.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 141.570843 22.1416) (xy 141.766629 22.24625) (xy 141.979069 22.310693) (xy 142.113894 22.323972) (xy 142.153964 22.398938)
        (xy 142.252137 22.518562) (xy 142.31042 22.589581) (xy 142.358188 22.628783) (xy 143.248 23.518595) (xy 143.248 27.017547)
        (xy 142.6038 27.017547) (xy 142.323601 27.045144) (xy 142.05417 27.126875) (xy 141.805861 27.259599) (xy 141.652749 27.385255)
        (xy 141.475763 27.240006) (xy 141.140999 27.061071) (xy 140.777758 26.950883) (xy 140.494658 26.923) (xy 139.505342 26.923)
        (xy 139.222242 26.950883) (xy 138.859001 27.061071) (xy 138.524237 27.240006) (xy 138.230813 27.480813) (xy 137.990006 27.774237)
        (xy 137.811071 28.109001) (xy 137.700883 28.472242) (xy 137.663677 28.85) (xy 137.700883 29.227758) (xy 137.811071 29.590999)
        (xy 137.990006 29.925763) (xy 138.230813 30.219187) (xy 138.524237 30.459994) (xy 138.859001 30.638929) (xy 139.222242 30.749117)
        (xy 139.505342 30.777) (xy 140.494658 30.777) (xy 140.777758 30.749117) (xy 141.140999 30.638929) (xy 141.223 30.595099)
        (xy 141.223 30.615924) (xy 141.259217 30.798) (xy 139.511496 30.798) (xy 139.45 30.791943) (xy 139.388504 30.798)
        (xy 139.388502 30.798) (xy 139.204565 30.816116) (xy 138.968562 30.887707) (xy 138.751061 31.003964) (xy 138.560419 31.160419)
        (xy 138.521213 31.208192) (xy 138.195464 31.533941) (xy 138.127975 31.432937) (xy 137.567063 30.872025) (xy 136.9075 30.431319)
        (xy 136.174633 30.127755) (xy 135.396625 29.973) (xy 134.603375 29.973) (xy 133.825367 30.127755) (xy 133.0925 30.431319)
        (xy 132.432937 30.872025) (xy 131.872025 31.432937) (xy 131.431319 32.0925) (xy 131.27083 32.479955) (xy 130.983376 32.192501)
        (xy 130.602248 31.93784) (xy 130.178761 31.762426) (xy 129.729189 31.673) (xy 129.270811 31.673) (xy 128.821239 31.762426)
        (xy 128.397752 31.93784) (xy 128.052 32.168864) (xy 128.052 30.001303) (xy 128.230813 30.219187) (xy 128.524237 30.459994)
        (xy 128.859001 30.638929) (xy 129.222242 30.749117) (xy 129.505342 30.777) (xy 130.494658 30.777) (xy 130.777758 30.749117)
        (xy 131.140999 30.638929) (xy 131.475763 30.459994) (xy 131.769187 30.219187) (xy 132.009994 29.925763) (xy 132.188929 29.590999)
        (xy 132.299117 29.227758) (xy 132.336323 28.85) (xy 132.299117 28.472242) (xy 132.188929 28.109001) (xy 132.009994 27.774237)
        (xy 131.769187 27.480813) (xy 131.475763 27.240006) (xy 131.140999 27.061071) (xy 130.777758 26.950883) (xy 130.494658 26.923)
        (xy 129.505342 26.923) (xy 129.222242 26.950883) (xy 128.859001 27.061071) (xy 128.524237 27.240006) (xy 128.230813 27.480813)
        (xy 128.052 27.698697) (xy 128.052 22.301268) (xy 128.233371 22.24625) (xy 128.429157 22.1416) (xy 128.571191 22.025035)
        (xy 128.708281 22.116636) (xy 129.204563 22.322203) (xy 129.667547 22.414296) (xy 129.667547 23.4) (xy 129.689307 23.620931)
        (xy 129.75375 23.833371) (xy 129.8584 24.029157) (xy 129.999235 24.200765) (xy 130.170843 24.3416) (xy 130.366629 24.44625)
        (xy 130.579069 24.510693) (xy 130.8 24.532453) (xy 132.8 24.532453) (xy 133.020931 24.510693) (xy 133.233371 24.44625)
        (xy 133.429157 24.3416) (xy 133.571191 24.225035) (xy 133.708281 24.316636) (xy 134.204563 24.522203) (xy 134.731414 24.627)
        (xy 135.268586 24.627) (xy 135.795437 24.522203) (xy 136.291719 24.316636) (xy 136.428809 24.225035) (xy 136.570843 24.3416)
        (xy 136.766629 24.44625) (xy 136.979069 24.510693) (xy 137.2 24.532453) (xy 139.2 24.532453) (xy 139.420931 24.510693)
        (xy 139.633371 24.44625) (xy 139.829157 24.3416) (xy 140.000765 24.200765) (xy 140.1416 24.029157) (xy 140.24625 23.833371)
        (xy 140.310693 23.620931) (xy 140.332453 23.4) (xy 140.332453 22.414296) (xy 140.795437 22.322203) (xy 141.291719 22.116636)
        (xy 141.428809 22.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 103.570843 22.1416) (xy 103.766629 22.24625) (xy 103.979069 22.310693) (xy 104.113894 22.323972) (xy 104.153964 22.398938)
        (xy 104.252137 22.518562) (xy 104.31042 22.589581) (xy 104.358188 22.628783) (xy 105.248 23.518595) (xy 105.248 27.017547)
        (xy 104.6038 27.017547) (xy 104.323601 27.045144) (xy 104.05417 27.126875) (xy 103.805861 27.259599) (xy 103.652749 27.385255)
        (xy 103.475763 27.240006) (xy 103.140999 27.061071) (xy 102.777758 26.950883) (xy 102.494658 26.923) (xy 101.505342 26.923)
        (xy 101.222242 26.950883) (xy 100.859001 27.061071) (xy 100.524237 27.240006) (xy 100.230813 27.480813) (xy 99.990006 27.774237)
        (xy 99.811071 28.109001) (xy 99.700883 28.472242) (xy 99.663677 28.85) (xy 99.700883 29.227758) (xy 99.811071 29.590999)
        (xy 99.990006 29.925763) (xy 100.230813 30.219187) (xy 100.524237 30.459994) (xy 100.859001 30.638929) (xy 101.222242 30.749117)
        (xy 101.505342 30.777) (xy 102.494658 30.777) (xy 102.777758 30.749117) (xy 103.140999 30.638929) (xy 103.223 30.595099)
        (xy 103.223 30.615924) (xy 103.259217 30.798) (xy 101.511496 30.798) (xy 101.45 30.791943) (xy 101.388504 30.798)
        (xy 101.388502 30.798) (xy 101.204565 30.816116) (xy 100.968562 30.887707) (xy 100.751061 31.003964) (xy 100.560419 31.160419)
        (xy 100.521213 31.208192) (xy 100.195464 31.533941) (xy 100.127975 31.432937) (xy 99.567063 30.872025) (xy 98.9075 30.431319)
        (xy 98.174633 30.127755) (xy 97.396625 29.973) (xy 96.603375 29.973) (xy 95.825367 30.127755) (xy 95.0925 30.431319)
        (xy 94.432937 30.872025) (xy 93.872025 31.432937) (xy 93.431319 32.0925) (xy 93.27083 32.479955) (xy 92.983376 32.192501)
        (xy 92.602248 31.93784) (xy 92.178761 31.762426) (xy 91.729189 31.673) (xy 91.270811 31.673) (xy 90.821239 31.762426)
        (xy 90.397752 31.93784) (xy 90.052 32.168864) (xy 90.052 30.001303) (xy 90.230813 30.219187) (xy 90.524237 30.459994)
        (xy 90.859001 30.638929) (xy 91.222242 30.749117) (xy 91.505342 30.777) (xy 92.494658 30.777) (xy 92.777758 30.749117)
        (xy 93.140999 30.638929) (xy 93.475763 30.459994) (xy 93.769187 30.219187) (xy 94.009994 29.925763) (xy 94.188929 29.590999)
        (xy 94.299117 29.227758) (xy 94.336323 28.85) (xy 94.299117 28.472242) (xy 94.188929 28.109001) (xy 94.009994 27.774237)
        (xy 93.769187 27.480813) (xy 93.475763 27.240006) (xy 93.140999 27.061071) (xy 92.777758 26.950883) (xy 92.494658 26.923)
        (xy 91.505342 26.923) (xy 91.222242 26.950883) (xy 90.859001 27.061071) (xy 90.524237 27.240006) (xy 90.230813 27.480813)
        (xy 90.052 27.698697) (xy 90.052 22.301268) (xy 90.233371 22.24625) (xy 90.429157 22.1416) (xy 90.571191 22.025035)
        (xy 90.708281 22.116636) (xy 91.204563 22.322203) (xy 91.667547 22.414296) (xy 91.667547 23.4) (xy 91.689307 23.620931)
        (xy 91.75375 23.833371) (xy 91.8584 24.029157) (xy 91.999235 24.200765) (xy 92.170843 24.3416) (xy 92.366629 24.44625)
        (xy 92.579069 24.510693) (xy 92.8 24.532453) (xy 94.8 24.532453) (xy 95.020931 24.510693) (xy 95.233371 24.44625)
        (xy 95.429157 24.3416) (xy 95.571191 24.225035) (xy 95.708281 24.316636) (xy 96.204563 24.522203) (xy 96.731414 24.627)
        (xy 97.268586 24.627) (xy 97.795437 24.522203) (xy 98.291719 24.316636) (xy 98.428809 24.225035) (xy 98.570843 24.3416)
        (xy 98.766629 24.44625) (xy 98.979069 24.510693) (xy 99.2 24.532453) (xy 101.2 24.532453) (xy 101.420931 24.510693)
        (xy 101.633371 24.44625) (xy 101.829157 24.3416) (xy 102.000765 24.200765) (xy 102.1416 24.029157) (xy 102.24625 23.833371)
        (xy 102.310693 23.620931) (xy 102.332453 23.4) (xy 102.332453 22.414296) (xy 102.795437 22.322203) (xy 103.291719 22.116636)
        (xy 103.428809 22.025035)
      )
    )
    (filled_polygon
      (pts
        (xy 1.234238 27.829164) (xy 1.431037 28.068963) (xy 1.65163 28.25) (xy 1.431037 28.431037) (xy 1.234238 28.670836)
        (xy 1.132 28.86211) (xy 1.132 27.63789)
      )
    )
    (filled_polygon
      (pts
        (xy 23.158188 11.571217) (xy 23.11042 11.610419) (xy 23.071218 11.658187) (xy 23.071217 11.658188) (xy 22.953964 11.801062)
        (xy 22.837707 12.018563) (xy 22.787834 12.182975) (xy 22.766117 12.254565) (xy 22.76554 12.26042) (xy 22.741943 12.5)
        (xy 22.748001 12.561506) (xy 22.748 27.938504) (xy 22.741943 28) (xy 22.748 28.061496) (xy 22.748 28.061497)
        (xy 22.766116 28.245434) (xy 22.837707 28.481437) (xy 22.886649 28.573) (xy 14.252 28.573) (xy 14.252 26.518595)
        (xy 17.641809 23.128786) (xy 17.689581 23.089581) (xy 17.846036 22.898939) (xy 17.962293 22.681438) (xy 18.033884 22.445435)
        (xy 18.052 22.261498) (xy 18.052 22.261496) (xy 18.058057 22.2) (xy 18.052 22.138504) (xy 18.052 19.685055)
        (xy 18.152542 19.602542) (xy 18.324468 19.39305) (xy 18.45222 19.154042) (xy 18.53089 18.894703) (xy 18.557453 18.625)
        (xy 18.557453 17.375) (xy 18.53089 17.105297) (xy 18.45222 16.845958) (xy 18.324468 16.60695) (xy 18.236696 16.5)
        (xy 18.324468 16.39305) (xy 18.45222 16.154042) (xy 18.53089 15.894703) (xy 18.557453 15.625) (xy 18.557453 14.402)
        (xy 18.788504 14.402) (xy 18.85 14.408057) (xy 18.911496 14.402) (xy 18.911498 14.402) (xy 19.095435 14.383884)
        (xy 19.331438 14.312293) (xy 19.548939 14.196036) (xy 19.739581 14.039581) (xy 19.778787 13.991808) (xy 22.518595 11.252)
        (xy 23.477405 11.252)
      )
    )
    (filled_polygon
      (pts
        (xy 1.234238 24.329164) (xy 1.431037 24.568963) (xy 1.65163 24.75) (xy 1.431037 24.931037) (xy 1.234238 25.170836)
        (xy 1.132 25.36211) (xy 1.132 24.13789)
      )
    )
    (filled_polygon
      (pts
        (xy 15.284076 19.777) (xy 15.515924 19.777) (xy 15.548001 19.77062) (xy 15.548 21.681405) (xy 13.145001 24.084404)
        (xy 13.232947 23.872085) (xy 13.307 23.499793) (xy 13.307 23.120207) (xy 13.232947 22.747915) (xy 13.087685 22.397223)
        (xy 12.876799 22.081609) (xy 12.83519 22.04) (xy 12.876799 21.998391) (xy 13.087685 21.682777) (xy 13.232947 21.332085)
        (xy 13.307 20.959793) (xy 13.307 20.580207) (xy 13.232947 20.207915) (xy 13.107813 19.905816) (xy 13.355297 19.98089)
        (xy 13.625 20.007453) (xy 14.375 20.007453) (xy 14.644703 19.98089) (xy 14.904042 19.90222) (xy 15.14305 19.774468)
        (xy 15.168079 19.753927)
      )
    )
    (filled_polygon
      (pts
        (xy 68.548 22.301268) (xy 68.548 23.277405) (xy 68.452 23.181405) (xy 68.452 22.301268) (xy 68.5 22.286708)
      )
    )
    (filled_polygon
      (pts
        (xy 1.234238 20.829164) (xy 1.431037 21.068963) (xy 1.65163 21.25) (xy 1.431037 21.431037) (xy 1.234238 21.670836)
        (xy 1.132 21.86211) (xy 1.132 20.63789)
      )
    )
    (filled_polygon
      (pts
        (xy 4.973917 20.755488) (xy 4.42034 21.309065) (xy 4.34837 21.25) (xy 4.568963 21.068963) (xy 4.765762 20.829164)
        (xy 4.807007 20.752) (xy 4.938504 20.752)
      )
    )
    (filled_polygon
      (pts
        (xy 9.92481 19.5) (xy 9.90681 19.518) (xy 9.791496 19.518) (xy 9.756083 19.514512) (xy 9.788595 19.482)
        (xy 9.90681 19.482)
      )
    )
    (filled_polygon
      (pts
        (xy 9.883201 9.298391) (xy 9.92481 9.34) (xy 9.883201 9.381609) (xy 9.672315 9.697223) (xy 9.527053 10.047915)
        (xy 9.453 10.420207) (xy 9.453 10.799793) (xy 9.527053 11.172085) (xy 9.672315 11.522777) (xy 9.883201 11.838391)
        (xy 9.92481 11.88) (xy 9.90681 11.898) (xy 9.411495 11.898) (xy 9.349999 11.891943) (xy 9.288503 11.898)
        (xy 9.288502 11.898) (xy 9.104565 11.916116) (xy 8.868562 11.987707) (xy 8.65106 12.103964) (xy 8.510661 12.219187)
        (xy 8.460419 12.260419) (xy 8.421217 12.308187) (xy 7.733263 12.996141) (xy 7.55459 13.031681) (xy 7.276694 13.14679)
        (xy 7.026594 13.313901) (xy 6.813901 13.526594) (xy 6.64679 13.776694) (xy 6.531681 14.05459) (xy 6.473 14.349604)
        (xy 6.473 14.650396) (xy 6.531681 14.94541) (xy 6.64679 15.223306) (xy 6.813901 15.473406) (xy 7.026594 15.686099)
        (xy 7.036612 15.692793) (xy 4.672369 18.057036) (xy 4.568963 17.931037) (xy 4.329164 17.734238) (xy 4.055579 17.588004)
        (xy 3.758721 17.497953) (xy 3.45 17.467547) (xy 2.55 17.467547) (xy 2.241279 17.497953) (xy 1.944421 17.588004)
        (xy 1.670836 17.734238) (xy 1.431037 17.931037) (xy 1.234238 18.170836) (xy 1.132 18.36211) (xy 1.132 16.13789)
        (xy 1.234238 16.329164) (xy 1.431037 16.568963) (xy 1.670836 16.765762) (xy 1.944421 16.911996) (xy 2.241279 17.002047)
        (xy 2.55 17.032453) (xy 3.45 17.032453) (xy 3.758721 17.002047) (xy 4.055579 16.911996) (xy 4.329164 16.765762)
        (xy 4.568963 16.568963) (xy 4.765762 16.329164) (xy 4.911996 16.055579) (xy 5.002047 15.758721) (xy 5.032453 15.45)
        (xy 5.032453 14.55) (xy 5.002047 14.241279) (xy 4.911996 13.944421) (xy 4.765762 13.670836) (xy 4.568963 13.431037)
        (xy 4.329164 13.234238) (xy 4.055579 13.088004) (xy 3.758721 12.997953) (xy 3.45 12.967547) (xy 2.55 12.967547)
        (xy 2.241279 12.997953) (xy 1.944421 13.088004) (xy 1.670836 13.234238) (xy 1.431037 13.431037) (xy 1.234238 13.670836)
        (xy 1.132 13.86211) (xy 1.132 11.63789) (xy 1.234238 11.829164) (xy 1.431037 12.068963) (xy 1.670836 12.265762)
        (xy 1.944421 12.411996) (xy 2.241279 12.502047) (xy 2.55 12.532453) (xy 3.45 12.532453) (xy 3.758721 12.502047)
        (xy 4.055579 12.411996) (xy 4.329164 12.265762) (xy 4.568963 12.068963) (xy 4.765762 11.829164) (xy 4.807007 11.752)
        (xy 6.438504 11.752) (xy 6.5 11.758057) (xy 6.561496 11.752) (xy 6.561498 11.752) (xy 6.745435 11.733884)
        (xy 6.981438 11.662293) (xy 7.198939 11.546036) (xy 7.389581 11.389581) (xy 7.428787 11.341808) (xy 9.718579 9.052016)
      )
    )
    (filled_polygon
      (pts
        (xy 9.92481 16.96) (xy 9.90681 16.978) (xy 9.331496 16.978) (xy 9.296083 16.974512) (xy 9.328595 16.942)
        (xy 9.90681 16.942)
      )
    )
    (filled_polygon
      (pts
        (xy 9.92481 14.42) (xy 9.90681 14.438) (xy 9.832596 14.438) (xy 9.868596 14.402) (xy 9.90681 14.402)
      )
    )
    (filled_polygon
      (pts
        (xy 21.071213 9.158192) (xy 18.331405 11.898) (xy 18.320406 11.898) (xy 18.324468 11.89305) (xy 18.45222 11.654042)
        (xy 18.53089 11.394703) (xy 18.557453 11.125) (xy 18.557453 9.875) (xy 18.53089 9.605297) (xy 18.45222 9.345958)
        (xy 18.337857 9.132) (xy 21.092708 9.132)
      )
    )
    (filled_polygon
      (pts
        (xy 12.868 3.836692) (xy 12.809157 3.7884) (xy 12.613371 3.68375) (xy 12.400931 3.619307) (xy 12.18 3.597547)
        (xy 10.58 3.597547) (xy 10.359069 3.619307) (xy 10.146629 3.68375) (xy 9.950843 3.7884) (xy 9.779235 3.929235)
        (xy 9.6384 4.100843) (xy 9.53375 4.296629) (xy 9.469307 4.509069) (xy 9.447547 4.73) (xy 9.447547 5.781857)
        (xy 5.981405 9.248) (xy 4.807007 9.248) (xy 4.765762 9.170836) (xy 4.568963 8.931037) (xy 4.329164 8.734238)
        (xy 4.055579 8.588004) (xy 3.758721 8.497953) (xy 3.45 8.467547) (xy 2.55 8.467547) (xy 2.241279 8.497953)
        (xy 1.944421 8.588004) (xy 1.670836 8.734238) (xy 1.431037 8.931037) (xy 1.234238 9.170836) (xy 1.132 9.36211)
        (xy 1.132 4.055359) (xy 1.191944 3.443995) (xy 1.353422 2.909158) (xy 1.615705 2.415875) (xy 1.968802 1.982935)
        (xy 2.39927 1.626821) (xy 2.890711 1.3611) (xy 3.424397 1.195896) (xy 3.657648 1.171381) (xy 3.51881 1.228889)
        (xy 3.006654 1.571101) (xy 2.571101 2.006654) (xy 2.228889 2.51881) (xy 1.993169 3.087888) (xy 1.873 3.692017)
        (xy 1.873 4.307983) (xy 1.993169 4.912112) (xy 2.228889 5.48119) (xy 2.571101 5.993346) (xy 3.006654 6.428899)
        (xy 3.51881 6.771111) (xy 4.087888 7.006831) (xy 4.692017 7.127) (xy 5.307983 7.127) (xy 5.912112 7.006831)
        (xy 6.48119 6.771111) (xy 6.993346 6.428899) (xy 7.428899 5.993346) (xy 7.771111 5.48119) (xy 8.006831 4.912112)
        (xy 8.127 4.307983) (xy 8.127 3.692017) (xy 8.006831 3.087888) (xy 7.771111 2.51881) (xy 7.428899 2.006654)
        (xy 6.993346 1.571101) (xy 6.48119 1.228889) (xy 6.247279 1.132) (xy 12.868 1.132)
      )
    )
    (filled_polygon
      (pts
        (xy 25.16481 6.8) (xy 25.132 6.83281) (xy 25.132 6.76719)
      )
    )
  )
)
`;
